<div *ngIf="reportType == 'indetailcontract'">
    <div style="margin-left: 80%;  margin-bottom: 2%;">
        <!-- <button class="noPrint" style="margin-top: 2%;" mat-raised-button color="primary"
            [printStyle]="{table : {'border-collapse':'collapse'}, td : {'border': 'solid 1px'}, th : {'border': 'solid 1px'}}"
            printSectionId="print-section2" ngxPrint>
            print
        </button> -->
        <button class="noPrint" style="margin-top: 2%; margin-left: 2%"
            (click)="exportExcel('Contract_InDetails_Report')" mat-raised-button color="primary">
            Export
        </button>
        <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>
            Close
        </button>
    </div>
    <div class="container" id="print-section">
        <table class="table table-bordered">
            <thead>
                <tr>
                    <th colspan="11">सा. विवेक जाहिरात वार्षिक करार २०२२-२३ नोंदणी तक्ता</th>
                    <th colspan="4">Indetail-contract</th>
                    <th *ngIf="totalweeks == 54" colspan="131"></th>
                    <th *ngIf="totalweeks == 53" colspan="130"></th>
                    <th *ngIf="totalweeks == 52" colspan="129"></th>
                </tr>
                <tr>
                    <th rowspan="3">अक्र.</th>
                    <th rowspan="3">जाहिरात कराराचे नाव</th>
                    <th rowspan="3">प्रतिनिधी</th>
                    <th rowspan="3">करार कालावधी</th>
                    <th rowspan="3">मागील करार</th>
                    <th rowspan="3">शिल्लक करार</th>
                    <th rowspan="3">नवीन करार</th>
                    <th rowspan="3">एजन्सी सूट</th>
                    <th rowspan="3">एकूण</th>
                    <th rowspan="3">जी एस टी</th>
                    <th rowspan="3">एकूण</th>
                    <th *ngIf="this.sundays(today | date:'yyyy', 3) == 5" colspan="12">एप्रिल {{ today | date:"yyyy"
                        }}
                    </th>
                    <th *ngIf="this.sundays(today | date:'yyyy', 3) == 4" colspan="10">एप्रिल {{ today | date:"yyyy"
                        }}
                    </th>
                    <th *ngIf="this.sundays(today | date:'yyyy', 4) == 5" colspan="12">मे {{ today | date:"yyyy" }}
                    <th *ngIf="this.sundays(today | date:'yyyy', 4) == 4" colspan="10">मे {{ today | date:"yyyy" }}
                    </th>
                    <th *ngIf="this.sundays(today | date:'yyyy', 5) == 5" colspan="12">जुन {{ today | date:"yyyy" }}
                    </th>
                    <th *ngIf="this.sundays(today | date:'yyyy', 5) == 4" colspan="10">जुन {{ today | date:"yyyy" }}
                    </th>
                    <th *ngIf="this.sundays(today | date:'yyyy', 6) == 5" colspan="12">जुलै {{ today | date:"yyyy" }}
                    </th>
                    <th *ngIf="this.sundays(today | date:'yyyy', 6) == 4" colspan="10">जुलै {{ today | date:"yyyy" }}
                    </th>
                    <th *ngIf="this.sundays(today | date:'yyyy', 7) == 5" colspan="12">ऑगस्ट{{ today | date:"yyyy" }}
                    </th>
                    <th *ngIf="this.sundays(today | date:'yyyy', 7) == 4" colspan="10">ऑगस्ट {{ today | date:"yyyy"
                        }}
                    </th>
                    <th *ngIf="this.sundays(today | date:'yyyy', 8) == 5" colspan="12">सप्टेंबर {{ today |
                        date:"yyyy" }}
                    </th>
                    <th *ngIf="this.sundays(today | date:'yyyy', 8) == 4" colspan="10">सप्टेंबर {{ today |
                        date:"yyyy" }}
                    </th>
                    <th *ngIf="this.sundays(today | date:'yyyy', 9) == 5" colspan="12">ऑक्टोबर {{ today | date:"yyyy"
                        }}
                    </th>
                    <th *ngIf="this.sundays(today | date:'yyyy', 9) == 4" colspan="10">ऑक्टोबर {{ today | date:"yyyy"
                        }}
                    </th>
                    <th *ngIf="this.sundays(today | date:'yyyy', 10) == 5" colspan="12">नोव्हेंबर {{ today |
                        date:"yyyy"
                        }}
                    </th>
                    <th *ngIf="this.sundays(today | date:'yyyy', 10) == 4" colspan="10">नोव्हेंबर {{ today |
                        date:"yyyy"
                        }}
                    </th>
                    <th *ngIf="this.sundays(today | date:'yyyy', 11) == 5" colspan="12">डिसेंबर {{ today |
                        date:"yyyy" }}
                    </th>
                    <th *ngIf="this.sundays(today | date:'yyyy', 11) == 4" colspan="10">डिसेंबर {{ today |
                        date:"yyyy" }}
                    </th>
                    <th *ngIf="this.sundays(nexttoday | date:'yyyy', 0) == 5" colspan="12">जानेवारी {{ nexttoday |
                        date:"yyyy" }}</th>
                    <th *ngIf="this.sundays(nexttoday | date:'yyyy', 0) == 4" colspan="10">जानेवारी {{ nexttoday |
                        date:"yyyy" }}</th>
                    <th *ngIf="this.sundays(nexttoday | date:'yyyy', 1) == 5" colspan="12">फेब्रुवारी {{ nexttoday |
                        date:"yyyy" }}</th>
                    <th *ngIf="this.sundays(nexttoday | date:'yyyy', 1) == 4" colspan="10">फेब्रुवारी {{ nexttoday |
                        date:"yyyy" }}</th>
                    <th *ngIf="this.sundays(nexttoday | date:'yyyy', 2) == 5" colspan="12">मार्च {{ nexttoday |
                        date:"yyyy"
                        }}</th>
                    <th *ngIf="this.sundays(nexttoday | date:'yyyy', 2) == 4" colspan="10">मार्च {{ nexttoday |
                        date:"yyyy"
                        }}</th>
                    <th rowspan="3">एकूण मार्च अखेर</th>
                    <th rowspan="3">पुढील वर्षासाठी</th>
                    <th rowspan="3">आज अखेर वापरले</th>
                    <th rowspan="3">मार्च अखेर वापरणे बाकी</th>
                </tr>
                <tr>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th *ngIf="this.sundays(today | date:'yyyy', 3) > 4" colspan="2"></th>
                    <th colspan="2" rowspan="2">एकूण</th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th *ngIf="this.sundays(today | date:'yyyy', 4) > 4" colspan="2"></th>
                    <th colspan="2" rowspan="2">एकूण</th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th *ngIf="this.sundays(today | date:'yyyy', 5) > 4" colspan="2"></th>
                    <th colspan="2" rowspan="2">एकूण</th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th *ngIf="this.sundays(today | date:'yyyy', 6) > 4" colspan="2"></th>
                    <th colspan="2" rowspan="2">एकूण</th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th *ngIf="this.sundays(today | date:'yyyy', 7) > 4" colspan="2"></th>
                    <th colspan="2" rowspan="2">एकूण</th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th *ngIf="this.sundays(today | date:'yyyy', 8) > 4" colspan="2"></th>
                    <th colspan="2" rowspan="2">एकूण</th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th *ngIf="this.sundays(today | date:'yyyy', 9) > 4" colspan="2"></th>
                    <th colspan="2" rowspan="2">एकूण</th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th *ngIf="this.sundays(today | date:'yyyy',10) > 4" colspan="2"></th>
                    <th colspan="2" rowspan="2">एकूण</th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th *ngIf="this.sundays(today | date:'yyyy', 11) > 4" colspan="2"></th>
                    <th colspan="2" rowspan="2">एकूण</th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th *ngIf="this.sundays(nexttoday | date:'yyyy', 0) > 4" colspan="2"></th>
                    <th colspan="2" rowspan="2">एकूण</th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th colspan="2" *ngIf="this.sundays(nexttoday | date:'yyyy', 1) > 4"></th>
                    <th colspan="2" rowspan="2">एकूण</th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th colspan="2"></th>
                    <th colspan="2" *ngIf="this.sundays(nexttoday | date:'yyyy', 2) > 4"></th>
                    <th colspan="2" rowspan="2">एकूण</th>
                </tr>
                <tr>
                    <th colspan="2">{{ firstSunday(3,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th colspan="2">{{ secondSunday(3,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th colspan="2">{{ thirdSunday(3,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th colspan="2">{{ fourthSunday(3,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th *ngIf="this.sundays(today | date:'yyyy', 3) > 4" colspan="2">{{ fifthSunday(3,today |
                        date:"yyyy") |
                        date:"dd/MM/yy" }}</th>
                    <th colspan="2">{{ firstSunday(4,today | date:"yyyy")| date:"dd/MM/yy" }}</th>
                    <th colspan="2">{{ secondSunday(4,today | date:"yyyy")| date:"dd/MM/yy" }}</th>
                    <th colspan="2">{{ thirdSunday(4,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th colspan="2">{{ fourthSunday(4,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th *ngIf="this.sundays(today | date:'yyyy', 4) > 4" colspan="2">{{ fifthSunday(4,today |
                        date:"yyyy") |
                        date:"dd/MM/yy" }}</th>
                    <th colspan="2">{{ firstSunday(5,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th colspan="2">{{ secondSunday(5,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th colspan="2">{{ thirdSunday(5,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th colspan="2">{{ fourthSunday(5,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th *ngIf="this.sundays(today | date:'yyyy', 5) > 4" colspan="2">{{ fifthSunday(5,today |
                        date:"yyyy") |
                        date:"dd/MM/yy" }}</th>
                    <th colspan="2">{{ firstSunday(6,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th colspan="2">{{ secondSunday(6,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th colspan="2">{{ thirdSunday(6,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th colspan="2">{{ fourthSunday(6,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th *ngIf="this.sundays(today | date:'yyyy', 6) > 4" colspan="2">{{ fifthSunday(6,today |
                        date:"yyyy") |
                        date:"dd/MM/yy" }}</th>
                    <th colspan="2">{{ firstSunday(7,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th colspan="2">{{ secondSunday(7,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th colspan="2">{{ thirdSunday(7,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th colspan="2">{{ fourthSunday(7,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th *ngIf="this.sundays(today | date:'yyyy', 7) > 4" colspan="2">{{ fifthSunday(7,today |
                        date:"yyyy") |
                        date:"dd/MM/yy" }}</th>
                    <th colspan="2">{{ firstSunday(8,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th colspan="2">{{ secondSunday(8,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th colspan="2">{{ thirdSunday(8,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th colspan="2">{{ fourthSunday(8,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th *ngIf="this.sundays(today | date:'yyyy', 8) > 4" colspan="2">{{ fifthSunday(8,today |
                        date:"yyyy") |
                        date:"dd/MM/yy" }}</th>
                    <th colspan="2">{{ firstSunday(9,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th colspan="2">{{ secondSunday(9,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th colspan="2">{{ thirdSunday(9,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th colspan="2">{{ fourthSunday(9,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th *ngIf="this.sundays(today | date:'yyyy', 9) > 4" colspan="2">{{ fifthSunday(9,today |
                        date:"yyyy") |
                        date:"dd/MM/yy" }}</th>
                    <th colspan="2">{{ firstSunday(10,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th colspan="2">{{ secondSunday(10,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th colspan="2">{{ thirdSunday(10,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th colspan="2">{{ fourthSunday(10,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th *ngIf="this.sundays(today | date:'yyyy', 10) > 4" colspan="2">{{ fifthSunday(10,today |
                        date:"yyyy") |
                        date:"dd/MM/yy" }}</th>
                    <th colspan="2">{{ firstSunday(11,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th colspan="2">{{ secondSunday(11,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th colspan="2">{{ thirdSunday(11,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th colspan="2">{{ fourthSunday(11,today | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th *ngIf="this.sundays(today | date:'yyyy', 11) > 4" colspan="2">{{ fifthSunday(11,today |
                        date:"yyyy") |
                        date:"dd/MM/yy" }}</th>
                    <th colspan="2">{{ firstSunday(0,nexttoday | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th colspan="2">{{ secondSunday(0,nexttoday | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th colspan="2">{{ thirdSunday(0,nexttoday | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th colspan="2">{{ fourthSunday(0,nexttoday | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th *ngIf="this.sundays(nexttoday | date:'yyyy', 0) > 4" colspan="2">{{ fifthSunday(0,nexttoday |
                        date:"yyyy") |
                        date:"dd/MM/yy" }}</th>
                    <th colspan="2">{{ firstSunday(1,nexttoday | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th colspan="2">{{ secondSunday(1,nexttoday | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th colspan="2">{{ thirdSunday(1,nexttoday | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th colspan="2">{{ fourthSunday(1,nexttoday | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th *ngIf="this.sundays(nexttoday | date:'yyyy', 1) > 4" colspan="2">{{ fifthSunday(1,nexttoday |
                        date:"yyyy") |
                        date:"dd/MM/yy" }}</th>
                    <th colspan="2">{{ firstSunday(2,nexttoday | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th colspan="2">{{ secondSunday(2,nexttoday | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th colspan="2">{{ thirdSunday(2,nexttoday | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th colspan="2">{{ fourthSunday(2,nexttoday | date:"yyyy") | date:"dd/MM/yy" }}</th>
                    <th *ngIf="this.sundays(nexttoday | date:'yyyy', 2) > 4" colspan="2">{{ fifthSunday(2,nexttoday |
                        date:"yyyy") |
                        date:"dd/MM/yy" }}</th>
                </tr>
            </thead>
            <tbody>
                <!-- indetailsData -->
                <ng-container *ngFor="let item of contractData; let s = index; let a = first; let b = last">
                    <tr style="background-color: rgb(120, 218, 233);">
                        <td style="color: red;">{{ s+1 }}</td>
                        <td style="color: red;font-size: large;font-weight: 600;">{{ item['name'] }}</td>
                        <td colspan="9"></td>
                        <td *ngIf="this.sundays(today | date:'yyyy', 3) == 5" colspan="12"></td>
                        <td *ngIf="this.sundays(today | date:'yyyy', 3) == 4" colspan="10"></td>
                        <td *ngIf="this.sundays(today | date:'yyyy', 4) == 5" colspan="12"></td>
                        <td *ngIf="this.sundays(today | date:'yyyy', 4) == 4" colspan="10"></td>
                        <td *ngIf="this.sundays(today | date:'yyyy', 5) == 5" colspan="12"></td>
                        <td *ngIf="this.sundays(today | date:'yyyy', 5) == 4" colspan="10"></td>
                        <td *ngIf="this.sundays(today | date:'yyyy', 6) == 5" colspan="12"></td>
                        <td *ngIf="this.sundays(today | date:'yyyy', 6) == 4" colspan="10"></td>
                        <td *ngIf="this.sundays(today | date:'yyyy', 7) == 5" colspan="12"></td>
                        <td *ngIf="this.sundays(today | date:'yyyy', 7) == 4" colspan="10"></td>
                        <td *ngIf="this.sundays(today | date:'yyyy', 8) == 5" colspan="12"></td>
                        <td *ngIf="this.sundays(today | date:'yyyy', 8) == 4" colspan="10"></td>
                        <td *ngIf="this.sundays(today | date:'yyyy', 9) == 5" colspan="12"></td>
                        <td *ngIf="this.sundays(today | date:'yyyy', 9) == 4" colspan="10"></td>
                        <td *ngIf="this.sundays(today | date:'yyyy', 10) == 5" colspan="12"></td>
                        <td *ngIf="this.sundays(today | date:'yyyy', 10) == 4" colspan="10"></td>
                        <td *ngIf="this.sundays(today | date:'yyyy', 11) == 5" colspan="12"></td>
                        <td *ngIf="this.sundays(today | date:'yyyy', 11) == 4" colspan="10"></td>
                        <td *ngIf="this.sundays(nexttoday | date:'yyyy', 0) == 5" colspan="12"></td>
                        <td *ngIf="this.sundays(nexttoday | date:'yyyy', 0) == 4" colspan="10"></td>
                        <td *ngIf="this.sundays(nexttoday | date:'yyyy', 1) == 5" colspan="12"></td>
                        <td *ngIf="this.sundays(nexttoday | date:'yyyy', 1) == 4" colspan="10"></td>
                        <td *ngIf="this.sundays(nexttoday | date:'yyyy', 2) == 5" colspan="12"></td>
                        <td *ngIf="this.sundays(nexttoday | date:'yyyy', 2) == 4" colspan="10"></td>
                        <td colspan="4"></td>
                    </tr>
                    <ng-container *ngFor="let data of contractData; let i = index">
                        <tr>
                            <td rowspan="2">{{ i+1 }}</td>
                            <td rowspan="2">{{ data['advt_name'] }}</td>
                            <td rowspan="2">{{ data['rep_name'] }}</td>
                            <td rowspan="2">{{ data['contract_period_from'] | date:"MM yyyy" }} to {{
                                data['contract_period_to'] |
                                date:"MM
                                yyyy" }}</td>
                            <td rowspan="2" class="amount">{{ data['contract_prev_bal'] }}</td>
                            <td rowspan="2"></td>
                            <td rowspan="2" class="amount">{{ data['contract_amt'] }}</td>
                            <td rowspan="2" class="amount">{{ data['contract_discnt_amt'] }}</td>
                            <td rowspan="2" class="amount">{{ data['contract_net_amt'] }}</td>
                            <td rowspan="2" class="amount">{{ data['contract_net_gst_amt'] }}</td>
                            <td rowspan="2" class="amount">{{ data['contract_net_total'] }}</td>
                            <td colspan="2"> {{ data['issue_name'] }}</td>
                            <td colspan="2"> {{ data['issue_name'] }}</td>
                            <td colspan="2"> {{ data['issue_name'] }}</td>
                            <td colspan="2"> {{ data['issue_name'] }}</td>
                            <td *ngIf="this.sundays(today | date:'yyyy', 3) > 4" colspan="2">{{ data['april5thWeekSize']
                                }}</td>
                            <td colspan="2" rowspan="2">
                                <span *ngIf="this.sundays(today | date:'yyyy', 3) == 4">{{
                                    calculateTotalAmount(data['april1stWeekAmt'],data['april2ndWeekAmt'],data['april3rdWeekAmt'],data['april4thWeekAmt'])
                                    }}</span>
                                <span *ngIf="this.sundays(today | date:'yyyy', 3) == 5">{{
                                    calculateTotalAmount(data['april1stWeekAmt'],data['april2ndWeekAmt'],data['april3rdWeekAmt'],data['april4thWeekAmt'],data['april5thWeekAmt'])
                                    }}</span>
                            </td>
                            <td colspan="2">{{ data['may1stWeekSize'] }}</td>
                            <td colspan="2">{{ data['may2ndWeekSize'] }}</td>
                            <td colspan="2">{{ data['may3rdWeekSize'] }}</td>
                            <td colspan="2">{{ data['may4thWeekSize'] }}</td>
                            <td *ngIf="this.sundays(today | date:'yyyy', 4) > 4" colspan="2">{{ data['may5thWeekSize']
                                }}</td>
                            <td colspan="2" rowspan="2">
                                <span *ngIf="this.sundays(today | date:'yyyy', 4) == 4">{{
                                    calculateTotalAmount(data['may1stWeekAmt'],data['may2ndWeekAmt'],data['may3rdWeekAmt'],data['may4thWeekAmt'])
                                    }}</span>
                                <span *ngIf="this.sundays(today | date:'yyyy', 4) == 5">{{
                                    calculateTotalAmount(data['may1stWeekAmt'],data['may2ndWeekAmt'],data['may3rdWeekAmt'],data['may4thWeekAmt'],data['may5thWeekAmt'])
                                    }}</span>
                            </td>
                            <td colspan="2">{{ data['june1stWeekSize'] }}</td>
                            <td colspan="2">{{ data['june2ndWeekSize'] }}</td>
                            <td colspan="2">{{ data['june3rdWeekSize'] }}</td>
                            <td colspan="2">{{ data['june4thWeekSize'] }}</td>
                            <td *ngIf="this.sundays(today | date:'yyyy', 5) > 4" colspan="2">{{ data['june5thWeekSize']
                                }}</td>
                            <td colspan="2" rowspan="2">
                                <span *ngIf="this.sundays(today | date:'yyyy', 5) == 4">{{
                                    calculateTotalAmount(data['june1stWeekAmt'],data['june2ndWeekAmt'],data['june3rdWeekAmt'],data['june4thWeekAmt'])
                                    }}</span>
                                <span *ngIf="this.sundays(today | date:'yyyy', 5) == 5">{{
                                    calculateTotalAmount(data['june1stWeekAmt'],data['june2ndWeekAmt'],data['june3rdWeekAmt'],data['june4thWeekAmt'],data['june5thWeekAmt'])
                                    }}</span>
                            </td>
                            <td colspan="2">{{ data['july1stWeekSize'] }}</td>
                            <td colspan="2">{{ data['july2ndWeekSize'] }}</td>
                            <td colspan="2">{{ data['july3rdWeekSize'] }}</td>
                            <td colspan="2">{{ data['july4thWeekSize'] }}</td>
                            <td *ngIf="this.sundays(today | date:'yyyy', 6) > 4" colspan="2">{{ data['july5thWeekSize']
                                }}</td>
                            <td colspan="2" rowspan="2">
                                <span *ngIf="this.sundays(today | date:'yyyy', 6) == 4">{{
                                    calculateTotalAmount(data['july1stWeekAmt'],data['july2ndWeekAmt'],data['july3rdWeekAmt'],data['july4thWeekAmt'])
                                    }}</span>
                                <span *ngIf="this.sundays(today | date:'yyyy', 6) == 5">{{
                                    calculateTotalAmount(data['july1stWeekAmt'],data['july2ndWeekAmt'],data['july3rdWeekAmt'],data['july4thWeekAmt'],data['july5thWeekAmt'])
                                    }}</span>
                            </td>
                            <td colspan="2">{{ data['august1stWeekSize'] }}</td>
                            <td colspan="2">{{ data['august2ndWeekSize'] }}</td>
                            <td colspan="2">{{ data['august3rdWeekSize'] }}</td>
                            <td colspan="2">{{ data['august4thWeekSize'] }}</td>
                            <td *ngIf="this.sundays(today | date:'yyyy', 7) > 4" colspan="2">{{
                                data['august5thWeekSize'] }}</td>
                            <td colspan="2" rowspan="2">
                                <span *ngIf="this.sundays(today | date:'yyyy', 7) == 4">{{
                                    calculateTotalAmount(data['august1stWeekAmt'],data['august2ndWeekAmt'],data['august3rdWeekAmt'],data['august4thWeekAmt'])
                                    }}</span>
                                <span *ngIf="this.sundays(today | date:'yyyy', 7) == 5">{{
                                    calculateTotalAmount(data['august1stWeekAmt'],data['august2ndWeekAmt'],data['august3rdWeekAmt'],data['august4thWeekAmt'],data['august5thWeekAmt'])
                                    }}</span>
                            </td>
                            <td colspan="2">{{ data['september1stWeekSize'] }}</td>
                            <td colspan="2">{{ data['september2ndWeekSize'] }}</td>
                            <td colspan="2">{{ data['september3rdWeekSize'] }}</td>
                            <td colspan="2">{{ data['september4thWeekSize'] }}</td>
                            <td *ngIf="this.sundays(today | date:'yyyy', 8) > 4" colspan="2">{{
                                data['september5thWeekSize'] }}</td>
                            <td colspan="2" rowspan="2">
                                <span *ngIf="this.sundays(today | date:'yyyy', 8) == 4">{{
                                    calculateTotalAmount(data['september1stWeekAmt'],data['september2ndWeekAmt'],data['september3rdWeekAmt'],data['september4thWeekAmt'])
                                    }}</span>
                                <span *ngIf="this.sundays(today | date:'yyyy', 8) == 5">{{
                                    calculateTotalAmount(data['september1stWeekAmt'],data['september2ndWeekAmt'],data['september3rdWeekAmt'],data['september4thWeekAmt'],data['september5thWeekAmt'])
                                    }}</span>
                            </td>
                            <td colspan="2">{{ data['october1stWeekSize'] }}</td>
                            <td colspan="2">{{ data['october2ndWeekSize'] }}</td>
                            <td colspan="2">{{ data['october3rdWeekSize'] }}</td>
                            <td colspan="2">{{ data['october4thWeekSize'] }}</td>
                            <td *ngIf="this.sundays(today | date:'yyyy', 9) > 4" colspan="2">{{
                                data['october5thWeekSize'] }}</td>
                            <td colspan="2" rowspan="2">
                                <span *ngIf="this.sundays(today | date:'yyyy', 9) == 4">{{
                                    calculateTotalAmount(data['october1stWeekAmt'],data['october2ndWeekAmt'],data['october3rdWeekAmt'],data['october4thWeekAmt'])
                                    }}</span>
                                <span *ngIf="this.sundays(today | date:'yyyy', 9) == 5">{{
                                    calculateTotalAmount(data['october1stWeekAmt'],data['october2ndWeekAmt'],data['october3rdWeekAmt'],data['october4thWeekAmt'],data['october5thWeekAmt'])
                                    }}</span>
                            </td>
                            <td colspan="2">{{ data['november1stWeekSize'] }}</td>
                            <td colspan="2">{{ data['november2ndWeekSize'] }}</td>
                            <td colspan="2">{{ data['november3rdWeekSize'] }}</td>
                            <td colspan="2">{{ data['november4thWeekSize'] }}</td>
                            <td *ngIf="this.sundays(today | date:'yyyy', 10) > 4" colspan="2">{{
                                data['november5thWeekSize'] }}</td>
                            <td colspan="2" rowspan="2">
                                <span *ngIf="this.sundays(today | date:'yyyy', 10) == 4">{{
                                    calculateTotalAmount(data['november1stWeekAmt'],data['november2ndWeekAmt'],data['november3rdWeekAmt'],data['november4thWeekAmt'])
                                    }}</span>
                                <span *ngIf="this.sundays(today | date:'yyyy', 10) == 5">{{
                                    calculateTotalAmount(data['november1stWeekAmt'],data['november2ndWeekAmt'],data['november3rdWeekAmt'],data['november4thWeekAmt'],data['november5thWeekAmt'])
                                    }}</span>
                            </td>
                            <td colspan="2">{{ data['december1stWeekSize'] }}</td>
                            <td colspan="2">{{ data['december2ndWeekSize'] }}</td>
                            <td colspan="2">{{ data['december3rdWeekSize'] }}</td>
                            <td colspan="2">{{ data['december4thWeekSize'] }}</td>
                            <td *ngIf="this.sundays(today | date:'yyyy', 11) > 4" colspan="2">{{
                                data['december5thWeekSize'] }}</td>
                            <td colspan="2" rowspan="2">
                                <span *ngIf="this.sundays(today | date:'yyyy', 11) == 4">{{
                                    calculateTotalAmount(data['december1stWeekAmt'],data['december2ndWeekAmt'],data['december3rdWeekAmt'],data['december4thWeekAmt'])
                                    }}</span>
                                <span *ngIf="this.sundays(today | date:'yyyy', 11) == 5">{{
                                    calculateTotalAmount(data['december1stWeekAmt'],data['december2ndWeekAmt'],data['december3rdWeekAmt'],data['december4thWeekAmt'],data['december5thWeekAmt'])
                                    }}</span>
                            </td>
                            <td colspan="2">{{ data['january1stWeekSize'] }}</td>
                            <td colspan="2">{{ data['january2ndWeekSize'] }}</td>
                            <td colspan="2">{{ data['january3rdWeekSize'] }}</td>
                            <td colspan="2">{{ data['january4thWeekSize'] }}</td>
                            <td *ngIf="this.sundays(nexttoday | date:'yyyy', 0) > 4" colspan="2">{{
                                data['january5thWeekSize'] }}</td>
                            <td colspan="2" rowspan="2">
                                <span *ngIf="this.sundays(today | date:'yyyy', 0) == 4">{{
                                    calculateTotalAmount(data['january1stWeekAmt'],data['january2ndWeekAmt'],data['january3rdWeekAmt'],data['january4thWeekAmt'])
                                    }}</span>
                                <span *ngIf="this.sundays(today | date:'yyyy', 0) == 5">{{
                                    calculateTotalAmount(data['january1stWeekAmt'],data['january2ndWeekAmt'],data['january3rdWeekAmt'],data['january4thWeekAmt'],data['january5thWeekAmt'])
                                    }}</span>
                            </td>
                            <td colspan="2">{{ data['feb1stWeekSize'] }}</td>
                            <td colspan="2">{{ data['feb2ndWeekSize'] }}</td>
                            <td colspan="2">{{ data['feb3rdWeekSize'] }}</td>
                            <td colspan="2">{{ data['feb4thWeekSize'] }}</td>
                            <td *ngIf="this.sundays(nexttoday | date:'yyyy', 1) > 4" colspan="2">{{
                                data['feb5thWeekSize'] }}</td>
                            <td colspan="2" rowspan="2">
                                <span *ngIf="this.sundays(today | date:'yyyy', 1) == 4">{{
                                    calculateTotalAmount(data['feb1stWeekAmt'],data['feb2ndWeekAmt'],data['feb3rdWeekAmt'],data['feb4thWeekAmt'])
                                    }}</span>
                                <span *ngIf="this.sundays(today | date:'yyyy', 1) == 5">{{
                                    calculateTotalAmount(data['feb1stWeekAmt'],data['feb2ndWeekAmt'],data['feb3rdWeekAmt'],data['feb4thWeekAmt'],data['feb5thWeekAmt'])
                                    }}</span>
                            </td>
                            <td colspan="2">{{ data['march1stWeekSize'] }}</td>
                            <td colspan="2">{{ data['march2ndWeekSize'] }}</td>
                            <td colspan="2">{{ data['march3rdWeekSize'] }}</td>
                            <td colspan="2">{{ data['march4thWeekSize'] }}</td>
                            <td *ngIf="this.sundays(nexttoday | date:'yyyy', 2) > 4" colspan="2">{{
                                data['march5thWeekSize'] }}</td>
                            <td colspan="2" rowspan="2">
                                <span *ngIf="this.sundays(today | date:'yyyy', 2) == 4">{{
                                    calculateTotalAmount(data['march1stWeekAmt'],data['march2ndWeekAmt'],data['march3rdWeekAmt'],data['march4thWeekAmt'])
                                    }}</span>
                                <span *ngIf="this.sundays(today | date:'yyyy', 2) == 5">{{
                                    calculateTotalAmount(data['march1stWeekAmt'],data['march2ndWeekAmt'],data['march3rdWeekAmt'],data['march4thWeekAmt'],data['march5thWeekAmt'])
                                    }}</span>
                            </td>
                            <td rowspan="2"></td>
                            <td rowspan="2"></td>
                            <td rowspan="2"></td>
                            <td rowspan="2"></td>
                        </tr>
                        <tr class="amount">
                            <td>{{ data['april1stWeekAmt'] }}</td>
                            <td>{{ data['april1stWeekPageNo'] }}</td>
                            <td>{{ data['april2ndWeekAmt'] }}</td>
                            <td>{{ data['april2ndWeekPageNo'] }}</td>
                            <td>{{ data['april3rdWeekAmt'] }}</td>
                            <td>{{ data['april3rdWeekPageNo'] }}</td>
                            <td>{{ data['april4thWeekAmt'] }}</td>
                            <td>{{ data['april4thWeekPageNo'] }}</td>
                            <td *ngIf="this.sundays(today | date:'yyyy', 3) > 4">{{ data['april5thWeekAmt'] }}</td>
                            <td *ngIf="this.sundays(today | date:'yyyy', 3) > 4">{{ data['april5thWeekPageNo'] }}</td>
                            <!-- <td></td>
                            <td></td> -->
                            <td>{{ data['may1stWeekAmt'] }}</td>
                            <td>{{ data['may1stWeekPageNo'] }}</td>
                            <td>{{ data['may2ndWeekAmt'] }}</td>
                            <td>{{ data['may2ndWeekPageNo'] }}</td>
                            <td>{{ data['may3rdWeekAmt'] }}</td>
                            <td>{{ data['may3rdWeekPageNo'] }}</td>
                            <td>{{ data['may4thWeekAmt'] }}</td>
                            <td>{{ data['may4thWeekPageNo'] }}</td>
                            <td *ngIf="this.sundays(today | date:'yyyy', 4) > 4">{{ data['may5thWeekAmt'] }}</td>
                            <td *ngIf="this.sundays(today | date:'yyyy', 4) > 4">{{ data['may5thWeekPageNo'] }}</td>
                            <!-- <td></td>
                            <td></td> -->
                            <td>{{ data['june1stWeekAmt'] }}</td>
                            <td>{{ data['june1stWeekPageNo'] }}</td>
                            <td>{{ data['june2ndWeekAmt'] }}</td>
                            <td>{{ data['june2ndWeekPageNo'] }}</td>
                            <td>{{ data['june3rdWeekAmt'] }}</td>
                            <td>{{ data['june3rdWeekPageNo'] }}</td>
                            <td>{{ data['june4thWeekAmt'] }}</td>
                            <td>{{ data['june4thWeekPageNo'] }}</td>
                            <td *ngIf="this.sundays(today | date:'yyyy', 5) > 4">{{ data['june5thWeekAmt'] }}</td>
                            <td *ngIf="this.sundays(today | date:'yyyy', 5) > 4">{{ data['june5thWeekPageNo'] }}</td>
                            <!-- <td></td>
                            <td></td> -->
                            <td>{{ data['july1stWeekAmt'] }}</td>
                            <td>{{ data['july1stWeekPageNo'] }}</td>
                            <td>{{ data['july2ndWeekAmt'] }}</td>
                            <td>{{ data['july2ndWeekPageNo'] }}</td>
                            <td>{{ data['july3rdWeekAmt'] }}</td>
                            <td>{{ data['july3rdWeekPageNo'] }}</td>
                            <td>{{ data['july4thWeekAmt'] }}</td>
                            <td>{{ data['july4thWeekPageNo'] }}</td>
                            <td *ngIf="this.sundays(today | date:'yyyy', 6) > 4">{{ data['july5thWeekAmt'] }}</td>
                            <td *ngIf="this.sundays(today | date:'yyyy', 6) > 4">{{ data['july5thWeekPageNo'] }}</td>
                            <!-- <td></td>
                            <td></td> -->
                            <td>{{ data['august1stWeekAmt'] }}</td>
                            <td>{{ data['august1stWeekPageNo'] }}</td>
                            <td>{{ data['august2ndWeekAmt'] }}</td>
                            <td>{{ data['august2ndWeekPageNo'] }}</td>
                            <td>{{ data['august3rdWeekAmt'] }}</td>
                            <td>{{ data['august3rdWeekPageNo'] }}</td>
                            <td>{{ data['august4thWeekAmt'] }}</td>
                            <td>{{ data['august4thWeekPageNo'] }}</td>
                            <td *ngIf="this.sundays(today | date:'yyyy', 7) > 4">{{ data['august5thWeekAmt'] }}</td>
                            <td *ngIf="this.sundays(today | date:'yyyy', 7) > 4">{{ data['august5thWeekPageNo'] }}</td>
                            <!-- <td></td>
                            <td></td> -->
                            <td>{{ data['september1stWeekAmt'] }}</td>
                            <td>{{ data['september1stWeekPageNo'] }}</td>
                            <td>{{ data['september2ndWeekAmt'] }}</td>
                            <td>{{ data['september2ndWeekPageNo'] }}</td>
                            <td>{{ data['september3rdWeekAmt'] }}</td>
                            <td>{{ data['september3rdWeekPageNo'] }}</td>
                            <td>{{ data['september4thWeekAmt'] }}</td>
                            <td>{{ data['september4thWeekPageNo'] }}</td>
                            <td *ngIf="this.sundays(today | date:'yyyy', 8) > 4">{{ data['september5thWeekAmt'] }}</td>
                            <td *ngIf="this.sundays(today | date:'yyyy', 8) > 4">{{ data['september5thWeekPageNo'] }}
                            </td>
                            <!-- <td></td>
                            <td></td> -->
                            <td>{{ data['october1stWeekAmt'] }}</td>
                            <td>{{ data['october1stWeekPageNo'] }}</td>
                            <td>{{ data['october2ndWeekAmt'] }}</td>
                            <td>{{ data['october2ndWeekPageNo'] }}</td>
                            <td>{{ data['october3rdWeekAmt'] }}</td>
                            <td>{{ data['october3rdWeekPageNo'] }}</td>
                            <td>{{ data['october4thWeekAmt'] }}</td>
                            <td>{{ data['october4thWeekPageNo'] }}</td>
                            <td *ngIf="this.sundays(today | date:'yyyy', 9) > 4">{{ data['october5thWeekAmt'] }}</td>
                            <td *ngIf="this.sundays(today | date:'yyyy', 9) > 4">{{ data['october5thWeekPageNo'] }}</td>
                            <!-- <td></td>
                            <td></td> -->
                            <td>{{ data['november1stWeekAmt'] }}</td>
                            <td>{{ data['november1stWeekPageNo'] }}</td>
                            <td>{{ data['november2ndWeekAmt'] }}</td>
                            <td>{{ data['november2ndWeekPageNo'] }}</td>
                            <td>{{ data['november3rdWeekAmt'] }}</td>
                            <td>{{ data['november3rdWeekPageNo'] }}</td>
                            <td>{{ data['november4thWeekAmt'] }}</td>
                            <td>{{ data['november4thWeekPageNo'] }}</td>
                            <td *ngIf="this.sundays(today | date:'yyyy', 10) > 4">{{ data['november5thWeekAmt'] }}</td>
                            <td *ngIf="this.sundays(today | date:'yyyy', 10) > 4">{{ data['november5thWeekPageNo'] }}
                            </td>
                            <!-- <td></td>
                            <td></td> -->
                            <td>{{ data['december1stWeekAmt'] }}</td>
                            <td>{{ data['december1stWeekPageNo'] }}</td>
                            <td>{{ data['december2ndWeekAmt'] }}</td>
                            <td>{{ data['december2ndWeekPageNo'] }}</td>
                            <td>{{ data['december3rdWeekAmt'] }}</td>
                            <td>{{ data['december3rdWeekPageNo'] }}</td>
                            <td>{{ data['december4thWeekAmt'] }}</td>
                            <td>{{ data['december4thWeekPageNo'] }}</td>
                            <td *ngIf="this.sundays(today | date:'yyyy', 11) > 4">{{ data['december5thWeekAmt'] }}</td>
                            <td *ngIf="this.sundays(today | date:'yyyy', 11) > 4">{{ data['december5thWeekPageNo'] }}
                            </td>
                            <!-- <td></td>
                            <td></td> -->
                            <td>{{ data['january1stWeekAmt'] }}</td>
                            <td>{{ data['january1stWeekPageNo'] }}</td>
                            <td>{{ data['january2ndWeekAmt'] }}</td>
                            <td>{{ data['january2ndWeekPageNo'] }}</td>
                            <td>{{ data['january3rdWeekAmt'] }}</td>
                            <td>{{ data['january3rdWeekPageNo'] }}</td>
                            <td>{{ data['january4thWeekAmt'] }}</td>
                            <td>{{ data['january4thWeekPageNo'] }}</td>
                            <td *ngIf="this.sundays(nexttoday | date:'yyyy', 0) > 4">{{ data['january5thWeekAmt'] }}
                            </td>
                            <td *ngIf="this.sundays(nexttoday | date:'yyyy', 0) > 4">{{ data['january5thWeekPageNo'] }}
                            </td>
                            <!-- <td></td>
                            <td></td> -->
                            <td>{{ data['feb1stWeekAmt'] }}</td>
                            <td>{{ data['feb1stWeekPageNo'] }}</td>
                            <td>{{ data['feb2ndWeekAmt'] }}</td>
                            <td>{{ data['feb2ndWeekPageNo'] }}</td>
                            <td>{{ data['feb3rdWeekAmt'] }}</td>
                            <td>{{ data['feb3rdWeekPageNo'] }}</td>
                            <td>{{ data['feb4thWeekAmt'] }}</td>
                            <td>{{ data['feb4thWeekPageNo'] }}</td>
                            <td *ngIf="this.sundays(nexttoday | date:'yyyy', 1) > 4">{{ data['feb5thWeekAmt'] }}</td>
                            <td *ngIf="this.sundays(nexttoday | date:'yyyy', 1) > 4">{{ data['feb5thWeekPageNo'] }}</td>
                            <!-- <td></td>
                            <td></td> -->
                            <td>{{ data['march1stWeekAmt'] }}</td>
                            <td>{{ data['march1stWeekPageNo'] }}</td>
                            <td>{{ data['march2ndWeekAmt'] }}</td>
                            <td>{{ data['march2ndWeekPageNo'] }}</td>
                            <td>{{ data['march3rdWeekAmt'] }}</td>
                            <td>{{ data['march3rdWeekPageNo'] }}</td>
                            <td>{{ data['march4thWeekAmt'] }}</td>
                            <td>{{ data['march4thWeekPageNo'] }}</td>
                            <td *ngIf="this.sundays(nexttoday | date:'yyyy', 2) > 4">{{ data['march5thWeekAmt'] }}</td>
                            <td *ngIf="this.sundays(nexttoday | date:'yyyy', 2) > 4">{{ data['march5thWeekPageNo'] }}
                            </td>
                            <!-- <td></td>
                            <td></td> -->
                        </tr>
                    </ng-container>
                    <tr>
                        <td></td>
                        <td style="font-weight: 600;">{{ item['name'] }} - एकूण</td>
                        <td></td>
                        <td></td>
                        <td>{{ item['contract_prev_bal'] }}</td>
                        <!-- <td>{{ item['remaining_contract'] }}</td> -->
                        <td></td>
                        <td>{{ item['contract_amt'] }}</td>
                        <td>{{ item['contract_discnt_amt'] }}</td>
                        <td>{{ item['contract_net_amt'] }}</td>
                        <td>{{ item['contract_net_gst_amt'] }}</td>
                        <td>{{ item['contract_net_total'] }}</td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td *ngIf="this.sundays(today | date:'yyyy', 3) > 4" colspan="2"></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td *ngIf="this.sundays(today | date:'yyyy', 4) > 4" colspan="2"></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td *ngIf="this.sundays(today | date:'yyyy', 5) > 4" colspan="2"></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td *ngIf="this.sundays(today | date:'yyyy', 6) > 4" colspan="2"></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td *ngIf="this.sundays(today | date:'yyyy', 7) > 4" colspan="2"></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td *ngIf="this.sundays(today | date:'yyyy', 8) > 4" colspan="2"></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td *ngIf="this.sundays(today | date:'yyyy', 9) > 4" colspan="2"></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td *ngIf="this.sundays(today | date:'yyyy', 10) > 4" colspan="2"></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td *ngIf="this.sundays(today | date:'yyyy', 11) > 4" colspan="2"></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td *ngIf="this.sundays(nexttoday | date:'yyyy', 0) > 4" colspan="2"></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td *ngIf="this.sundays(nexttoday | date:'yyyy', 1) > 4" colspan="2"></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td colspan="2"></td>
                        <td *ngIf="this.sundays(nexttoday | date:'yyyy', 2) > 4" colspan="2"></td>
                        <td colspan="2"></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                </ng-container>
                <!-- <tr>
                    <td></td>
                    <td>एकूण</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr> -->
                <!-- <tr>
                    <td></td>
                    <td>एकूण</td>
                    <td></td>
                    <td></td>
                    <td>{{ totalData['contract_prev_bal'] }}</td>
                    <td>{{ totalData['remaining_contract'] }}</td>
                    <td>{{ totalData['contract_amt'] }}</td>
                    <td>{{ totalData['contract_discnt_amt'] }}</td>
                    <td>{{ totalData['contract_net_amt'] }}</td>
                    <td>{{ totalData['contract_net_gst_amt'] }}</td>
                    <td>{{ totalData['contract_net_total'] }}</td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2" *ngIf="this.sundays(today | date:'yyyy', 3) > 4"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2" *ngIf="this.sundays(today | date:'yyyy', 4) > 4"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2" *ngIf="this.sundays(today | date:'yyyy', 5) > 4"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2" *ngIf="this.sundays(today | date:'yyyy', 6) > 4"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2" *ngIf="this.sundays(today | date:'yyyy', 7) > 4"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2" *ngIf="this.sundays(today | date:'yyyy', 8) > 4"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2" *ngIf="this.sundays(today | date:'yyyy', 9) > 4"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2" *ngIf="this.sundays(today | date:'yyyy', 10) > 4"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2" *ngIf="this.sundays(today | date:'yyyy', 11) > 4"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2" *ngIf="this.sundays(nexttoday | date:'yyyy', 0) > 4"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2" *ngIf="this.sundays(nexttoday | date:'yyyy', 1) > 4"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="2" *ngIf="this.sundays(nexttoday | date:'yyyy', 2) > 4"></td>
                    <td colspan="2"></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr> -->
            </tbody>
            <!-- <tfoot>
                <tr>
                    <td></td>
                    <td>एकूण</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
            </tfoot> -->
        </table>
        <!-- </div> -->
    </div>
</div>

<!-- 
<div *ngIf="reportType == 'unpaidOutstandingVbriefly'">
    
    <div class="container" id="print-section">
        <table class="table table-bordered">
            <thead>
                <tr>
                    <th colspan="3" style="font-size: medium;font-weight: bold;" class="br-bottom br-right br-top">हिंदुस्तान प्रकाशन संस्था - विवेक साप्ताहिक</th>
                    <th colspan="2" style="font-size: medium;font-weight: bold;" class="br-bottom br-right br-top">Advt. Outstanding Report</th>
                    <th colspan="2" style="font-size: medium;font-weight: bold;" class="br-bottom br-right br-top">दिनांक {{ currentDate | date: 'dd-MM-yyyy' }}  </th>
                    <th colspan="1" style="font-size: medium;font-weight: bold;" class="br-bottom br-right br-top">पृष्ठ क्र</th>
                </tr>
                <tr>
                    <th colspan="3" style="font-size: medium;font-weight: bold;" class="br-bottom br-right br-top" >अंकाचे नाव</th>
                    <th colspan="2" style="font-size: medium;font-weight: bold;" class="br-bottom br-right br-top">From  {{startDate | date: 'dd-MM-yyyy' }}</th>
                    <th colspan="2" style="font-size: medium;font-weight: bold;" class="br-bottom br-right br-top">To {{endDate | date: 'dd-MM-yyyy' }}</th>
                    <th colspan="1" style="font-size: medium;font-weight: bold;" class="br-bottom br-right br-top">Very Brief</th>
                </tr>
                <tr>
                    <th colspan="2" style="font-size: medium;font-weight: bold;" class="br-bottom br-right br-top">Representative Name</th>
                    <th colspan="1" style="font-size: medium;font-weight: bold;text-align: center;" class="br-bottom br-right br-top">Advt Name</th>
                    <th colspan="2" style="font-size: medium;font-weight: bold;text-align: end;" class="br-bottom br-right br-top">Advt Amount </th>
                    <th colspan="2" style="font-size: medium;font-weight: bold;text-align: end;" class="br-bottom br-right br-top">Net Amount</th>
                    <th colspan="1" style="font-size: medium;font-weight: bold;text-align: end;" class="br-bottom br-right br-top">Unpaid Amount</th>
                </tr>
            </thead>
            <tbody *ngFor="let data of onlyOutstandingVB; let i = index">
                <tr>
                    <td colspan="3" style="font-weight: bold; font-size: medium;" class="br-bottom br-right br-top">{{data.off_rep_name}} / {{data.office_rep_mob}}</td>
                    <td colspan="5" class="br-bottom br-right br-top"></td>
                </tr>
                <tr *ngFor="let data1 of data.rep_data; let i = index">
                    <td colspan="2" style="font-size:medium;font-weight: bold;" class="br-bottom br-right br-top">{{data1.rep_name}}</td>
                    <td colspan="2" style="font-size:medium;font-weight: bold;" class="br-bottom br-right br-top">{{data1.advt_name | slice: 0:30 }}</td>
                    <td colspan="1" style="text-align: end; font-size: medium; font-weight: bold;" class="br-bottom br-right br-top">{{data1.contract_bkng_advt_amt}}</td>
                    <td colspan="2" style="text-align: end; font-weight: bold;font-size: medium;" class="br-bottom br-right br-top">{{data1.contract_net_total}} </td>
                    <td colspan="1" style="text-align: end; font-weight: bold;font-size: medium;" class="br-bottom br-right br-top">{{data1.contract_bal_amt | number: '1.2-2' }} </td> 
                </tr>
                <tr>
                    <td colspan="3" style="font-weight: bold; font-size: 15px; font-weight: bold;" class="br-bottom br-right br-top">Total {{data.off_rep_name}}:</td>
                    <td colspan="2" style="font-weight: bold; font-size: 15px;font-weight: bold; text-align: right;" class="br-bottom br-right br-top">{{data.adv_total}}</td>
                    <td colspan="2" style="font-weight: bold; font-size: 15px;font-weight: bold; text-align: right;" class="br-bottom br-right br-top">{{data.net_total}}</td>
                    <td colspan="1" style="font-weight: bold; font-size: 15px;font-weight: bold; text-align: right;" class="br-bottom br-right br-top">{{data.bal_total}}</td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td colspan="3" style="font-weight: bold; font-size: 15px;" class="br-bottom br-right br-top">Total:</td>
                    <td colspan="2" style="font-weight: bold; font-size: 15px; text-align: end;" class="br-bottom br-right br-top">Rs-{{ onlytotalAdvtAmount | number: '1.2-2'  }}</td>
                    <td colspan="2" style="font-weight: bold; font-size: 15px; text-align: end;" class="br-bottom br-right br-top">Rs-{{ onlytotalNetAmount | number: '1.2-2'  }}</td>
                    <td colspan="1" style="font-weight: bold; font-size: 15px; text-align: end;" class="br-bottom br-right br-top">Rs-{{ onlytotalUnpaidAmount | number: '1.2-2'   }}</td>
                </tr>
            </tfoot>  
        </table>
       
    </div>
    <div style="margin-left: 80%; margin-bottom: 2%;">
        <button class="noPrint" style="margin-top: 2%; margin-left: 2%"
            (click)="exportExcel('Contract_InDetails_Report')" mat-raised-button color="primary">
            Export
        </button>

        <button id="print-button" class="noPrint" style="margin-top: 2%; margin-left: 2%; display: none; " mat-raised-button color="primary"
        printSectionId="print-section" [useExistingCss]="true" ngxPrint>
      Print
      </button>

      <button (click)="print()" class="noPrint" style="margin-top: 2%; margin-left: 2%" mat-raised-button color="primary">
    Print
    </button>     
        
        <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>
            Close
        </button>
    </div>
</div> -->



<div *ngIf="reportType == 'creditOutstandingbriefly'">

    <div class="container" id="print-section">
        <table class="table table-bordered">
            <thead>
                <tr>
                    <th colspan="4" style="font-weight: bold; font-size: medium;" class="br-bottom fs-15 br-right">
                        हिंदुस्तान प्रकाशन संस्था </th>
                    <th colspan="3" style="font-weight: bold; font-size: medium;" class="br-bottom fs-15 br-right">Advt.
                        Outstanding Report</th>
                    <th colspan="2" style="font-weight: bold; font-size: small;" class="br-bottom fs-15 br-right">दिनांक
                        {{ currentDate | date: 'dd-MM-yyyy' }}</th>
                    <!-- <th colspan="1" style="font-weight: bold; font-size: small;" class="br-bottom fs-15">पृष्ठ क्र</th> -->
                </tr>
                <tr>
                    <th colspan="2" style="font-weight: bold; font-size: small;" class="br-bottom fs-15 br-right">अंकाचे
                        नाव - विवेक साप्ताहिक </th>
                    <th colspan="1" style="font-weight: bold; font-size: small;" class="br-bottom fs-15 br-right">Date
                    </th>
                    <th colspan="2" style="font-weight: bold; font-size: small;" class="br-bottom fs-15 br-right">From
                        {{startDate | date: 'dd-MM-yyyy'}} - To {{endDate | date: 'dd-MM-yyyy'}}</th>
                    <th colspan="2" style="font-weight: bold; font-size: small;" class="br-bottom fs-15 br-right">
                        Outstanding List</th>
                    <th colspan="2" style="font-weight: bold; font-size: small;" class="br-bottom fs-15">Brief</th>
                </tr>
                <tr>
                    <th colspan="2" style="font-weight: bold; font-size: small;" class="br-bottom br-right">Advt Name
                    </th>
                    <th colspan="3" style="font-weight: bold; font-size: small;" class="br-bottom br-right">
                        Representative Name</th>
                    <th colspan="1" style="font-weight: bold; font-size: small;" class="br-bottom br-right">Contact No
                    </th>
                    <th colspan="1" style="font-weight: bold; font-size: small;" class="br-bottom br-right">Advt Amount
                    </th>
                    <th colspan="1" style="font-weight: bold; font-size: small;" class="br-bottom br-right">Net Amount
                    </th>
                    <th colspan="1" style="font-weight: bold; font-size: small;" class="br-bottom">Unpaid Amount</th>
                </tr>
            </thead>

            <tbody *ngFor="let data of creditoutstandongbrief; let i = index">

                <tr>
                    <td colspan="2" class="br-bottom br-right" style="font-weight: bold; font-size: small;">Office
                        Representative Name</td>
                    <td colspan="4" class="br-bottom br-right" style="font-weight: bold; font-size: small;">
                        {{data.off_rep_name}} / {{data.office_rep_mob}}</td>
                    <!-- <td colspan="1" class="br-bottom br-right" style="font-weight: bold; font-size: small;">{{data.office_rep_mob}}</td> -->
                    <td colspan="3" class="br-bottom br-right"></td> <!-- Empty columns to maintain row structure -->
                </tr>

                <tr *ngFor="let data1 of data.rep_data; let j = index">
                    <td colspan="2" class="br-bottom br-right" style="font-weight: bold; font-size: small;">
                        {{data1.advt_name}}</td>
                    <td colspan="3" class="br-bottom br-right" style="font-weight: bold; font-size: small;">
                        {{data1.rep_name}}</td>
                    <td colspan="1" class="br-bottom br-right" style="font-weight: bold; font-size: small;">
                        {{data1.rep_mob}}</td>
                    <td colspan="1" class="br-bottom br-right"
                        style="font-weight: bold; font-size: small; text-align: end;">{{data1.contract_bkng_advt_amt}}
                    </td>
                    <td colspan="1" class="br-bottom br-right"
                        style="font-weight: bold; font-size: small; text-align: end;">{{data1.contract_net_total}}</td>
                    <td colspan="1" class="br-bottom" style="font-weight: bold; font-size: small; text-align: end;">
                        {{data1.contract_bal_amt}}</td>
                </tr>

                <tr>
                    <td colspan="5" class="br-bottom br-right" style="font-weight: bold; font-size: 15px;">Total for
                        {{data.off_rep_name}}:</td>
                    <td colspan="1" class="br-bottom br-right"></td>
                    <td colspan="1" class="br-bottom br-right"
                        style="font-weight: bold; font-size: 15px; text-align: end;">{{data.adv_total}}</td>
                    <td colspan="1" class="br-bottom br-right"
                        style="font-weight: bold; font-size: 15px; text-align: end;">{{data.net_total}}</td>
                    <td colspan="1" class="br-bottom" style="font-weight: bold; font-size: 15px; text-align: end;">
                        {{data.bal_total}}</td>
                </tr>
            </tbody>

            <tfoot>
                <tr>
                    <td colspan="5" class="br-bottom br-right" style="font-weight: bold; font-size: 15px;">Grand Total:
                    </td>
                    <td colspan="1" class="br-bottom br-right"></td>
                    <td colspan="1" class="br-bottom br-right"
                        style="font-weight: bold; font-size: 15px; text-align: end;">Rs-{{ creditlastonlytotalAdvtAmount
                        }}</td>
                    <td colspan="1" class="br-bottom br-right"
                        style="font-weight: bold; font-size: 15px; text-align: end;">Rs-{{ creditlastonlytotalNetAmount
                        }}</td>
                    <td colspan="1" class="br-bottom" style="font-weight: bold; font-size: 15px; text-align: end;">Rs-{{
                        creditlastonlytotalUnpaidAmount }}</td>
                </tr>
            </tfoot>
        </table>
    </div>

    <div style="margin-left: 80%; margin-bottom: 2%;">
        <button class="noPrint" style="margin-top: 2%; margin-left: 2%"
            (click)="exportExcel('Contract_InDetails_Report')" mat-raised-button color="primary">Export</button>
        <button id="print-button" class="noPrint" style="margin-top: 2%; margin-left: 2%; display: none; "
            mat-raised-button color="primary" printSectionId="print-section" [useExistingCss]="true" ngxPrint>
            Print
        </button>

        <button (click)="print()" class="noPrint" style="margin-top: 2%; margin-left: 2%" mat-raised-button
            color="primary">
            Print
        </button>
        <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>Close</button>
    </div>

</div>


<!-- OutStanding GST Register  -->
<div *ngIf="reportType == 'GSTFullReport'">

    <div class="container-fluid" id="print-section" style="margin-top:50px; margin-right: 10px;overflow: auto;">
        <table class="table table-bordered">
            <thead>
                <tr>
                    <th colspan="4" style="border:none" class="br-bottom br-right br-top">Hindustan - Vivek Saptahik
                    </th>
                    <th colspan="9" style="border:none" class="br-bottom br-right br-top">Advt. GST Register</th>
                    <th colspan="3" style="border:none" class="br-bottom br-right br-top">Date : From {{startDate}} To
                        {{endDate}}</th>
                    <th colspan="2" style="border:none" class="br-bottom br-right br-top">Date : </th>
                    <th colspan="1" style="border:none" class="br-bottom br-top">Page No : </th>
                </tr>

                <tr>
                    <th colspan="1" style="border:none" class="br-bottom br-right">Invoice Date</th>
                    <th colspan="1" style="border:none" class="br-bottom br-right">Invoice No</th>
                    <th colspan="2" style="border:none" class="br-bottom br-right">Advt Name </th>
                    <th colspan="2" style="border:none" class="br-bottom br-right">Advt English Name </th>
                    <th colspan="1" style="border:none" class="br-bottom br-right">District</th>
                    <th colspan="1" style="border:none" class="br-bottom br-right">GST No</th>
                    <th colspan="1" style="border:none" class="br-bottom br-right">HSN No</th>
                    <th colspan="1" style="border:none" class="br-bottom br-right">Advt Size</th>
                    <!-- <th colspan="1" style="border:none" class="br-bottom br-right">Advt Amount</th> -->
                    <!-- <th colspan="1" style="border:none" class="br-bottom br-right">Discount</th> -->
                    <th colspan="1" style="border:none" class="br-bottom br-right">Advt Net Amt</th>
                    <th colspan="1" style="border:none" class="br-bottom br-right">CGST Rate</th>
                    <th colspan="1" style="border:none" class="br-bottom br-right">CGST Amt</th>
                    <th colspan="1" style="border:none" class="br-bottom br-right">SGST Rate</th>
                    <th colspan="1" style="border:none" class="br-bottom br-right">SGST Amt</th>
                    <th colspan="1" style="border:none" class="br-bottom br-right">IGST Rate</th>
                    <th colspan="1" style="border:none" class="br-bottom br-right">IGST Amount</th>
                    <th colspan="1" style="border:none" class="br-bottom br-right">Roundup Amt</th>
                    <th colspan="1" style="border:none" class="br-bottom">GST Amt</th>
                </tr>
            </thead>
            <!-- *ngFor="let data of OutstandingInDetailFormBeans; let i = index" -->
            <tbody *ngFor="let data of GSTfullreportFormBeans; let i = index">

                <tr>
                    <td colspan="1" style="border:none" class="br-right">{{data.invoice_date}}</td>
                    <td colspan="1" style="border:none" class="br-right">{{data.invoice_no}}</td>
                    <td colspan="2" style="border:none" class="br-right">{{data.advt_name}} </td>
                    <td colspan="2" style="border:none" class="br-right">{{data.eng_advt_name}} </td>
                    <td colspan="1" style="border:none" class="br-right">{{data.eng_district}}</td>
                    <td colspan="1" style="border:none" class="br-right">{{data.gst_no}}</td>
                    <td colspan="1" style="border:none" class="br-right">998363</td>
                    <td colspan="1" style="border:none" class="br-right">{{data.advt_size}}</td>
                    <!-- <td colspan="1" style="border:none;text-align: end;"class="br-right">{{data.adv_amt}}</td> -->
                    <!-- <td colspan="1" style="border:none;text-align: end;"class="br-right">{{data.advt_discount}}</td> -->
                    <td colspan="1" style="border:none;text-align: end;" class="br-right">{{data.before_gst_amt}}</td>
                    <td colspan="1" style="border:none;text-align: end;" class="br-right">{{data.cgst_rate}}%</td>
                    <td colspan="1" style="border:none;text-align: end;" class="br-right">{{data.cgst}}</td>
                    <td colspan="1" style="border:none;text-align: end;" class="br-right">{{data.sgst_rate}}%</td>
                    <td colspan="1" style="border:none;text-align: end;" class="br-right">{{data.sgst}}</td>
                    <td colspan="1" style="border:none;text-align: end;" class="br-right">{{data.igst_rate}}%</td>
                    <td colspan="1" style="border:none;text-align: end;" class="br-right">{{data.igst}}</td>
                    <td colspan="1" style="border:none;text-align: end;" class="br-right">{{data.round_up_amt}}</td>
                    <td colspan="1" style="border:none;text-align: end;" class="">{{data.gst_amount}}</td>
                </tr>

            </tbody>

            <tfoot>
                <tr>
                    <td colspan="10" style="border:none;" class="br-bottom br-top br-right ">Total-</td>
                    <td colspan="1" style="border:none; text-align: end;" class="br-bottom br-top br-right text-end">
                        {{beforegstamt}}</td>

                    <!-- <td colspan="1"></td> -->
                    <!-- <td colspan="1" style="border:none; text-align: end;" class="br-bottom br-top br-right">{{GSTDiscount}}</td> -->
                    <!-- <td colspan="1" style="border:none; text-align: end;" class="br-bottom br-top br-right">{{GSTNetAdvtAmt}}</td> -->
                    <td colspan="1" style="border:none; text-align: end;" class="br-bottom br-top br-right"></td>
                    <td colspan="1" style="border:none; text-align: end;" class="br-bottom br-top br-right">
                        {{CGSTAmount}}</td>
                    <td colspan="1" style="border:none; text-align: end;" class="br-bottom br-top br-right"></td>
                    <td colspan="1" style="border:none; text-align: end;" class="br-bottom br-top br-right">
                        {{SGSTAmount}}</td>
                    <td colspan="1" style="border:none; text-align: end;" class="br-bottom br-top br-right"></td>
                    <td colspan="1" style="border:none; text-align: end;" class="br-bottom br-top br-right">
                        {{IGSTAmount}}</td>
                    <!-- <td colspan="1" style="border:none; text-align: end;" class="br-bottom br-top br-right">0</td> -->
                    <td colspan="1" style="border:none; text-align: end;" class="br-bottom br-top br-right">0</td>
                    <td colspan="1" style="border:none; text-align: end;" class="br-bottom br-top">{{AllGSTAmount}}</td>
                </tr>

            </tfoot>
        </table>

    </div>

    <div style="margin-left: 80%; margin-bottom: 2%; margin-top: 5%;">
        <!-- <button class="noPrint" style="margin-top: 2%;" mat-raised-button color="primary"
            [printStyle]="{table : {'border-collapse':'collapse'}, td : {'border': 'solid 1px'}, th : {'border': 'solid 1px'}}"
            printSectionId="print-section2" ngxPrint>
            print
        </button> -->
        <button class="noPrint" style="margin-top: 2%; margin-left: 2%"
            (click)="exportExcel('Contract_InDetails_Report')" mat-raised-button color="primary">
            Export
        </button>

        <button class="noPrint" style="margin-top: 2%;" mat-raised-button color="primary" [useExistingCss]="true"
            printSectionId="print-section" ngxPrint>
            print
        </button>

        <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>
            Close
        </button>
    </div>
</div>

<!-- Commission Report -->



<!-- Personal Ledger -->
<!-- <div *ngIf="reportType == 'InDetail-personalledger'">
    <div class="container" id="print-section" style="margin-top: 50px;">
        <table class="table table-bordered" style="border-color: #ccc;">
            <thead>
                <tr>
                    <th colspan="2" class="br-bottom br-right" style="border: 1px solid #ccc; font-size: large;">
                        हिंदुस्तान प्रकाशन संस्था - विवेक साप्ताहिक
                    </th>
                    <th colspan="3" class="br-bottom br-right" style="border: 1px solid #ccc; font-size: medium;">
                        Advertiser Personal Ledger - In Details
                    </th>
                    <th colspan="1" class="br-bottom br-right" style="border: 1px solid #ccc;">
                        Date: From {{ startDate | date: 'dd-MM-yyyy' }} - To {{ endDate | date: 'dd-MM-yyyy' }}
                    </th>
                    <th colspan="2" class="br-bottom br-right" style="border: 1px solid #ccc;">
                        दिनांक {{ currentDate | date: 'dd-MM-yyyy' }}
                    </th>
                    <th colspan="1" class="br-bottom" style="border: 1px solid #ccc;">पृष्ठ क्र</th>
                </tr>

                <tr>
                    <th colspan="4" class="br-bottom br-right" style="border: 1px solid #ccc; font-weight: bolder; text-align: center; font-size: large;">
                        डेबिट
                    </th>
                    <th colspan="8" class="br-bottom br-right" style="border: 1px solid #ccc; font-weight: bolder; text-align: center; font-size: large;">
                        क्रेडिट
                    </th>
                </tr>

                <tr>
                    <th class="br-bottom br-right" style="border: 1px solid #ccc;">Invoice No</th>
                    <th class="br-bottom br-right" style="border: 1px solid #ccc;">Invoice Date</th>
                    <th class="br-bottom br-right" style="border: 1px solid #ccc;">Issue Name</th>
                    <th class="br-bottom br-right" style="border: 1px solid #ccc;">Invoice Amount</th>
                    <th class="br-bottom br-right" style="border: 1px solid #ccc;">Receipt No</th>
                    <th class="br-bottom br-right" style="border: 1px solid #ccc;">Receipt Date</th>
                    <th class="br-bottom br-right" style="border: 1px solid #ccc;">Credit Voucher</th>
                    <th class="br-bottom br-right" style="border: 1px solid #ccc;">Bank Details</th>
                    <th class="br-bottom br-right" style="border: 1px solid #ccc;">Invoice Number</th>
                    <th class="br-bottom br-right" style="border: 1px solid #ccc;">Received Amount</th>
                    <th class="br-bottom" style="border: 1px solid #ccc;">Balance</th>
                </tr>
            </thead>

            <tbody *ngFor="let data of getpersonalleddata; let i = index">
                <tr>
                    <td colspan="11" style="font-size: 13px; border: none; text-align: left;">
                        Advertiser Name: <span>{{ data.advt_name }}</span>
                    </td>
                </tr>

                <tr>
                    <td colspan="3" class="br-bottom br-right br-top" style="border: 1px solid #ccc;">
                        Opening Balance
                    </td>
                    <td colspan="1" class="br-bottom br-right br-top" style="border: 1px solid #ccc; text-align: end;">
                        {{ data.opening_bal }}
                    </td>
                    <td colspan="7" class="br-bottom br-top" style="border: 1px solid #ccc; text-align: end;">
                        {{ data.opening_bal }} येणे
                    </td>
                </tr>

                <tr *ngFor="let data1 of data.rep_data; let k = index">
                    <td class="br-right" style="border: 1px solid #ccc;">{{ data1.invoice_no }}</td>
                    <td class="br-right" style="border: 1px solid #ccc;">{{ data1.invoice_date }}</td>
                    <td class="br-right" style="border: 1px solid #ccc;">{{ data1.issue_name }}</td>
                    <td class="br-right" style="text-align: end; border: 1px solid #ccc;">{{ data1.net_amt }}</td>
                    <td class="br-right" style="border: 1px solid #ccc;">{{ data1.rcpt_no }} <br> {{ data1.credit_voc }}</td>
                    <td class="br-right" style="text-align: center; border: 1px solid #ccc;">{{ data1.rcpt_date }}<br>{{ data1.voc_date }}</td>
                    <td class="br-right" style="text-align: end; border: 1px solid #ccc;">{{ data1.voucher_no }}</td>
                    <td class="br-right" style="border: 1px solid #ccc;">
                        <ng-container *ngIf="data1.cheque_no || data1.pymt_options">
                            Cheque No: {{ data1.cheque_no }}, Pay. Mode: {{ data1.pymt_options }}
                        </ng-container>
                    </td>
                    <td class="br-right" style="border: 1px solid #ccc;">{{ data1.invoice_num }}</td>
                    <td class="br-right" style="text-align: end; border: 1px solid #ccc;">{{ data1.actual_arc_amt }} <br> {{ data1.credit_amt }}</td>
                    <td class="br-bottom" style="text-align: end; vertical-align: bottom; border: 1px solid #ccc;">
                        <ng-container *ngIf="data1.act_amt != null">{{ data1.act_amt }} येणे</ng-container> <br> {{ data1.rem_amount }} येणे
                    </td>
                </tr>

                <tr>
                    <td colspan="3" class="br-bottom br-right br-top" style="border: 1px solid #ccc; text-align: end;">
                        Total
                    </td>
                    <td class="br-bottom br-right br-top" style="border: 1px solid #ccc; text-align: end;">
                        {{ data.invoice_total }}
                    </td>
                    <td colspan="5" class="br-bottom br-right br-top" style="border: none;"></td>
                    <td class="br-bottom br-top br-right" style="border: 1px solid #ccc; text-align: end;">
                        {{ data.rcv_total }}
                    </td>
                    <td class="br-bottom br-top br-right" style="border: 1px solid #ccc; text-align: end;">
                        {{ balancecfamt }}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <div style="margin-left: 80%; margin-bottom: 2%;">
        <button class="noPrint" style="margin-top: 2%; margin-left: 2%;" 
                (click)="exportExcel('Contract_InDetails_Report')" 
                mat-raised-button color="primary">
            Export
        </button>

        <button class="noPrint" style="margin-top: 2%;" 
                mat-raised-button color="primary"
                [useExistingCss]="true"
                printSectionId="print-section" ngxPrint>
            Print
        </button>

        <button class="noPrint" style="margin-top: 2%;" mat-button mat-dialog-close>
            Close
        </button>
    </div>
</div> -->











<div *ngIf="reportType == 'briefly-personalledger'">
    <style>
        .ledger-cell {
            font-weight: bold;
            font-size: 14px;
            color: black;
            width: 0%;
            border: 2 px solid #000 !important;
        }

        .ledger-title {
            font-weight: bold;
            font-size: 14px;
            text-align: left;
            color: black;
            width: 0%;
        }

        .ledger-header {
            font-weight: bold;
            font-size: 14px;
            text-align: center;
            color: black;
        }
    </style>

    <div class="container-fluid d-flex justify-content-center p-0 m-0" id="print-section">
        <div class="table-responsive" style="max-width: 95%; width: 100%;">
            <table class="table table-bordered table-condensed text-center" style="margin: 0 auto;">
                <thead>
                    <tr>
                        <th colspan="6" class="ledger-header">
                            हिंदुस्तान प्रकाशन संस्था - विवेक साप्ताहिक
                        </th>
                        <th colspan="3" class="ledger-header">
                            दिनांक: {{ startDate | date : 'dd-MM-yyy' }} To {{ endDate | date :'dd-MM-yyy' }}
                        </th>
                    </tr>
                    <tr>
                        <th colspan="9" class="ledger-header">
                            Advertiser Personal Ledger (In Briefly)
                        </th>
                    </tr>
                    <tr>
                        <th class="ledger-header" rowspan="2">Advertiser <br> Name</th>
                        <th class="ledger-header" rowspan="2">Opening <br> Balance</th>
                        <th class="ledger-header" rowspan="2">Credit <br> Amount</th>
                        <th class="ledger-header" rowspan="2">Billing <br> Amount</th>
                        <th class="ledger-header" rowspan="2">Received <br> Amount</th>
                        <th class="ledger-header" colspan="2">Total Credit Amount</th>
                        <th class="ledger-header" rowspan="2">Total</th>
                        <th class="ledger-header" rowspan="2">Balance</th>
                    </tr>
                    <tr>
                        <th class="ledger-header text-end">TDS</th>
                        <th class="ledger-header text-end">Other</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let data1 of getpersonalledBridflydata; let k = index">
                        <ng-container *ngIf="
      (data1.opening_balance_amount ?? 0) !== 0 ||
      (data1.credit_noinvoice_amt ?? 0) !== 0 ||
      (data1.inv_amount ?? 0) !== 0 ||
      (data1.received_amt ?? 0) !== 0 ||
      (data1.tds_amt ?? 0) !== 0 ||
      (data1.other_credit_amt ?? 0) !== 0 ||
      (data1.total_amount ?? 0) !== 0 ||
      (data1.balance_amt ?? 0) !== 0
    ">
                            <td class="ledger-title">{{ data1.advt_name | slice:0:40 }}</td>

                            <td class="text-right ledger-cell">
                                <span *ngIf="(data1.opening_balance_amount ?? 0) !== 0">
                                    {{ (data1.opening_balance_amount * 1).toFixed(2) }}
                                </span>
                            </td>

                            <td class="text-right ledger-cell">
                                <span *ngIf="(data1.credit_noinvoice_amt ?? 0) !== 0">
                                    {{ (data1.credit_noinvoice_amt * 1).toFixed(2) }}
                                </span>
                            </td>

                            <td class="text-right ledger-cell">
                                <span *ngIf="(data1.inv_amount ?? 0) !== 0">
                                    {{ (data1.inv_amount * 1).toFixed(2) }}
                                </span>
                            </td>

                            <td class="text-right ledger-cell">
                                <span *ngIf="(data1.received_amt ?? 0) !== 0">
                                    {{ (data1.received_amt * 1).toFixed(2) }}
                                </span>
                            </td>

                            <td class="text-right ledger-cell">
                                <span *ngIf="(data1.tds_amt ?? 0) !== 0">
                                    {{ (data1.tds_amt * 1).toFixed(2) }}
                                </span>
                            </td>

                            <td class="text-right ledger-cell">
                                <span *ngIf="(data1.other_credit_amt ?? 0) !== 0">
                                    {{ (data1.other_credit_amt * 1).toFixed(2) }}
                                </span>
                            </td>

                            <td class="text-right ledger-cell">
                                <span *ngIf="(data1.total_amount ?? 0) !== 0">
                                    {{ (data1.total_amount * 1).toFixed(2) }}
                                </span>
                            </td>

                            <td class="text-right ledger-cell">
                                <span *ngIf="(data1.balance_amt ?? 0) !== 0">
                                    {{ (data1.balance_amt * 1).toFixed(2) }}
                                </span>
                            </td>
                        </ng-container>
                    </tr>
                </tbody>


                <tfoot>

                </tfoot>
                <tr style="border: 1px solid #000;">
                    <td class="ledger-title" style="border: 1px solid #000;">Total</td>
                    <td class="text-right ledger-cell" style="border: 1px solid #000;">{{ (Totalop * 1).toFixed(2) }}
                    </td>
                    <td class="text-right ledger-cell" style="border: 1px solid #000;">{{ (Totaldirect * 1).toFixed(2)
                        }}</td>
                    <td class="text-right ledger-cell" style="border: 1px solid #000;">{{ (Totalnet * 1).toFixed(2) }}
                    </td>
                    <td class="text-right ledger-cell" style="border: 1px solid #000;">{{ (Totalrcv * 1).toFixed(2) }}
                    </td>
                    <td class="text-right ledger-cell" style="border: 1px solid #000;">{{ (TotalcreditTDSAmt *
                        1).toFixed(2) }}</td>
                    <td class="text-right ledger-cell" style="border: 1px solid #000;">{{ (TotalCreditOtherTotal *
                        1).toFixed(2) }}</td>
                    <td class="text-right ledger-cell" style="border: 1px solid #000;">{{ (TotalCreditTotal *
                        1).toFixed(2) }}</td>
                    <td class="text-right ledger-cell" style="border: 1px solid #000;">{{ (Totalbal * 1).toFixed(2) }}
                    </td>
                </tr>

            </table>
        </div>
    </div>

    <div class="action-buttons text-center noPrint">
        <button style="margin: 10px;" (click)="exportExcelledger('Contract_InDetails_Report')" mat-raised-button
            color="primary">
            Export
        </button>

        <button style="margin: 10px;" mat-raised-button color="primary" (click)="printPage4()">
            Print
        </button>

        <button style="margin: 10px;" mat-button mat-dialog-close>
            Close
        </button>
    </div>
</div>


<!-- Send reminder -->



<!-- Subscription -->
<div class="table-container" *ngIf="reportType == 'Renewaljilha'">
    <div id="print-section1" class="container">

        <table class="table table-bordered">
            <thead>
                <tr>
                    <th colspan="65"
                        style="text-align: center !important; font-size: 13px; border-left: 2px solid black; border-right: 2px solid black">
                        हिंदुस्तान प्रकाशन संस्था - विवेक साप्ताहिक - वर्गणी विभाग रिपोर्ट वर्गणीदार नूतनीकरण व्यवसाय
                    </th>
                    <th colspan="5"
                        style="text-align: center !important; border-left: 2px solid black; border-right: 2px solid black">
                        दिनांक :- {{ currentDate | date: 'dd-MM-yyyy' }}
                    </th>
                </tr>
                <tr>
                    <th colspan="60"
                        style="text-align: center !important; font-size: 10px; padding-left: 6%; border-left: 2px solid black; border-right: 2px solid black">
                        जिल्हा निहाय संक्षिप्त बाकी तपशील</th>
                    <th colspan="5"
                        style="text-align: center !important; border-left: 2px solid black; border-right: 2px solid black;">
                        दिनांक पासून :- {{startDate | date: 'dd-MM-yyyy'}}</th>
                    <th colspan="5"
                        style="text-align: center !important; border-left: 2px solid black; border-right: 2px solid black">
                        पर्यंत :- {{endDate | date: 'dd-MM-yyyy'}}</th>
                </tr>
                <tr>
                    <th colspan="5" style="border-left: 2px solid black; border-top: 2px solid black;">नूतनीकरण येणे
                        बाकी (जिल्हानिहाय संक्षिप्त)</th>
                    <th colspan="5"
                        style="text-align: center; font-weight: 600; border-left: 2px solid black; border-top: 2px solid black;">
                        एप्रिल</th>
                    <th colspan="5"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black;">मे</th>
                    <th colspan="5"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black;">जून</th>
                    <th colspan="5"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black;">जुलै</th>
                    <th colspan="5"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black;">ऑगस्ट
                    </th>
                    <th colspan="5"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black;">सप्टेंबर
                    </th>
                    <th colspan="5"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black;">ऑक्टोबर
                    </th>
                    <th colspan="5"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black;">नोव्हेंबर
                    </th>
                    <th colspan="5"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black;">डिसेंबर
                    </th>
                    <th colspan="5"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black;">जानेवारी
                    </th>
                    <th colspan="5"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black;">
                        फेब्रुवारी</th>
                    <th colspan="5"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black;">मार्च
                    </th>
                    <th colspan="5"
                        style="text-align: center; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black;">
                        एकूण</th>
                </tr>

                <tr>
                    <th colspan="1"
                        style="border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        देश</th>
                    <th colspan="2"
                        style="border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        राज्य</th>
                    <th colspan="2"
                        style="border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        जिल्हा</th>
                    <th
                        style="border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        पोस्ट</th>
                    <th style="border-top: 2px solid black; border-bottom: 2px solid black;">हस्ते</th>
                    <th
                        style="overflow-wrap: break-word; white-space: normal; border-top: 2px solid black; border-bottom: 2px solid black;">
                        मॅगझीन</th>
                    <th
                        style="overflow-wrap: break-word; white-space: normal; border-top: 2px solid black; border-bottom: 2px solid black;">
                        डिजिटल</th>
                    <th style="border-top: 2px solid black; border-bottom: 2px solid black;">एकूण</th>
                    <th
                        style="border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        पोस्ट</th>
                    <th style="border-top: 2px solid black; border-bottom: 2px solid black;">हस्ते</th>
                    <th
                        style="overflow-wrap: break-word; white-space: normal; border-top: 2px solid black; border-bottom: 2px solid black;">
                        मॅगझीन</th>
                    <th
                        style="overflow-wrap: break-word; white-space: normal; border-top: 2px solid black; border-bottom: 2px solid black;">
                        डिजिटल</th>
                    <th style="border-top: 2px solid black; border-bottom: 2px solid black;">एकूण</th>
                    <th
                        style="border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        पोस्ट</th>
                    <th style="border-top: 2px solid black; border-bottom: 2px solid black;">हस्ते</th>
                    <th
                        style="overflow-wrap: break-word; white-space: normal; border-top: 2px solid black; border-bottom: 2px solid black;">
                        मॅगझीन</th>
                    <th
                        style="overflow-wrap: break-word; white-space: normal; border-top: 2px solid black; border-bottom: 2px solid black;">
                        डिजिटल</th>
                    <th style="border-top: 2px solid black; border-bottom: 2px solid black;">एकूण</th>
                    <th
                        style="border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        पोस्ट</th>
                    <th style="border-top: 2px solid black; border-bottom: 2px solid black;">हस्ते</th>
                    <th
                        style="overflow-wrap: break-word; white-space: normal; border-top: 2px solid black; border-bottom: 2px solid black;">
                        मॅगझीन</th>
                    <th
                        style="overflow-wrap: break-word; white-space: normal; border-top: 2px solid black; border-bottom: 2px solid black;">
                        डिजिटल</th>
                    <th style="border-top: 2px solid black; border-bottom: 2px solid black;">एकूण</th>
                    <th
                        style="border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        पोस्ट</th>
                    <th style="border-top: 2px solid black; border-bottom: 2px solid black;">हस्ते</th>
                    <th
                        style="overflow-wrap: break-word; white-space: normal; border-top: 2px solid black; border-bottom: 2px solid black;">
                        मॅगझीन</th>
                    <th
                        style="overflow-wrap: break-word; white-space: normal; border-top: 2px solid black; border-bottom: 2px solid black;">
                        डिजिटल</th>
                    <th style="border-top: 2px solid black; border-bottom: 2px solid black;">एकूण</th>
                    <th
                        style="border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        पोस्ट</th>
                    <th style="border-top: 2px solid black; border-bottom: 2px solid black;">हस्ते</th>
                    <th
                        style="overflow-wrap: break-word; white-space: normal; border-top: 2px solid black; border-bottom: 2px solid black;">
                        मॅगझीन</th>
                    <th
                        style="overflow-wrap: break-word; white-space: normal; border-top: 2px solid black; border-bottom: 2px solid black;">
                        डिजिटल</th>
                    <th style="border-top: 2px solid black; border-bottom: 2px solid black;">एकूण</th>
                    <th
                        style="border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        पोस्ट</th>
                    <th style="border-top: 2px solid black; border-bottom: 2px solid black;">हस्ते</th>
                    <th
                        style="overflow-wrap: break-word; white-space: normal; border-top: 2px solid black; border-bottom: 2px solid black;">
                        मॅगझीन</th>
                    <th
                        style="overflow-wrap: break-word; white-space: normal; border-top: 2px solid black; border-bottom: 2px solid black;">
                        डिजिटल</th>
                    <th style="border-top: 2px solid black; border-bottom: 2px solid black;">एकूण</th>
                    <th
                        style="border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        पोस्ट</th>
                    <th style="border-top: 2px solid black; border-bottom: 2px solid black;">हस्ते</th>
                    <th
                        style="overflow-wrap: break-word; white-space: normal; border-top: 2px solid black; border-bottom: 2px solid black;">
                        मॅगझीन</th>
                    <th
                        style="overflow-wrap: break-word; white-space: normal; border-top: 2px solid black; border-bottom: 2px solid black;">
                        डिजिटल</th>
                    <th style="border-top: 2px solid black; border-bottom: 2px solid black;">एकूण</th>
                    <th
                        style="border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        पोस्ट</th>
                    <th style="border-top: 2px solid black; border-bottom: 2px solid black;">हस्ते</th>
                    <th
                        style="overflow-wrap: break-word; white-space: normal; border-top: 2px solid black; border-bottom: 2px solid black;">
                        मॅगझीन</th>
                    <th
                        style="overflow-wrap: break-word; white-space: normal; border-top: 2px solid black; border-bottom: 2px solid black;">
                        डिजिटल</th>
                    <th style="border-top: 2px solid black; border-bottom: 2px solid black;">एकूण</th>
                    <th
                        style="border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        पोस्ट</th>
                    <th style="border-top: 2px solid black; border-bottom: 2px solid black;">हस्ते</th>
                    <th
                        style="overflow-wrap: break-word; white-space: normal; border-top: 2px solid black; border-bottom: 2px solid black;">
                        मॅगझीन</th>
                    <th
                        style="overflow-wrap: break-word; white-space: normal; border-top: 2px solid black; border-bottom: 2px solid black;">
                        डिजिटल</th>
                    <th style="border-top: 2px solid black; border-bottom: 2px solid black;">एकूण</th>
                    <th
                        style="border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        पोस्ट</th>
                    <th style="border-top: 2px solid black; border-bottom: 2px solid black;">हस्ते</th>
                    <th
                        style="overflow-wrap: break-word; white-space: normal; border-top: 2px solid black; border-bottom: 2px solid black;">
                        मॅगझीन</th>
                    <th
                        style="overflow-wrap: break-word; white-space: normal; border-top: 2px solid black; border-bottom: 2px solid black;">
                        डिजिटल</th>
                    <th style="border-top: 2px solid black; border-bottom: 2px solid black;">एकूण</th>
                    <th
                        style="border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        पोस्ट</th>
                    <th style="border-top: 2px solid black; border-bottom: 2px solid black;">हस्ते</th>
                    <th
                        style="overflow-wrap: break-word; white-space: normal; border-top: 2px solid black; border-bottom: 2px solid black;">
                        मॅगझीन</th>
                    <th
                        style="overflow-wrap: break-word; white-space: normal; border-top: 2px solid black; border-bottom: 2px solid black;">
                        डिजिटल</th>
                    <th
                        style="border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        एकूण</th>
                </tr>
            </thead>

            <tbody>
                <ng-container *ngFor="let group of stateWiseList; let i = index">
                    <ng-container *ngFor="let data of group.district; let j = index">

                        <tr>
                            <td *ngIf="j == 0" colspan="1"
                                style="text-align: left; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                                {{data.country}}</td>
                            <td *ngIf="j > 0" colspan="1" style="border-left: 2px solid black;"></td>

                            <td colspan="2"
                                style="text-align: left; font-weight: bold; border-left: 2px solid black; word-wrap: break-word; border-bottom: 2px solid black;"
                                *ngIf="j==0">{{group.state}}</td>
                            <td colspan="2" *ngIf="j>0" style="border-left: 2px solid black;"></td>

                            <td colspan="2"
                                style="border-left: 2px solid black; word-wrap: break-word; border-bottom: 2px solid black;">
                                {{data.district}}</td>

                            <!-- April -->
                            <td style="text-align: right; border-left: 2px solid black;">{{
                                formatValue(data.april_post_count) }}</td>
                            <td style="text-align: right;">{{ formatValue(data.april_haste_count) }}</td>
                            <td style="text-align: right;">{{ formatValue(data.april_magzine_count) }}</td>
                            <td style="text-align: right;">{{ formatValue(data.april_digital_count) }}</td>
                            <td style="text-align: right;">{{ formatValue(data.april_total) }}</td>
                            <!-- May -->
                            <td style="text-align: right; border-left: 2px solid black;">{{
                                formatValue(data.may_post_count) }}</td>
                            <td style="text-align: right;">{{ formatValue(data.may_haste_count) }}</td>
                            <td style="text-align: right;">{{ formatValue(data.may_magzine_count) }}</td>
                            <td style="text-align: right;">{{ formatValue(data.may_digital_count) }}</td>
                            <td style="text-align: right;">{{ formatValue(data.may_total) }}</td>
                            <!-- June -->
                            <td style="text-align: right; border-left: 2px solid black;">{{
                                formatValue(data.jun_post_count) }}</td>
                            <td style="text-align: right;">{{ formatValue(data.jun_haste_count) }}</td>
                            <td style="text-align: right;">{{ formatValue(data.jun_magzine_count) }}</td>
                            <td style="text-align: right;">{{ formatValue(data.jun_digital_count) }}</td>
                            <td style="text-align: right;">{{ formatValue(data.jun_total) }}</td>
                            <!-- July -->
                            <td style="text-align: right; border-left: 2px solid black;">{{
                                formatValue(data.jul_post_count) }}</td>
                            <td style="text-align: right;">{{ formatValue(data.jul_haste_count) }}</td>
                            <td style="text-align: right;">{{ formatValue(data.jul_magzine_count) }}</td>
                            <td style="text-align: right;">{{ formatValue(data.jul_digital_count) }}</td>
                            <td style="text-align: right;">{{ formatValue(data.jul_total) }}</td>
                            <!-- August -->
                            <td style="text-align: right; border-left: 2px solid black;">{{
                                formatValue(data.aug_post_count) }}</td>
                            <td style="text-align: right;">{{ formatValue(data.aug_haste_count) }}</td>
                            <td style="text-align: right;">{{ formatValue(data.aug_magzine_count) }}</td>
                            <td style="text-align: right;">{{ formatValue(data.aug_digital_count) }}</td>
                            <td style="text-align: right;">{{ formatValue(data.aug_total) }}</td>
                            <!-- September -->
                            <td style="text-align: right; border-left: 2px solid black;">{{
                                formatValue(data.sep_post_count) }}</td>
                            <td style="text-align: right;">{{ formatValue(data.sep_haste_count) }}</td>
                            <td style="text-align: right;">{{ formatValue(data.sep_magzine_count) }}</td>
                            <td style="text-align: right;">{{ formatValue(data.sep_digital_count) }}</td>
                            <td style="text-align: right;">{{ formatValue(data.sep_total) }}</td>
                            <!-- October -->
                            <td style="text-align: right; border-left: 2px solid black;">{{
                                formatValue(data.oct_post_count) }}</td>
                            <td style="text-align: right;">{{ formatValue(data.oct_haste_count) }}</td>
                            <td style="text-align: right;">{{ formatValue(data.oct_magzine_count) }}</td>
                            <td style="text-align: right;">{{ formatValue(data.oct_digital_count) }}</td>
                            <td style="text-align: right;">{{ formatValue(data.oct_total) }}</td>
                            <!-- November -->
                            <td style="text-align: right; border-left: 2px solid black;">{{
                                formatValue(data.nov_post_count) }}</td>
                            <td style="text-align: right;">{{ formatValue(data.nov_haste_count) }}</td>
                            <td style="text-align: right;">{{ formatValue(data.nov_magzine_count) }}</td>
                            <td style="text-align: right;">{{ formatValue(data.nov_digital_count) }}</td>
                            <td style="text-align: right;">{{ formatValue(data.nov_total) }}</td>
                            <!-- December -->
                            <td style="text-align: right; border-left: 2px solid black;">{{
                                formatValue(data.dec_post_count) }}</td>
                            <td style="text-align: right;">{{ formatValue(data.dec_haste_count) }}</td>
                            <td style="text-align: right;">{{ formatValue(data.dec_magzine_count) }}</td>
                            <td style="text-align: right;">{{ formatValue(data.dec_digital_count) }}</td>
                            <td style="text-align: right;">{{ formatValue(data.dec_total) }}</td>
                            <!-- January -->
                            <td style="text-align: right; border-left: 2px solid black;">{{
                                formatValue(data.jan_post_count) }}</td>
                            <td style="text-align: right;">{{ formatValue(data.jan_haste_count) }}</td>
                            <td style="text-align: right;">{{ formatValue(data.jan_magzine_count) }}</td>
                            <td style="text-align: right;">{{ formatValue(data.jan_digital_count) }}</td>
                            <td style="text-align: right;">{{ formatValue(data.jan_total) }}</td>
                            <!-- February -->
                            <td style="text-align: right; border-left: 2px solid black;">{{
                                formatValue(data.feb_post_count) }}</td>
                            <td style="text-align: right;">{{ formatValue(data.feb_haste_count) }}</td>
                            <td style="text-align: right;">{{ formatValue(data.feb_magzine_count) }}</td>
                            <td style="text-align: right;">{{ formatValue(data.feb_digital_count) }}</td>
                            <td style="text-align: right;">{{ formatValue(data.feb_total) }}</td>
                            <!-- March -->
                            <td style="text-align: right; border-left: 2px solid black;">{{
                                formatValue(data.mar_post_count) }}</td>
                            <td style="text-align: right;">{{ formatValue(data.mar_haste_count) }}</td>
                            <td style="text-align: right;">{{ formatValue(data.mar_magzine_count) }}</td>
                            <td style="text-align: right;">{{ formatValue(data.mar_digital_count) }}</td>
                            <td style="text-align: right;">{{ formatValue(data.mar_total) }}</td>
                            <!-- Grand Total -->
                            <td style="text-align: right; border-left: 2px solid black;">{{ formatValue(data.post_total)
                                }}</td>
                            <td style="text-align: right;">{{ formatValue(data.haste_total) }}</td>
                            <td style="text-align: right;">{{ formatValue(data.magzine_total) }}</td>
                            <td style="text-align: right;">{{ formatValue(data.digital_total) }}</td>
                            <td style="text-align: right; border-right: 2px solid black;">{{
                                formatValue(data.grand_total) }}</td>
                        </tr>

                        <!-- State Subtotal Row -->
                        <tr *ngIf="j == group.district.length - 1">
                            <td colspan="5"
                                style="text-align: right; font-weight: bold; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                                एकूण :-</td>
                            <!-- April -->
                            <td
                                style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.aprilpost) }}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.aprilhaste) }}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.aprilmagzine) }}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.aprildigital) }}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.apriltotal) }}</td>
                            <!-- May -->
                            <td
                                style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.maypost) }}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.mayhaste) }}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.maymagzine) }}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.maydigital) }}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.maytotal) }}</td>
                            <!-- June -->
                            <td
                                style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.junepost) }}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.junehaste) }}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.junmagzine) }}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.jundigital) }}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.junetotal) }}</td>
                            <!-- July -->
                            <td
                                style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.julypost) }}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.julyhaste) }}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.julymagzine) }}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.julydigital) }}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.julytotal) }}</td>
                            <!-- August -->
                            <td
                                style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.augpost) }}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.aughaste) }}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.augmagzine) }}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.augdigital) }}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.augtotal) }}</td>
                            <!-- September -->
                            <td
                                style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.seppost) }}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.sephaste) }}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.sepmagzine) }}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.sepdigital) }}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.septotal) }}</td>
                            <!-- October -->
                            <td
                                style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.octopost) }}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.octohaste) }}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.octmagzine) }}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.octdigital) }}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.octototal) }}</td>
                            <!-- November -->
                            <td
                                style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.novpost) }}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.novhaste) }}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.novmagzine) }}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.novdigital) }}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.novtotal) }}</td>
                            <!-- December -->
                            <td
                                style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.decpost) }}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.dechaste) }}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.decmagzine) }}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.decdigital) }}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.dectotal) }}</td>
                            <!-- January -->
                            <td
                                style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.janpost) }}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.janhaste) }}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.janmagzine) }}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.jandigital) }}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.jantotal) }}</td>
                            <!-- February -->
                            <td
                                style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.febpost) }}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.febhaste) }}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.febmagzine) }}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.febdigital) }}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.febtotal) }}</td>
                            <!-- March -->
                            <td
                                style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.marchpost) }}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.marchhaste) }}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.marchmagzine) }}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.marchdigital) }}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.marchtotal) }}</td>
                            <!-- Grand Total -->
                            <td
                                style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.totalzilhahapost1) }}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.totalzilhahahaste1) }}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.totalzilhahamagzine1) }}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.totalzilhahadigital1) }}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-right: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{ formatValue(group.totalzilhahatotal1) }}</td>
                        </tr>

                    </ng-container>
                </ng-container>

                <!-- Grand Total Row in tbody (shown when show is false) -->
                <tr *ngIf="!show">
                    <td colspan="5"
                        style="text-align: left; font-weight: bold; font-size: 11px; border-left: 2px solid black; border-right: 2px solid black; border-bottom: 2px solid black;">
                        एकूण :- </td>
                    <!-- April -->
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{ formatValue(aprilpost) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(aprilhaste) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(aprilmagzine) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(aprildigital) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(apriltotal) }}</td>
                    <!-- May -->
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{ formatValue(maypost) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(mayhaste) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(maymagzine) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(maydigital) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(maytotal) }}</td>
                    <!-- June -->
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{ formatValue(junepost) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(junehaste) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(junmagzine) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(jundigital) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(junetotal) }}</td>
                    <!-- July -->
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{ formatValue(julypost) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(julyhaste) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(julymagzine) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(julydigital) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(julytotal) }}</td>
                    <!-- August -->
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{ formatValue(augpost) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(aughaste) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(augmagzine) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(augdigital) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(augtotal) }}</td>
                    <!-- September -->
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{ formatValue(seppost) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(sephaste) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(sepmagzine) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(sepdigital) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(septotal) }}</td>
                    <!-- October -->
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{ formatValue(octopost) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(octohaste) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(octmagzine) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(octdigital) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(octototal) }}</td>
                    <!-- November -->
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{ formatValue(novpost) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(novhaste) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(novmagzine) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(novdigital) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(novtotal) }}</td>
                    <!-- December -->
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{ formatValue(decpost) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(dechaste) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(decmagzine) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(decdigital) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(dectotal) }}</td>
                    <!-- January -->
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{ formatValue(janpost) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(janhaste) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(janmagzine) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(jandigital) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(jantotal) }}</td>
                    <!-- February -->
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{ formatValue(febpost) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(febhaste) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(febmagzine) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(febdigital) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(febtotal) }}</td>
                    <!-- March -->
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{ formatValue(marchpost) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(marchhaste) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(marchmagzine) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(marchdigital) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(marchtotal) }}</td>
                    <!-- Grand Total -->
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{ formatValue(totalzilhahapost) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(totalzilhahahaste) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(totalzilhahamagzine) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(totalzilhahadigital) }}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-right: 2px solid black; border-bottom: 2px solid black;">
                        {{ formatValue(totalzilhahatotal) }}</td>
                </tr>

            </tbody>

            <!-- Grand Total Row in tfoot (shown when show is true) -->
            <tfoot *ngIf="show">
                <tr>
                    <td colspan="5"
                        style="text-align: left; font-weight: bold; font-size: 11px; border-left: 2px solid black; border-right: 2px solid black; border-bottom: 2px solid black;">
                        एकूण :- </td>
                    <!-- April -->
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{ formatValue(aprilpost) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(aprilhaste) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(aprilmagzine) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(aprildigital) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(apriltotal) }}</td>
                    <!-- May -->
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{ formatValue(maypost) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(mayhaste) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(maymagzine) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(maydigital) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(maytotal) }}</td>
                    <!-- June -->
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{ formatValue(junepost) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(junehaste) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(junmagzine) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(jundigital) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(junetotal) }}</td>
                    <!-- July -->
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{ formatValue(julypost) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(julyhaste) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(julymagzine) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(julydigital) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(julytotal) }}</td>
                    <!-- August -->
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{ formatValue(augpost) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(aughaste) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(augmagzine) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(augdigital) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(augtotal) }}</td>
                    <!-- September -->
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{ formatValue(seppost) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(sephaste) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(sepmagzine) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(sepdigital) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(septotal) }}</td>
                    <!-- October -->
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{ formatValue(octopost) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(octohaste) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(octmagzine) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(octdigital) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(octototal) }}</td>
                    <!-- November -->
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{ formatValue(novpost) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(novhaste) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(novmagzine) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(novdigital) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(novtotal) }}</td>
                    <!-- December -->
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{ formatValue(decpost) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(dechaste) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(decmagzine) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(decdigital) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(dectotal) }}</td>
                    <!-- January -->
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{ formatValue(janpost) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(janhaste) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(janmagzine) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(jandigital) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(jantotal) }}</td>
                    <!-- February -->
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{ formatValue(febpost) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(febhaste) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(febmagzine) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(febdigital) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(febtotal) }}</td>
                    <!-- March -->
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{ formatValue(marchpost) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(marchhaste) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(marchmagzine) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(marchdigital) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(marchtotal) }}</td>
                    <!-- Grand Total -->
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{ formatValue(totalzilhahapost) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(totalzilhahahaste) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(totalzilhahamagzine) }}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{
                        formatValue(totalzilhahadigital) }}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-right: 2px solid black; border-bottom: 2px solid black;">
                        {{ formatValue(totalzilhahatotal) }}</td>
                </tr>
            </tfoot>

        </table>

    </div>
    <div style="margin-left: 80%; margin-bottom: 2%;">
        <button class="noPrint" style="margin-top: 2%; margin-left: 2%"
            (click)="exportExcel('Contract_InDetails_Report')" mat-raised-button color="primary">
            Export
        </button>
        <button class="noPrint" style="margin-top: 2%; margin-left: 2%" mat-raised-button color="primary"
            (click)="printPage()">
            Print
        </button>
        <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>
            Close
        </button>
    </div>
</div>

<!-- Zillha Wise Indetails -->
<div class="table-container" *ngIf="reportType == 'RenewaljilhaIndetails'">
    <div id="print-section1" class="container">

        <table class="fixed-header">
            <thead>
                <tr>
                    <th colspan="64"
                        style="text-align: center !important; font-size: 13px; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black;">
                        हिंदुस्तान प्रकाशन संस्था - विवेक साप्ताहिक - वर्गणी विभाग रिपोर्ट वर्गणीदार नूतनीकरण व्यवसाय
                        जमा </th>
                    <th colspan="5"
                        style="text-align: center !important; border-top: 2px solid black; border-right: 2px solid black;">
                        दिनांक : {{ currentDate | date: 'dd-MM-yyyy' }}</th>
                </tr>
                <tr>
                    <th colspan="59"
                        style="text-align: center !important; font-size: 11px; padding-left: 7%; border-left: 2px solid black;">
                        जिल्हा निहाय बाकी तपशील</th>
                    <th colspan="5"
                        style="text-align: center !important; border-left: 2px solid black; border-right: 2px solid black;">
                        दिनांक पासून:{{startDate | date: 'dd-MM-yyyy'}} </th>
                    <th colspan="5" style="text-align: center !important; border-right: 2px solid black;">पर्यंत:
                        {{endDate | date: 'dd-MM-yyyy'}}</th>
                </tr>

                <tr>
                    <th colspan="4" style=" border-left: 2px solid black; border-top: 2px solid black;">नुतनीकरण येणे
                        बाकी(जिल्हानिहाया)</th>

                    <th colspan="5"
                        style="text-align: center; font-weight: 600; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        एप्रिल</th>
                    <th colspan="5"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        मे</th>
                    <th colspan="5"
                        style="text-align: center;border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        जून</th>
                    <th colspan="5"
                        style="text-align: center;border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        जुलै</th>
                    <th colspan="5"
                        style="text-align: center;border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        ऑगस्ट</th>
                    <th colspan="5"
                        style="text-align: center;border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        सप्टेंबर</th>
                    <th colspan="5"
                        style="text-align: center;border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        ऑक्टोबर</th>
                    <th colspan="5"
                        style="text-align: center;border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        नोव्हेंबर</th>
                    <th colspan="5"
                        style="text-align: center;border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        डिसेंबर</th>
                    <th colspan="5"
                        style="text-align: center;border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        जानेवारी</th>
                    <th colspan="5"
                        style="text-align: center;border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        फेब्रुवारी</th>
                    <th colspan="5"
                        style="text-align: center;border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        मार्च</th>
                    <th colspan="5"
                        style="text-align: center;border-left: 2px solid black;border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        एकूण</th>
                </tr>

                <tr>
                    <th colspan="1"
                        style="border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        देश</th>
                    <th colspan="1"
                        style="border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        राज्य</th>
                    <th colspan="1"
                        style="border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        जिल्हा</th>
                    <th colspan="1"
                        style="border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        तालुका</th>
                    <th style=" border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट</th>
                    <th style="border-bottom: 2px solid black;">हस्ते</th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">मॅगझीन
                    </th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">डिजिटल
                    </th>
                    <th style="border-bottom: 2px solid black;">एकूण</th>
                    <th style=" border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट</th>
                    <th style="border-bottom: 2px solid black;">हस्ते</th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">मॅगझीन
                    </th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">डिजिटल
                    </th>
                    <th style="border-bottom: 2px solid black;">एकूण</th>
                    <th style=" border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट</th>
                    <th style="border-bottom: 2px solid black;">हस्ते</th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">मॅगझीन
                    </th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">डिजिटल
                    </th>
                    <th style="border-bottom: 2px solid black;">एकूण</th>
                    <th style=" border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट</th>
                    <th style="border-bottom: 2px solid black;">हस्ते</th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">मॅगझीन
                    </th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">डिजिटल
                    </th>
                    <th style="border-bottom: 2px solid black;">एकूण</th>
                    <th style=" border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट</th>
                    <th style="border-bottom: 2px solid black;">हस्ते</th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">मॅगझीन
                    </th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">डिजिटल
                    </th>
                    <th style="border-bottom: 2px solid black;">एकूण</th>
                    <th style=" border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट</th>
                    <th style="border-bottom: 2px solid black;">हस्ते</th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">मॅगझीन
                    </th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">डिजिटल
                    </th>
                    <th style="border-bottom: 2px solid black;">एकूण</th>
                    <th style=" border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट</th>
                    <th style="border-bottom: 2px solid black;">हस्ते</th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">मॅगझीन
                    </th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">डिजिटल
                    </th>
                    <th style="border-bottom: 2px solid black;">एकूण</th>
                    <th style=" border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट</th>
                    <th style="border-bottom: 2px solid black;">हस्ते</th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">मॅगझीन
                    </th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">डिजिटल
                    </th>
                    <th style="border-bottom: 2px solid black;">एकूण</th>
                    <th style=" border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट</th>
                    <th style="border-bottom: 2px solid black;">हस्ते</th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">मॅगझीन
                    </th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">डिजिटल
                    </th>
                    <th style="border-bottom: 2px solid black;">एकूण</th>
                    <th style=" border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट</th>
                    <th style="border-bottom: 2px solid black;">हस्ते</th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">मॅगझीन
                    </th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">डिजिटल
                    </th>
                    <th style="border-bottom: 2px solid black;">एकूण</th>
                    <th style=" border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट</th>
                    <th style="border-bottom: 2px solid black;">हस्ते</th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">मॅगझीन
                    </th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">डिजिटल
                    </th>
                    <th style="border-bottom: 2px solid black;">एकूण</th>
                    <th style=" border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट</th>
                    <th style="border-bottom: 2px solid black;">हस्ते</th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">मॅगझीन
                    </th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">डिजिटल
                    </th>
                    <th style="border-bottom: 2px solid black;">एकूण</th>
                    <th style=" border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट</th>
                    <th style="border-bottom: 2px solid black;">हस्ते</th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">मॅगझीन
                    </th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">डिजिटल
                    </th>
                    <th style="border-right: 2px solid black; border-bottom: 2px solid black;">एकूण</th>
                </tr>

            </thead>
            <!-- *ngFor="let data of OutstandingInDetailFormBeans; let i = index" -->
            <tbody>
                <ng-container *ngFor="let data of SubByZilhaIndetails; let i = index">
                    <tr>
                        <td colspan="1"
                            style="text-align: left; font-weight: bold; border-left: 2px solid black; word-wrap: break-word; border-bottom: 2px solid black;">
                            {{data.country}} </td>
                        <td colspan="1"
                            style="text-align: left; font-weight: bold; border-left: 2px solid black; word-wrap: break-word; border-bottom: 2px solid black;">
                            {{data.state}} </td>
                        <td colspan="2" style="border-left: 2px solid black;"></td>
                        <td colspan="65" style="border-left: 2px solid black; border-right: 2px solid black;"></td>
                    </tr>

                    <ng-container *ngFor="let data2 of data.districts; let j = index">
                        <tr>

                            <td colspan="2" style="border-left: 2px solid black;"></td>
                            <td colspan="1"
                                style="border-left: 2px solid black; word-wrap: break-word; font-weight: bold; border-right: 2px solid black; border-top: 2px solid black;">
                                {{data2.district}}</td>
                            <td colspan="1" style="border-left: 2px solid black; border-top: 2px solid black;"></td>
                            <td colspan="65" style="border-left: 2px solid black; border-right: 2px solid black;"></td>
                        </tr>
                        <ng-container *ngFor="let data3 of data2.talukas; let k = index">

                            <tr>
                                <td colspan="2"
                                    style="border-left: 2px solid black; font-weight: bold; word-wrap: break-word;">
                                    {{data3.rep_name}} - {{data2.district}}</td>
                                <td colspan="1" style="border-left: 2px solid black;"></td>
                                <td colspan="1"
                                    style="border-left: 2px solid black;font-weight: bold; word-wrap: break-word;">
                                    {{data3.taluka}}</td>

                                <td style="text-align: right; border-left: 2px solid black;">
                                    {{formatValue(data3.april_post_count)}}
                                </td>
                                <td style="text-align: right; ">{{formatValue(data3.april_haste_count)}}</td>
                                <td style="text-align: right;">{{formatValue(data3.april_magzine_count)}}</td>
                                <td style="text-align: right;">{{formatValue(data3.april_digital_count)}}</td>
                                <td style="text-align: right;">{{formatValue(data3.april_total)}}</td>
                                <td style="text-align: right; border-left: 2px solid black;">
                                    {{formatValue(data3.may_post_count)}}
                                </td>
                                <td style="text-align: right;">{{ formatValue(data3.may_haste_count)}}</td>
                                <td style="text-align: right;">{{ formatValue(data3.may_magzine_count)}}</td>
                                <td style="text-align: right;">{{ formatValue(data3.may_digital_count)}}</td>
                                <td style="text-align: right;">{{ formatValue(data3.may_total)}}</td>
                                <td style="text-align: right; border-left: 2px solid black;">
                                    {{formatValue(data3.jun_post_count)}}
                                </td>
                                <td style="text-align: right;">{{formatValue(data3.jun_haste_count)}}</td>
                                <td style="text-align: right;">{{formatValue(data3.jun_magzine_count)}}</td>
                                <td style="text-align: right;">{{formatValue(data3.jun_digital_count)}}</td>
                                <td style="text-align: right;">{{formatValue(data3.jun_total)}}</td>
                                <!-- april -->
                                <td style="text-align: right; border-left: 2px solid black;">
                                    {{formatValue(data3.jul_post_count)}}
                                </td>
                                <td style="text-align: right;">{{formatValue(data3.jul_haste_count)}}</td>
                                <td style="text-align: right;">{{formatValue(data3.jul_magzine_count)}}</td>
                                <td style="text-align: right;">{{formatValue(data3.jul_digital_count)}}</td>
                                <td style="text-align: right;">{{formatValue(data3.jul_total)}}</td>
                                <td style="text-align: right; border-left: 2px solid black;">
                                    {{formatValue(data3.aug_post_count)}}
                                </td>
                                <td style="text-align: right;">{{formatValue(data3.aug_haste_count)}}</td>
                                <td style="text-align: right;">{{formatValue(data3.aug_magzine_count)}}</td>
                                <td style="text-align: right;">{{formatValue(data3.aug_digital_count)}}</td>
                                <td style="text-align: right;">{{formatValue(data3.aug_total)}}</td>
                                <td style="text-align: right; border-left: 2px solid black;">
                                    {{formatValue(data3.sep_post_count)}}
                                </td>
                                <td style="text-align: right;">{{formatValue(data3.sep_haste_count)}}</td>
                                <td style="text-align: right;">{{formatValue(data3.sep_magzine_count)}}</td>
                                <td style="text-align: right;">{{formatValue(data3.sep_digital_count)}}</td>
                                <td style="text-align: right;">{{formatValue(data3.sep_total)}}</td>
                                <td style="text-align: right; border-left: 2px solid black;">
                                    {{formatValue(data3.oct_post_count)}}
                                </td>
                                <td style="text-align: right;">{{formatValue(data3.oct_haste_count)}}</td>
                                <td style="text-align: right;">{{formatValue(data3.oct_magzine_count)}}</td>
                                <td style="text-align: right;">{{formatValue(data3.oct_digital_count)}}</td>
                                <td style="text-align: right;">{{formatValue(data3.oct_total)}}</td>
                                <td style="text-align: right; border-left: 2px solid black;">
                                    {{formatValue(data3.nov_post_count)}}
                                </td>
                                <td style="text-align: right;">{{formatValue(data3.nov_haste_count)}}</td>
                                <td style="text-align: right;">{{formatValue(data3.nov_magzine_count)}}</td>
                                <td style="text-align: right;">{{formatValue(data3.nov_digital_count)}}</td>
                                <td style="text-align: right;">{{formatValue(data3.nov_total)}}</td>
                                <td style="text-align: right; border-left: 2px solid black;">
                                    {{formatValue(data3.dec_post_count)}}
                                </td>
                                <td style="text-align: right;">{{formatValue(data3.dec_haste_count)}}</td>
                                <td style="text-align: right;">{{formatValue(data3.dec_magzine_count)}}</td>
                                <td style="text-align: right;">{{formatValue(data3.dec_digital_count)}}</td>
                                <td style="text-align: right;">{{formatValue(data3.dec_total)}}</td>
                                <td style="text-align: right; border-left: 2px solid black;">
                                    {{formatValue(data3.jan_post_count)}}
                                </td>
                                <td style="text-align: right;">{{formatValue(data3.jan_haste_count)}}</td>
                                <td style="text-align: right;">{{formatValue(data3.jan_magzine_count)}}</td>
                                <td style="text-align: right;">{{formatValue(data3.jan_digital_count)}}</td>
                                <td style="text-align: right;">{{formatValue(data3.jan_total)}}</td>
                                <td style="text-align: right; border-left: 2px solid black;">
                                    {{formatValue(data3.feb_post_count)}}
                                </td>
                                <td style="text-align: right;">{{formatValue(data3.feb_haste_count)}}</td>
                                <td style="text-align: right;">{{formatValue(data3.feb_magzine_count)}}</td>
                                <td style="text-align: right;">{{formatValue(data3.feb_digital_count)}}</td>
                                <td style="text-align: right;">{{formatValue(data3.feb_total)}}</td>
                                <td style="text-align: right; border-left: 2px solid black;">
                                    {{formatValue(data3.mar_post_count)}}
                                </td>
                                <td style="text-align: right;">{{formatValue(data3.mar_haste_count)}}</td>
                                <td style="text-align: right;">{{formatValue(data3.mar_magzine_count)}}</td>
                                <td style="text-align: right;">{{formatValue(data3.mar_digital_count)}}</td>
                                <td style="text-align: right;">{{formatValue(data3.mar_total)}}</td>

                                <td style="text-align: right; border-left: 2px solid black;">
                                    {{formatValue(data3.post_total)}}</td>
                                <td style="text-align: right;">{{formatValue(data3.haste_total)}}</td>
                                <td style="text-align: right;">{{formatValue(data3.magzine_total)}}</td>
                                <td style="text-align: right;">{{formatValue(data3.digital_total)}}</td>
                                <td style="text-align: right; border-right: 2px solid black;">
                                    {{formatValue(data3.grand_total)}}</td>

                            </tr>

                        </ng-container>
                        <tr *ngIf="data2.talukas.length!=0">

                            <td colspan="4"
                                style="text-align: right; font-weight: bold; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                                एकूण :-</td>
                            <td
                                style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.aprilpost)}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.aprilhaste )}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.aprilmagzine) }}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.aprildigital) }}
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.apriltotal)}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.maypost)}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.mayhaste)}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.maymagzine)}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.maydigital)}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.maytotal)}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.junepost)}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.junehaste)}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.junmagzine)}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.jundigital)}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.junetotal)}}</td>

                            <td
                                style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.julypost)}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.julyhaste)}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.julymagzine)}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.julydigital)}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.julytotal)}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.augpost)}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.aughaste)}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.augmagzine)}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.augdigital)}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.augtotal)}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.seppost)}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.sephaste)}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.sepmagzine)}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.sepdigital)}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.septotal)}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.octopost)}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.octohaste)}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.octmagzine)}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.octdigital)}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.octototal)}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.novpost)}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.novhaste)}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.novmagzine)}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.novdigital)}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.novtotal)}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.decpost)}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.dechaste)}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.decmagzine)}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.decdigital)}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.dectotal)}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.janpost)}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.janhaste)}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.janmagzine)}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.jandigital)}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.jantotal)}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.febpost)}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.febhaste)}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.febmagzine)}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.febdigital)}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.febtotal)}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.marchpost)}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.marchhaste)}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.marchmagzine)}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.marchdigital)}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.marchtotal)}}</td>

                            <td
                                style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.totalZilhaPostIndetail1)}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.totalZilhaHasteIndetails1)}}</td>
                            <td
                                style="text-align: right; font-weight: bold;border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.totalZilhaMagzineIndetails1)}}</td>
                            <td
                                style="text-align: right; font-weight: bold;border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.totalZilhaDigitalIndetails1)}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-right: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                                {{formatValue(data2.totalZilhaTotalIndetailTotal1)}}</td>
                        </tr>
                    </ng-container>
                </ng-container>
                <tr *ngIf="!show">
                    <td colspan="4"
                        style="text-align: left; font-weight: bold;  font-size: 11px; border-left: 2px solid black; border-right: 2px solid black; border-bottom: 2px solid black;">
                        एकूण :- </td>

                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{formatValue(aprilpost)}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(aprilhaste)}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(aprilmagzine)}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(aprildigital)}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(apriltotal)}}
                    </td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{formatValue(maypost)}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(mayhaste)}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(maymagzine)}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(maydigital)}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(maytotal)}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{formatValue(junepost)}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(junehaste)}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(junmagzine)}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(jundigital)}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(junetotal)}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{formatValue(julypost)}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(julyhaste)}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(julymagzine)}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(julydigital)}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(julytotal)}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{formatValue(augpost)}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(aughaste)}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(augmagzine)}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(augdigital)}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(augtotal)}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{formatValue(seppost)}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(sephaste)}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(sepmagzine)}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(sepdigital)}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(septotal)}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{formatValue(octopost)}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(octohaste)}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(octmagzine)}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(octdigital)}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(octototal)}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{formatValue(novpost)}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(novhaste)}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(novmagzine)}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(novdigital)}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(novtotal)}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{formatValue(decpost)}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(dechaste)}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(decmagzine)}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(decdigital)}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(dectotal)}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{formatValue(janpost)}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(janhaste)}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(janmagzine)}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(jandigital)}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(jantotal)}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{formatValue(febpost)}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(febhaste)}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(febmagzine)}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(febdigital)}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(febtotal)}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{formatValue(marchpost)}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(marchhaste)}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(marchmagzine)}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(marchdigital)}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(marchtotal)}}
                    </td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{formatValue(totalZilhaPostIndetail)}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(totalZilhaHasteIndetails)}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(totalZilhaMagzineIndetails)}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(totalZilhaDigitalIndetails)}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-right: 2px solid black; border-bottom: 2px solid black;">
                        {{formatValue(totalZilhaTotalIndetailTotal)}}</td>


                </tr>
            </tbody>

            <tfoot *ngIf="show">
                <tr>
                    <td colspan="4"
                        style="text-align: left; font-weight: bold;  font-size: 11px; border-left: 2px solid black; border-right: 2px solid black; border-bottom: 2px solid black;">
                        एकूण :- </td>

                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{formatValue(aprilpost)}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(aprilhaste)}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(aprilmagzine)}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(aprildigital)}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(apriltotal)}}
                    </td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{formatValue(maypost)}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(mayhaste)}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(maymagzine)}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(maydigital)}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(maytotal)}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{formatValue(junepost)}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(junehaste)}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(junmagzine)}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(jundigital)}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(junetotal)}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{formatValue(julypost)}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(julyhaste)}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(julymagzine)}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(julydigital)}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(julytotal)}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{formatValue(augpost)}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(aughaste)}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(augmagzine)}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(augdigital)}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(augtotal)}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{formatValue(seppost)}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(sephaste)}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(sepmagzine)}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(sepdigital)}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(septotal)}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{formatValue(octopost)}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(octohaste)}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(octmagzine)}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(octdigital)}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(octototal)}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{formatValue(novpost)}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(novhaste)}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(novmagzine)}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(novdigital)}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(novtotal)}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{formatValue(decpost)}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(dechaste)}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(decmagzine)}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(decdigital)}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(dectotal)}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{formatValue(janpost)}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(janhaste)}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(janmagzine)}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(jandigital)}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(jantotal)}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{formatValue(febpost)}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(febhaste)}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(febmagzine)}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(febdigital)}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(febtotal)}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{formatValue(marchpost)}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(marchhaste)}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(marchmagzine)}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(marchdigital)}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(marchtotal)}}
                    </td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{formatValue(totalZilhaPostIndetail)}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(totalZilhaHasteIndetails)}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(totalZilhaMagzineIndetails)}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{formatValue(totalZilhaDigitalIndetails)}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-right: 2px solid black; border-bottom: 2px solid black;">
                        {{formatValue(totalZilhaTotalIndetailTotal)}}</td>


                </tr>
            </tfoot>
        </table>


    </div>
    <div style="margin-left: 40%; margin-bottom: 2%;">

        <button class="noPrint" style="margin-top: 2%; margin-left: 2%"
            (click)="exportExcel('Contract_InDetails_Report')" mat-raised-button color="primary">
            Export
        </button>

        <button class="noPrint" style="margin-top: 2%; margin-left: 2%" mat-raised-button color="primary"
            (click)="printPage()">
            Print
        </button>

        <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>
            Close
        </button>
    </div>
</div>

<!-- Taluka Wise Briefly -->
<div class="table-container" *ngIf="reportType == 'Renewaltaluka'">
    <div id="print-section1" class="container">

        <table class="fixed-header">
            <thead>
                <tr>
                    <th colspan="64"
                        style="text-align: center !important; font-size: 13px; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black;">
                        हिंदुस्तान प्रकाशन संस्था - विवेक साप्ताहिक - वर्गणी विभाग रिपोर्ट वर्गणीदार नूतनीकरण व्यवसाय
                    </th>
                    <th colspan="5"
                        style="text-align: center !important; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black;">
                        दिनांक :- {{ currentDate | date: 'dd-MM-yyyy' }}</th>

                </tr>
                <tr>
                    <th colspan="59"
                        style="text-align: center !important; font-size: 11px; padding-left: 6%; border-left: 2px solid black;">
                        तालुका निहाय संक्षिप्त</th>
                    <!-- <th colspan="7" style="text-align: center !important; border-left: 2px solid black; border-right: 2px solid black;">दिनांक :-  {{ currentDate | date: 'dd-MM-yyyy' }}</th> -->
                    <th colspan="5" style="text-align: center !important; border-left: 2px solid black;">दिनांक पासून :-
                        {{startDate | date: 'dd-MM-yyyy'}}</th>
                    <th colspan="5"
                        style="text-align: center !important; border-left: 2px solid black; border-right: 2px solid black;">
                        पर्यंत :- {{endDate | date: 'dd-MM-yyyy'}}</th>
                </tr>
                <!-- <tr>
                    <th colspan="29" style="text-align: center !important; border-left: 2px solid black;">वर्गणीदार नूतनीकरण व्यवसाय तपशिल </th>
                    <th colspan="30" style="text-align: center !important; border-left: 2px solid black;">वितरण पद्धतीनुसार</th>
                    <th colspan="5" style="text-align: center !important; border-left: 2px solid black;">दिनांक पासून :- {{startDate | date: 'dd-MM-yyyy'}}</th>
                    <th colspan="7" style="text-align: center !important; border-left: 2px solid black; border-right: 2px solid black;">पर्यंत :-  {{endDate | date: 'dd-MM-yyyy'}}</th>
                </tr> -->
                <tr>
                    <th colspan="4" style="border-left: 2px solid black; border-top: 2px solid black;">नूतनीकरण येणे
                        बाकी (तालुका निहाय संक्षिप्त)</th>

                    <th colspan="5"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        एप्रिल</th>
                    <th colspan="5"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        मे</th>
                    <th colspan="5"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        जून</th>
                    <th colspan="5"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        जुलै</th>
                    <th colspan="5"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        ऑगस्ट</th>
                    <th colspan="5"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        सप्टेंबर</th>
                    <th colspan="5"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        ऑक्टोबर</th>
                    <th colspan="5"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        नोव्हेंबर</th>
                    <th colspan="5"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        डिसेंबर</th>
                    <th colspan="5"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        जानेवारी</th>
                    <th colspan="5"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        फेब्रुवारी</th>
                    <th colspan="5"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        मार्च</th>
                    <th colspan="5"
                        style="text-align: center; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        एकूण</th>
                </tr>
                <tr>
                    <th colspan="1"
                        style="border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                        देश</th>
                    <th colspan="1"
                        style="border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                        राज्य </th>
                    <th colspan="1"
                        style="border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                        जिल्हा</th>
                    <th colspan="1"
                        style="border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                        तालुका </th>

                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट</th>
                    <th style="border-bottom: 2px solid black;">हस्ते</th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">मॅगझीन
                    </th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">डिजिटल
                    </th>
                    <th style="border-bottom: 2px solid black;">एकूण</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट</th>
                    <th style="border-bottom: 2px solid black;">हस्ते</th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">मॅगझीन
                    </th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">डिजिटल
                    </th>
                    <th style="border-bottom: 2px solid black;">एकूण</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट</th>
                    <th style="border-bottom: 2px solid black;">हस्ते</th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">मॅगझीन
                    </th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">डिजिटल
                    </th>
                    <th style="border-bottom: 2px solid black;">एकूण</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट</th>
                    <th style="border-bottom: 2px solid black;">हस्ते</th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">मॅगझीन
                    </th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">डिजिटल
                    </th>
                    <th style="border-bottom: 2px solid black;">एकूण</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट</th>
                    <th style="border-bottom: 2px solid black;">हस्ते</th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">मॅगझीन
                    </th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">डिजिटल
                    </th>
                    <th style="border-bottom: 2px solid black;">एकूण</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट</th>
                    <th style="border-bottom: 2px solid black;">हस्ते</th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">मॅगझीन
                    </th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">डिजिटल
                    </th>
                    <th style="border-bottom: 2px solid black;">एकूण</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट</th>
                    <th style="border-bottom: 2px solid black;">हस्ते</th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">मॅगझीन
                    </th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">डिजिटल
                    </th>
                    <th style="border-bottom: 2px solid black;">एकूण</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट</th>
                    <th style="border-bottom: 2px solid black;">हस्ते</th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">मॅगझीन
                    </th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">डिजिटल
                    </th>
                    <th style="border-bottom: 2px solid black;">एकूण</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट</th>
                    <th style="border-bottom: 2px solid black;">हस्ते</th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">मॅगझीन
                    </th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">डिजिटल
                    </th>
                    <th style="border-bottom: 2px solid black;">एकूण</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट</th>
                    <th style="border-bottom: 2px solid black;">हस्ते</th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">मॅगझीन
                    </th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">डिजिटल
                    </th>
                    <th style="border-bottom: 2px solid black;">एकूण</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट</th>
                    <th style="border-bottom: 2px solid black;">हस्ते</th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">मॅगझीन
                    </th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">डिजिटल
                    </th>
                    <th style="border-bottom: 2px solid black;">एकूण</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट</th>
                    <th style="border-bottom: 2px solid black;">हस्ते</th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">मॅगझीन
                    </th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">डिजिटल
                    </th>
                    <th style="border-bottom: 2px solid black;">एकूण</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट</th>
                    <th style="border-bottom: 2px solid black;">हस्ते</th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">मॅगझीन
                    </th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">डिजिटल
                    </th>
                    <th style="border-right: 2px solid black; border-bottom: 2px solid black;">एकूण</th>
                </tr>
            </thead>
            <!-- *ngFor="let data of OutstandingInDetailFormBeans; let i = index" -->
            <!-- <tbody *ngFor="let data of SubByTaluka; let i = index"> -->
            <tbody>
                <ng-container *ngFor="let group of districtWiseList; let i = index">
                    <ng-container *ngFor="let data of group.talukas;let j=index">
                        <tr>
                            <td colspan="1"
                                style="text-align: left; font-weight: bold; border-left: 2px solid black; word-wrap: break-word; border-bottom: 2px solid black;"
                                *ngIf="j==0">{{data.country}}</td>
                            <td colspan="1"
                                style="text-align: left; font-weight: bold; border-left: 2px solid black; word-wrap: break-word; border-bottom: 2px solid black;"
                                *ngIf="j==0">{{data.state}}</td>
                            <td colspan="1"
                                style="text-align: left; font-weight: bold; border-left: 2px solid black; word-wrap: break-word; border-bottom: 2px solid black;"
                                *ngIf="j==0">{{group.district}}</td>
                            <td colspan="0" *ngIf="j>0" style="border-left: 2px solid black;"></td>
                            <td colspan="0" *ngIf="j>0" style="border-left: 2px solid black;"></td>
                            <td colspan="0" *ngIf="j>0" style="border-left: 2px solid black;"></td>


                            <td colspan="1"
                                style="border-left: 2px solid black; word-wrap: break-word; font-weight: bold; border-bottom: 2px solid black;">
                                {{data.taluka}}</td>
                            <td style="text-align: right; border-left: 2px solid black;">{{data.april_post_count}}</td>
                            <td style="text-align: right;">{{data.april_haste_count}}</td>
                            <td style="text-align: right;">{{data.april_magzine_count}}</td>
                            <td style="text-align: right;">{{data.april_digital_count}}</td>
                            <td style="text-align: right;">{{data.april_total}}</td>
                            <td style="text-align: right; border-left: 2px solid black;">{{data.may_post_count}}</td>
                            <td style="text-align: right;">{{data.may_haste_count}}</td>
                            <td style="text-align: right;">{{data.may_magzine_count}}</td>
                            <td style="text-align: right;">{{data.may_digital_count}}</td>
                            <td style="text-align: right;">{{data.may_total}}</td>
                            <td style="text-align: right; border-left: 2px solid black;">{{data.jun_post_count}}</td>
                            <td style="text-align: right;">{{data.jun_haste_count}}</td>
                            <td style="text-align: right;">{{data.jun_magzine_count}}</td>
                            <td style="text-align: right;">{{data.jun_digital_count}}</td>
                            <td style="text-align: right;">{{data.jun_total}}</td>
                            <!-- april -->
                            <td style="text-align: right; border-left: 2px solid black;">{{data.jul_post_count}}</td>
                            <td style="text-align: right;">{{data.jul_haste_count}}</td>
                            <td style="text-align: right;">{{data.jul_magzine_count}}</td>
                            <td style="text-align: right;">{{data.jul_digital_count}}</td>
                            <td style="text-align: right;">{{data.jul_total}}</td>
                            <td style="text-align: right; border-left: 2px solid black;">{{data.aug_post_count}}</td>
                            <td style="text-align: right;">{{data.aug_haste_count}}</td>
                            <td style="text-align: right;">{{data.aug_magzine_count}}</td>
                            <td style="text-align: right;">{{data.aug_digital_count}}</td>
                            <td style="text-align: right;">{{data.aug_total}}</td>
                            <td style="text-align: right; border-left: 2px solid black;">{{data.sep_post_count}}</td>
                            <td style="text-align: right;">{{data.sep_haste_count}}</td>
                            <td style="text-align: right;">{{data.sep_magzine_count}}</td>
                            <td style="text-align: right;">{{data.sep_digital_count}}</td>
                            <td style="text-align: right;">{{data.sep_total}}</td>
                            <td style="text-align: right; border-left: 2px solid black;">{{data.oct_post_count}}</td>
                            <td style="text-align: right;">{{data.oct_haste_count}}</td>
                            <td style="text-align: right;">{{data.oct_magzine_count}}</td>
                            <td style="text-align: right;">{{data.oct_digital_count}}</td>
                            <td style="text-align: right;">{{data.oct_total}}</td>
                            <td style="text-align: right; border-left: 2px solid black;">{{data.nov_post_count}}</td>
                            <td style="text-align: right;">{{data.nov_haste_count}}</td>
                            <td style="text-align: right;">{{data.nov_magzine_count}}</td>
                            <td style="text-align: right;">{{data.nov_digital_count}}</td>
                            <td style="text-align: right;">{{data.nov_total}}</td>
                            <td style="text-align: right; border-left: 2px solid black;">{{data.dec_post_count}}</td>
                            <td style="text-align: right;">{{data.dec_haste_count}}</td>
                            <td style="text-align: right;">{{data.dec_magzine_count}}</td>
                            <td style="text-align: right;">{{data.dec_digital_count}}</td>
                            <td style="text-align: right;">{{data.dec_total}}</td>
                            <td style="text-align: right; border-left: 2px solid black;">{{data.jan_post_count}}</td>
                            <td style="text-align: right;">{{data.jan_haste_count}}</td>
                            <td style="text-align: right;">{{data.jan_magzine_count}}</td>
                            <td style="text-align: right;">{{data.jan_digital_count}}</td>
                            <td style="text-align: right;">{{data.jan_total}}</td>
                            <td style="text-align: right; border-left: 2px solid black;">{{data.feb_post_count}}</td>
                            <td style="text-align: right;">{{data.feb_haste_count}}</td>
                            <td style="text-align: right;">{{data.feb_magzine_count}}</td>
                            <td style="text-align: right;">{{data.feb_digital_count}}</td>
                            <td style="text-align: right;">{{data.feb_total}}</td>
                            <td style="text-align: right; border-left: 2px solid black;">{{data.mar_post_count}}</td>
                            <td style="text-align: right;">{{data.mar_haste_count}}</td>
                            <td style="text-align: right;">{{data.mar_magzine_count}}</td>
                            <td style="text-align: right;">{{data.mar_digital_count}}</td>
                            <td style="text-align: right;">{{data.mar_total}}</td>

                            <td style="text-align: right; border-left: 2px solid black;">{{data.post_total}}</td>
                            <td style="text-align: right;">{{data.haste_total}}</td>
                            <td style="text-align: right;">{{data.magzine_total}}</td>
                            <td style="text-align: right;">{{data.digital_total}}</td>
                            <td style="text-align: right; border-right: 2px solid black;">{{data.grand_total}}</td>
                        </tr>

                        <tr *ngIf="j == group.talukas.length - 1">
                            <!-- <td colspan="2"></td> -->
                            <td colspan="4"
                                style="text-align: right; font-weight: bold; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                                एकूण :-</td>
                            <td
                                style="text-align: right; font-weight: bold; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{ group.aprilpost}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{ group.aprilhaste }}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{ group.aprilmagzine }}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{ group.aprildigital }}
                            <td
                                style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.apriltotal}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-left: 2px solid black;border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.maypost}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.mayhaste}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.maymagzine}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.maydigital}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.maytotal}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.junepost}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.junehaste}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.junmagzine}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.jundigital}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.junetotal}}</td>
                            <!-- april -->
                            <td
                                style="text-align: right; font-weight: bold; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.julypost}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.julyhaste}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.julymagzine}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.julydigital}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.julytotal}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.augpost}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.aughaste}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.augmagzine}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.augdigital}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.augtotal}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.seppost}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.sephaste}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.sepmagzine}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.sepdigital}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.septotal}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.octopost}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.octohaste}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.octmagzine}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.octdigital}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.octototal}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.novpost}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.novhaste}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.novmagzine}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.novdigital}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.novtotal}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.decpost}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.dechaste}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.decmagzine}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.decdigital}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.dectotal}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.janpost}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.janhaste}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.janmagzine}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.jandigital}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.jantotal}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.febpost}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.febhaste}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.febmagzine}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.febdigital}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.febtotal}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.marchpost}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.marchhaste}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.marchmagzine}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.marchdigital}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.marchtotal}}</td>

                            <td
                                style="text-align: right; font-weight: bold; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.totalzilhahapost1}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.totalzilhahahaste1}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.totalzilhahamagzine1}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.totalzilhahadigital1}}</td>
                            <td
                                style="text-align: right; font-weight: bold; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{group.totalzilhahatotal1}}</td>
                        </tr>
                    </ng-container>
                </ng-container>

                <tr *ngIf="!show">
                    <td colspan="4"
                        style="text-align: left; font-weight: bold; font-size: 11px; border-left: 2px solid black; border-right: 2px solid black; border-bottom: 2px solid black;">
                        एकूण :-</td>
                    <td
                        style="text-align: right; font-weight: bold;  border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{aprilpost}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{aprilhaste}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{aprilmagzine}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{aprildigital}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{apriltotal}}
                    </td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{maypost}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{mayhaste}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{maymagzine}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{maydigital}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{maytotal}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{junepost}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{junehaste}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{junmagzine}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{jundigital}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{junetotal}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{julypost}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{julyhaste}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{julymagzine}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{julydigital}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{julytotal}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{augpost}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{aughaste}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{augmagzine}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{augdigital}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{augtotal}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{seppost}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{sephaste}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{sepmagzine}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{sepdigital}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{septotal}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{octopost}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{octohaste}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{octmagzine}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{octdigital}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{octototal}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{novpost}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{novhaste}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{novmagzine}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{novdigital}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{novtotal}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{decpost}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{dechaste}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{decmagzine}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{decdigital}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{dectotal}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{janpost}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{janhaste}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{janmagzine}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{jandigital}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{jantotal}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{febpost}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{febhaste}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{febmagzine}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{febdigital}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{febtotal}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{marchpost}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{marchhaste}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{marchmagzine}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{marchdigital}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{marchtotal}}
                    </td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{totalsubhilhapost}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{totalsubhilhahaste}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{totalsubhilhamagzine}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{totalsubhilhadigital}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-right: 2px solid black; border-bottom: 2px solid black;">
                        {{totalsubhilhatotal}}</td>

                </tr>

            </tbody>

            <tfoot *ngIf="show">
                <tr>
                    <td colspan="4"
                        style="text-align: left; font-weight: bold; font-size: 11px; border-left: 2px solid black; border-right: 2px solid black; border-bottom: 2px solid black;">
                        एकूण :-</td>
                    <td
                        style="text-align: right; font-weight: bold;  border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{aprilpost}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{aprilhaste}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{aprilmagzine}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{aprildigital}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{apriltotal}}
                    </td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{maypost}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{mayhaste}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{maymagzine}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{maydigital}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{maytotal}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{junepost}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{junehaste}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{junmagzine}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{jundigital}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{junetotal}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{julypost}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{julyhaste}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{julymagzine}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{julydigital}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{julytotal}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{augpost}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{aughaste}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{augmagzine}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{augdigital}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{augtotal}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{seppost}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{sephaste}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{sepmagzine}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{sepdigital}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{septotal}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{octopost}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{octohaste}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{octmagzine}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{octdigital}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{octototal}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{novpost}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{novhaste}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{novmagzine}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{novdigital}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{novtotal}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{decpost}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{dechaste}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{decmagzine}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{decdigital}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{dectotal}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{janpost}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{janhaste}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{janmagzine}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{jandigital}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{jantotal}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{febpost}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{febhaste}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{febmagzine}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{febdigital}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{febtotal}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{marchpost}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{marchhaste}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{marchmagzine}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{marchdigital}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{marchtotal}}
                    </td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{totalsubhilhapost}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{totalsubhilhahaste}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{totalsubhilhamagzine}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{totalsubhilhadigital}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-right: 2px solid black; border-bottom: 2px solid black;">
                        {{totalsubhilhatotal}}</td>

                </tr>

            </tfoot>
        </table>


    </div>

    <div style="margin-left: 80%; margin-bottom: 2%;">
        <!-- <button class="noPrint" style="margin-top: 2%;" mat-raised-button color="primary"
            [printStyle]="{table : {'border-collapse':'collapse'}, td : {'border': 'solid 1px'}, th : {'border': 'solid 1px'}}"
            printSectionId="print-section2" ngxPrint>
            print
        </button> -->
        <button class="noPrint" style="margin-top: 2%; margin-left: 2%"
            (click)="exportExcel('Contract_InDetails_Report')" mat-raised-button color="primary">
            Export
        </button>

        <!-- <button class="noPrint" style="margin-top: 2%; margin-left: 2%" mat-raised-button color="primary"
           [useExistingCss]="true"
            printSectionId="print-section" ngxPrint>
            Print
        </button> -->

        <button class="noPrint" style="margin-top: 2%; margin-left: 2%" mat-raised-button color="primary"
            (click)="printPage()">
            Print
        </button>

        <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>
            Close
        </button>
    </div>

</div>

<!-- Taluka Wise Indetails -->
<div class="table-container" *ngIf="reportType == 'RenewaltalukaIndetails'">
    <div id="print-section1" class="container">

        <table class="fixed-header">
            <thead>
                <tr>
                    <th colspan="64"
                        style="text-align: center !important; font-size: 14px; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black;">
                        हिंदुस्तान प्रकाशन संस्था - विवेक साप्ताहिक - वर्गणी विभाग रिपोर्ट वर्गणीदार नूतनीकरण व्यवसाय
                    </th>
                    <th colspan="5"
                        style="text-align: center !important; border-top: 2px solid black; border-right: 2px solid black;">
                        दिनांक : {{ currentDate | date: 'dd-MM-yyyy' }}</th>
                </tr>
                <tr>
                    <th colspan="59"
                        style="text-align: center !important; font-size: 13px; padding-left: 7%; border-left: 2px solid black;">
                        तालुका निहाय बाकी तपशील</th>
                    <th colspan="5"
                        style="text-align: center !important; border-left: 2px solid black; border-right: 2px solid black;">
                        दिनांक पासून:{{startDate | date: 'dd-MM-yyyy'}} </th>
                    <th colspan="5" style="text-align: center !important; border-right: 2px solid black;">पर्यंत:
                        {{endDate | date: 'dd-MM-yyyy'}}</th>
                </tr>

                <tr>
                    <th colspan="4" style="font-size: 13px; border-left: 2px solid black; border-top: 2px solid black;">
                        नुतनीकरण येणे बाकी(तालुका निहाय)</th>

                    <th colspan="5"
                        style="font-size: 13px; text-align: center; font-weight: 600; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        एप्रिल</th>
                    <th colspan="5"
                        style="font-size: 13px; text-align: center; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        मे</th>
                    <th colspan="5"
                        style="font-size: 13px; text-align: center;border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        जून</th>
                    <th colspan="5"
                        style="font-size: 13px; text-align: center;border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        जुलै</th>
                    <th colspan="5"
                        style="font-size: 13px; text-align: center;border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        ऑगस्ट</th>
                    <th colspan="5"
                        style="font-size: 13px; text-align: center;border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        सप्टेंबर</th>
                    <th colspan="5"
                        style="font-size: 13px; text-align: center;border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        ऑक्टोबर</th>
                    <th colspan="5"
                        style="font-size: 13px; text-align: center;border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        नोव्हेंबर</th>
                    <th colspan="5"
                        style="font-size: 13px; text-align: center;border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        डिसेंबर</th>
                    <th colspan="5"
                        style="font-size: 13px; text-align: center;border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        जानेवारी</th>
                    <th colspan="5"
                        style="font-size: 13px; text-align: center;border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        फेब्रुवारी</th>
                    <th colspan="5"
                        style="font-size: 13px; text-align: center;border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        मार्च</th>
                    <th colspan="5"
                        style="font-size: 13px; text-align: center;border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        एकूण</th>
                </tr>

                <tr>
                    <th colspan="1"
                        style="font-size: 13px; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        देश</th>
                    <th colspan="1"
                        style="font-size: 13px; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        राज्य</th>
                    <th colspan="1"
                        style="font-size: 13px; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        जिल्हा</th>
                    <th colspan="1"
                        style="font-size: 13px; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        तालुका</th>
                    <th style="font-size: 13px; border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट
                    </th>
                    <th style="font-size: 13px; border-bottom: 2px solid black;">हस्ते</th>
                    <th
                        style="font-size: 13px; overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">
                        मॅगझीन</th>
                    <th
                        style="font-size: 13px; overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">
                        डिजिटल</th>
                    <th style="font-size: 13px; border-bottom: 2px solid black;">एकूण</th>
                    <th style="font-size: 13px; border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट
                    </th>
                    <th style="font-size: 13px; border-bottom: 2px solid black;">हस्ते</th>
                    <th
                        style="font-size: 13px; overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">
                        मॅगझीन</th>
                    <th
                        style="font-size: 13px; overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">
                        डिजिटल</th>
                    <th style="font-size: 13px; border-bottom: 2px solid black;">एकूण</th>
                    <th style="font-size: 13px; border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट
                    </th>
                    <th style="font-size: 13px; border-bottom: 2px solid black;">हस्ते</th>
                    <th
                        style="font-size: 13px; overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">
                        मॅगझीन</th>
                    <th
                        style="font-size: 13px; overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">
                        डिजिटल</th>
                    <th style="font-size: 13px; border-bottom: 2px solid black;">एकूण</th>
                    <th style="font-size: 13px; border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट
                    </th>
                    <th style="font-size: 13px; border-bottom: 2px solid black;">हस्ते</th>
                    <th
                        style="font-size: 13px; overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">
                        मॅगझीन</th>
                    <th
                        style="font-size: 13px; overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">
                        डिजिटल</th>
                    <th style="font-size: 13px; border-bottom: 2px solid black;">एकूण</th>
                    <th style="font-size: 13px; border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट
                    </th>
                    <th style="font-size: 13px; border-bottom: 2px solid black;">हस्ते</th>
                    <th
                        style="font-size: 13px; overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">
                        मॅगझीन</th>
                    <th
                        style="font-size: 13px; overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">
                        डिजिटल</th>
                    <th style="font-size: 13px; border-bottom: 2px solid black;">एकूण</th>
                    <th style="font-size: 13px; border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट
                    </th>
                    <th style="font-size: 13px; border-bottom: 2px solid black;">हस्ते</th>
                    <th
                        style="font-size: 13px; overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">
                        मॅगझीन</th>
                    <th
                        style="font-size: 13px; overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">
                        डिजिटल</th>
                    <th style="font-size: 13px; border-bottom: 2px solid black;">एकूण</th>
                    <th style="font-size: 13px; border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट
                    </th>
                    <th style="font-size: 13px; border-bottom: 2px solid black;">हस्ते</th>
                    <th
                        style="font-size: 13px; overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">
                        मॅगझीन</th>
                    <th
                        style="font-size: 13px; overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">
                        डिजिटल</th>
                    <th style="font-size: 13px; border-bottom: 2px solid black;">एकूण</th>
                    <th style="font-size: 13px; border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट
                    </th>
                    <th style="font-size: 13px; border-bottom: 2px solid black;">हस्ते</th>
                    <th
                        style="font-size: 13px; overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">
                        मॅगझीन</th>
                    <th
                        style="font-size: 13px; overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">
                        डिजिटल</th>
                    <th style="font-size: 13px; border-bottom: 2px solid black;">एकूण</th>
                    <th style="font-size: 13px; border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट
                    </th>
                    <th style="font-size: 13px; border-bottom: 2px solid black;">हस्ते</th>
                    <th
                        style="font-size: 13px; overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">
                        मॅगझीन</th>
                    <th
                        style="font-size: 13px; overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">
                        डिजिटल</th>
                    <th style="font-size: 13px; border-bottom: 2px solid black;">एकूण</th>
                    <th style="font-size: 13px; border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट
                    </th>
                    <th style="font-size: 13px; border-bottom: 2px solid black;">हस्ते</th>
                    <th
                        style="font-size: 13px; overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">
                        मॅगझीन</th>
                    <th
                        style="font-size: 13px; overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">
                        डिजिटल</th>
                    <th style="font-size: 13px; border-bottom: 2px solid black;">एकूण</th>
                    <th style="font-size: 13px; border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट
                    </th>
                    <th style="font-size: 13px; border-bottom: 2px solid black;">हस्ते</th>
                    <th
                        style="font-size: 13px; overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">
                        मॅगझीन</th>
                    <th
                        style="font-size: 13px; overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">
                        डिजिटल</th>
                    <th style="font-size: 13px; border-bottom: 2px solid black;">एकूण</th>
                    <th style="font-size: 13px; border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट
                    </th>
                    <th style="font-size: 13px; border-bottom: 2px solid black;">हस्ते</th>
                    <th
                        style="font-size: 13px; overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">
                        मॅगझीन</th>
                    <th
                        style="font-size: 13px; overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">
                        डिजिटल</th>
                    <th style="font-size: 13px; border-bottom: 2px solid black;">एकूण</th>
                    <th style="font-size: 13px; border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट
                    </th>
                    <th style="font-size: 13px; border-bottom: 2px solid black;">हस्ते</th>
                    <th
                        style="font-size: 13px; overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">
                        मॅगझीन</th>
                    <th
                        style="font-size: 13px; overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">
                        डिजिटल</th>
                    <th style="font-size: 13px; border-right: 2px solid black; border-bottom: 2px solid black;">एकूण
                    </th>
                </tr>

            </thead>
            <!-- *ngFor="let data of OutstandingInDetailFormBeans; let i = index" -->
            <tbody>
                <ng-container *ngFor="let data of SubByTalukaIndetails; let i = index">
                    <tr>
                        <td colspan="1"
                            style="text-align: left; font-weight: bold; border-left: 2px solid black; word-wrap: break-word; border-bottom: 2px solid black;">
                            {{data.country}} </td>
                        <td colspan="1"
                            style="text-align: left; font-weight: bold; border-left: 2px solid black; word-wrap: break-word; border-bottom: 2px solid black;">
                            {{data.state}} </td>
                        <td colspan="2" style="border-left: 2px solid black;"></td>
                        <!-- <td colspan="65" style="border-left: 2px solid black; border-right: 2px solid black;"></td> -->
                        <td colspan="5" style="border-left: 2px solid black; border-right: 2px solid black;"></td>
                        <td colspan="5" style="border-left: 2px solid black; border-right: 2px solid black;"></td>
                        <td colspan="5" style="border-left: 2px solid black; border-right: 2px solid black;"></td>
                        <td colspan="5" style="border-left: 2px solid black; border-right: 2px solid black;"></td>
                        <td colspan="5" style="border-left: 2px solid black; border-right: 2px solid black;"></td>
                        <td colspan="5" style="border-left: 2px solid black; border-right: 2px solid black;"></td>
                        <td colspan="5" style="border-left: 2px solid black; border-right: 2px solid black;"></td>
                        <td colspan="5" style="border-left: 2px solid black; border-right: 2px solid black;"></td>
                        <td colspan="5" style="border-left: 2px solid black; border-right: 2px solid black;"></td>
                        <td colspan="5" style="border-left: 2px solid black; border-right: 2px solid black;"></td>
                        <td colspan="5" style="border-left: 2px solid black; border-right: 2px solid black;"></td>
                        <td colspan="5" style="border-left: 2px solid black; border-right: 2px solid black;"></td>
                        <td colspan="5" style="border-left: 2px solid black; border-right: 2px solid black;"></td>

                    </tr>

                    <ng-container *ngFor="let data2 of data.districts; let j = index">
                        <tr>

                            <td colspan="2" style="border-left: 2px solid black;"></td>
                            <td colspan="1"
                                style="border-left: 2px solid black; word-wrap: break-word; font-weight: bold; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{data2.district}}</td>
                            <td colspan="1"
                                style="border-left: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                            </td>
                            <!-- <td colspan="65" style="border-left: 2px solid black;"></td> -->
                            <td colspan="5" style="border-right: 2px solid black;"></td>
                            <td colspan="5" style="border-right: 2px solid black;"></td>
                            <td colspan="5" style="border-right: 2px solid black;"></td>
                            <td colspan="5" style="border-right: 2px solid black;"></td>
                            <td colspan="5" style="border-right: 2px solid black;"></td>
                            <td colspan="5" style="border-right: 2px solid black;"></td>
                            <td colspan="5" style="border-right: 2px solid black;"></td>
                            <td colspan="5" style="border-right: 2px solid black;"></td>
                            <td colspan="5" style="border-right: 2px solid black;"></td>
                            <td colspan="5" style="border-right: 2px solid black;"></td>
                            <td colspan="5" style="border-right: 2px solid black;"></td>
                            <td colspan="5" style="border-right: 2px solid black;"></td>
                            <td colspan="5" style="border-right: 2px solid black;"></td>
                        </tr>
                        <ng-container *ngFor="let data3 of data2.talukas; let k = index">
                            <tr>
                                <td colspan="3" style="border-left: 2px solid black;"></td>
                                <td colspan="1"
                                    style="border-left: 2px solid black; font-weight: bold; word-wrap: break-word; border-right: 2px solid black; border-top: 2px solid black;">
                                    {{data3.taluka}}</td>
                                <!-- <td colspan="65" style="border-left: 2px solid black;"></td> -->
                                <td colspan="5" style="border-right: 2px solid black;"></td>
                                <td colspan="5" style="border-right: 2px solid black;"></td>
                                <td colspan="5" style="border-right: 2px solid black;"></td>
                                <td colspan="5" style="border-right: 2px solid black;"></td>
                                <td colspan="5" style="border-right: 2px solid black;"></td>
                                <td colspan="5" style="border-right: 2px solid black;"></td>
                                <td colspan="5" style="border-right: 2px solid black;"></td>
                                <td colspan="5" style="border-right: 2px solid black;"></td>
                                <td colspan="5" style="border-right: 2px solid black;"></td>
                                <td colspan="5" style="border-right: 2px solid black;"></td>
                                <td colspan="5" style="border-right: 2px solid black;"></td>
                                <td colspan="5" style="border-right: 2px solid black;"></td>
                                <td colspan="5" style="border-right: 2px solid black;"></td>
                            </tr>


                            <ng-container *ngFor="let data4 of data3.rep_info; let l = index">
                                <tr>
                                    <td colspan="2"
                                        style="border-left: 2px solid black; font-weight: bold; word-wrap: break-word; border-top: 2px solid black;">
                                        {{data4.rep_name}} - {{data2.district}}</td>
                                    <td colspan="1" style="border-left: 2px solid black;"></td>
                                    <td colspan="1"
                                        style="border-left: 2px solid black;font-weight: bold; word-wrap: break-word;">
                                        {{data3.taluka}}</td>

                                    <td style="text-align: right; border-left: 2px solid black;">
                                        {{data4.april_post_count}}</td>
                                    <td style="text-align: right; ">{{data4.april_haste_count}}</td>
                                    <td style="text-align: right;">{{data4.april_magzine_count}}</td>
                                    <td style="text-align: right;">{{data4.april_digital_count}}</td>
                                    <td style="text-align: right;">{{data4.april_total}}</td>
                                    <td style="text-align: right; border-left: 2px solid black;">
                                        {{data4.may_post_count}}</td>
                                    <td style="text-align: right;">{{data4.may_haste_count}}</td>
                                    <td style="text-align: right;">{{data4.may_magzine_count}}</td>
                                    <td style="text-align: right;">{{data4.may_digital_count}}</td>
                                    <td style="text-align: right;">{{data4.may_total}}</td>
                                    <td style="text-align: right; border-left: 2px solid black;">
                                        {{data4.jun_post_count}}</td>
                                    <td style="text-align: right;">{{data4.jun_haste_count}}</td>
                                    <td style="text-align: right;">{{data4.jun_magzine_count}}</td>
                                    <td style="text-align: right;">{{data4.jun_digital_count}}</td>
                                    <td style="text-align: right;">{{data4.jun_total}}</td>
                                    <!-- april -->
                                    <td style="text-align: right; border-left: 2px solid black;">
                                        {{data4.jul_post_count}}</td>
                                    <td style="text-align: right;">{{data4.jul_haste_count}}</td>
                                    <td style="text-align: right;">{{data4.jul_magzine_count}}</td>
                                    <td style="text-align: right;">{{data4.jul_digital_count}}</td>
                                    <td style="text-align: right;">{{data4.jul_total}}</td>
                                    <td style="text-align: right; border-left: 2px solid black;">
                                        {{data4.aug_post_count}}</td>
                                    <td style="text-align: right;">{{data4.aug_haste_count}}</td>
                                    <td style="text-align: right;">{{data4.aug_magzine_count}}</td>
                                    <td style="text-align: right;">{{data4.aug_digital_count}}</td>
                                    <td style="text-align: right;">{{data4.aug_total}}</td>
                                    <td style="text-align: right; border-left: 2px solid black;">
                                        {{data4.sep_post_count}}</td>
                                    <td style="text-align: right;">{{data4.sep_haste_count}}</td>
                                    <td style="text-align: right;">{{data4.sep_magzine_count}}</td>
                                    <td style="text-align: right;">{{data4.sep_digital_count}}</td>
                                    <td style="text-align: right;">{{data4.sep_total}}</td>
                                    <td style="text-align: right; border-left: 2px solid black;">
                                        {{data4.oct_post_count}}</td>
                                    <td style="text-align: right;">{{data4.oct_haste_count}}</td>
                                    <td style="text-align: right;">{{data4.oct_magzine_count}}</td>
                                    <td style="text-align: right;">{{data4.oct_digital_count}}</td>
                                    <td style="text-align: right;">{{data4.oct_total}}</td>
                                    <td style="text-align: right; border-left: 2px solid black;">
                                        {{data4.nov_post_count}}</td>
                                    <td style="text-align: right;">{{data4.nov_haste_count}}</td>
                                    <td style="text-align: right;">{{data4.nov_magzine_count}}</td>
                                    <td style="text-align: right;">{{data4.nov_digital_count}}</td>
                                    <td style="text-align: right;">{{data4.nov_total}}</td>
                                    <td style="text-align: right; border-left: 2px solid black;">
                                        {{data4.dec_post_count}}</td>
                                    <td style="text-align: right;">{{data4.dec_haste_count}}</td>
                                    <td style="text-align: right;">{{data4.dec_magzine_count}}</td>
                                    <td style="text-align: right;">{{data4.dec_digital_count}}</td>
                                    <td style="text-align: right;">{{data4.dec_total}}</td>
                                    <td style="text-align: right; border-left: 2px solid black;">
                                        {{data4.jan_post_count}}</td>
                                    <td style="text-align: right;">{{data4.jan_haste_count}}</td>
                                    <td style="text-align: right;">{{data4.jan_magzine_count}}</td>
                                    <td style="text-align: right;">{{data4.jan_digital_count}}</td>
                                    <td style="text-align: right;">{{data4.jan_total}}</td>
                                    <td style="text-align: right; border-left: 2px solid black;">
                                        {{data4.feb_post_count}}</td>
                                    <td style="text-align: right;">{{data4.feb_haste_count}}</td>
                                    <td style="text-align: right;">{{data4.feb_magzine_count}}</td>
                                    <td style="text-align: right;">{{data4.feb_digital_count}}</td>
                                    <td style="text-align: right;">{{data4.feb_total}}</td>
                                    <td style="text-align: right; border-left: 2px solid black;">
                                        {{data4.mar_post_count}}</td>
                                    <td style="text-align: right;">{{data4.mar_haste_count}}</td>
                                    <td style="text-align: right;">{{data4.mar_magzine_count}}</td>
                                    <td style="text-align: right;">{{data4.mar_digital_count}}</td>
                                    <td style="text-align: right;">{{data4.mar_total}}</td>

                                    <td style="text-align: right; border-left: 2px solid black;">{{data4.post_total}}
                                    </td>
                                    <td style="text-align: right;">{{data4.haste_total}}</td>
                                    <td style="text-align: right;">{{data4.magzine_total}}</td>
                                    <td style="text-align: right;">{{data4.digital_total}}</td>
                                    <td style="text-align: right; border-right: 2px solid black;">{{data4.grand_total}}
                                    </td>

                                </tr>

                            </ng-container>
                            <tr *ngIf="data2.talukas.length!=0">

                                <td colspan="4"
                                    style="text-align: right; font-weight: bold; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    एकूण :-</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.aprilpost}}</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.aprilhaste}}</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.aprilmagzine}}</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.aprildigital}}</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.apriltotal}}</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.maypost}}</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.mayhaste}}</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.maymagzine}}</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.maydigital}}</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.maytotal}}</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.junepost}}</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.junehaste}}</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.junmagzine}}</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.jundigital}}</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.junetotal}}</td>

                                <td
                                    style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.julypost}}</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.julyhaste}}</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.julymagzine}}</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.julydigital}}</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.julytotal}}</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.augpost}}</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.aughaste}}</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.augmagzine}}</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.augdigital}}</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.augtotal}}</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.seppost}}</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.sephaste}}</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.sepmagzine}}</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.sepdigital}}</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.septotal}}</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.octopost}}</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.octohaste}}</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.octmagzine}}</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.octdigital}}</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.octototal}}</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.novpost}}</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.novhaste}}</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.novmagzine}}</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.novdigital}}</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.novtotal}}</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.decpost}}</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.dechaste}}</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.decmagzine}}</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.decdigital}}</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.dectotal}}</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.janpost}}</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.janhaste}}</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.janmagzine}}</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.jandigital}}</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.jantotal}}</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.febpost}}</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.febhaste}}</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.febmagzine}}</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.febdigital}}</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.febtotal}}</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.marchpost}}</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.marchhaste}}</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.marchmagzine}}</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.marchdigital}}</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.marchtotal}}</td>

                                <td
                                    style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.totalTalukaPostIndetail2}}</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.totalTalukaHasteIndetails2}}</td>
                                <td
                                    style="text-align: right; font-weight: bold;border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.totalTalukaMagzineIndetails2}}</td>
                                <td
                                    style="text-align: right; font-weight: bold;border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.totalTalukaDigitalIndetails2}}</td>
                                <td
                                    style="text-align: right; font-weight: bold; border-right: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                                    {{data3.totalTalukaTotalIndetailTotal2}}</td>
                            </tr>
                        </ng-container>
                    </ng-container>
                </ng-container>

                <tr *ngIf="!show">
                    <td colspan="4"
                        style="text-align: left; font-weight: bold;  font-size: 11px; border-left: 2px solid black; border-right: 2px solid black; border-bottom: 2px solid black;">
                        एकूण :- </td>

                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{aprilpost}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{aprilhaste}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{aprilmagzine}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{aprildigital}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{apriltotal}}
                    </td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{maypost}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{mayhaste}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{maymagzine}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{maydigital}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{maytotal}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{junepost}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{junehaste}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{junmagzine}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{jundigital}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{junetotal}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{julypost}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{julyhaste}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{julymagzine}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{julydigital}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{julytotal}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{augpost}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{aughaste}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{augmagzine}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{augdigital}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{augtotal}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{seppost}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{sephaste}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{sepmagzine}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{sepdigital}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{septotal}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{octopost}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{octohaste}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{octmagzine}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{octdigital}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{octototal}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{novpost}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{novhaste}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{novmagzine}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{novdigital}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{novtotal}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{decpost}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{dechaste}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{decmagzine}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{decdigital}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{dectotal}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{janpost}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{janhaste}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{janmagzine}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{jandigital}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{jantotal}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{febpost}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{febhaste}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{febmagzine}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{febdigital}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{febtotal}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{marchpost}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{marchhaste}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{marchmagzine}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{marchdigital}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{marchtotal}}
                    </td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{totalTalukaPostIndetail}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{totalTalukaHasteIndetails}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{totalTalukaMagzineIndetails}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{totalTalukaDigitalIndetails}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-right: 2px solid black; border-bottom: 2px solid black;">
                        {{totalTalukaTotalIndetailTotal}}</td>


                </tr>

            </tbody>

            <tfoot *ngIf="show">
                <tr>
                    <td colspan="4"
                        style="text-align: left; font-weight: bold;  font-size: 11px; border-left: 2px solid black; border-right: 2px solid black; border-bottom: 2px solid black;">
                        एकूण :- </td>

                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{aprilpost}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{aprilhaste}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{aprilmagzine}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{aprildigital}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{apriltotal}}
                    </td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{maypost}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{mayhaste}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{maymagzine}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{maydigital}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{maytotal}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{junepost}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{junehaste}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{junmagzine}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{jundigital}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{junetotal}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{julypost}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{julyhaste}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{julymagzine}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{julydigital}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{julytotal}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{augpost}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{aughaste}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{augmagzine}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{augdigital}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{augtotal}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{seppost}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{sephaste}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{sepmagzine}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{sepdigital}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{septotal}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{octopost}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{octohaste}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{octmagzine}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{octdigital}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{octototal}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{novpost}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{novhaste}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{novmagzine}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{novdigital}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{novtotal}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{decpost}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{dechaste}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{decmagzine}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{decdigital}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{dectotal}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{janpost}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{janhaste}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{janmagzine}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{jandigital}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{jantotal}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{febpost}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{febhaste}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{febmagzine}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{febdigital}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{febtotal}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{marchpost}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{marchhaste}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{marchmagzine}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{marchdigital}}
                    </td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">{{marchtotal}}
                    </td>
                    <td
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black;">
                        {{totalTalukaPostIndetail}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{totalTalukaHasteIndetails}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{totalTalukaMagzineIndetails}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{totalTalukaDigitalIndetails}}</td>
                    <td
                        style="text-align: right; font-weight: bold; border-right: 2px solid black; border-bottom: 2px solid black;">
                        {{totalTalukaTotalIndetailTotal}}</td>


                </tr>
            </tfoot>
        </table>


    </div>

    <div style="margin-left: 40%; margin-bottom: 2%;">

        <button class="noPrint" style="margin-top: 2%; margin-left: 2%"
            (click)="exportExcel('Contract_InDetails_Report')" mat-raised-button color="primary">
            Export
        </button>

        <button class="noPrint" style="margin-top: 2%; margin-left: 2%" mat-raised-button color="primary"
            (click)="printPage()">
            Print
        </button>

        <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>
            Close
        </button>
    </div>

</div>


<div *ngIf="reportType == 'Renewalrep'">
    <div id="print-section1" class="container">

        <table class="table table-bordered">
            <thead>
                <tr>
                    <th colspan="69"
                        style="text-align: center !important; font-size: 20px; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black;">
                        प्रतिनिधी निहाय </th>
                    <!-- <th colspan="2">Advt. Outstanding Report</th> -->
                    <!-- <th colspan="2">दिनांक</th>
                    <th colspan="2">पृष्ठ क्र</th> -->
                </tr>
                <tr>
                    <th colspan="64"
                        style="text-align: center !important; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black;">
                        हिंदुस्तान प्रकाशन संस्था - विवेक साप्ताहिक - वर्गणी विभाग</th>
                    <th colspan="5"
                        style="text-align: center !important; border-right: 2px solid black; border-top: 2px solid black;">
                        दिनांक :- {{ currentDate | date: 'dd-MM-yyyy' }}
                    </th>
                    <!-- <th colspan="2">To {{endDate}}</th>
                     <th colspan="1">In Details</th>  -->
                </tr>
                <tr>
                    <th colspan="29"
                        style="text-align: center !important; border-left: 2px solid black;  border-top: 2px solid black;">
                        वर्गणीदार नोंदणी - नवीन व्यवसाय तपशिल </th>
                    <!-- <th colspan="20" style="text-align: center !important;">प्रांताचे नाव :- {{prant_name}}</th> -->
                    <th colspan="30"
                        style="text-align: center !important; border-left: 2px solid black;  border-top: 2px solid black;">
                        वितरण पद्धतीनुसार</th>
                    <!-- <th colspan="5" style="text-align: center !important;">Very Briefly</th> -->
                    <!-- <th colspan="4" style="text-align: center !important;">From</th>
                    <th colspan="4" style="text-align: center !important;">To</th> 
                     -->
                    <th colspan="5"
                        style="text-align: center !important; border-left: 2px solid black;  border-top: 2px solid black;">
                        दिनांक पासून :- {{startDate | date: 'dd-MM-yyyy'}}</th>
                    <th colspan="5"
                        style="text-align: center !important; border-left: 2px solid black; border-right: 2px solid black;  border-top: 2px solid black;">
                        पर्यंत :- {{endDate | date: 'dd-MM-yyyy'}}</th>
                </tr>
                <tr>
                    <th colspan="4"
                        style="border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        नूतनीकरण येणे बाकी (प्रतिनिधीनिहाय)</th>

                    <th colspan="5"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        एप्रिल</th>
                    <th colspan="5"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        मे</th>
                    <th colspan="5"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        जून</th>
                    <th colspan="5"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        जुलै</th>
                    <th colspan="5"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        ऑगस्ट</th>
                    <th colspan="5"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        सप्टेंबर</th>
                    <th colspan="5"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        ऑक्टोबर</th>
                    <th colspan="5"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        नोव्हेंबर</th>
                    <th colspan="5"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        डिसेंबर</th>
                    <th colspan="5"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        जानेवारी</th>
                    <th colspan="5"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        फेब्रुवारी</th>
                    <th colspan="5"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        मार्च</th>
                    <th colspan="5"
                        style="text-align: center; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        एकूण</th>

                </tr>
                <tr>
                    <th colspan="2" style="border-left: 2px solid black; border-bottom: 2px solid black;">जिल्हा</th>
                    <th colspan="2" style="border-left: 2px solid black; border-bottom: 2px solid black;">तालुका</th>
                    <!-- <th colspan="1">तालुका</th> -->
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट</th>
                    <th style="border-bottom: 2px solid black;">हस्ते</th>
                    <th style="border-bottom: 2px solid black;">मॅगझीन</th>
                    <th style="border-bottom: 2px solid black;">डिजिटल</th>
                    <th style="border-bottom: 2px solid black;">एकूण</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट</th>
                    <th style="border-bottom: 2px solid black;">हस्ते</th>
                    <th style="border-bottom: 2px solid black;">मॅगझीन</th>
                    <th style="border-bottom: 2px solid black;">डिजिटल</th>
                    <th style="border-bottom: 2px solid black;">एकूण</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट</th>
                    <th style="border-bottom: 2px solid black;">हस्ते</th>
                    <th style="border-bottom: 2px solid black;">मॅगझीन</th>
                    <th style="border-bottom: 2px solid black;">डिजिटल</th>
                    <th style="border-bottom: 2px solid black;">एकूण</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट</th>
                    <th style="border-bottom: 2px solid black;">हस्ते</th>
                    <th style="border-bottom: 2px solid black;">मॅगझीन</th>
                    <th style="border-bottom: 2px solid black;">डिजिटल</th>
                    <th style="border-bottom: 2px solid black;">एकूण</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट</th>
                    <th style="border-bottom: 2px solid black;">हस्ते</th>
                    <th style="border-bottom: 2px solid black;">मॅगझीन</th>
                    <th style="border-bottom: 2px solid black;">डिजिटल</th>
                    <th style="border-bottom: 2px solid black;">एकूण</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट</th>
                    <th style="border-bottom: 2px solid black;">हस्ते</th>
                    <th style="border-bottom: 2px solid black;">मॅगझीन</th>
                    <th style="border-bottom: 2px solid black;">डिजिटल</th>
                    <th style="border-bottom: 2px solid black;">एकूण</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट</th>
                    <th style="border-bottom: 2px solid black;">हस्ते</th>
                    <th style="border-bottom: 2px solid black;">मॅगझीन</th>
                    <th style="border-bottom: 2px solid black;">डिजिटल</th>
                    <th style="border-bottom: 2px solid black;">एकूण</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट</th>
                    <th style="border-bottom: 2px solid black;">हस्ते</th>
                    <th style="border-bottom: 2px solid black;">मॅगझीन</th>
                    <th style="border-bottom: 2px solid black;">डिजिटल</th>
                    <th style="border-bottom: 2px solid black;">एकूण</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट</th>
                    <th style="border-bottom: 2px solid black;">हस्ते</th>
                    <th style="border-bottom: 2px solid black;">मॅगझीन</th>
                    <th style="border-bottom: 2px solid black;">डिजिटल</th>
                    <th style="border-bottom: 2px solid black;">एकूण</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट</th>
                    <th style="border-bottom: 2px solid black;">हस्ते</th>
                    <th style="border-bottom: 2px solid black;">मॅगझीन</th>
                    <th style="border-bottom: 2px solid black;">डिजिटल</th>
                    <th style="border-bottom: 2px solid black;">एकूण</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट</th>
                    <th style="border-bottom: 2px solid black;">हस्ते</th>
                    <th style="border-bottom: 2px solid black;">मॅगझीन</th>
                    <th style="border-bottom: 2px solid black;">डिजिटल</th>
                    <th style="border-bottom: 2px solid black;">एकूण</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट</th>
                    <th style="border-bottom: 2px solid black;">हस्ते</th>
                    <th style="border-bottom: 2px solid black;">मॅगझीन</th>
                    <th style="border-bottom: 2px solid black;">डिजिटल</th>
                    <th style="border-bottom: 2px solid black;">एकूण</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट</th>
                    <th style="border-bottom: 2px solid black;">हस्ते</th>
                    <th style="border-bottom: 2px solid black;">मॅगझीन</th>
                    <th style="border-bottom: 2px solid black;">डिजिटल</th>
                    <th
                        style="border-right: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                        एकूण</th>
                </tr>
            </thead>
            <!-- *ngFor="let data of OutstandingInDetailFormBeans; let i = index" -->
            <tbody *ngFor="let data1 of SubByRep; let i = index">

                <tr>
                    <td colspan="4"
                        style="font-size: 15px; font-weight: bold; text-align: left !important; border-left: 2px solid black !important; padding: 3px;border-radius: 5px !important; border-right: 2px solid black;">
                        {{data1.rep_name}}</td>
                    <!-- <td colspan="65" style="font-size: 15px; font-weight: bold; text-align: center !important; border-left: 2px solid black; border-right: 2px solid black;"></td> -->
                    <td colspan="5" style="border-right: 2px solid black;"></td>
                    <td colspan="5" style="border-right: 2px solid black;"></td>
                    <td colspan="5" style="border-right: 2px solid black;"></td>
                    <td colspan="5" style="border-right: 2px solid black;"></td>
                    <td colspan="5" style="border-right: 2px solid black;"></td>
                    <td colspan="5" style="border-right: 2px solid black;"></td>
                    <td colspan="5" style="border-right: 2px solid black;"></td>
                    <td colspan="5" style="border-right: 2px solid black;"></td>
                    <td colspan="5" style="border-right: 2px solid black;"></td>
                    <td colspan="5" style="border-right: 2px solid black;"></td>
                    <td colspan="5" style="border-right: 2px solid black;"></td>
                    <td colspan="5" style="border-right: 2px solid black;"></td>
                    <td colspan="5" style="border-right: 2px solid black;"></td>

                </tr>
                <ng-container *ngFor="let data of data1.rep_data; let i = index">
                    <tr>
                        <td colspan="2" style="border-left: 2px solid black;">{{data.district}}</td>
                        <td colspan="2" style="border-left: 2px solid black;">{{data.taluka}}</td>
                        <td style="text-align:right; border-left: 2px solid black;">{{data.april_post_count}}</td>
                        <td style="text-align:right">{{data.april_haste_count}}</td>
                        <td style="text-align:right">{{data.april_magzine_count}}</td>
                        <td style="text-align:right">{{data.april_digital_count}}</td>
                        <td style="text-align:right">{{data.april_total}}</td>
                        <!-- april -->
                        <td style="text-align:right; border-left: 2px solid black;">{{data.may_post_count}}</td>
                        <td style="text-align:right">{{data.may_haste_count}}</td>
                        <td style="text-align:right">{{data.may_magzine_count}}</td>
                        <td style="text-align:right">{{data.may_digital_count}}</td>
                        <td style="text-align:right">{{data.may_total}}</td>

                        <td style="text-align:right; border-left: 2px solid black;">{{data.jun_post_count}}</td>
                        <td style="text-align:right">{{data.jun_haste_count}}</td>
                        <td style="text-align:right">{{data.jun_magzine_count}}</td>
                        <td style="text-align:right">{{data.jun_digital_count}}</td>
                        <td style="text-align:right">{{data.jun_total}}</td>

                        <td style="text-align:right; border-left: 2px solid black;">{{data.jul_post_count}}</td>
                        <td style="text-align:right">{{data.jul_haste_count}}</td>
                        <td style="text-align:right">{{data.jul_magzine_count}}</td>
                        <td style="text-align:right">{{data.jul_digital_count}}</td>
                        <td style="text-align:right">{{data.jul_total}}</td>

                        <td style="text-align:right; border-left: 2px solid black;">{{data.aug_post_count}}</td>
                        <td style="text-align:right">{{data.aug_haste_count}}</td>
                        <td style="text-align:right">{{data.aug_magzine_count}}</td>
                        <td style="text-align:right">{{data.aug_digital_count}}</td>
                        <td style="text-align:right">{{data.aug_total}}</td>

                        <td style="text-align:right; border-left: 2px solid black;">{{data.sep_post_count}}</td>
                        <td style="text-align:right">{{data.sep_haste_count}}</td>
                        <td style="text-align:right">{{data.sep_magzine_count}}</td>
                        <td style="text-align:right">{{data.sep_digital_count}}</td>
                        <td style="text-align:right">{{data.sep_total}}</td>

                        <td style="text-align:right; border-left: 2px solid black;">{{data.oct_post_count}}</td>
                        <td style="text-align:right">{{data.oct_haste_count}}</td>
                        <td style="text-align:right">{{data.oct_magzine_count}}</td>
                        <td style="text-align:right">{{data.oct_digital_count}}</td>
                        <td style="text-align:right">{{data.oct_total}}</td>

                        <td style="text-align:right; border-left: 2px solid black;">{{data.nov_post_count}}</td>
                        <td style="text-align:right">{{data.nov_haste_count}}</td>
                        <td style="text-align:right">{{data.nov_magzine_count}}</td>
                        <td style="text-align:right">{{data.nov_digital_count}}</td>
                        <td style="text-align:right">{{data.nov_total}}</td>

                        <td style="text-align:right; border-left: 2px solid black;">{{data.dec_post_count}}</td>
                        <td style="text-align:right">{{data.dec_haste_count}}</td>
                        <td style="text-align:right">{{data.dec_magzine_count}}</td>
                        <td style="text-align:right">{{data.dec_digital_count}}</td>
                        <td style="text-align:right">{{data.dec_total}}</td>

                        <td style="text-align:right; border-left: 2px solid black;">{{data.jan_post_count}}</td>
                        <td style="text-align:right">{{data.jan_haste_count}}</td>
                        <td style="text-align:right">{{data.jan_magzine_count}}</td>
                        <td style="text-align:right">{{data.jan_digital_count}}</td>
                        <td style="text-align:right">{{data.jan_total}}</td>

                        <td style="text-align:right; border-left: 2px solid black;">{{data.feb_post_count}}</td>
                        <td style="text-align:right">{{data.feb_haste_count}}</td>
                        <td style="text-align:right">{{data.feb_magzine_count}}</td>
                        <td style="text-align:right">{{data.feb_digital_count}}</td>
                        <td style="text-align:right">{{data.feb_total}}</td>

                        <td style="text-align:right; border-left: 2px solid black;">{{data.mar_post_count}}</td>
                        <td style="text-align:right">{{data.mar_haste_count}}</td>
                        <td style="text-align:right">{{data.mar_magzine_count}}</td>
                        <td style="text-align:right">{{data.mar_digital_count}}</td>
                        <td style="text-align:right">{{data.mar_total}}</td>

                        <td style="text-align:right; border-left: 2px solid black;">{{data.post_total}}</td>
                        <td style="text-align:right">{{data.haste_total}}</td>
                        <td style="text-align:right">{{data.magzine_total}}</td>
                        <td style="text-align:right">{{data.digital_total}}</td>
                        <td style="text-align:right; border-right: 2px solid black;">{{data.grand_total}}</td>




                    </tr>
                </ng-container>
                <tr>
                    <td colspan="4"
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-right: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                        <b>एकूण :- </b>
                    </td>
                    <td
                        style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-left: 2px solid black;">
                        {{data1.april_post_count_total}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{data1.april_haste_count_total}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{data1.april_magzine_count_total}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{data1.april_digital_count_total}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{data1.april_total_total_total}}</td>

                    <td
                        style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-left: 2px solid black;">
                        {{data1.may_post_count_total}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{data1.may_haste_count_total}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{data1.may_magzine_count_total}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{data1.may_digital_count_total}}</td>
                    <td style="text-align: right; font-weight: bold; border-bottom: 2px solid black;">
                        {{data1.may_total_total_total}}</td>

                    <td
                        style="text-align:right; font-weight: bold; border-bottom: 2px solid black; border-left: 2px solid black;">
                        {{data1.jun_post_count_total}}</td>
                    <td style="text-align:right; font-weight: bold; border-bottom: 2px solid black;">
                        {{data1.jun_haste_count_total}}</td>
                    <td style="text-align:right; font-weight: bold; border-bottom: 2px solid black;">
                        {{data1.jun_magzine_count_total}}</td>
                    <td style="text-align:right; font-weight: bold; border-bottom: 2px solid black;">
                        {{data1.jun_digital_count_total}}</td>
                    <td style="text-align:right; font-weight: bold; border-bottom: 2px solid black;">
                        {{data1.jun_total_total_total}}</td>

                    <td
                        style="text-align:right; font-weight: bold; border-bottom: 2px solid black; border-left: 2px solid black;">
                        {{data1.jul_post_count_total}}</td>
                    <td style="text-align:right; font-weight: bold; border-bottom: 2px solid black;">
                        {{data1.jul_haste_count_total}}</td>
                    <td style="text-align:right; font-weight: bold; border-bottom: 2px solid black;">
                        {{data1.jul_magzine_count_total}}</td>
                    <td style="text-align:right; font-weight: bold; border-bottom: 2px solid black;">
                        {{data1.jul_digital_count_total}}</td>
                    <td style="text-align:right; font-weight: bold; border-bottom: 2px solid black;">
                        {{data1.jul_total_total_total}}</td>

                    <td
                        style="text-align:right; font-weight: bold; border-bottom: 2px solid black; border-left: 2px solid black;">
                        {{data1.aug_post_count_total}}</td>
                    <td style="text-align:right; font-weight: bold; border-bottom: 2px solid black;">
                        {{data1.aug_haste_count_total}}</td>
                    <td style="text-align:right; font-weight: bold; border-bottom: 2px solid black;">
                        {{data1.aug_magzine_count_total}}</td>
                    <td style="text-align:right; font-weight: bold; border-bottom: 2px solid black;">
                        {{data1.aug_digital_count_total}}</td>
                    <td style="text-align:right; font-weight: bold; border-bottom: 2px solid black;">
                        {{data1.aug_total_total_total}}</td>

                    <td
                        style="text-align:right; font-weight: bold; border-bottom: 2px solid black; border-left: 2px solid black;">
                        {{data1.sep_post_count_total}}</td>
                    <td style="text-align:right; font-weight: bold; border-bottom: 2px solid black;">
                        {{data1.sep_haste_count_total}}</td>
                    <td style="text-align:right; font-weight: bold; border-bottom: 2px solid black;">
                        {{data1.sep_magzine_count_total}}</td>
                    <td style="text-align:right; font-weight: bold; border-bottom: 2px solid black;">
                        {{data1.sep_digital_count_total}}</td>
                    <td style="text-align:right; font-weight: bold; border-bottom: 2px solid black;">
                        {{data1.sep_total_total_total}}</td>

                    <td
                        style="text-align:right; font-weight: bold; border-bottom: 2px solid black; border-left: 2px solid black;">
                        {{data1.oct_post_count_total}}</td>
                    <td style="text-align:right; font-weight: bold; border-bottom: 2px solid black;">
                        {{data1.oct_haste_count_total}}</td>
                    <td style="text-align:right; font-weight: bold; border-bottom: 2px solid black;">
                        {{data1.oct_magzine_count_total}}</td>
                    <td style="text-align:right; font-weight: bold; border-bottom: 2px solid black;">
                        {{data1.oct_digital_count_total}}</td>
                    <td style="text-align:right; font-weight: bold; border-bottom: 2px solid black;">
                        {{data1.oct_total_total_total}}</td>

                    <td
                        style="text-align:right; font-weight: bold; border-bottom: 2px solid black; border-left: 2px solid black;">
                        {{data1.nov_post_count_total}}</td>
                    <td style="text-align:right; font-weight: bold; border-bottom: 2px solid black;">
                        {{data1.nov_haste_count_total}}</td>
                    <td style="text-align:right; font-weight: bold; border-bottom: 2px solid black;">
                        {{data1.nov_magzine_count_total}}</td>
                    <td style="text-align:right; font-weight: bold; border-bottom: 2px solid black;">
                        {{data1.nov_digital_count_total}}</td>
                    <td style="text-align:right; font-weight: bold; border-bottom: 2px solid black;">
                        {{data1.nov_total_total_total}}</td>

                    <td
                        style="text-align:right; font-weight: bold; border-bottom: 2px solid black; border-left: 2px solid black;">
                        {{data1.dec_post_count_total}}</td>
                    <td style="text-align:right; font-weight: bold; border-bottom: 2px solid black;">
                        {{data1.dec_haste_count_total}}</td>
                    <td style="text-align:right; font-weight: bold; border-bottom: 2px solid black;">
                        {{data1.dec_magzine_count_total}}</td>
                    <td style="text-align:right; font-weight: bold; border-bottom: 2px solid black;">
                        {{data1.dec_digital_count_total}}</td>
                    <td style="text-align:right; font-weight: bold; border-bottom: 2px solid black;">
                        {{data1.dec_total_total_total}}</td>

                    <td
                        style="text-align:right; font-weight: bold; border-bottom: 2px solid black; border-left: 2px solid black;">
                        {{data1.jan_post_count_total}}</td>
                    <td style="text-align:right; font-weight: bold; border-bottom: 2px solid black;">
                        {{data1.jan_haste_count_total}}</td>
                    <td style="text-align:right; font-weight: bold; border-bottom: 2px solid black;">
                        {{data1.jan_magzine_count_total}}</td>
                    <td style="text-align:right; font-weight: bold; border-bottom: 2px solid black;">
                        {{data1.jan_digital_count_total}}</td>
                    <td style="text-align:right; font-weight: bold; border-bottom: 2px solid black;">
                        {{data1.jan_total_total_total}}</td>

                    <td
                        style="text-align:right; font-weight: bold; border-bottom: 2px solid black; border-left: 2px solid black;">
                        {{data1.feb_post_count_total}}</td>
                    <td style="text-align:right; font-weight: bold; border-bottom: 2px solid black;">
                        {{data1.feb_haste_count_total}}</td>
                    <td style="text-align:right; font-weight: bold; border-bottom: 2px solid black;">
                        {{data1.feb_magzine_count_total}}</td>
                    <td style="text-align:right; font-weight: bold; border-bottom: 2px solid black;">
                        {{data1.feb_digital_count_total}}</td>
                    <td style="text-align:right; font-weight: bold; border-bottom: 2px solid black;">
                        {{data1.feb_total_total_total}}</td>

                    <td
                        style="text-align:right; font-weight: bold; border-bottom: 2px solid black; border-left: 2px solid black;">
                        {{data1.mar_post_count_total}}</td>
                    <td style="text-align:right; font-weight: bold; border-bottom: 2px solid black;">
                        {{data1.mar_haste_count_total}}</td>
                    <td style="text-align:right; font-weight: bold; border-bottom: 2px solid black;">
                        {{data1.mar_magzine_count_total}}</td>
                    <td style="text-align:right; font-weight: bold; border-bottom: 2px solid black;">
                        {{data1.mar_digital_count_total}}</td>
                    <td style="text-align:right; font-weight: bold; border-bottom: 2px solid black;">
                        {{data1.mar_total_total_total}}</td>

                    <td
                        style="text-align:right; font-weight: bold; border-bottom: 2px solid black; border-left: 2px solid black;">
                        {{data1.post_count_total}}</td>
                    <td style="text-align:right; font-weight: bold; border-bottom: 2px solid black;">
                        {{data1.haste_count_total}}</td>
                    <td style="text-align:right; font-weight: bold; border-bottom: 2px solid black;">
                        {{data1.magzine_count_total}}</td>
                    <td style="text-align:right; font-weight: bold; border-bottom: 2px solid black;">
                        {{data1.digital_count_total}}</td>
                    <td
                        style="text-align:right; font-weight: bold; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{data1.total_total_total}}</td>

                </tr>
                <!-- Jilha Total  -->
                <!-- <tr >
                <td colspan="4" style="text-align: right; font-weight: bold; border-left: 2px solid black; border-right: 2px solid black; border-bottom: 2px solid black;"><b>जिल्हा एकूण :- </b></td>
                <td  style="text-align: right; font-weight: bold; border-left: 2px solid black;">{{data1.april_post_count_total}}</td>
                <td  style="text-align: right; font-weight: bold;">{{data1.april_haste_count_total}}</td>
                <td  style="text-align: right; font-weight: bold;">{{data1.april_magzine_count_total}}</td>
                <td  style="text-align: right; font-weight: bold;">{{data1.april_digital_count_total}}</td>
                <td  style="text-align: right; font-weight: bold;">{{data1.april_total_total_total}}</td>

                <td  style="text-align: right; font-weight: bold; border-left: 2px solid black;">{{data1.may_post_count_total}}</td>
                <td  style="text-align: right; font-weight: bold;">{{data1.may_haste_count_total}}</td>
                <td  style="text-align: right; font-weight: bold;">{{data1.may_magzine_count_total}}</td>
                <td  style="text-align: right; font-weight: bold;">{{data1.may_digital_count_total}}</td>
                <td  style="text-align: right; font-weight: bold;">{{data1.may_total_total_total}}</td>

                <td style="text-align:right; font-weight: bold; border-left: 2px solid black;">{{data1.jun_post_count_total}}</td>
                <td style="text-align:right; font-weight: bold;">{{data1.jun_haste_count_total}}</td>
                <td style="text-align:right; font-weight: bold;">{{data1.jun_magzine_count_total}}</td>
                <td style="text-align:right; font-weight: bold;">{{data1.jun_digital_count_total}}</td>
                <td style="text-align:right; font-weight: bold;">{{data1.jun_total_total_total}}</td>
                
                <td style="text-align:right; font-weight: bold; border-left: 2px solid black;">{{data1.jul_post_count_total}}</td>
                <td style="text-align:right; font-weight: bold;">{{data1.jul_haste_count_total}}</td>
                <td style="text-align:right; font-weight: bold;">{{data1.jul_magzine_count_total}}</td>
                <td style="text-align:right; font-weight: bold;">{{data1.jul_digital_count_total}}</td>
                <td style="text-align:right; font-weight: bold;">{{data1.jul_total_total_total}}</td>
                
                <td style="text-align:right; font-weight: bold; border-left: 2px solid black;">{{data1.aug_post_count_total}}</td>
                <td style="text-align:right; font-weight: bold;">{{data1.aug_haste_count_total}}</td>
                <td style="text-align:right; font-weight: bold;">{{data1.aug_magzine_count_total}}</td>
                <td style="text-align:right; font-weight: bold;">{{data1.aug_digital_count_total}}</td>
                <td style="text-align:right; font-weight: bold;">{{data1.aug_total_total_total}}</td>
                
                <td style="text-align:right; font-weight: bold; border-left: 2px solid black;">{{data1.sep_post_count_total}}</td>
                <td style="text-align:right; font-weight: bold;">{{data1.sep_haste_count_total}}</td>
                <td style="text-align:right; font-weight: bold;">{{data1.sep_magzine_count_total}}</td>
                <td style="text-align:right; font-weight: bold;">{{data1.sep_digital_count_total}}</td>
                <td style="text-align:right; font-weight: bold;">{{data1.sep_total_total_total}}</td>
                
                <td style="text-align:right; font-weight: bold; border-left: 2px solid black;">{{data1.oct_post_count_total}}</td>
                <td style="text-align:right; font-weight: bold;">{{data1.oct_haste_count_total}}</td>
                <td style="text-align:right; font-weight: bold;">{{data1.oct_magzine_count_total}}</td>
                <td style="text-align:right; font-weight: bold;">{{data1.oct_digital_count_total}}</td>
                <td style="text-align:right; font-weight: bold;">{{data1.oct_total_total_total}}</td>
                
                <td style="text-align:right; font-weight: bold; border-left: 2px solid black;">{{data1.nov_post_count_total}}</td>
                <td style="text-align:right; font-weight: bold;">{{data1.nov_haste_count_total}}</td>
                <td style="text-align:right; font-weight: bold;">{{data1.nov_magzine_count_total}}</td>
                <td style="text-align:right; font-weight: bold;">{{data1.nov_digital_count_total}}</td>
                <td style="text-align:right; font-weight: bold;">{{data1.nov_total_total_total}}</td>

                <td style="text-align:right; font-weight: bold; border-left: 2px solid black;">{{data1.dec_post_count_total}}</td>
                <td style="text-align:right; font-weight: bold;">{{data1.dec_haste_count_total}}</td>
                <td style="text-align:right; font-weight: bold;">{{data1.dec_magzine_count_total}}</td>
                <td style="text-align:right; font-weight: bold;">{{data1.dec_digital_count_total}}</td>
                <td style="text-align:right; font-weight: bold;">{{data1.dec_total_total_total}}</td>
                
                <td style="text-align:right; font-weight: bold; border-left: 2px solid black;">{{data1.jan_post_count_total}}</td>
                <td style="text-align:right; font-weight: bold;">{{data1.jan_haste_count_total}}</td>
                <td style="text-align:right; font-weight: bold;">{{data1.jan_magzine_count_total}}</td>
                <td style="text-align:right; font-weight: bold;">{{data1.jan_digital_count_total}}</td>
                <td style="text-align:right; font-weight: bold;">{{data1.jan_total_total_total}}</td>
                
                <td style="text-align:right; font-weight: bold; border-left: 2px solid black;">{{data1.feb_post_count_total}}</td>
                <td style="text-align:right; font-weight: bold;">{{data1.feb_haste_count_total}}</td>
                <td style="text-align:right; font-weight: bold;">{{data1.feb_magzine_count_total}}</td>
                <td style="text-align:right; font-weight: bold;">{{data1.feb_digital_count_total}}</td>
                <td style="text-align:right; font-weight: bold;">{{data1.feb_total_total_total}}</td>
                
                <td style="text-align:right; font-weight: bold; border-left: 2px solid black;">{{data1.mar_post_count_total}}</td>
                <td style="text-align:right; font-weight: bold;">{{data1.mar_haste_count_total}}</td>
                <td style="text-align:right; font-weight: bold;">{{data1.mar_magzine_count_total}}</td>
                <td style="text-align:right; font-weight: bold;">{{data1.mar_digital_count_total}}</td>
                <td style="text-align:right; font-weight: bold;">{{data1.mar_total_total_total}}</td>
                
                <td style="text-align:right; font-weight: bold; border-left: 2px solid black;">{{data1.post_count_total}}</td>
                <td style="text-align:right; font-weight: bold;">{{data1.haste_count_total}}</td>
                <td style="text-align:right; font-weight: bold;">{{data1.magzine_count_total}}</td>
                <td style="text-align:right; font-weight: bold;">{{data1.digital_count_total}}</td>
                <td style="text-align:right; font-weight: bold; border-right: 2px solid black;">{{data1.total_total_total}}</td>
                
            </tr> -->

            </tbody>

            <tfoot>
                <tr>
                    <td colspan="4"
                        style="color: black; text-align:center; font-weight: bold; border-left: 2px solid black; border-right: 2px solid black; border-bottom: 2px solid black; font-size: 13px;">
                        <b>एकूण :-</b>
                    </td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{aprilpost}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{aprilhaste}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{aprilmagzine}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{aprildigital}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{apriltotal}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{maypost}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{mayhaste}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{maymagzine}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{maydigital}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{maytotal}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{junepost}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{junehaste}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{junmagzine}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{jundigital}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{junetotal}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{julypost}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{julyhaste}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{julymagzine}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{julydigital}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{julytotal}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{augpost}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{aughaste}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{augmagzine}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{augdigital}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{augtotal}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{seppost}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{sephaste}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{sepmagzine}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{sepdigital}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{septotal}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{octopost}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{octohaste}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{octmagzine}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{octdigital}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{octototal}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{novpost}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{novhaste}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{novmagzine}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{novdigital}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{novtotal}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{decpost}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{dechaste}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{decmagzine}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{decdigital}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{dectotal}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{janpost}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{janhaste}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{janmagzine}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{jandigital}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{jantotal}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{febpost}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{febhaste}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{febmagzine}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{febdigital}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{febtotal}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{marchpost}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{marchhaste}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{marchmagzine}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{marchdigital}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{marchtotal}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{totalrepsubhilhapost}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{totalrepsubhilhahaste}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{totalrepsubhilhamagzine}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{totalrepsubhilhadigital}}</td>
                    <td
                        style="color: black; text-align:right; font-weight: bold; border-right: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black; font-size: 13px;">
                        {{totalrepsubhilhatotal}}</td>
                </tr>


            </tfoot>
        </table>


    </div>

    <div style="margin-left: 80%; margin-bottom: 2%;">
        <!-- <button class="noPrint" style="margin-top: 2%;" mat-raised-button color="primary"
            [printStyle]="{table : {'border-collapse':'collapse'}, td : {'border': 'solid 1px'}, th : {'border': 'solid 1px'}}"
            printSectionId="print-section2" ngxPrint>
            print
        </button> -->
        <button class="noPrint" style="margin-top: 2%; margin-left: 2%"
            (click)="exportExcel('Contract_InDetails_Report')" mat-raised-button color="primary">
            Export
        </button>

        <button class="noPrint" style="margin-top: 2%; margin-left: 2%" mat-raised-button color="primary"
            [useExistingCss]="true" printSectionId="print-section" ngxPrint>
            Print
        </button>

        <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>
            Close
        </button>
    </div>

</div>

<div class="table-container" *ngIf="reportType == 'PrantwiseDeliverymode'">
    <div id="print-section1" class="container">

        <table class="fixed-header">
            <thead>
                <tr>
                    <th colspan="64"
                        style="text-align: center !important; font-size: 14px; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black;">
                        प्रांत निहाय वर्गणीदार नोंदणी - नवीन व्यवसाय तपशिल वितरण पद्धतीनुसार </th>
                    <th colspan="5"
                        style="text-align: center  !important; font-size: 14px; border-right: 2px solid black; border-left: 2px solid black; border-top: 2px solid black;">
                        दिनांक :- {{currentDate | date: 'dd-MM-yyyy'}}</th>
                </tr>
                <tr>
                    <th colspan="59"
                        style="text-align: center !important; font-size: 14px; padding-left: 6%; border-left: 2px solid black;">
                        हिंदुस्तान प्रकाशन संस्था - विवेक साप्ताहिक - वर्गणी विभाग</th>
                    <th colspan="5"
                        style="text-align: center !important; font-size: 14px;  border-left: 2px solid black; border-right: 2px solid black;">
                        दिनांक पासून :- {{startDate | date: 'dd-MM-yyyy'}}</th>
                    <th colspan="5"
                        style="text-align: center !important; font-size: 14px; border-left: 2px solid black; border-right: 2px solid black; ">
                        पर्यंत :- {{endDate | date: 'dd-MM-yyyy'}}</th>
                </tr>

                <tr>
                    <th colspan="4"
                        style="border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        नूतनीकरण येणे बाकी</th>

                    <th colspan="5"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        एप्रिल</th>
                    <th colspan="5"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        मे</th>
                    <th colspan="5"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        जून</th>
                    <th colspan="5"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        जुलै</th>
                    <th colspan="5"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        ऑगस्ट</th>
                    <th colspan="5"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        सप्टेंबर</th>
                    <th colspan="5"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        ऑक्टोबर</th>
                    <th colspan="5"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        नोव्हेंबर</th>
                    <th colspan="5"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        डिसेंबर</th>
                    <th colspan="5"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        जानेवारी</th>
                    <th colspan="5"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        फेब्रुवारी</th>
                    <th colspan="5"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        मार्च</th>
                    <th colspan="5"
                        style="text-align: center; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        एकूण</th>
                </tr>
                <tr>
                    <th colspan="4" style="border-left: 2px solid black; border-bottom: 2px solid black;">जिल्हा</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट</th>
                    <th style="border-bottom: 2px solid black;">हस्ते</th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">मॅगझीन
                    </th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">डिजिटल
                    </th>
                    <th style="border-bottom: 2px solid black;">एकूण</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट</th>
                    <th style="border-bottom: 2px solid black;">हस्ते</th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">मॅगझीन
                    </th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">डिजिटल
                    </th>
                    <th style="border-bottom: 2px solid black;">एकूण</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट</th>
                    <th style="border-bottom: 2px solid black;">हस्ते</th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">मॅगझीन
                    </th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">डिजिटल
                    </th>
                    <th style="border-bottom: 2px solid black;">एकूण</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट</th>
                    <th style="border-bottom: 2px solid black;">हस्ते</th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">मॅगझीन
                    </th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">डिजिटल
                    </th>
                    <th style="border-bottom: 2px solid black;">एकूण</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट</th>
                    <th style="border-bottom: 2px solid black;">हस्ते</th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">मॅगझीन
                    </th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">डिजिटल
                    </th>
                    <th style="border-bottom: 2px solid black;">एकूण</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट</th>
                    <th style="border-bottom: 2px solid black;">हस्ते</th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">मॅगझीन
                    </th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">डिजिटल
                    </th>
                    <th style="border-bottom: 2px solid black; border-bottom: 2px solid black;">एकूण</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट</th>
                    <th style="border-bottom: 2px solid black;">हस्ते</th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">मॅगझीन
                    </th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">डिजिटल
                    </th>
                    <th style="border-bottom: 2px solid black;">एकूण</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट</th>
                    <th style="border-bottom: 2px solid black;">हस्ते</th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">मॅगझीन
                    </th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">डिजिटल
                    </th>
                    <th style="border-bottom: 2px solid black;">एकूण</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट</th>
                    <th style="border-bottom: 2px solid black;">हस्ते</th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">मॅगझीन
                    </th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">डिजिटल
                    </th>
                    <th style="border-bottom: 2px solid black;">एकूण</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट</th>
                    <th style="border-bottom: 2px solid black;">हस्ते</th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">मॅगझीन
                    </th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">डिजिटल
                    </th>
                    <th style="border-bottom: 2px solid black;">एकूण</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट</th>
                    <th style="border-bottom: 2px solid black;">हस्ते</th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">मॅगझीन
                    </th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">डिजिटल
                    </th>
                    <th style="border-bottom: 2px solid black;">एकूण</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट</th>
                    <th style="border-bottom: 2px solid black;">हस्ते</th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">मॅगझीन
                    </th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">डिजिटल
                    </th>
                    <th style="border-bottom: 2px solid black;">एकूण</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">पोस्ट</th>
                    <th style="border-bottom: 2px solid black;">हस्ते</th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">मॅगझीन
                    </th>
                    <th style="overflow-wrap: break-word; white-space: normal; border-bottom: 2px solid black;">डिजिटल
                    </th>
                    <th style="border-right: 2px solid black; border-bottom: 2px solid black;">एकूण</th>
                </tr>
            </thead>
            <!-- *ngFor="let data of OutstandingInDetailFormBeans; let i = index" -->
            <!-- <tbody *ngFor="let data1 of getdeliverytype; let i = index"> -->
            <tbody *ngFor="let group of prantWiseList; let i = index">

                <ng-container *ngFor="let data1 of group.sub_data;let j=index">
                    <tr>
                        <td colspan="4" *ngIf="j==0"
                            style="font-size: 15px; font-weight: bold; text-align: center !important; border-left: 2px solid black; border-right: 2px solid black; border-bottom: 2px solid black;">
                            {{data1.prant_name}}</td>
                        <!-- <td colspan="65" style="font-size: 15px; font-weight: bold; text-align: center !important; border-right: 2px solid black;"></td> -->
                        <td colspan="5"
                            style="font-size: 15px; font-weight: bold; text-align: center !important; border-right: 2px solid black;">
                        </td>
                        <td colspan="5"
                            style="font-size: 15px; font-weight: bold; text-align: center !important; border-right: 2px solid black;">
                        </td>
                        <td colspan="5"
                            style="font-size: 15px; font-weight: bold; text-align: center !important; border-right: 2px solid black;">
                        </td>
                        <td colspan="5"
                            style="font-size: 15px; font-weight: bold; text-align: center !important; border-right: 2px solid black;">
                        </td>
                        <td colspan="5"
                            style="font-size: 15px; font-weight: bold; text-align: center !important; border-right: 2px solid black;">
                        </td>
                        <td colspan="5"
                            style="font-size: 15px; font-weight: bold; text-align: center !important; border-right: 2px solid black;">
                        </td>
                        <td colspan="5"
                            style="font-size: 15px; font-weight: bold; text-align: center !important; border-right: 2px solid black;">
                        </td>
                        <td colspan="5"
                            style="font-size: 15px; font-weight: bold; text-align: center !important; border-right: 2px solid black;">
                        </td>
                        <td colspan="5"
                            style="font-size: 15px; font-weight: bold; text-align: center !important; border-right: 2px solid black;">
                        </td>
                        <td colspan="5"
                            style="font-size: 15px; font-weight: bold; text-align: center !important; border-right: 2px solid black;">
                        </td>
                        <td colspan="5"
                            style="font-size: 15px; font-weight: bold; text-align: center !important; border-right: 2px solid black;">
                        </td>
                        <td colspan="5"
                            style="font-size: 15px; font-weight: bold; text-align: center !important; border-right: 2px solid black;">
                        </td>
                        <td colspan="5"
                            style="font-size: 15px; font-weight: bold; text-align: center !important; border-right: 2px solid black;">
                        </td>

                        <!-- <td colspan="65" *ngIf="j>0"  style="font-size: 15px; font-weight: bold; text-align: center !important; border-right: 2px solid black;"></td> -->
                        <td colspan="5" *ngIf="j>0"
                            style="font-size: 15px; font-weight: bold; text-align: center !important; border-right: 2px solid black;">
                        </td>
                        <td colspan="5" *ngIf="j>0"
                            style="font-size: 15px; font-weight: bold; text-align: center !important; border-right: 2px solid black;">
                        </td>
                        <td colspan="5" *ngIf="j>0"
                            style="font-size: 15px; font-weight: bold; text-align: center !important; border-right: 2px solid black;">
                        </td>
                        <td colspan="5" *ngIf="j>0"
                            style="font-size: 15px; font-weight: bold; text-align: center !important; border-right: 2px solid black;">
                        </td>
                        <td colspan="5" *ngIf="j>0"
                            style="font-size: 15px; font-weight: bold; text-align: center !important; border-right: 2px solid black;">
                        </td>
                        <td colspan="5" *ngIf="j>0"
                            style="font-size: 15px; font-weight: bold; text-align: center !important; border-right: 2px solid black;">
                        </td>
                        <td colspan="5" *ngIf="j>0"
                            style="font-size: 15px; font-weight: bold; text-align: center !important; border-right: 2px solid black;">
                        </td>
                        <td colspan="5" *ngIf="j>0"
                            style="font-size: 15px; font-weight: bold; text-align: center !important; border-right: 2px solid black;">
                        </td>
                        <td colspan="5" *ngIf="j>0"
                            style="font-size: 15px; font-weight: bold; text-align: center !important; border-right: 2px solid black;">
                        </td>
                        <td colspan="5" *ngIf="j>0"
                            style="font-size: 15px; font-weight: bold; text-align: center !important; border-right: 2px solid black;">
                        </td>
                        <td colspan="5" *ngIf="j>0"
                            style="font-size: 15px; font-weight: bold; text-align: center !important; border-right: 2px solid black;">
                        </td>
                        <td colspan="5" *ngIf="j>0"
                            style="font-size: 15px; font-weight: bold; text-align: center !important; border-right: 2px solid black;">
                        </td>
                        <td colspan="5" *ngIf="j>0"
                            style="font-size: 15px; font-weight: bold; text-align: center !important; border-right: 2px solid black;">
                        </td>

                    </tr>

                    <tr *ngFor="let data of data1.sub_data; let i = index">
                        <td colspan="4" style="border-left: 2px solid black; word-wrap: break-word;">{{data.district}}
                        </td>
                        <td style="text-align: right; border-left: 2px solid black;">{{data.april_post_count}}</td>
                        <td style="text-align: right;">{{data.april_haste_count}}</td>
                        <td style="text-align: right;">{{data.april_magzine_count}}</td>
                        <td style="text-align: right;">{{data.april_digital_count}}</td>
                        <td style="text-align: right;">{{data.april_total}}</td>
                        <td style="text-align: right; border-left: 2px solid black;">{{data.may_post_count}}</td>
                        <td style="text-align: right;">{{data.may_haste_count}}</td>
                        <td style="text-align: right;">{{data.may_magzine_count}}</td>
                        <td style="text-align: right;">{{data.may_digital_count}}</td>
                        <td style="text-align: right;">{{data.may_total}}</td>
                        <td style="text-align: right; border-left: 2px solid black;">{{data.jun_post_count}}</td>
                        <td style="text-align: right;">{{data.jun_haste_count}}</td>
                        <td style="text-align: right;">{{data.jun_magzine_count}}</td>
                        <td style="text-align: right;">{{data.jun_digital_count}}</td>
                        <td style="text-align: right;">{{data.jun_total}}</td>
                        <!-- april -->
                        <td style="text-align: right; border-left: 2px solid black;">{{data.jul_post_count}}</td>
                        <td style="text-align: right;">{{data.jul_haste_count}}</td>
                        <td style="text-align: right;">{{data.jul_magzine_count}}</td>
                        <td style="text-align: right;">{{data.jul_digital_count}}</td>
                        <td style="text-align: right;">{{data.jul_total}}</td>
                        <td style="text-align: right; border-left: 2px solid black;">{{data.aug_post_count}}</td>
                        <td style="text-align: right;">{{data.aug_haste_count}}</td>
                        <td style="text-align: right;">{{data.aug_magzine_count}}</td>
                        <td style="text-align: right;">{{data.aug_digital_count}}</td>
                        <td style="text-align: right;">{{data.aug_total}}</td>
                        <td style="text-align: right; border-left: 2px solid black;">{{data.sep_post_count}}</td>
                        <td style="text-align: right;">{{data.sep_haste_count}}</td>
                        <td style="text-align: right;">{{data.sep_magzine_count}}</td>
                        <td style="text-align: right;">{{data.sep_digital_count}}</td>
                        <td style="text-align: right;">{{data.sep_total}}</td>
                        <td style="text-align: right; border-left: 2px solid black;">{{data.oct_post_count}}</td>
                        <td style="text-align: right;">{{data.oct_haste_count}}</td>
                        <td style="text-align: right;">{{data.oct_magzine_count}}</td>
                        <td style="text-align: right;">{{data.oct_digital_count}}</td>
                        <td style="text-align: right;">{{data.oct_total}}</td>
                        <td style="text-align: right; border-left: 2px solid black;">{{data.nov_post_count}}</td>
                        <td style="text-align: right;">{{data.nov_haste_count}}</td>
                        <td style="text-align: right;">{{data.nov_magzine_count}}</td>
                        <td style="text-align: right;">{{data.nov_digital_count}}</td>
                        <td style="text-align: right;">{{data.nov_total}}</td>
                        <td style="text-align: right; border-left: 2px solid black;">{{data.dec_post_count}}</td>
                        <td style="text-align: right;">{{data.dec_haste_count}}</td>
                        <td style="text-align: right;">{{data.dec_magzine_count}}</td>
                        <td style="text-align: right;">{{data.dec_digital_count}}</td>
                        <td style="text-align: right;">{{data.dec_total}}</td>
                        <td style="text-align: right; border-left: 2px solid black;">{{data.jan_post_count}}</td>
                        <td style="text-align: right;">{{data.jan_haste_count}}</td>
                        <td style="text-align: right;">{{data.jan_magzine_count}}</td>
                        <td style="text-align: right;">{{data.jan_digital_count}}</td>
                        <td style="text-align: right;">{{data.jan_total}}</td>
                        <td style="text-align: right; border-left: 2px solid black;">{{data.feb_post_count}}</td>
                        <td style="text-align: right;">{{data.feb_haste_count}}</td>
                        <td style="text-align: right;">{{data.feb_magzine_count}}</td>
                        <td style="text-align: right;">{{data.feb_digital_count}}</td>
                        <td style="text-align: right;">{{data.feb_total}}</td>
                        <td style="text-align: right; border-left: 2px solid black;">{{data.mar_post_count}}</td>
                        <td style="text-align: right;">{{data.mar_haste_count}}</td>
                        <td style="text-align: right;">{{data.mar_magzine_count}}</td>
                        <td style="text-align: right;">{{data.mar_digital_count}}</td>
                        <td style="text-align: right;">{{data.mar_total}}</td>

                        <td style="text-align: right; border-left: 2px solid black;">{{data.post_total}}</td>
                        <td style="text-align: right;">{{data.haste_total}}</td>
                        <td style="text-align: right;">{{data.magzine_total}}</td>
                        <td style="text-align: right;">{{data.digital_total}}</td>
                        <td style="text-align: right; border-right: 2px solid black;">{{data.grand_total}}</td>
                    </tr>

                    <tr *ngIf="j == group.sub_data.length - 1">
                        <!-- <td colspan="2"></td> -->
                        <td colspan="4"
                            style="text-align: right; font-weight: bold; border-left: 2px solid black; border-right: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                            एकूण :-</td>
                        <td
                            style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{ group.aprilpost}}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{ group.aprilhaste }}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{ group.aprilmagzine }}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{ group.aprildigital }}
                        <td
                            style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.apriltotal}}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.maypost}}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.mayhaste}}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.maymagzine}}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.maydigital}}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.maytotal}}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.junepost}}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.junehaste}}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.junmagzine}}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.jundigital}}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.junetotal}}</td>
                        <!-- april -->
                        <td
                            style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.julypost}}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.julyhaste}}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.julymagzine}}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.julydigital}}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.julytotal}}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.augpost}}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.aughaste}}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.augmagzine}}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.augdigital}}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.augtotal}}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.seppost}}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.sephaste}}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.sepmagzine}}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.sepdigital}}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.septotal}}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.octopost}}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.octohaste}}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.octmagzine}}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.octdigital}}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.octototal}}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.novpost}}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.novhaste}}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.novmagzine}}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.novdigital}}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.novtotal}}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.decpost}}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.dechaste}}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.decmagzine}}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.decdigital}}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.dectotal}}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.janpost}}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.janhaste}}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.janmagzine}}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.jandigital}}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.jantotal}}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.febpost}}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.febhaste}}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.febmagzine}}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.febdigital}}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.febtotal}}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.marchpost}}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.marchhaste}}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.marchmagzine}}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.marchdigital}}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.marchtotal}}</td>

                        <td
                            style="text-align: right; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.totalzilhahapost1}}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.totalzilhahahaste1}}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.totalzilhahamagzine1}}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.totalzilhahadigital1}}</td>
                        <td
                            style="text-align: right; font-weight: bold; border-right: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{group.totalzilhahatotal1}}</td>
                    </tr>

                </ng-container>
            </tbody>

            <tfoot>
                <tr>
                    <td colspan="4"
                        style="text-align: left; font-size: 15px; font-weight: bold; color: black; border-left: 2px solid black; border-bottom: 2px solid black;">
                        एकूण :-</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                        {{aprilpost}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black;">
                        {{aprilhaste}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black;">
                        {{aprilmagzine}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black;">
                        {{aprildigital}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black;">
                        {{apriltotal}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                        {{maypost}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black;">
                        {{mayhaste}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black;">
                        {{maymagzine}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black;">
                        {{maydigital}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black;">
                        {{maytotal}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                        {{junepost}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black;">
                        {{junehaste}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black;">
                        {{junmagzine}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black;">
                        {{jundigital}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black;">
                        {{junetotal}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                        {{julypost}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black;">
                        {{julyhaste}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black;">
                        {{julymagzine}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black;">
                        {{julydigital}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black;">
                        {{julytotal}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                        {{augpost}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black;">
                        {{aughaste}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black;">
                        {{augmagzine}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black;">
                        {{augdigital}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black;">
                        {{augtotal}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                        {{seppost}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black;">
                        {{sephaste}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black;">
                        {{sepmagzine}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black;">
                        {{sepdigital}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black;">
                        {{septotal}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                        {{octopost}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black;">
                        {{octohaste}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black;">
                        {{octmagzine}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black;">
                        {{octdigital}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black;">
                        {{octototal}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                        {{novpost}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black;">
                        {{novhaste}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black;">
                        {{novmagzine}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black;">
                        {{novdigital}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black;">
                        {{novtotal}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black;border-left: 2px solid black;">
                        {{decpost}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black;">
                        {{dechaste}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black;">
                        {{decmagzine}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black;">
                        {{decdigital}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black;">
                        {{dectotal}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                        {{janpost}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black;">
                        {{janhaste}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black;">
                        {{janmagzine}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black;">
                        {{jandigital}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black;">
                        {{jantotal}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                        {{febpost}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black;">
                        {{febhaste}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black;">
                        {{febmagzine}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black;">
                        {{febdigital}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black;">
                        {{febtotal}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                        {{marchpost}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black;">
                        {{marchhaste}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black;">
                        {{marchmagzine}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black;">
                        {{marchdigital}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black;">
                        {{marchtotal}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                        {{totalzilhahapost}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black;">
                        {{totalzilhahahaste}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black;">
                        {{totalzilhahamagzine}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black;">
                        {{totalzilhahadigital}}</td>
                    <td
                        style="text-align: right; font-weight: bold; font-size: 15px; color: black; border-right: 1px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{totalzilhahatotal}}</td>

                </tr>

            </tfoot>
            <!-- <tfoot>
                    <tr>
                        {{columnSums | json}}
                      <td *ngFor="let sum of columnSums">{{ sum }}</td>
                    </tr>
                </tfoot> -->
        </table>


    </div>
    <div style="margin-left: 80%; margin-bottom: 2%;">
        <!-- <button class="noPrint" style="margin-top: 2%;" mat-raised-button color="primary"
            [printStyle]="{table : {'border-collapse':'collapse'}, td : {'border': 'solid 1px'}, th : {'border': 'solid 1px'}}"
            printSectionId="print-section2" ngxPrint>
            print
        </button> -->
        <button class="noPrint" style="margin-top: 2%; margin-left: 2%"
            (click)="exportExcel('Contract_InDetails_Report')" mat-raised-button color="primary">
            Export
        </button>

        <!-- <button class="noPrint" style="margin-top: 2%; margin-left: 2%"  mat-raised-button color="primary"
           [useExistingCss]="true"
            printSectionId="print-section" ngxPrint>
            Print
        </button> -->

        <button class="noPrint" style="margin-top: 2%; margin-left: 2%" mat-raised-button color="primary"
            (click)="printPage()">
            Print
        </button>

        <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>
            Close
        </button>
    </div>
</div>

<div *ngIf="reportType == 'RenewalOff'">
    <div id="print-section" class="container">

        <table class="table table-bordered">
            <thead>
                <tr>
                    <th colspan="73"
                        style="text-align: center !important; font-size: 15px; border-left: 2px solid black; border-right: 2px solid black;">
                        कार्यालानियाय प्रतिनिधी निहाय </th>
                    <!-- <th colspan="2">Advt. Outstanding Report</th> -->
                    <!-- <th colspan="2">दिनांक</th>
                    <th colspan="2">पृष्ठ क्र</th> -->
                </tr>
                <tr>
                    <th colspan="63" style="text-align: center !important; border-left: 2px solid black;">हिंदुस्तान
                        प्रकाशन संस्था - विवेक साप्ताहिक - वर्गणी विभाग</th>
                    <th colspan="10"
                        style="text-align: center !important; border-left: 2px solid black; border-right: 2px solid black;">
                        दिनांक :- {{ currentDate | date: 'dd-MM-yyyy'}}</th>
                    <!-- <th colspan="2">To {{endDate}}</th>
                     <th colspan="1">In Details</th>  -->
                </tr>
                <tr>
                    <th colspan="28"
                        style="text-align: center !important; border-left: 2px solid black; border-right: 2px solid black;">
                        वर्गणीदार नूतनीकरण व्यवसाय तपशिल </th>
                    <!-- <th colspan="20" style="text-align: center !important;">प्रांताचे नाव - {{prant_name}}</th> -->
                    <th colspan="30" style="text-align: center !important; border-left: 2px solid black;">वितरण
                        पद्धतीनुसार</th>

                    <th colspan="5" style="text-align: center !important; border-left: 2px solid black;">दिनांक पासून :-
                        {{startDate | date: 'dd-MM-yyyy'}}</th>
                    <th colspan="10"
                        style="text-align: center !important; border-left: 2px solid black; border-right: 2px solid black;">
                        पर्यंत :- {{endDate | date: 'dd-MM-yyyy'}}</th>
                </tr>
                <tr>
                    <th colspan="3" style="border-left: 2px solid black;">नूतनीकरण येणे बाकी (कार्यालानियाय प्रतिनिधी )
                    </th>
                    <!-- <th colspan="3">January</th>
                    <th colspan="3">February</th>
                    <th colspan="3">March</th> -->
                    <th colspan="5" style="text-align: center; border-left: 2px solid black;">एप्रिल</th>
                    <th colspan="5" style="text-align: center; border-left: 2px solid black;">मे</th>
                    <th colspan="5" style="text-align: center; border-left: 2px solid black;">जून</th>
                    <th colspan="5" style="text-align: center; border-left: 2px solid black;">जुलै</th>
                    <th colspan="5" style="text-align: center; border-left: 2px solid black;">ऑगस्ट</th>
                    <th colspan="5" style="text-align: center; border-left: 2px solid black;">सप्टेंबर</th>
                    <th colspan="5" style="text-align: center; border-left: 2px solid black;">ऑक्टोबर</th>
                    <th colspan="5" style="text-align: center; border-left: 2px solid black;">नोव्हेंबर</th>
                    <th colspan="5" style="text-align: center; border-left: 2px solid black;">डिसेंबर</th>
                    <th colspan="5" style="text-align: center; border-left: 2px solid black;">जानेवारी</th>
                    <th colspan="5" style="text-align: center; border-left: 2px solid black;">फेब्रुवारी</th>
                    <th colspan="5" style="text-align: center; border-left: 2px solid black;">मार्च</th>
                    <th colspan="5"
                        style="text-align: center; border-left: 2px solid black; border-right: 2px solid black;">एकूण
                    </th>
                </tr>
                <tr>
                    <th colspan="1" style="border-left: 2px solid black;">जिल्हा</th>
                    <th colspan="2" style="border-left: 2px solid black;">प्रतिनिधी</th>
                    <!-- <th colspan="1" style="border-left: 2px solid black;">तालुका</th> -->

                    <th style="border-left: 2px solid black;">पोस्ट</th>
                    <th>हस्ते</th>
                    <th>मॅगझीन</th>
                    <th>डिजिटल</th>
                    <th>एकूण</th>
                    <th style="border-left: 2px solid black;">पोस्ट</th>
                    <th>हस्ते</th>
                    <th>मॅगझीन</th>
                    <th>डिजिटल</th>
                    <th>एकूण</th>
                    <th style="border-left: 2px solid black;">पोस्ट</th>
                    <th>हस्ते</th>
                    <th>मॅगझीन</th>
                    <th>डिजिटल</th>
                    <th>एकूण</th>
                    <th style="border-left: 2px solid black;">पोस्ट</th>
                    <th>हस्ते</th>
                    <th>मॅगझीन</th>
                    <th>डिजिटल</th>
                    <th>एकूण</th>
                    <th style="border-left: 2px solid black;">पोस्ट</th>
                    <th>हस्ते</th>
                    <th>मॅगझीन</th>
                    <th>डिजिटल</th>
                    <th>एकूण</th>
                    <th style="border-left: 2px solid black;">पोस्ट</th>
                    <th>हस्ते</th>
                    <th>मॅगझीन</th>
                    <th>डिजिटल</th>
                    <th>एकूण</th>
                    <th style="border-left: 2px solid black;">पोस्ट</th>
                    <th>हस्ते</th>
                    <th>मॅगझीन</th>
                    <th>डिजिटल</th>
                    <th>एकूण</th>
                    <th style="border-left: 2px solid black;">पोस्ट</th>
                    <th>हस्ते</th>
                    <th>मॅगझीन</th>
                    <th>डिजिटल</th>
                    <th>एकूण</th>
                    <th style="border-left: 2px solid black;">पोस्ट</th>
                    <th>हस्ते</th>
                    <th>मॅगझीन</th>
                    <th>डिजिटल</th>
                    <th>एकूण</th>
                    <th style="border-left: 2px solid black;">पोस्ट</th>
                    <th>हस्ते</th>
                    <th>मॅगझीन</th>
                    <th>डिजिटल</th>
                    <th>एकूण</th>
                    <th style="border-left: 2px solid black;">पोस्ट</th>
                    <th>हस्ते</th>
                    <th>मॅगझीन</th>
                    <th>डिजिटल</th>
                    <th>एकूण</th>
                    <th style="border-left: 2px solid black;">पोस्ट</th>
                    <th>हस्ते</th>
                    <th>मॅगझीन</th>
                    <th>डिजिटल</th>
                    <th>एकूण</th>
                    <th style="border-left: 2px solid black;">पोस्ट</th>
                    <th>हस्ते</th>
                    <th>मॅगझीन</th>
                    <th>डिजिटल</th>
                    <th style="border-right: 2px solid black;">एकूण</th>

                </tr>
            </thead>
            <!-- *ngFor="let data of OutstandingInDetailFormBeans; let i = index" -->
            <tbody *ngFor="let data2  of SubByOffRep; let i = index">

                <tr>
                    <td colspan="73"
                        style="font-size: 15px; font-weight: bold; text-align: left !important; border-left: 2px solid black;">
                        {{data2.office_rep_name}}</td>
                    <!-- <td  style="font-size: 15px; font-weight: bold; text-align: center !important;"></td> -->
                </tr>
                <ng-container *ngFor="let data1 of data2.districts;">
                    <tr>
                        <!-- <td colspan="1"></td> -->
                        <td colspan="2" style="border-left: 2px solid black; border-right: 2px solid black;">
                            {{data1.district}}</td>
                    </tr>

                    <ng-container *ngFor="let data of data1.representatives;">
                        <tr>

                            <td colspan="1" style="border-left: 2px solid black;"></td>
                            <!-- <td colspan="1"></td> -->
                            <td colspan="2" style="border-left: 2px solid black; border-right: 2px solid black;">
                                {{data.rep_name}}</td>
                            <!-- <td colspan="1">{{data.rep_taluka}}</td> -->
                            <td style="text-align: right; border-left: 2px solid black;">{{data.april_post_count}}</td>
                            <td style="text-align: right;">{{data.april_haste_count}}</td>
                            <td style="text-align: right;">{{data.april_magzine_count}}</td>
                            <td style="text-align: right;">{{data.april_digital_count}}</td>
                            <td style="text-align: right;">{{data.april_total}}</td>
                            <td style="text-align: right; border-left: 2px solid black;">{{data.may_post_count}}</td>
                            <td style="text-align: right;">{{data.may_haste_count}}</td>
                            <td style="text-align: right;">{{data.may_magzine_count}}</td>
                            <td style="text-align: right;">{{data.may_digital_count}}</td>
                            <td style="text-align: right;">{{data.may_total}}</td>
                            <td style="text-align: right; border-left: 2px solid black;">{{data.jun_post_count}}</td>
                            <td style="text-align: right;">{{data.jun_haste_count}}</td>
                            <td style="text-align: right;">{{data.jun_magzine_count}}</td>
                            <td style="text-align: right;">{{data.jun_digital_count}}</td>
                            <td style="text-align: right;">{{data.jun_total}}</td>
                            <!-- april -->
                            <td style="text-align: right; border-left: 2px solid black;">{{data.jul_post_count}}</td>
                            <td style="text-align: right;">{{data.jul_haste_count}}</td>
                            <td style="text-align: right;">{{data.jul_magzine_count}}</td>
                            <td style="text-align: right;">{{data.jul_digital_count}}</td>
                            <td style="text-align: right;">{{data.jul_total}}</td>
                            <td style="text-align: right; border-left: 2px solid black;">{{data.aug_post_count}}</td>
                            <td style="text-align: right;">{{data.aug_haste_count}}</td>
                            <td style="text-align: right;">{{data.aug_magzine_count}}</td>
                            <td style="text-align: right;">{{data.aug_digital_count}}</td>
                            <td style="text-align: right;">{{data.aug_total}}</td>
                            <td style="text-align: right; border-left: 2px solid black;">{{data.sep_post_count}}</td>
                            <td style="text-align: right;">{{data.sep_haste_count}}</td>
                            <td style="text-align: right;">{{data.sep_magzine_count}}</td>
                            <td style="text-align: right;">{{data.sep_digital_count}}</td>
                            <td style="text-align: right;">{{data.sep_total}}</td>
                            <td style="text-align: right; border-left: 2px solid black;">{{data.oct_post_count}}</td>
                            <td style="text-align: right;">{{data.oct_haste_count}}</td>
                            <td style="text-align: right;">{{data.oct_magzine_count}}</td>
                            <td style="text-align: right;">{{data.oct_digital_count}}</td>
                            <td style="text-align: right;">{{data.oct_total}}</td>
                            <td style="text-align: right; border-left: 2px solid black;">{{data.nov_post_count}}</td>
                            <td style="text-align: right;">{{data.nov_haste_count}}</td>
                            <td style="text-align: right;">{{data.nov_magzine_count}}</td>
                            <td style="text-align: right;">{{data.nov_digital_count}}</td>
                            <td style="text-align: right;">{{data.nov_total}}</td>
                            <td style="text-align: right; border-left: 2px solid black;">{{data.dec_post_count}}</td>
                            <td style="text-align: right;">{{data.dec_haste_count}}</td>
                            <td style="text-align: right;">{{data.dec_magzine_count}}</td>
                            <td style="text-align: right;">{{data.dec_digital_count}}</td>
                            <td style="text-align: right;">{{data.dec_total}}</td>
                            <td style="text-align: right; border-left: 2px solid black;">{{data.jan_post_count}}</td>
                            <td style="text-align: right;">{{data.jan_haste_count}}</td>
                            <td style="text-align: right;">{{data.jan_magzine_count}}</td>
                            <td style="text-align: right;">{{data.jan_digital_count}}</td>
                            <td style="text-align: right;">{{data.jan_total}}</td>
                            <td style="text-align: right; border-left: 2px solid black;">{{data.feb_post_count}}</td>
                            <td style="text-align: right;">{{data.feb_haste_count}}</td>
                            <td style="text-align: right;">{{data.feb_magzine_count}}</td>
                            <td style="text-align: right;">{{data.feb_digital_count}}</td>
                            <td style="text-align: right;">{{data.feb_total}}</td>
                            <td style="text-align: right; border-left: 2px solid black;">{{data.mar_post_count}}</td>
                            <td style="text-align: right;">{{data.mar_haste_count}}</td>
                            <td style="text-align: right;">{{data.mar_magzine_count}}</td>
                            <td style="text-align: right;">{{data.mar_digital_count}}</td>
                            <td style="text-align: right;">{{data.mar_total}}</td>

                            <td style="text-align: right; border-left: 2px solid black;">{{data.post_total}}</td>
                            <td style="text-align: right;">{{data.haste_total}}</td>
                            <td style="text-align: right;">{{data.magzine_total}}</td>
                            <td style="text-align: right;">{{data.digital_total}}</td>
                            <td style="text-align: right; border-right: 2px solid black;">{{data.grand_total}}</td>

                        </tr>

                    </ng-container>
                    <tr>
                        <td colspan="3"
                            style="text-align: right; font-weight: bold; border-left: 2px solid black; border-right: 2px solid black;">
                            एकूण :-</td>
                        <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">
                            {{data1.aprilpost}}</td>
                        <td style="text-align: right; font-weight: bold;">{{data1.aprilhaste }}</td>
                        <td style="text-align: right; font-weight: bold;">{{data1.aprilmagzine }}</td>
                        <td style="text-align: right; font-weight: bold;">{{data1.aprildigital }}
                        <td style="text-align: right; font-weight: bold;">{{data1.apriltotal}}</td>
                        <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">
                            {{data1.maypost}}</td>
                        <td style="text-align: right; font-weight: bold;">{{data1.mayhaste}}</td>
                        <td style="text-align: right; font-weight: bold;">{{data1.maymagzine}}</td>
                        <td style="text-align: right; font-weight: bold;">{{data1.maydigital}}</td>
                        <td style="text-align: right; font-weight: bold;">{{data1.maytotal}}</td>
                        <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">
                            {{data1.junepost}}</td>
                        <td style="text-align: right; font-weight: bold;">{{data1.junehaste}}</td>
                        <td style="text-align: right; font-weight: bold;">{{data1.junmagzine}}</td>
                        <td style="text-align: right; font-weight: bold;">{{data1.jundigital}}</td>
                        <td style="text-align: right; font-weight: bold;">{{data1.junetotal}}</td>

                        <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">
                            {{data1.julypost}}</td>
                        <td style="text-align: right; font-weight: bold;">{{data1.julyhaste}}</td>
                        <td style="text-align: right; font-weight: bold;">{{data1.julymagzine}}</td>
                        <td style="text-align: right; font-weight: bold;">{{data1.julydigital}}</td>
                        <td style="text-align: right; font-weight: bold;">{{data1.julytotal}}</td>
                        <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">
                            {{data1.augpost}}</td>
                        <td style="text-align: right; font-weight: bold;">{{data1.aughaste}}</td>
                        <td style="text-align: right; font-weight: bold;">{{data1.augmagzine}}</td>
                        <td style="text-align: right; font-weight: bold;">{{data1.augdigital}}</td>
                        <td style="text-align: right; font-weight: bold;">{{data1.augtotal}}</td>
                        <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">
                            {{data1.seppost}}</td>
                        <td style="text-align: right; font-weight: bold;">{{data1.sephaste}}</td>
                        <td style="text-align: right; font-weight: bold;">{{data1.sepmagzine}}</td>
                        <td style="text-align: right; font-weight: bold;">{{data1.sepdigital}}</td>
                        <td style="text-align: right; font-weight: bold;">{{data1.septotal}}</td>
                        <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">
                            {{data1.octopost}}</td>
                        <td style="text-align: right; font-weight: bold;">{{data1.octohaste}}</td>
                        <td style="text-align: right; font-weight: bold;">{{data1.octmagzine}}</td>
                        <td style="text-align: right; font-weight: bold;">{{data1.octdigital}}</td>
                        <td style="text-align: right; font-weight: bold;">{{data1.octototal}}</td>
                        <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">
                            {{data1.novpost}}</td>
                        <td style="text-align: right; font-weight: bold;">{{data1.novhaste}}</td>
                        <td style="text-align: right; font-weight: bold;">{{data1.novmagzine}}</td>
                        <td style="text-align: right; font-weight: bold;">{{data1.novdigital}}</td>
                        <td style="text-align: right; font-weight: bold;">{{data1.novtotal}}</td>
                        <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">
                            {{data1.decpost}}</td>
                        <td style="text-align: right; font-weight: bold;">{{data1.dechaste}}</td>
                        <td style="text-align: right; font-weight: bold;">{{data1.decmagzine}}</td>
                        <td style="text-align: right; font-weight: bold;">{{data1.decdigital}}</td>
                        <td style="text-align: right; font-weight: bold;">{{data1.dectotal}}</td>
                        <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">
                            {{data1.janpost}}</td>
                        <td style="text-align: right; font-weight: bold;">{{data1.janhaste}}</td>
                        <td style="text-align: right; font-weight: bold;">{{data1.janmagzine}}</td>
                        <td style="text-align: right; font-weight: bold;">{{data1.jandigital}}</td>
                        <td style="text-align: right; font-weight: bold;">{{data1.jantotal}}</td>
                        <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">
                            {{data1.febpost}}</td>
                        <td style="text-align: right; font-weight: bold;">{{data1.febhaste}}</td>
                        <td style="text-align: right; font-weight: bold;">{{data1.febmagzine}}</td>
                        <td style="text-align: right; font-weight: bold;">{{data1.febdigital}}</td>
                        <td style="text-align: right; font-weight: bold;">{{data1.febtotal}}</td>
                        <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">
                            {{data1.marchpost}}</td>
                        <td style="text-align: right; font-weight: bold;">{{data1.marchhaste}}</td>
                        <td style="text-align: right; font-weight: bold;">{{data1.marchmagzine}}</td>
                        <td style="text-align: right; font-weight: bold;">{{data1.marchdigital}}</td>
                        <td style="text-align: right; font-weight: bold;">{{data1.marchtotal}}</td>


                        <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">
                            {{data1.post_total}}</td>
                        <td style="text-align: right; font-weight: bold;">{{data1.haste_total}}</td>
                        <td style="text-align: right; font-weight: bold;">{{data1.magzine_total}}</td>
                        <td style="text-align: right; font-weight: bold;">{{data1.digital_total}}</td>
                        <td style="text-align: right; font-weight: bold; border-right: 2px solid black;">
                            {{data1.grand_total}}</td>

                    </tr>

                    <!--  District Wise Total  -->
                    <!-- <tr>
                    <td colspan="3" style="text-align: right; font-weight: bold; border-left: 2px solid black; border-right: 2px solid black;">{{data1.district}} एकूण :-</td>
                    <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">{{data1.aprilpost}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data1.aprilhaste }}</td>
                    <td style="text-align: right; font-weight: bold;">{{data1.aprilmagzine }}</td>
                    <td style="text-align: right; font-weight: bold;">{{data1.aprildigital }}
                    <td style="text-align: right; font-weight: bold;">{{data1.apriltotal}}</td>
                    <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">{{data1.maypost}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data1.mayhaste}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data1.maymagzine}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data1.maydigital}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data1.maytotal}}</td>
                    <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">{{data1.junepost}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data1.junehaste}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data1.junmagzine}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data1.jundigital}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data1.junetotal}}</td>
                    
                    <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">{{data1.julypost}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data1.julyhaste}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data1.julymagzine}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data1.julydigital}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data1.julytotal}}</td>
                    <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">{{data1.augpost}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data1.aughaste}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data1.augmagzine}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data1.augdigital}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data1.augtotal}}</td>
                    <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">{{data1.seppost}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data1.sephaste}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data1.sepmagzine}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data1.sepdigital}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data1.septotal}}</td>
                    <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">{{data1.octopost}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data1.octohaste}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data1.octmagzine}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data1.octdigital}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data1.octototal}}</td>
                    <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">{{data1.novpost}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data1.novhaste}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data1.novmagzine}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data1.novdigital}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data1.novtotal}}</td>
                    <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">{{data1.decpost}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data1.dechaste}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data1.decmagzine}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data1.decdigital}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data1.dectotal}}</td>
                    <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">{{data1.janpost}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data1.janhaste}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data1.janmagzine}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data1.jandigital}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data1.jantotal}}</td>
                    <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">{{data1.febpost}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data1.febhaste}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data1.febmagzine}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data1.febdigital}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data1.febtotal}}</td>
                    <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">{{data1.marchpost}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data1.marchhaste}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data1.marchmagzine}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data1.marchdigital}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data1.marchtotal}}</td>


                    <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">{{data1.post_total}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data1.haste_total}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data1.magzine_total}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data1.digital_total}}</td>
                    <td style="text-align: right; font-weight: bold; border-right: 2px solid black;">{{data1.grand_total}}</td> 

                </tr>  -->

                </ng-container>
                <!-- Jilha Wise Total -->
                <!-- <tr>
                <td colspan="3" style="text-align: right; font-weight: bold; border-left: 2px solid black; border-right: 2px solid black;">जिल्हा एकूण :-</td>
                <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">{{data2.aprilpost}}</td>
                <td style="text-align: right; font-weight: bold;">{{data2.aprilhaste }}</td>
                <td style="text-align: right; font-weight: bold;">{{data2.aprilmagzine }}</td>
                <td style="text-align: right; font-weight: bold;">{{data2.aprildigital }}
                <td style="text-align: right; font-weight: bold;">{{data2.apriltotal}}</td>
                <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">{{data2.maypost}}</td>
                <td style="text-align: right; font-weight: bold;">{{data2.mayhaste}}</td>
                <td style="text-align: right; font-weight: bold;">{{data2.maymagzine}}</td>
                <td style="text-align: right; font-weight: bold;">{{data2.maydigital}}</td>
                <td style="text-align: right; font-weight: bold;">{{data2.maytotal}}</td>
                <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">{{data2.junepost}}</td>
                <td style="text-align: right; font-weight: bold;">{{data2.junehaste}}</td>
                <td style="text-align: right; font-weight: bold;">{{data2.junmagzine}}</td>
                <td style="text-align: right; font-weight: bold;">{{data2.jundigital}}</td>
                <td style="text-align: right; font-weight: bold;">{{data2.junetotal}}</td>
                
                <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">{{data2.julypost}}</td>
                <td style="text-align: right; font-weight: bold;">{{data2.julyhaste}}</td>
                <td style="text-align: right; font-weight: bold;">{{data2.julymagzine}}</td>
                <td style="text-align: right; font-weight: bold;">{{data2.julydigital}}</td>
                <td style="text-align: right; font-weight: bold;">{{data2.julytotal}}</td>
                <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">{{data2.augpost}}</td>
                <td style="text-align: right; font-weight: bold;">{{data2.aughaste}}</td>
                <td style="text-align: right; font-weight: bold;">{{data2.augmagzine}}</td>
                <td style="text-align: right; font-weight: bold;">{{data2.augdigital}}</td>
                <td style="text-align: right; font-weight: bold;">{{data2.augtotal}}</td>
                <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">{{data2.seppost}}</td>
                <td style="text-align: right; font-weight: bold;">{{data2.sephaste}}</td>
                <td style="text-align: right; font-weight: bold;">{{data2.sepmagzine}}</td>
                <td style="text-align: right; font-weight: bold;">{{data2.sepdigital}}</td>
                <td style="text-align: right; font-weight: bold;">{{data2.septotal}}</td>
                <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">{{data2.octopost}}</td>
                <td style="text-align: right; font-weight: bold;">{{data2.octohaste}}</td>
                <td style="text-align: right; font-weight: bold;">{{data2.octmagzine}}</td>
                <td style="text-align: right; font-weight: bold;">{{data2.octdigital}}</td>
                <td style="text-align: right; font-weight: bold;">{{data2.octototal}}</td>
                <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">{{data2.novpost}}</td>
                <td style="text-align: right; font-weight: bold;">{{data2.novhaste}}</td>
                <td style="text-align: right; font-weight: bold;">{{data2.novmagzine}}</td>
                <td style="text-align: right; font-weight: bold;">{{data2.novdigital}}</td>
                <td style="text-align: right; font-weight: bold;">{{data2.novtotal}}</td>
                <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">{{data2.decpost}}</td>
                <td style="text-align: right; font-weight: bold;">{{data2.dechaste}}</td>
                <td style="text-align: right; font-weight: bold;">{{data2.decmagzine}}</td>
                <td style="text-align: right; font-weight: bold;">{{data2.decdigital}}</td>
                <td style="text-align: right; font-weight: bold;">{{data2.dectotal}}</td>
                <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">{{data2.janpost}}</td>
                <td style="text-align: right; font-weight: bold;">{{data2.janhaste}}</td>
                <td style="text-align: right; font-weight: bold;">{{data2.janmagzine}}</td>
                <td style="text-align: right; font-weight: bold;">{{data2.jandigital}}</td>
                <td style="text-align: right; font-weight: bold;">{{data2.jantotal}}</td>
                <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">{{data2.febpost}}</td>
                <td style="text-align: right; font-weight: bold;">{{data2.febhaste}}</td>
                <td style="text-align: right; font-weight: bold;">{{data2.febmagzine}}</td>
                <td style="text-align: right; font-weight: bold;">{{data2.febdigital}}</td>
                <td style="text-align: right; font-weight: bold;">{{data2.febtotal}}</td>
                <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">{{data2.marchpost}}</td>
                <td style="text-align: right; font-weight: bold;">{{data2.marchhaste}}</td>
                <td style="text-align: right; font-weight: bold;">{{data2.marchmagzine}}</td>
                <td style="text-align: right; font-weight: bold;">{{data2.marchdigital}}</td>
                <td style="text-align: right; font-weight: bold;">{{data2.marchtotal}}</td>


                <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">{{data2.totalOffRepPost1}}</td>
                <td style="text-align: right; font-weight: bold;">{{data2.totalOffRepHaste1}}</td>
                <td style="text-align: right; font-weight: bold;">{{data2.totalOffRepmagzine1}}</td>
                <td style="text-align: right; font-weight: bold;">{{data2.totalOffRepDigital1}}</td>
                <td style="text-align: right; font-weight: bold; border-right: 2px solid black;">{{data2.totalOffReptotal1}}</td> 

            </tr> -->

                <!-- Representative Wise Total  -->
                <tr>
                    <td colspan="3"
                        style="text-align: right; font-weight: bold; border-left: 2px solid black; border-right: 2px solid black;">
                        कार्यालय प्रतिनिधी एकूण :-</td>
                    <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">{{data2.aprilpost}}
                    </td>
                    <td style="text-align: right; font-weight: bold;">{{data2.aprilhaste }}</td>
                    <td style="text-align: right; font-weight: bold;">{{data2.aprilmagzine }}</td>
                    <td style="text-align: right; font-weight: bold;">{{data2.aprildigital }}
                    <td style="text-align: right; font-weight: bold;">{{data2.apriltotal}}</td>
                    <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">{{data2.maypost}}
                    </td>
                    <td style="text-align: right; font-weight: bold;">{{data2.mayhaste}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data2.maymagzine}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data2.maydigital}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data2.maytotal}}</td>
                    <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">{{data2.junepost}}
                    </td>
                    <td style="text-align: right; font-weight: bold;">{{data2.junehaste}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data2.junmagzine}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data2.jundigital}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data2.junetotal}}</td>

                    <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">{{data2.julypost}}
                    </td>
                    <td style="text-align: right; font-weight: bold;">{{data2.julyhaste}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data2.julymagzine}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data2.julydigital}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data2.julytotal}}</td>
                    <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">{{data2.augpost}}
                    </td>
                    <td style="text-align: right; font-weight: bold;">{{data2.aughaste}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data2.augmagzine}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data2.augdigital}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data2.augtotal}}</td>
                    <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">{{data2.seppost}}
                    </td>
                    <td style="text-align: right; font-weight: bold;">{{data2.sephaste}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data2.sepmagzine}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data2.sepdigital}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data2.septotal}}</td>
                    <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">{{data2.octopost}}
                    </td>
                    <td style="text-align: right; font-weight: bold;">{{data2.octohaste}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data2.octmagzine}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data2.octdigital}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data2.octototal}}</td>
                    <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">{{data2.novpost}}
                    </td>
                    <td style="text-align: right; font-weight: bold;">{{data2.novhaste}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data2.novmagzine}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data2.novdigital}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data2.novtotal}}</td>
                    <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">{{data2.decpost}}
                    </td>
                    <td style="text-align: right; font-weight: bold;">{{data2.dechaste}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data2.decmagzine}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data2.decdigital}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data2.dectotal}}</td>
                    <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">{{data2.janpost}}
                    </td>
                    <td style="text-align: right; font-weight: bold;">{{data2.janhaste}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data2.janmagzine}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data2.jandigital}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data2.jantotal}}</td>
                    <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">{{data2.febpost}}
                    </td>
                    <td style="text-align: right; font-weight: bold;">{{data2.febhaste}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data2.febmagzine}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data2.febdigital}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data2.febtotal}}</td>
                    <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">{{data2.marchpost}}
                    </td>
                    <td style="text-align: right; font-weight: bold;">{{data2.marchhaste}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data2.marchmagzine}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data2.marchdigital}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data2.marchtotal}}</td>


                    <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">
                        {{data2.totalOffRepPost1}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data2.totalOffRepHaste1}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data2.totalOffRepmagzine1}}</td>
                    <td style="text-align: right; font-weight: bold;">{{data2.totalOffRepDigital1}}</td>
                    <td style="text-align: right; font-weight: bold; border-right: 2px solid black;">
                        {{data2.totalOffReptotal1}}</td>

                </tr>
            </tbody>

            <tfoot>
                <tr>
                    <td colspan="3"
                        style="text-align: left; font-weight: bold; border-left: 2px solid black; border-right: 2px solid black;">
                        एकूण :- </td>
                    <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">{{aprilpost}}</td>
                    <td style="text-align: right; font-weight: bold;">{{aprilhaste}}</td>
                    <td style="text-align: right; font-weight: bold;">{{aprilmagzine}}</td>
                    <td style="text-align: right; font-weight: bold;">{{aprildigital}}</td>
                    <td style="text-align: right; font-weight: bold;">{{apriltotal}}</td>
                    <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">{{maypost}}</td>
                    <td style="text-align: right; font-weight: bold;">{{mayhaste}}</td>
                    <td style="text-align: right; font-weight: bold;">{{maymagzine}}</td>
                    <td style="text-align: right; font-weight: bold;">{{maydigital}}</td>
                    <td style="text-align: right; font-weight: bold;">{{maytotal}}</td>
                    <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">{{junepost}}</td>
                    <td style="text-align: right; font-weight: bold;">{{junehaste}}</td>
                    <td style="text-align: right; font-weight: bold;">{{junmagzine}}</td>
                    <td style="text-align: right; font-weight: bold;">{{jundigital}}</td>
                    <td style="text-align: right; font-weight: bold;">{{junetotal}}</td>
                    <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">{{julypost}}</td>
                    <td style="text-align: right; font-weight: bold;">{{julyhaste}}</td>
                    <td style="text-align: right; font-weight: bold;">{{julymagzine}}</td>
                    <td style="text-align: right; font-weight: bold;">{{julydigital}}</td>
                    <td style="text-align: right; font-weight: bold;">{{julytotal}}</td>
                    <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">{{augpost}}</td>
                    <td style="text-align: right; font-weight: bold;">{{aughaste}}</td>
                    <td style="text-align: right; font-weight: bold;">{{augmagzine}}</td>
                    <td style="text-align: right; font-weight: bold;">{{augdigital}}</td>
                    <td style="text-align: right; font-weight: bold;">{{augtotal}}</td>
                    <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">{{seppost}}</td>
                    <td style="text-align: right; font-weight: bold;">{{sephaste}}</td>
                    <td style="text-align: right; font-weight: bold;">{{sepmagzine}}</td>
                    <td style="text-align: right; font-weight: bold;">{{sepdigital}}</td>
                    <td style="text-align: right; font-weight: bold;">{{septotal}}</td>
                    <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">{{octopost}}</td>
                    <td style="text-align: right; font-weight: bold;">{{octohaste}}</td>
                    <td style="text-align: right; font-weight: bold;">{{octmagzine}}</td>
                    <td style="text-align: right; font-weight: bold;">{{octdigital}}</td>
                    <td style="text-align: right; font-weight: bold;">{{octototal}}</td>
                    <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">{{novpost}}</td>
                    <td style="text-align: right; font-weight: bold;">{{novhaste}}</td>
                    <td style="text-align: right; font-weight: bold;">{{novmagzine}}</td>
                    <td style="text-align: right; font-weight: bold;">{{novdigital}}</td>
                    <td style="text-align: right; font-weight: bold;">{{novtotal}}</td>
                    <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">{{decpost}}</td>
                    <td style="text-align: right; font-weight: bold;">{{dechaste}}</td>
                    <td style="text-align: right; font-weight: bold;">{{decmagzine}}</td>
                    <td style="text-align: right; font-weight: bold;">{{decdigital}}</td>
                    <td style="text-align: right; font-weight: bold;">{{dectotal}}</td>
                    <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">{{janpost}}</td>
                    <td style="text-align: right; font-weight: bold;">{{janhaste}}</td>
                    <td style="text-align: right; font-weight: bold;">{{janmagzine}}</td>
                    <td style="text-align: right; font-weight: bold;">{{jandigital}}</td>
                    <td style="text-align: right; font-weight: bold;">{{jantotal}}</td>
                    <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">{{febpost}}</td>
                    <td style="text-align: right; font-weight: bold;">{{febhaste}}</td>
                    <td style="text-align: right; font-weight: bold;">{{febmagzine}}</td>
                    <td style="text-align: right; font-weight: bold;">{{febdigital}}</td>
                    <td style="text-align: right; font-weight: bold;">{{febtotal}}</td>
                    <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">{{marchpost}}</td>
                    <td style="text-align: right; font-weight: bold;">{{marchhaste}}</td>
                    <td style="text-align: right; font-weight: bold;">{{marchmagzine}}</td>
                    <td style="text-align: right; font-weight: bold;">{{marchdigital}}</td>
                    <td style="text-align: right; font-weight: bold;">{{marchtotal}}</td>
                    <td style="text-align: right; font-weight: bold; border-left: 2px solid black;">
                        {{totaloffrepsubhilhapost}}</td>
                    <td style="text-align: right; font-weight: bold;">{{totaloffrepsubhilhahaste}}</td>
                    <td style="text-align: right; font-weight: bold;">{{totalsubhilhamagzine}}</td>
                    <td style="text-align: right; font-weight: bold;">{{totalsubhilhadigital}}</td>
                    <td style="text-align: right; font-weight: bold; border-right: 2px solid black;">
                        {{totaloffrepsubhilhatotal}}</td>

                </tr>

            </tfoot>
        </table>

    </div>
    <div style="margin-left: 80%; margin-bottom: 2%;">
        <!-- <button class="noPrint" style="margin-top: 2%;" mat-raised-button color="primary"
            [printStyle]="{table : {'border-collapse':'collapse'}, td : {'border': 'solid 1px'}, th : {'border': 'solid 1px'}}"
            printSectionId="print-section2" ngxPrint>
            print
        </button> -->
        <button class="noPrint" style="margin-top: 2%; margin-left: 2%"
            (click)="exportExcel('Contract_InDetails_Report')" mat-raised-button color="primary">
            Export
        </button>

        <button class="noPrint" style="margin-top: 2%; margin-left: 2%" mat-raised-button color="primary"
            [useExistingCss]="true" printSectionId="print-section" ngxPrint>
            Print
        </button>

        <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>
            Close
        </button>
    </div>
</div>

<!-- Subscription Type -->
<div *ngIf="reportType == 'SubscriptionTypeAll'">
    <div id="print-section" class="container">

        <table class="table table-bordered">
            <thead>
                <tr>
                    <th colspan="15" style="text-align: center !important; font-size: 20px;">जिल्हा निहाय </th>
                    <!-- <th colspan="2">Advt. Outstanding Report</th> -->
                    <!-- <th colspan="2">दिनांक</th>
                    <th colspan="2">पृष्ठ क्र</th> -->
                </tr>
                <tr>
                    <th colspan="10" style="text-align: center !important;">हिंदुस्तान प्रकाशन संस्था - विवेक साप्ताहिक
                        - वर्गणी विभाग</th>
                    <th colspan="3" style="text-align: center !important;">Date From {{startDate}}</th>
                    <th colspan="2" style="text-align: center !important;">Page No</th>
                    <!-- <th colspan="2">To {{endDate}}</th>
                     <th colspan="1">In Details</th>  -->
                </tr>
                <tr>
                    <th colspan="3" style="text-align: center !important;">वर्गणीदार नोंदणी - नवीन व्यवसाय तपशिल </th>
                    <th colspan="2" style="text-align: center !important;">कोकण प्रांत</th>
                    <th colspan="3" style="text-align: center !important;"></th>
                    <th colspan="7" style="text-align: center !important;">Date</th>
                    <!-- <th colspan="4" style="text-align: center !important;">From</th>
                    <th colspan="4" style="text-align: center !important;">To</th>  -->
                </tr>
                <tr>
                    <th colspan="2">नूतनीकरण येणे बाकी</th>
                    <!-- <th colspan="3">January</th>
                    <th colspan="3">February</th>
                    <th colspan="3">March</th> -->
                    <th colspan="6">पोस्ट </th>
                    <th colspan="6">हस्ते </th>
                    <th colspan="1">एकूण </th>
                </tr>
                <tr>
                    <th>जिल्हा</th>
                    <th>तालुका</th>
                    <th>वार्षिक</th>
                    <th>त्रेवार्षिक</th>
                    <th>पंचवार्षिक</th>
                    <th>हिंदूत्व</th>
                    <th>लो. वा</th>
                    <th>एकूण</th>
                    <th>वार्षिक</th>
                    <th>त्रेवार्षिक</th>
                    <th>पंचवार्षिक</th>
                    <th>हिंदूत्व</th>
                    <th>लो. वा</th>
                    <th>एकूण</th>
                    <th>एकूण</th>

                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let data of typewisedistrict; let i = index">
                    <td colspan="2">{{data.district}}</td>
                    <td>{{data.varshik_tapal_count}}</td>
                    <td>{{data.trivarshik_tapal_count}}</td>
                    <td>{{data.panvarshik_tapal_count}}</td>
                    <td>{{data.hindutva_tapal_count}}</td>
                    <td>null</td>
                    <td>{{data.post_total}}</td>
                    <td>{{data.varshik_haste_count}}</td>
                    <td>{{data.trivarshik_haste_count}}</td>
                    <td>{{data.panvarshik_haste_count}}</td>
                    <td>{{data.hindutva_haste_count}}</td>
                    <td>null</td>
                    <td>{{data.haste_total}}</td>
                    <td>{{data.grand_total}}</td>
                </tr>

            </tbody>

            <tfoot>
                <tr>
                    <!-- <td>{{data.district}}</td> -->
                    <td colspan="2">Total</td>
                    <td>{{pvarshik}}</td>
                    <td>{{ptrevarshik}}</td>
                    <td>{{ppanchvarshik}}</td>
                    <td>{{phindutva}}</td>
                    <td>null</td>
                    <td>{{ptotal}}</td>
                    <td>{{hvarshik}}</td>
                    <td>{{htrevarshik}}</td>
                    <td>{{hpanchvarshik}}</td>
                    <td>{{hhindutva}}</td>
                    <td>null</td>
                    <td>{{htotal}}</td>
                    <td>{{gtotal}}</td>
                </tr>

            </tfoot>
            <!-- <tfoot>
                    <tr>
                        {{columnSums | json}}
                      <td *ngFor="let sum of columnSums">{{ sum }}</td>
                    </tr>
                </tfoot> -->
        </table>


    </div>
    <div style="margin-left: 80%; margin-bottom: 2%;">
        <!-- <button class="noPrint" style="margin-top: 2%;" mat-raised-button color="primary"
            [printStyle]="{table : {'border-collapse':'collapse'}, td : {'border': 'solid 1px'}, th : {'border': 'solid 1px'}}"
            printSectionId="print-section2" ngxPrint>
            print
        </button> -->
        <button class="noPrint" style="margin-top: 2%; margin-left: 2%"
            (click)="exportExcel('Contract_InDetails_Report')" mat-raised-button color="primary">
            Export
        </button>

        <button class="noPrint" style="margin-top: 2%;" mat-raised-button color="primary" [useExistingCss]="true"
            printSectionId="print-section" ngxPrint>
            print
        </button>

        <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>
            Close
        </button>
    </div>
</div>

<div *ngIf="reportType == 'SubscriptionTypeTaluka'">
    <div id="print-section" class="container">

        <table class="table table-bordered">
            <thead>
                <tr>
                    <th colspan="15" style="text-align: center !important; font-size: 20px;">जिल्हा निहाय </th>
                    <!-- <th colspan="2">Advt. Outstanding Report</th> -->
                    <!-- <th colspan="2">दिनांक</th>
                    <th colspan="2">पृष्ठ क्र</th> -->
                </tr>
                <tr>
                    <th colspan="10" style="text-align: center !important;">हिंदुस्तान प्रकाशन संस्था - विवेक साप्ताहिक
                        - वर्गणी विभाग</th>
                    <th colspan="3" style="text-align: center !important;">Date From {{startDate}}</th>
                    <th colspan="2" style="text-align: center !important;">Page No</th>
                    <!-- <th colspan="2">To {{endDate}}</th>
                     <th colspan="1">In Details</th>  -->
                </tr>
                <tr>
                    <th colspan="3" style="text-align: center !important;">वर्गणीदार नोंदणी - नवीन व्यवसाय तपशिल </th>
                    <th colspan="2" style="text-align: center !important;">कोकण प्रांत</th>
                    <th colspan="3" style="text-align: center !important;"></th>
                    <th colspan="7" style="text-align: center !important;">Date</th>
                    <!-- <th colspan="4" style="text-align: center !important;">From</th>
                    <th colspan="4" style="text-align: center !important;">To</th>  -->
                </tr>
                <tr>
                    <th colspan="2">नूतनीकरण येणे बाकी</th>
                    <!-- <th colspan="3">January</th>
                    <th colspan="3">February</th>
                    <th colspan="3">March</th> -->
                    <th colspan="6">पोस्ट </th>
                    <th colspan="6">हस्ते </th>
                    <th colspan="1">एकूण </th>
                </tr>
                <tr>
                    <th>जिल्हा</th>
                    <th>तालुका</th>
                    <th>वार्षिक</th>
                    <th>त्रेवार्षिक</th>
                    <th>पंचवार्षिक</th>
                    <th>हिंदूत्व</th>
                    <th>लो. वा</th>
                    <th>एकूण</th>
                    <th>वार्षिक</th>
                    <th>त्रेवार्षिक</th>
                    <th>पंचवार्षिक</th>
                    <th>हिंदूत्व</th>
                    <th>लो. वा</th>
                    <th>एकूण</th>
                    <th>एकूण</th>

                </tr>
            </thead>
            <!-- *ngFor="let data of OutstandingInDetailFormBeans; let i = index" -->
            <tbody>

                <tr *ngFor="let data of typewisetaluka; let i = index">
                    <td>{{data.district}}</td>
                    <td>{{data.taluka}}</td>
                    <td>{{data.varshik_tapal_count}}</td>
                    <td>{{data.trivarshik_tapal_count}}</td>
                    <td>{{data.panvarshik_tapal_count}}</td>
                    <td>{{data.hindutva_tapal_count}}</td>

                    <td>null</td>
                    <td>{{data.post_total}}</td>
                    <td>{{data.varshik_haste_count}}</td>
                    <td>{{data.trivarshik_haste_count}}</td>
                    <td>{{data.panvarshik_haste_count}}</td>
                    <td>{{data.hindutva_haste_count}}</td>
                    <td>null</td>
                    <td>{{data.haste_total}}</td>
                    <td>{{data.grand_total}}</td>

                </tr>

            </tbody>

            <tfoot>
                <tr>
                    <!-- <td>{{data.district}}</td> -->
                    <td colspan="2">Total</td>
                    <td>{{pvarshik}}</td>
                    <td>{{ptrevarshik}}</td>
                    <td>{{ppanchvarshik}}</td>
                    <td>{{phindutva}}</td>
                    <td>null</td>
                    <td>{{ptotal}}</td>
                    <td>{{hvarshik}}</td>
                    <td>{{htrevarshik}}</td>
                    <td>{{hpanchvarshik}}</td>
                    <td>{{hhindutva}}</td>
                    <td>null</td>
                    <td>{{htotal}}</td>
                    <td>{{gtotal}}</td>
                </tr>

            </tfoot>
            <!-- <tfoot>
                    <tr>
                        {{columnSums | json}}
                      <td *ngFor="let sum of columnSums">{{ sum }}</td>
                    </tr>
                </tfoot> -->
        </table>


    </div>
    <div style="margin-left: 80%; margin-bottom: 2%;">
        <!-- <button class="noPrint" style="margin-top: 2%;" mat-raised-button color="primary"
            [printStyle]="{table : {'border-collapse':'collapse'}, td : {'border': 'solid 1px'}, th : {'border': 'solid 1px'}}"
            printSectionId="print-section2" ngxPrint>
            print
        </button> -->
        <button class="noPrint" style="margin-top: 2%; margin-left: 2%"
            (click)="exportExcel('Contract_InDetails_Report')" mat-raised-button color="primary">
            Export
        </button>

        <button class="noPrint" style="margin-top: 2%;" mat-raised-button color="primary" [useExistingCss]="true"
            printSectionId="print-section" ngxPrint>
            print
        </button>

        <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>
            Close
        </button>
    </div>
</div>
<div *ngIf="reportType == 'SubscriptionTypeOffReprensantive'">
    <div id="print-section" class="container">

        <table class="table table-bordered">
            <thead>
                <tr>
                    <th colspan="16" style="text-align: center !important; font-size: 20px;">जिल्हा निहाय </th>
                    <!-- <th colspan="2">Advt. Outstanding Report</th> -->
                    <!-- <th colspan="2">दिनांक</th>
                    <th colspan="2">पृष्ठ क्र</th> -->
                </tr>
                <tr>
                    <th colspan="11" style="text-align: center !important;">हिंदुस्तान प्रकाशन संस्था - विवेक साप्ताहिक
                        - वर्गणी विभाग</th>
                    <th colspan="3" style="text-align: center !important;">Date From {{startDate}}</th>
                    <th colspan="2" style="text-align: center !important;">Page No</th>
                    <!-- <th colspan="2">To {{endDate}}</th>
                     <th colspan="1">In Details</th>  -->
                </tr>
                <tr>
                    <th colspan="4" style="text-align: center !important;">वर्गणीदार नोंदणी - नवीन व्यवसाय तपशिल </th>
                    <th colspan="2" style="text-align: center !important;">कोकण प्रांत</th>
                    <th colspan="3" style="text-align: center !important;"></th>
                    <th colspan="7" style="text-align: center !important;">Date</th>
                    <!-- <th colspan="4" style="text-align: center !important;">From</th>
                    <th colspan="4" style="text-align: center !important;">To</th>  -->
                </tr>
                <tr>
                    <th colspan="3">नूतनीकरण येणे बाकी(कार्यालानियाय प्रतिनिधी )</th>
                    <!-- <th colspan="3">January</th>
                    <th colspan="3">February</th>
                    <th colspan="3">March</th> -->
                    <th colspan="6">पोस्ट </th>
                    <th colspan="6">हस्ते </th>
                    <th colspan="1">एकूण </th>
                </tr>
                <tr>
                    <th>जिल्हा</th>
                    <th>तालुका</th>
                    <th>प्रतिनिधी</th>
                    <th>वार्षिक</th>
                    <th>त्रेवार्षिक</th>
                    <th>पंचवार्षिक</th>
                    <th>हिंदूत्व</th>
                    <th>लो. वा</th>
                    <th>एकूण</th>
                    <th>वार्षिक</th>
                    <th>त्रेवार्षिक</th>
                    <th>पंचवार्षिक</th>
                    <th>हिंदूत्व</th>
                    <th>लो. वा</th>
                    <th>एकूण</th>
                    <th>एकूण</th>

                </tr>
            </thead>
            <!-- *ngFor="let data of OutstandingInDetailFormBeans; let i = index" -->
            <tbody *ngFor="let data1 of typewiseofficer; let i = index">

                <tr>
                    <td colspan="3">{{data1.off_rep_name}}</td>
                    <td colspan="13"></td>
                </tr>
                <tr *ngFor="let data of data1.rep_data; let i = index">
                    <td>{{data.district}}</td>
                    <td>{{data.taluka}}</td>
                    <td>{{data.rep_name}}</td>
                    <td>{{data.varshik_tapal_count}}</td>
                    <td>{{data.trivarshik_tapal_count}}</td>
                    <td>{{data.panvarshik_tapal_count}}</td>
                    <td>{{data.hindutva_tapal_count}}</td>
                    <td>null</td>
                    <td>{{data.post_total}}</td>
                    <td>{{data.varshik_haste_count}}</td>
                    <td>{{data.trivarshik_haste_count}}</td>
                    <td>{{data.panvarshik_haste_count}}</td>
                    <td>{{data.hindutva_haste_count}}</td>
                    <td>null</td>
                    <td>{{data.haste_total}}</td>
                    <td>{{data.grand_total}}</td>

                </tr>

            </tbody>

            <tfoot>
                <tr>
                    <!-- <td>{{data.district}}</td> -->
                    <td colspan="3">Total</td>
                    <td>{{pvarshik}}</td>
                    <td>{{ptrevarshik}}</td>
                    <td>{{ppanchvarshik}}</td>
                    <td>{{phindutva}}</td>
                    <td>null</td>
                    <td>{{ptotal}}</td>
                    <td>{{hvarshik}}</td>
                    <td>{{htrevarshik}}</td>
                    <td>{{hpanchvarshik}}</td>
                    <td>{{hhindutva}}</td>
                    <td>null</td>
                    <td>{{htotal}}</td>
                    <td>{{gtotal}}</td>
                </tr>

            </tfoot>
            <!-- <tfoot>
                    <tr>
                        {{columnSums | json}}
                      <td *ngFor="let sum of columnSums">{{ sum }}</td>
                    </tr>
                </tfoot> -->
        </table>


    </div>
    <div style="margin-left: 80%; margin-bottom: 2%;">
        <!-- <button class="noPrint" style="margin-top: 2%;" mat-raised-button color="primary"
            [printStyle]="{table : {'border-collapse':'collapse'}, td : {'border': 'solid 1px'}, th : {'border': 'solid 1px'}}"
            printSectionId="print-section2" ngxPrint>
            print
        </button> -->
        <button class="noPrint" style="margin-top: 2%; margin-left: 2%"
            (click)="exportExcel('Contract_InDetails_Report')" mat-raised-button color="primary">
            Export
        </button>

        <button class="noPrint" style="margin-top: 2%;" mat-raised-button color="primary" [useExistingCss]="true"
            printSectionId="print-section" ngxPrint>
            print
        </button>

        <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>
            Close
        </button>
    </div>
</div>

<div *ngIf="reportType == 'SubscriptionTypeReprensantive'">
    <div id="print-section" class="container">

        <table class="table table-bordered">
            <thead>
                <tr>
                    <th colspan="16" style="text-align: center !important; font-size: 20px;">जिल्हा निहाय </th>
                    <!-- <th colspan="2">Advt. Outstanding Report</th> -->
                    <!-- <th colspan="2">दिनांक</th>
                    <th colspan="2">पृष्ठ क्र</th> -->
                </tr>
                <tr>
                    <th colspan="11" style="text-align: center !important;">हिंदुस्तान प्रकाशन संस्था - विवेक साप्ताहिक
                        - वर्गणी विभाग</th>
                    <th colspan="3" style="text-align: center !important;">Date From {{startDate}}</th>
                    <th colspan="2" style="text-align: center !important;">Page No</th>
                    <!-- <th colspan="2">To {{endDate}}</th>
                     <th colspan="1">In Details</th>  -->
                </tr>
                <tr>
                    <th colspan="4" style="text-align: center !important;">वर्गणीदार नोंदणी - नवीन व्यवसाय तपशिल </th>
                    <th colspan="2" style="text-align: center !important;">कोकण प्रांत</th>
                    <th colspan="3" style="text-align: center !important;"></th>
                    <th colspan="7" style="text-align: center !important;">Date</th>
                    <!-- <th colspan="4" style="text-align: center !important;">From</th>
                    <th colspan="4" style="text-align: center !important;">To</th>  -->
                </tr>
                <tr>
                    <th colspan="3">नूतनीकरण येणे बाकी(कार्यालानियाय प्रतिनिधी )</th>
                    <!-- <th colspan="3">January</th>
                    <th colspan="3">February</th>
                    <th colspan="3">March</th> -->
                    <th colspan="6">पोस्ट </th>
                    <th colspan="6">हस्ते </th>
                    <th colspan="1">एकूण </th>
                </tr>
                <tr>
                    <th>जिल्हा</th>
                    <th>तालुका</th>
                    <th>प्रतिनिधी</th>
                    <th>वार्षिक</th>
                    <th>त्रेवार्षिक</th>
                    <th>पंचवार्षिक</th>
                    <th>हिंदूत्व</th>
                    <th>लो. वा</th>
                    <th>एकूण</th>
                    <th>वार्षिक</th>
                    <th>त्रेवार्षिक</th>
                    <th>पंचवार्षिक</th>
                    <th>हिंदूत्व</th>
                    <th>लो. वा</th>
                    <th>एकूण</th>
                    <th>एकूण</th>

                </tr>
            </thead>
            <!-- *ngFor="let data of OutstandingInDetailFormBeans; let i = index" -->
            <tbody *ngFor="let data1 of typewiserep; let i = index">

                <tr>
                    <td colspan="3">{{data1.rep_name}}</td>
                    <td colspan="13"></td>
                </tr>
                <tr *ngFor="let data of data1.rep_data; let i = index">
                    <td>{{data.district}}</td>
                    <td>{{data.taluka}}</td>
                    <td>{{data.rep_name}}</td>
                    <td>{{data.varshik_tapal_count}}</td>
                    <td>{{data.trivarshik_tapal_count}}</td>
                    <td>{{data.panvarshik_tapal_count}}</td>
                    <td>{{data.hindutva_tapal_count}}</td>
                    <td>null</td>
                    <td>{{data.post_total}}</td>
                    <td>{{data.varshik_haste_count}}</td>
                    <td>{{data.trivarshik_haste_count}}</td>
                    <td>{{data.panvarshik_haste_count}}</td>
                    <td>{{data.hindutva_haste_count}}</td>
                    <td>null</td>
                    <td>{{data.haste_total}}</td>
                    <td>{{data.grand_total}}</td>

                </tr>

            </tbody>

            <tfoot>
                <tr>
                    <!-- <td>{{data.district}}</td> -->
                    <td colspan="3">Total</td>
                    <td>{{pvarshik}}</td>
                    <td>{{ptrevarshik}}</td>
                    <td>{{ppanchvarshik}}</td>
                    <td>{{phindutva}}</td>
                    <td>null</td>
                    <td>{{ptotal}}</td>
                    <td>{{hvarshik}}</td>
                    <td>{{htrevarshik}}</td>
                    <td>{{hpanchvarshik}}</td>
                    <td>{{hhindutva}}</td>
                    <td>null</td>
                    <td>{{htotal}}</td>
                    <td>{{gtotal}}</td>
                </tr>

            </tfoot>
            <!-- <tfoot>
                    <tr>
                        {{columnSums | json}}
                      <td *ngFor="let sum of columnSums">{{ sum }}</td>
                    </tr>
                </tfoot> -->
        </table>


    </div>
    <div style="margin-left: 80%; margin-bottom: 2%;">
        <!-- <button class="noPrint" style="margin-top: 2%;" mat-raised-button color="primary"
            [printStyle]="{table : {'border-collapse':'collapse'}, td : {'border': 'solid 1px'}, th : {'border': 'solid 1px'}}"
            printSectionId="print-section2" ngxPrint>
            print
        </button> -->
        <button class="noPrint" style="margin-top: 2%; margin-left: 2%"
            (click)="exportExcel('Contract_InDetails_Report')" mat-raised-button color="primary">
            Export
        </button>

        <button class="noPrint" style="margin-top: 2%;" mat-raised-button color="primary" [useExistingCss]="true"
            printSectionId="print-section" ngxPrint>
            print
        </button>

        <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>
            Close
        </button>
    </div>
</div>

<!-- Subscription Remaining Renewal -->

<div class="table-container" *ngIf="reportType == 'RemainingSubscriptionDistrict'">
    <div id="print-section2" class="container">

        <table class="fixed-header">
            <thead>
                <tr>
                    <th colspan="148"
                        style="text-align: center !important; font-size: 13px; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black;">
                        जिल्हा निहाय वर्गणीदार नूतनीकरण व्यवसाय जमा बाकी तपशील</th>
                    <th colspan="12"
                        style="text-align: center !important; border-right: 2px solid black; border-left: 2px solid black; border-top: 2px solid black;">
                        दिनांक {{ currentDate | date: 'dd-MM-yyyy' }}</th>

                </tr>
                <tr>
                    <th colspan="136"
                        style="text-align: center !important; padding-left: 6%; font-size: 11px; border-right: 2px solid black; border-left: 2px solid black;">
                        हिंदुस्तान प्रकाशन संस्था - विवेक साप्ताहिक - वर्गणी विभाग</th>
                    <!-- <th colspan="24" style="text-align: center !important;font-size: 20;font-weight: 600;"> दिनांक   {{ currentDate | date: 'dd-MM-yyyy' }}</th> -->
                    <th colspan="12" style="text-align: center !important; border-right: 2px solid black;"> दिनांक
                        पासून:{{startDate | date: 'dd-MM-yyyy'}}</th>
                    <th colspan="12" style="text-align: center !important; border-right: 2px solid black;"> पर्यंत:
                        {{endDate | date: 'dd-MM-yyyy'}}</th>

                </tr>
                <!-- <tr>
                    <th colspan="80" style="text-align: center !important;"> वर्गणीदार नूतनीकरण व्यवसाय तपशिल </th>
                    <th colspan="56" style="text-align: center !important;"> जमा बाकी तपशील</th>
                    <th colspan="12" style="text-align: center !important;"> दिनांक पासून:{{startDate  | date: 'dd-MM-yyyy'}}</th>
                    <th colspan="12" style="text-align: center !important;"> पर्यंत: {{endDate  | date: 'dd-MM-yyyy'}}</th>
                  
                </tr> -->
                <tr>
                    <th colspan="4"
                        style="border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        नूतनीकरण येणे बाकी</th>

                    <th colspan="12"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        एप्रिल</th>
                    <th colspan="12"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        मे</th>
                    <th colspan="12"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        जून</th>
                    <th colspan="12"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        जुलै</th>
                    <th colspan="12"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        ऑगस्ट</th>
                    <th colspan="12"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        सप्टेंबर</th>
                    <th colspan="12"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        ऑक्टोबर</th>
                    <th colspan="12"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        नोव्हेंबर</th>
                    <th colspan="12"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        डिसेंबर</th>
                    <th colspan="12"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        जानेवारी</th>
                    <th colspan="12"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        फेब्रुवारी</th>
                    <th colspan="12"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        मार्च</th>
                    <th colspan="12"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        एकूण</th>
                </tr>
                <tr>
                    <th colspan="4" style="text-align: center; border-left: 2px solid black;"></th>
                    <!-- april-->
                    <th colspan="3"
                        style="text-align: center; border-left: 2px solid black; border-right: 2px solid black; border-bottom: 2px solid black;">
                        पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-right: 2px solid black; border-bottom: 2px solid black;">हस्ते
                    </th>
                    <th colspan="3"
                        style="overflow-wrap: break-word; white-space: normal; border-right: 2px solid black; border-bottom: 2px solid black;">
                        मॅगझीन पोस्ट</th>
                    <th colspan="3"
                        style="overflow-wrap: break-word; white-space: normal; border-right: 2px solid black; border-bottom: 2px solid black;">
                        डिजिटल</th>
                    <!-- may-->
                    <th colspan="3"
                        style="text-align: center; border-left: 2px solid black; border-right: 2px solid black; border-bottom: 2px solid black;">
                        पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-right: 2px solid black; border-bottom: 2px solid black;">हस्ते
                    </th>
                    <th colspan="3"
                        style="overflow-wrap: break-word; white-space: normal; border-right: 2px solid black; border-bottom: 2px solid black;">
                        मॅगझीन पोस्ट</th>
                    <th colspan="3"
                        style="overflow-wrap: break-word; white-space: normal; border-right: 2px solid black; border-bottom: 2px solid black;">
                        डिजिटल</th>
                    <!-- june-->
                    <th colspan="3"
                        style="text-align: center; border-left: 2px solid black; border-right: 2px solid black; border-bottom: 2px solid black;">
                        पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-right: 2px solid black; border-bottom: 2px solid black;">हस्ते
                    </th>
                    <th colspan="3"
                        style="overflow-wrap: break-word; white-space: normal; border-right: 2px solid black; border-bottom: 2px solid black;">
                        मॅगझीन पोस्ट</th>
                    <th colspan="3"
                        style="overflow-wrap: break-word; white-space: normal; border-right: 2px solid black; border-bottom: 2px solid black;">
                        डिजिटल</th>
                    <!-- jul-->
                    <th colspan="3"
                        style="text-align: center; border-left: 2px solid black; border-right: 2px solid black; border-bottom: 2px solid black;">
                        पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-right: 2px solid black; border-bottom: 2px solid black;">हस्ते
                    </th>
                    <th colspan="3"
                        style="overflow-wrap: break-word; white-space: normal; border-right: 2px solid black; border-bottom: 2px solid black;">
                        मॅगझीन पोस्ट</th>
                    <th colspan="3"
                        style="overflow-wrap: break-word; white-space: normal; border-right: 2px solid black; border-bottom: 2px solid black;">
                        डिजिटल</th>
                    <!-- aug-->
                    <th colspan="3"
                        style="text-align: center; border-left: 2px solid black; border-right: 2px solid black; border-bottom: 2px solid black;">
                        पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-right: 2px solid black; border-bottom: 2px solid black;">हस्ते
                    </th>
                    <th colspan="3"
                        style="overflow-wrap: break-word; white-space: normal; border-right: 2px solid black; border-bottom: 2px solid black;">
                        मॅगझीन पोस्ट</th>
                    <th colspan="3"
                        style="overflow-wrap: break-word; white-space: normal; border-right: 2px solid black; border-bottom: 2px solid black;">
                        डिजिटल</th>
                    <!-- sep-->
                    <th colspan="3"
                        style="text-align: center; border-left: 2px solid black; border-right: 2px solid black; border-bottom: 2px solid black;">
                        पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-right: 2px solid black; border-bottom: 2px solid black;">हस्ते
                    </th>
                    <th colspan="3"
                        style="overflow-wrap: break-word; white-space: normal; border-right: 2px solid black; border-bottom: 2px solid black;">
                        मॅगझीन पोस्ट</th>
                    <th colspan="3"
                        style="overflow-wrap: break-word; white-space: normal; border-right: 2px solid black; border-bottom: 2px solid black;">
                        डिजिटल</th>
                    <!-- oct-->
                    <th colspan="3"
                        style="text-align: center; border-left: 2px solid black; border-right: 2px solid black; border-bottom: 2px solid black;">
                        पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-right: 2px solid black; border-bottom: 2px solid black;">हस्ते
                    </th>
                    <th colspan="3"
                        style="overflow-wrap: break-word; white-space: normal; border-right: 2px solid black; border-bottom: 2px solid black;">
                        मॅगझीन पोस्ट</th>
                    <th colspan="3"
                        style="overflow-wrap: break-word; white-space: normal; border-right: 2px solid black; border-bottom: 2px solid black;">
                        डिजिटल</th>
                    <!-- nov-->
                    <th colspan="3"
                        style="text-align: center; border-left: 2px solid black; border-right: 2px solid black; border-bottom: 2px solid black;">
                        पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-right: 2px solid black; border-bottom: 2px solid black;">हस्ते
                    </th>
                    <th colspan="3"
                        style="overflow-wrap: break-word; white-space: normal; border-right: 2px solid black; border-bottom: 2px solid black;">
                        मॅगझीन पोस्ट</th>
                    <th colspan="3"
                        style="overflow-wrap: break-word; white-space: normal; border-right: 2px solid black; border-bottom: 2px solid black;">
                        डिजिटल</th>
                    <!-- dec-->
                    <th colspan="3"
                        style="text-align: center; border-left: 2px solid black; border-right: 2px solid black; border-bottom: 2px solid black;">
                        पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-right: 2px solid black; border-bottom: 2px solid black;">हस्ते
                    </th>
                    <th colspan="3"
                        style="overflow-wrap: break-word; white-space: normal; border-right: 2px solid black; border-bottom: 2px solid black;">
                        मॅगझीन पोस्ट</th>
                    <th colspan="3"
                        style="overflow-wrap: break-word; white-space: normal; border-right: 2px solid black; border-bottom: 2px solid black;">
                        डिजिटल</th>
                    <!-- jan-->
                    <th colspan="3"
                        style="text-align: center; border-left: 2px solid black; border-right: 2px solid black; border-bottom: 2px solid black;">
                        पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-right: 2px solid black; border-bottom: 2px solid black;">हस्ते
                    </th>
                    <th colspan="3"
                        style="overflow-wrap: break-word; white-space: normal; border-right: 2px solid black; border-bottom: 2px solid black;">
                        मॅगझीन पोस्ट</th>
                    <th colspan="3"
                        style="overflow-wrap: break-word; white-space: normal; border-right: 2px solid black; border-bottom: 2px solid black;">
                        डिजिटल</th>
                    <!-- feb-->
                    <th colspan="3"
                        style="text-align: center; border-left: 2px solid black; border-right: 2px solid black; border-bottom: 2px solid black;">
                        पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-right: 2px solid black; border-bottom: 2px solid black;">हस्ते
                    </th>
                    <th colspan="3"
                        style="overflow-wrap: break-word; white-space: normal; border-right: 2px solid black; border-bottom: 2px solid black;">
                        मॅगझीन पोस्ट</th>
                    <th colspan="3"
                        style="overflow-wrap: break-word; white-space: normal; border-right: 2px solid black; border-bottom: 2px solid black;">
                        डिजिटल</th>
                    <!-- mar-->
                    <th colspan="3"
                        style="text-align: center; border-left: 2px solid black; border-right: 2px solid black; border-bottom: 2px solid black;">
                        पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-right: 2px solid black; border-bottom: 2px solid black;">हस्ते
                    </th>
                    <th colspan="3"
                        style="overflow-wrap: break-word; white-space: normal; border-right: 2px solid black; border-bottom: 2px solid black;">
                        मॅगझीन पोस्ट</th>
                    <th colspan="3"
                        style="overflow-wrap: break-word; white-space: normal; border-right: 2px solid black; border-bottom: 2px solid black;">
                        डिजिटल</th>

                    <!-- total-->
                    <th colspan="3"
                        style="text-align: center; border-left: 2px solid black; border-right: 2px solid black; border-bottom: 2px solid black;">
                        पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-right: 2px solid black; border-bottom: 2px solid black;">हस्ते
                    </th>
                    <th colspan="3"
                        style="overflow-wrap: break-word; white-space: normal; border-right: 2px solid black; border-bottom: 2px solid black;">
                        मॅगझीन पोस्ट</th>
                    <th colspan="3"
                        style="overflow-wrap: break-word; white-space: normal; border-right: 2px solid black; border-bottom: 2px solid black;">
                        डिजिटल</th>
                </tr>
                <tr>
                    <th colspan="4" style="border-left: 2px solid black; border-right: 2px solid black;">जिल्हा</th>
                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; overflow-wrap: break-word;">बाकी</th>
                    <th
                        style="border-right: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        एकूण</th>
                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; overflow-wrap: break-word;">बाकी</th>
                    <th
                        style="border-right: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        एकूण</th>
                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; overflow-wrap: break-word;">बाकी</th>
                    <th
                        style="border-right: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        एकूण</th>
                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; overflow-wrap: break-word;">बाकी</th>
                    <th
                        style="border-right: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        एकूण</th>

                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black; overflow-wrap: break-word;">बाकी</th>
                    <th
                        style="border-right: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        एकूण</th>
                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; overflow-wrap: break-word;">बाकी</th>
                    <th
                        style="border-right: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        एकूण</th>
                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; overflow-wrap: break-word;">बाकी</th>
                    <th
                        style="border-right: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        एकूण</th>
                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; overflow-wrap: break-word;">बाकी</th>
                    <th
                        style="border-right: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        एकूण</th>

                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; overflow-wrap: break-word;">बाकी</th>
                    <th
                        style="border-right: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        एकूण</th>
                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; overflow-wrap: break-word;">बाकी</th>
                    <th
                        style="border-right: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        एकूण</th>
                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; overflow-wrap: break-word;">बाकी</th>
                    <th
                        style="border-right: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        एकूण</th>
                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; overflow-wrap: break-word;">बाकी</th>
                    <th
                        style="border-right: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        एकूण</th>

                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; overflow-wrap: break-word;">बाकी</th>
                    <th
                        style="border-right: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        एकूण</th>
                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; overflow-wrap: break-word;">बाकी</th>
                    <th
                        style="border-right: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        एकूण</th>
                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; overflow-wrap: break-word;">बाकी</th>
                    <th
                        style="border-right: 2px solid black; border-bottom: 2px solid black;overflow-wrap: break-word;">
                        एकूण</th>
                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; overflow-wrap: break-word;">बाकी</th>
                    <th
                        style="border-right: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        एकूण</th>

                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; overflow-wrap: break-word;">बाकी</th>
                    <th
                        style="border-right: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        एकूण</th>
                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; overflow-wrap: break-word;">बाकी</th>
                    <th
                        style="border-right: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        एकूण</th>
                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; overflow-wrap: break-word;">बाकी</th>
                    <th
                        style="border-right: 2px solid black; border-bottom: 2px solid black;overflow-wrap: break-word;">
                        एकूण</th>
                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; overflow-wrap: break-word;">बाकी</th>
                    <th
                        style="border-right: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        एकूण</th>

                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; overflow-wrap: break-word;">बाकी</th>
                    <th
                        style="border-right: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        एकूण</th>
                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; overflow-wrap: break-word;">बाकी</th>
                    <th
                        style="border-right: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        एकूण</th>
                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; overflow-wrap: break-word;">बाकी</th>
                    <th
                        style="border-right: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        एकूण</th>
                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; overflow-wrap: break-word;">बाकी</th>
                    <th
                        style="border-right: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        एकूण</th>

                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; overflow-wrap: break-word;">बाकी</th>
                    <th
                        style="border-right: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        एकूण</th>
                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; overflow-wrap: break-word;">बाकी</th>
                    <th
                        style="border-right: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        एकूण</th>
                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; overflow-wrap: break-word;">बाकी</th>
                    <th
                        style="border-right: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        एकूण</th>
                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; overflow-wrap: break-word;">बाकी</th>
                    <th
                        style="border-right: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        एकूण</th>

                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; overflow-wrap: break-word;">बाकी</th>
                    <th
                        style="border-right: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        एकूण</th>
                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        जमा</th>
                    <th
                        style="border-bottom: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        बाकी</th>
                    <th
                        style="border-right: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        एकूण</th>
                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; overflow-wrap: break-word;">बाकी</th>
                    <th
                        style="border-right: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        एकूण</th>
                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; overflow-wrap: break-word;">बाकी</th>
                    <th
                        style="border-right: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        एकूण</th>

                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; overflow-wrap: break-word;">बाकी</th>
                    <th
                        style="border-right: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        एकूण</th>
                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; overflow-wrap: break-word;">बाकी</th>
                    <th
                        style="border-right: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        एकूण</th>
                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; overflow-wrap: break-word;">बाकी</th>
                    <th
                        style="border-right: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        एकूण</th>
                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; overflow-wrap: break-word;">बाकी</th>
                    <th
                        style="border-right: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        एकूण</th>

                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; overflow-wrap: break-word;">बाकी</th>
                    <th
                        style="border-right: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        एकूण</th>
                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; overflow-wrap: break-word;">बाकी</th>
                    <th
                        style="border-right: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        एकूण</th>
                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; overflow-wrap: break-word;">बाकी</th>
                    <th
                        style="border-right: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        एकूण</th>
                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; overflow-wrap: break-word;">बाकी</th>
                    <th
                        style="border-right: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        एकूण</th>

                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; overflow-wrap: break-word;">बाकी</th>
                    <th
                        style="border-right: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        एकूण</th>
                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; overflow-wrap: break-word;">बाकी</th>
                    <th
                        style="border-right: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        एकूण</th>
                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        जमा</th>
                    <th
                        style="border-bottom: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        बाकी</th>
                    <th
                        style="border-right: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        एकूण</th>
                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; overflow-wrap: break-word;">बाकी</th>
                    <th
                        style="border-right: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        एकूण</th>

                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; overflow-wrap: break-word;">बाकी</th>
                    <th
                        style="border-right: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        एकूण</th>
                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; overflow-wrap: break-word;">बाकी</th>
                    <th
                        style="border-right: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        एकूण</th>
                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; overflow-wrap: break-word;">बाकी</th>
                    <th
                        style="border-right: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        एकूण</th>
                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; overflow-wrap: break-word;">बाकी</th>
                    <th
                        style="border-right: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        एकूण</th>
                    <!-- <th colspan="6"></th> -->
                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; overflow-wrap: break-word;">बाकी</th>
                    <th
                        style="border-right: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        एकूण</th>
                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; overflow-wrap: break-word;">बाकी</th>
                    <th
                        style="border-right: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        एकूण</th>
                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; overflow-wrap: break-word;">बाकी</th>
                    <th
                        style="border-right: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        एकूण</th>
                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; overflow-wrap: break-word;">बाकी</th>
                    <th
                        style="border-right: 2px solid black; border-bottom: 2px solid black; overflow-wrap: break-word;">
                        एकूण</th>
                </tr>
            </thead>
            <!-- *ngFor="let data of OutstandingInDetailFormBeans; let i = index" -->
            <tbody>
                <ng-container *ngFor="let dataset of SubRemDistrict; let i = index">
                    <tr>
                        <td colspan="4"
                            style="text-align: center; border-left: 2px solid black; overflow-wrap: break-word; border-right: 2px solid black; font-weight: bold; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.country}} <br
                                style="overflow-wrap: break-word; font-weight: bold; border-bottom: 2px solid black;">
                            {{dataset.state}}</td>
                        <!-- <td colspan="156" style="text-align: center; border-right: 2px solid black;"></td> -->
                        <td colspan="12" style="text-align: center; border-right: 2px solid black;"></td>
                        <td colspan="12" style="text-align: center; border-right: 2px solid black;"></td>
                        <td colspan="12" style="text-align: center; border-right: 2px solid black;"></td>
                        <td colspan="12" style="text-align: center; border-right: 2px solid black;"></td>
                        <td colspan="12" style="text-align: center; border-right: 2px solid black;"></td>
                        <td colspan="12" style="text-align: center; border-right: 2px solid black;"></td>
                        <td colspan="12" style="text-align: center; border-right: 2px solid black;"></td>
                        <td colspan="12" style="text-align: center; border-right: 2px solid black;"></td>
                        <td colspan="12" style="text-align: center; border-right: 2px solid black;"></td>
                        <td colspan="12" style="text-align: center; border-right: 2px solid black;"></td>
                        <td colspan="12" style="text-align: center; border-right: 2px solid black;"></td>
                        <td colspan="12" style="text-align: center; border-right: 2px solid black;"></td>
                        <td colspan="12" style="text-align: center; border-right: 2px solid black;"></td>

                    </tr>

                    <ng-container *ngFor="let data of dataset.districts; let i = index">
                        <tr>
                            <td colspan="4"
                                style="border-left: 2px solid black; overflow-wrap: break-word; border-right: 2px solid black;">
                                {{data.district || '--'}}</td>
                            <td style="text-align:right;">{{data.tapal_New_4}}</td>
                            <td style="text-align:right;">{{data.tapal_Renew_4}}</td>
                            <td style="text-align:right; border-right: 2px solid black;">{{data.tapal_Total_4}}</td>

                            <td style="text-align:right;">{{data.haste_New_4}}</td>
                            <td style="text-align:right;">{{data.haste_Renew_4}}</td>
                            <td style="text-align:right; border-right: 2px solid black;">{{data.haste_Total_4}}</td>

                            <td style="text-align:right;">{{data.magzine_Renew_4}}</td>
                            <td style="text-align:right;">{{data.magzine_New_4}}</td>
                            <td style="text-align:right; border-right: 2px solid black;">{{data.magzine_Total_4}}</td>

                            <td style="text-align:right;">{{data.digital_Renew_4}}</td>
                            <td style="text-align:right;">{{data.digital_New_4}}</td>
                            <td style="text-align:right; border-right: 2px solid black;">{{data.digital_Total_4}}</td>

                            <td style="text-align:right;">{{data.tapal_New_5}}</td>
                            <td style="text-align:right;">{{data.tapal_Renew_5}}</td>
                            <td style="text-align:right; border-right: 2px solid black;">{{data.tapal_Total_5}}</td>

                            <td style="text-align:right;">{{data.haste_New_5}}</td>
                            <td style="text-align:right;">{{data.haste_Renew_5}}</td>
                            <td style="text-align:right; border-right: 2px solid black;">{{data.haste_Total_5}}</td>

                            <td style="text-align:right;">{{data.magzine_Renew_5}}</td>
                            <td style="text-align:right;">{{data.magzine_New_5}}</td>
                            <td style="text-align:right; border-right: 2px solid black;">{{data.magzine_Total_5}}</td>

                            <td style="text-align:right;">{{data.digital_Renew_5}}</td>
                            <td style="text-align:right;">{{data.digital_New_5}}</td>
                            <td style="text-align:right; border-right: 2px solid black;">{{data.digital_Total_5}}</td>

                            <td style="text-align:right;">{{data.tapal_New_6}}</td>
                            <td style="text-align:right;">{{data.tapal_Renew_6}}</td>
                            <td style="text-align:right; border-right: 2px solid black;">{{data.tapal_Total_6}}</td>

                            <td style="text-align:right;">{{data.haste_New_6}}</td>
                            <td style="text-align:right;">{{data.haste_Renew_6}}</td>
                            <td style="text-align:right; border-right: 2px solid black;">{{data.haste_Total_6}}</td>

                            <td style="text-align:right;">{{data.magzine_Renew_6}}</td>
                            <td style="text-align:right;">{{data.magzine_New_6}}</td>
                            <td style="text-align:right; border-right: 2px solid black;">{{data.magzine_Total_6}}</td>

                            <td style="text-align:right;">{{data.digital_Renew_6}}</td>
                            <td style="text-align:right;">{{data.digital_New_6}}</td>
                            <td style="text-align:right; border-right: 2px solid black;">{{data.digital_Total_6}}</td>

                            <td style="text-align:right;">{{data.tapal_New_7}}</td>
                            <td style="text-align:right;">{{data.tapal_Renew_7}}</td>
                            <td style="text-align:right; border-right: 2px solid black;">{{data.tapal_Total_7}}</td>

                            <td style="text-align:right;">{{data.haste_New_7}}</td>
                            <td style="text-align:right;">{{data.haste_Renew_7}}</td>
                            <td style="text-align:right; border-right: 2px solid black;">{{data.haste_Total_7}}</td>

                            <td style="text-align:right;">{{data.magzine_Renew_7}}</td>
                            <td style="text-align:right;">{{data.magzine_New_7}}</td>
                            <td style="text-align:right; border-right: 2px solid black;">{{data.magzine_Total_7}}</td>

                            <td style="text-align:right;">{{data.digital_Renew_7}}</td>
                            <td style="text-align:right;">{{data.digital_New_7}}</td>
                            <td style="text-align:right; border-right: 2px solid black;">{{data.digital_Total_7}}</td>

                            <td style="text-align:right;">{{data.tapal_New_8}}</td>
                            <td style="text-align:right;">{{data.tapal_Renew_8}}</td>
                            <td style="text-align:right; border-right: 2px solid black;">{{data.tapal_Total_8}}</td>

                            <td style="text-align:right;">{{data.haste_New_8}}</td>
                            <td style="text-align:right;">{{data.haste_Renew_8}}</td>
                            <td style="text-align:right; border-right: 2px solid black;">{{data.haste_Total_8}}</td>

                            <td style="text-align:right;">{{data.magzine_Renew_8}}</td>
                            <td style="text-align:right;">{{data.magzine_New_8}}</td>
                            <td style="text-align:right; border-right: 2px solid black;">{{data.magzine_Total_8}}</td>

                            <td style="text-align:right;">{{data.digital_Renew_8}}</td>
                            <td style="text-align:right;">{{data.digital_New_8}}</td>
                            <td style="text-align:right; border-right: 2px solid black;">{{data.digital_Total_8}}</td>

                            <td style="text-align:right;">{{data.tapal_New_9}}</td>
                            <td style="text-align:right;">{{data.tapal_Renew_9}}</td>
                            <td style="text-align:right; border-right: 2px solid black;">{{data.tapal_Total_9}}</td>

                            <td style="text-align:right;">{{data.haste_New_9}}</td>
                            <td style="text-align:right;">{{data.haste_Renew_9}}</td>
                            <td style="text-align:right; border-right: 2px solid black;">{{data.haste_Total_9}}</td>

                            <td style="text-align:right;">{{data.magzine_Renew_9}}</td>
                            <td style="text-align:right;">{{data.magzine_New_9}}</td>
                            <td style="text-align:right; border-right: 2px solid black;">{{data.magzine_Total_9}}</td>

                            <td style="text-align:right;">{{data.digital_Renew_9}}</td>
                            <td style="text-align:right;">{{data.digital_New_9}}</td>
                            <td style="text-align:right; border-right: 2px solid black;">{{data.digital_Total_9}}</td>

                            <td style="text-align:right;">{{data.tapal_New_10}}</td>
                            <td style="text-align:right;">{{data.tapal_Renew_10}}</td>
                            <td style="text-align:right; border-right: 2px solid black;">{{data.tapal_Total_10}}</td>

                            <td style="text-align:right;">{{data.haste_New_10}}</td>
                            <td style="text-align:right;">{{data.haste_Renew_10}}</td>
                            <td style="text-align:right; border-right: 2px solid black;">{{data.haste_Total_10}}</td>

                            <td style="text-align:right;">{{data.magzine_Renew_10}}</td>
                            <td style="text-align:right;">{{data.magzine_New_10}}</td>
                            <td style="text-align:right; border-right: 2px solid black;">{{data.magzine_Total_10}}</td>

                            <td style="text-align:right;">{{data.digital_Renew_10}}</td>
                            <td style="text-align:right;">{{data.digital_New_10}}</td>
                            <td style="text-align:right; border-right: 2px solid black;">{{data.digital_Total_10}}</td>

                            <td style="text-align:right;">{{data.tapal_New_11}}</td>
                            <td style="text-align:right;">{{data.tapal_Renew_11}}</td>
                            <td style="text-align:right; border-right: 2px solid black;">{{data.tapal_Total_11}}</td>

                            <td style="text-align:right;">{{data.haste_New_11}}</td>
                            <td style="text-align:right;">{{data.haste_Renew_11}}</td>
                            <td style="text-align:right; border-right: 2px solid black;">{{data.haste_Total_11}}</td>

                            <td style="text-align:right;">{{data.magzine_Renew_11}}</td>
                            <td style="text-align:right;">{{data.magzine_New_11}}</td>
                            <td style="text-align:right; border-right: 2px solid black;">{{data.magzine_Total_11}}</td>

                            <td style="text-align:right;">{{data.digital_Renew_11}}</td>
                            <td style="text-align:right;">{{data.digital_New_11}}</td>
                            <td style="text-align:right; border-right: 2px solid black;">{{data.digital_Total_11}}</td>

                            <td style="text-align:right;">{{data.tapal_New_12}}</td>
                            <td style="text-align:right;">{{data.tapal_Renew_12}}</td>
                            <td style="text-align:right; border-right: 2px solid black;">{{data.tapal_Total_12}}</td>

                            <td style="text-align:right;">{{data.haste_New_12}}</td>
                            <td style="text-align:right;">{{data.haste_Renew_12}}</td>
                            <td style="text-align:right; border-right: 2px solid black;">{{data.haste_Total_12}}</td>

                            <td style="text-align:right;">{{data.magzine_Renew_12}}</td>
                            <td style="text-align:right;">{{data.magzine_New_12}}</td>
                            <td style="text-align:right; border-right: 2px solid black;">{{data.magzine_Total_12}}</td>

                            <td style="text-align:right;">{{data.digital_Renew_12}}</td>
                            <td style="text-align:right;">{{data.digital_New_12}}</td>
                            <td style="text-align:right; border-right: 2px solid black;">{{data.digital_Total_12}}</td>

                            <td style="text-align:right;">{{data.tapal_New_1}}</td>
                            <td style="text-align:right;">{{data.tapal_Renew_1}}</td>
                            <td style="text-align:right; border-right: 2px solid black;">{{data.tapal_Total_1}}</td>

                            <td style="text-align:right;">{{data.haste_New_1}}</td>
                            <td style="text-align:right;">{{data.haste_Renew_1}}</td>
                            <td style="text-align:right; border-right: 2px solid black;">{{data.haste_Total_1}}</td>

                            <td style="text-align:right;">{{data.magzine_Renew_1}}</td>
                            <td style="text-align:right;">{{data.magzine_New_1}}</td>
                            <td style="text-align:right; border-right: 2px solid black;">{{data.magzine_Total_1}}</td>

                            <td style="text-align:right;">{{data.digital_Renew_1}}</td>
                            <td style="text-align:right;">{{data.digital_New_1}}</td>
                            <td style="text-align:right; border-right: 2px solid black;">{{data.digital_Total_1}}</td>

                            <td style="text-align:right;">{{data.tapal_New_2}}</td>
                            <td style="text-align:right;">{{data.tapal_Renew_2}}</td>
                            <td style="text-align:right; border-right: 2px solid black;">{{data.tapal_Total_2}}</td>

                            <td style="text-align:right;">{{data.haste_New_2}}</td>
                            <td style="text-align:right;">{{data.haste_Renew_2}}</td>
                            <td style="text-align:right; border-right: 2px solid black;">{{data.haste_Total_2}}</td>

                            <td style="text-align:right;">{{data.magzine_Renew_2}}</td>
                            <td style="text-align:right;">{{data.magzine_New_2}}</td>
                            <td style="text-align:right; border-right: 2px solid black;">{{data.magzine_Total_2}}</td>

                            <td style="text-align:right;">{{data.digital_Renew_2}}</td>
                            <td style="text-align:right;">{{data.digital_New_2}}</td>
                            <td style="text-align:right; border-right: 2px solid black;">{{data.digital_Total_2}}</td>

                            <td style="text-align:right;">{{data.tapal_New_3}}</td>
                            <td style="text-align:right;">{{data.tapal_Renew_3}}</td>
                            <td style="text-align:right; border-right: 2px solid black;">{{data.tapal_Total_3}}</td>

                            <td style="text-align:right;">{{data.haste_New_3}}</td>
                            <td style="text-align:right;">{{data.haste_Renew_3}}</td>
                            <td style="text-align:right; border-right: 2px solid black;">{{data.haste_Total_3}}</td>

                            <td style="text-align:right;">{{data.magzine_Renew_3}}</td>
                            <td style="text-align:right;">{{data.magzine_New_3}}</td>
                            <td style="text-align:right; border-right: 2px solid black;">{{data.magzine_Total_3}}</td>

                            <td style="text-align:right;">{{data.digital_Renew_3}}</td>
                            <td style="text-align:right;">{{data.digital_New_3}}</td>
                            <td style="text-align:right; border-right: 2px solid black;">{{data.digital_Total_3}}</td>

                            <td style="text-align:right;">{{data.tapal_New_total}}</td>
                            <td style="text-align:right;">{{data.tapal_Renew_total}}</td>
                            <td style="text-align:right; border-right: 2px solid black;">{{data.tapal_Total_total}}</td>

                            <td style="text-align:right;">{{data.haste_New_total}}</td>
                            <td style="text-align:right;">{{data.haste_Renew_total}}</td>
                            <td style="text-align:right; border-right: 2px solid black;">{{data.haste_Total_total}}</td>

                            <td style="text-align:right;">{{data.magzine_New_total}}</td>
                            <td style="text-align:right;">{{data.magzine_Renew_total}}</td>
                            <td style="text-align:right; border-right: 2px solid black;">{{data.magzine_Total_total}}
                            </td>

                            <td style="text-align:right;">{{data.digital_New_total}}</td>
                            <td style="text-align:right;">{{data.digital_Renew_total}}</td>
                            <td style="text-align:right; border-right: 2px solid black;">{{data.digital_Total_total}}
                            </td>



                        </tr>
                    </ng-container>

                    <tr>
                        <td colspan="4"
                            style="text-align: right; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; font-weight: bold;">
                            <b>एकूण :- </b>
                        </td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.tapal_New_4}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.tapal_Renew_4}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                            {{dataset.tapal_Total_4}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.haste_New_4}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.haste_Renew_4}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                            {{dataset.haste_Total_4}}</td>

                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.magzine_New_4}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.magzine_Renew_4}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                            {{dataset.magzine_Total_4}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.digital_New_4}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.digital_Renew_4}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                            {{dataset.digital_Total_4}}</td>

                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.tapal_New_5}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.tapal_Renew_5}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                            {{dataset.tapal_Total_5}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.haste_New_5}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.haste_Renew_5}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                            {{dataset.haste_Total_5}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.magzine_New_5}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.magzine_Renew_5}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                            {{dataset.magzine_Total_5}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.digital_New_5}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.digital_Renew_5}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                            {{dataset.digital_Total_5}}</td>

                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.tapal_New_6}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.tapal_Renew_6}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                            {{dataset.tapal_Total_6}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.haste_New_6}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.haste_Renew_6}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                            {{dataset.haste_Total_6}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.magzine_New_6}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.magzine_Renew_6}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                            {{dataset.magzine_Total_6}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.digital_New_6}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.digital_Renew_6}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                            {{dataset.digital_Total_6}}</td>

                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.tapal_New_7}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.tapal_Renew_7}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                            {{dataset.tapal_Total_7}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.haste_New_7}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.haste_Renew_7}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                            {{dataset.haste_Total_7}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.magzine_New_7}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.magzine_Renew_7}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                            {{dataset.magzine_Total_7}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.digital_New_7}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.digital_Renew_7}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                            {{dataset.digital_Total_7}}</td>

                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.tapal_New_8}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.tapal_Renew_8}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                            {{dataset.tapal_Total_8}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.haste_New_8}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.haste_Renew_8}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                            {{dataset.haste_Total_8}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.magzine_New_8}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.magzine_Renew_8}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                            {{dataset.magzine_Total_8}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.digital_New_8}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.digital_Renew_8}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                            {{dataset.digital_Total_8}}</td>

                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.tapal_New_9}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.tapal_Renew_9}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                            {{dataset.tapal_Total_9}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.haste_New_9}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.haste_Renew_9}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                            {{dataset.haste_Total_9}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.magzine_New_9}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.magzine_Renew_9}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                            {{dataset.magzine_Total_9}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.digital_New_9}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.digital_Renew_9}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                            {{dataset.digital_Total_9}}</td>

                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.tapal_New_10}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.tapal_Renew_10}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                            {{dataset.tapal_Total_10}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.haste_New_10}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.haste_Renew_10}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                            {{dataset.haste_Total_10}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.magzine_New_10}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.magzine_Renew_10}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                            {{dataset.magzine_Total_10}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.digital_New_10}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.digital_Renew_10}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                            {{dataset.digital_Total_10}}</td>

                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.tapal_New_11}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.tapal_Renew_11}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                            {{dataset.tapal_Total_11}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.haste_New_11}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.haste_Renew_11}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                            {{dataset.haste_Total_11}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.magzine_New_11}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.magzine_Renew_11}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                            {{dataset.magzine_Total_11}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.digital_New_11}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.digital_Renew_11}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                            {{dataset.digital_Total_11}}</td>

                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.tapal_New_12}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.tapal_Renew_12}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                            {{dataset.tapal_Total_12}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.haste_New_12}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.haste_Renew_12}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                            {{dataset.haste_Total_12}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.magzine_New_12}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.magzine_Renew_12}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                            {{dataset.magzine_Total_12}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.digital_New_12}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.digital_Renew_12}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                            {{dataset.digital_Total_12}}</td>

                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.tapal_New_1}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.tapal_Renew_1}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                            {{dataset.tapal_Total_1}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.haste_New_1}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.haste_Renew_1}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                            {{dataset.haste_Total_1}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.magzine_New_1}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.magzine_Renew_1}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                            {{dataset.magzine_Total_1}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.digital_New_1}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.digital_Renew_1}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                            {{dataset.digital_Total_1}}</td>

                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.tapal_New_2}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.tapal_Renew_2}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                            {{dataset.tapal_Total_2}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.haste_New_2}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.haste_Renew_2}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                            {{dataset.haste_Total_2}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.magzine_New_2}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.magzine_Renew_2}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                            {{dataset.magzine_Total_2}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.digital_New_2}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.digital_Renew_2}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                            {{dataset.digital_Total_2}}</td>

                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.tapal_New_3}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.tapal_Renew_3}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                            {{dataset.tapal_Total_3}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.haste_New_3}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.haste_Renew_3}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                            {{dataset.haste_Total_3}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.magzine_New_3}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.magzine_Renew_3}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                            {{dataset.magzine_Total_3}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.digital_New_3}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.digital_Renew_3}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                            {{dataset.digital_Total_3}}</td>

                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.tapal_New_total}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.tapal_Renew_total}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                            {{dataset.tapal_Total_total}}</td>

                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.haste_New_total}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.haste_Renew_total}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                            {{dataset.haste_Total_total}}</td>

                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.magzine_New_total}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.magzine_Renew_total}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                            {{dataset.magzine_Total_total}}</td>

                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.digital_New_total}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                            {{dataset.digital_Renew_total}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                            {{dataset.digital_Total_total}}</td>

                    </tr>


                </ng-container>

            </tbody>


            <tfoot>
                <tr>
                    <td colspan="4"
                        style="text-align: left; color: black; font-size: 11px; font-weight: bold; border-right: 2px solid black; border-left: 2px solid black; border-bottom: 2px solid black;">
                        एकूण :-</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black;">
                        {{tapal_New_4}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{tapal_Renew_4}}</td>
                    <td
                        style="text-align:right; color: black; font-weight:600; border-right: 2px solid black; border-bottom: 2px solid black; ">
                        {{tapal_Total_4}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{haste_New_4}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{haste_Renew_4}}</td>
                    <td
                        style="text-align:right; color: black; font-weight:600; border-right: 2px solid black; border-bottom: 2px solid black;">
                        {{haste_Total_4}}</td>

                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{magzine_New_4}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black;">
                        {{magzine_Renew_4}}</td>
                    <td
                        style="text-align:right; color: black; font-weight:600; border-right: 2px solid black; border-bottom: 2px solid black; ">
                        {{magzine_Total_4}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{digital_New_4}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{digital_Renew_4}}</td>
                    <td
                        style="text-align:right; color: black; font-weight:600; border-right: 2px solid black; border-bottom: 2px solid black; ">
                        {{digital_Total_4}}</td>

                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black;">
                        {{tapal_New_5}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{tapal_Renew_5}}</td>
                    <td
                        style="text-align:right; color: black; font-weight:600; border-right: 2px solid black; border-bottom: 2px solid black; ">
                        {{tapal_Total_5}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{haste_New_5}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{haste_Renew_5}}</td>
                    <td
                        style="text-align:right; color: black; font-weight:600; border-right: 2px solid black; border-bottom: 2px solid black; ">
                        {{haste_Total_5}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{magzine_New_5}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{magzine_Renew_5}}</td>
                    <td
                        style="text-align:right; color: black; font-weight:600; border-right: 2px solid black; border-bottom: 2px solid black; ">
                        {{magzine_Total_5}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{digital_New_5}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{digital_Renew_5}}</td>
                    <td
                        style="text-align:right; color: black; font-weight:600; border-right: 2px solid black; border-bottom: 2px solid black; ">
                        {{digital_Total_5}}</td>

                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{tapal_New_6}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{tapal_Renew_6}}</td>
                    <td
                        style="text-align:right; color: black; font-weight:600; border-right: 2px solid black; border-bottom: 2px solid black; ">
                        {{tapal_Total_6}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{haste_New_6}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{haste_Renew_6}}</td>
                    <td
                        style="text-align:right; color: black; font-weight:600; border-right: 2px solid black; border-bottom: 2px solid black; ">
                        {{haste_Total_6}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{magzine_New_6}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{magzine_Renew_6}}</td>
                    <td
                        style="text-align:right; color: black; font-weight:600; border-right: 2px solid black; border-bottom: 2px solid black; ">
                        {{magzine_Total_6}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{digital_New_6}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black;">
                        {{digital_Renew_6}}</td>
                    <td
                        style="text-align:right; color: black; font-weight:600; border-right: 2px solid black; border-bottom: 2px solid black; ">
                        {{digital_Total_6}}</td>

                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black;">
                        {{tapal_New_7}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{tapal_Renew_7}}</td>
                    <td
                        style="text-align:right; color: black; font-weight:600; border-right: 2px solid black; border-bottom: 2px solid black;">
                        {{tapal_Total_7}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{haste_New_7}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{haste_Renew_7}}</td>
                    <td
                        style="text-align:right; color: black; font-weight:600; border-right: 2px solid black; border-bottom: 2px solid black; ">
                        {{haste_Total_7}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{magzine_New_7}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{magzine_Renew_7}}</td>
                    <td
                        style="text-align:right; color: black; font-weight:600; border-right: 2px solid black; border-bottom: 2px solid black; ">
                        {{magzine_Total_7}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{digital_New_7}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{digital_Renew_7}}</td>
                    <td
                        style="text-align:right; color: black; font-weight:600; border-right: 2px solid black; border-bottom: 2px solid black; ">
                        {{digital_Total_7}}</td>

                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{tapal_New_8}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{tapal_Renew_8}}</td>
                    <td
                        style="text-align:right; color: black; font-weight:600; border-right: 2px solid black; border-bottom: 2px solid black; ">
                        {{tapal_Total_8}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black;">
                        {{haste_New_8}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{haste_Renew_8}}</td>
                    <td
                        style="text-align:right; color: black; font-weight:600; border-right: 2px solid black; border-bottom: 2px solid black;">
                        {{haste_Total_8}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{magzine_New_8}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{magzine_Renew_8}}</td>
                    <td
                        style="text-align:right; color: black; font-weight:600; border-right: 2px solid black; border-bottom: 2px solid black; ">
                        {{magzine_Total_8}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black;;">
                        {{digital_New_8}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black;">
                        {{digital_Renew_8}}</td>
                    <td
                        style="text-align:right; color: black; font-weight:600; border-right: 2px solid black; border-bottom: 2px solid black; ">
                        {{digital_Total_8}}</td>

                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black;">
                        {{tapal_New_9}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{tapal_Renew_9}}</td>
                    <td
                        style="text-align:right; color: black; font-weight:600; border-right: 2px solid black; border-bottom: 2px solid black; ">
                        {{tapal_Total_9}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{haste_New_9}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black;">
                        {{haste_Renew_9}}</td>
                    <td
                        style="text-align:right; color: black; font-weight:600; border-right: 2px solid black; border-bottom: 2px solid black; ">
                        {{haste_Total_9}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{magzine_New_9}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{magzine_Renew_9}}</td>
                    <td
                        style="text-align:right; color: black; font-weight:600; border-right: 2px solid black; border-bottom: 2px solid black; ">
                        {{magzine_Total_9}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black;">
                        {{digital_New_9}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{digital_Renew_9}}</td>
                    <td
                        style="text-align:right; color: black; font-weight:600; border-right: 2px solid black; border-bottom: 2px solid black;">
                        {{digital_Total_9}}</td>

                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{tapal_New_10}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{tapal_Renew_10}}</td>
                    <td
                        style="text-align:right; color: black; font-weight:600; border-right: 2px solid black; border-bottom: 2px solid black; ">
                        {{tapal_Total_10}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{haste_New_10}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{haste_Renew_10}}</td>
                    <td
                        style="text-align:right; color: black; font-weight:600; border-right: 2px solid black; border-bottom: 2px solid black; ">
                        {{haste_Total_10}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black;">
                        {{magzine_New_10}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black;">
                        {{magzine_Renew_10}}</td>
                    <td
                        style="text-align:right; color: black; font-weight:600; border-right: 2px solid black; border-bottom: 2px solid black;">
                        {{magzine_Total_10}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black;">
                        {{digital_New_10}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black;">
                        {{digital_Renew_10}}</td>
                    <td
                        style="text-align:right; color: black; font-weight:600; border-right: 2px solid black; border-bottom: 2px solid black; ">
                        {{digital_Total_10}}</td>

                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{tapal_New_11}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black;">
                        {{tapal_Renew_11}}</td>
                    <td
                        style="text-align:right; color: black; font-weight:600; border-right: 2px solid black; border-bottom: 2px solid black; ">
                        {{tapal_Total_11}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{haste_New_11}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{haste_Renew_11}}</td>
                    <td
                        style="text-align:right; color: black; font-weight:600; border-right: 2px solid black; border-bottom: 2px solid black; ">
                        {{haste_Total_11}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{magzine_New_11}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{magzine_Renew_11}}</td>
                    <td
                        style="text-align:right; color: black; font-weight:600; border-right: 2px solid black; border-bottom: 2px solid black; ">
                        {{magzine_Total_11}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{digital_New_11}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{digital_Renew_11}}</td>
                    <td
                        style="text-align:right; color: black; font-weight:600; border-right: 2px solid black; border-bottom: 2px solid black;  ">
                        {{digital_Total_11}}</td>

                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black;">
                        {{tapal_New_12}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{tapal_Renew_12}}</td>
                    <td
                        style="text-align:right; color: black; font-weight:600; border-right: 2px solid black; border-bottom: 2px solid black; ">
                        {{tapal_Total_12}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{haste_New_12}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black;">
                        {{haste_Renew_12}}</td>
                    <td
                        style="text-align:right; color: black; font-weight:600; border-right: 2px solid black; border-bottom: 2px solid black; ">
                        {{haste_Total_12}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{magzine_New_12}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{magzine_Renew_12}}</td>
                    <td
                        style="text-align:right; color: black; font-weight:600; border-right: 2px solid black; border-bottom: 2px solid black; ">
                        {{magzine_Total_12}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{digital_New_12}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{digital_Renew_12}}</td>
                    <td
                        style="text-align:right; color: black; font-weight:600; border-right: 2px solid black; border-bottom: 2px solid black; ">
                        {{digital_Total_12}}</td>

                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{tapal_New_1}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{tapal_Renew_1}}</td>
                    <td
                        style="text-align:right; color: black; font-weight:600; border-right: 2px solid black; border-bottom: 2px solid black; ">
                        {{tapal_Total_1}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{haste_New_1}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{haste_Renew_1}}</td>
                    <td
                        style="text-align:right; color: black; font-weight:600; border-right: 2px solid black; border-bottom: 2px solid black; ">
                        {{haste_Total_1}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{magzine_New_1}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{magzine_Renew_1}}</td>
                    <td
                        style="text-align:right; color: black; font-weight:600; border-right: 2px solid black; border-bottom: 2px solid black;">
                        {{magzine_Total_1}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{digital_New_1}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black;">
                        {{digital_Renew_1}}</td>
                    <td
                        style="text-align:right; color: black; font-weight:600; border-right: 2px solid black; border-bottom: 2px solid black; ">
                        {{digital_Total_1}}</td>

                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{tapal_New_2}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black;">
                        {{tapal_Renew_2}}</td>
                    <td
                        style="text-align:right; color: black; font-weight:600; border-right: 2px solid black; border-bottom: 2px solid black; ">
                        {{tapal_Total_2}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{haste_New_2}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black;">
                        {{haste_Renew_2}}</td>
                    <td
                        style="text-align:right; color: black; font-weight:600; border-right: 2px solid black; border-bottom: 2px solid black; ">
                        {{haste_Total_2}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{magzine_New_2}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black;">
                        {{magzine_Renew_2}}</td>
                    <td
                        style="text-align:right; color: black; font-weight:600; border-right: 2px solid black; border-bottom: 2px solid black; ">
                        {{magzine_Total_2}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{digital_New_2}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black;">
                        {{digital_Renew_2}}</td>
                    <td
                        style="text-align:right; color: black; font-weight:600; border-right: 2px solid black; border-bottom: 2px solid black;">
                        {{digital_Total_2}}</td>

                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black;">
                        {{tapal_New_3}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{tapal_Renew_3}}</td>
                    <td
                        style="text-align:right; color: black; font-weight:600; border-right: 2px solid black; border-bottom: 2px solid black; ">
                        {{tapal_Total_3}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{haste_New_3}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{haste_Renew_3}}</td>
                    <td
                        style="text-align:right; color: black; font-weight:600; border-right: 2px solid black; border-bottom: 2px solid black; ">
                        {{haste_Total_3}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{magzine_New_3}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{magzine_Renew_3}}</td>
                    <td
                        style="text-align:right; color: black; font-weight:600; border-right: 2px solid black; border-bottom: 2px solid black; ">
                        {{magzine_Total_3}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{digital_New_3}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{digital_Renew_3}}</td>
                    <td
                        style="text-align:right; color: black; font-weight:600; border-right: 2px solid black; border-bottom: 2px solid black; ">
                        {{digital_Total_3}}</td>

                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{tapal_New_total}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{tapal_Renew_total}}</td>
                    <td
                        style="text-align:right; color: black; font-weight:600; border-right: 2px solid black; border-bottom: 2px solid black; ">
                        {{tapal_Total_total}}</td>

                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{haste_New_total}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{haste_Renew_total}}</td>
                    <td
                        style="text-align:right; color: black; font-weight:600; border-right: 2px solid black; border-bottom: 2px solid black;">
                        {{haste_Total_total}}</td>

                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black;">
                        {{magzine_New_total}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black;">
                        {{magzine_Renew_total}}</td>
                    <td
                        style="text-align:right; color: black; font-weight:600; border-right: 2px solid black; border-bottom: 2px solid black;  ">
                        {{magzine_Total_total}}</td>

                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{digital_New_total}}</td>
                    <td style="text-align:right; color: black; font-weight:600; border-bottom: 2px solid black; ">
                        {{digital_Renew_total}}</td>
                    <td
                        style="text-align:right; color: black; font-weight:600; border-right: 2px solid black; border-bottom: 2px solid black;  ">
                        {{digital_Total_total}}</td>

                </tr>


            </tfoot>
        </table>


    </div>
    <div style="margin-left: 80%; margin-bottom: 2%;">
        <!-- <button class="noPrint" style="margin-top: 2%;" mat-raised-button color="primary"
            [printStyle]="{table : {'border-collapse':'collapse'}, td : {'border': 'solid 1px'}, th : {'border': 'solid 1px'}}"
            printSectionId="print-section2" ngxPrint>
            print
        </button> -->
        <button class="noPrint" style="margin-top: 2%; margin-left: 2%"
            (click)="exportExcel1('Remaining_Subscription_District')" mat-raised-button color="primary">
            Export
        </button>

        <!-- <button class="noPrint" style="margin-top: 2%;" mat-raised-button color="primary"
           [useExistingCss]="true"
            printSectionId="print-section" ngxPrint>
            print
        </button> -->

        <button class="noPrint" style="margin-top: 2%; margin-left: 2%" mat-raised-button color="primary"
            (click)="printPage1()">
            Print
        </button>

        <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>
            Close
        </button>
    </div>
</div>


<div class="table-container" *ngIf="reportType == 'RemainingSubscriptionDistrictBriefly'">
    <div id="print-section2" class="container">

        <table class="fixed-header">
            <thead>
                <tr>
                    <th colspan="38"
                        style="text-align: center; font-size: 14px; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black;">
                        जिल्हा निहाय वर्गणीदार नूतनीकरण व्यवसाय जमा बाकी तपशील</th>
                    <th colspan="6"
                        style="text-align: center; font-size: 13px; border-right: 2px solid black; border-left: 2px solid black; border-top: 2px solid black;">
                        दिनांक {{ currentDate | date: 'dd-MM-yyyy' }}</th>

                </tr>
                <tr>
                    <th colspan="38"
                        style="text-align: center; padding-left: 6%; font-size: 13px; border-right: 2px solid black; border-left: 2px solid black;">
                        हिंदुस्तान प्रकाशन संस्था - विवेक साप्ताहिक - वर्गणी विभाग</th>

                    <th colspan="3" style="text-align: center; font-size: 13px; border-right: 2px solid black;"> दिनांक
                        पासून:{{startDate | date: 'dd-MM-yyyy'}}</th>
                    <th colspan="3" style="text-align: center; font-size: 13px; border-right: 2px solid black;"> पर्यंत:
                        {{endDate | date: 'dd-MM-yyyy'}}</th>

                </tr>

                <tr>
                    <th colspan="4"
                        style="border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                        नूतनीकरण येणे बाकी</th>

                    <th colspan="3"
                        style="text-align: center; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                        एप्रिल</th>
                    <th colspan="3"
                        style="text-align: center; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                        मे</th>
                    <th colspan="3"
                        style="text-align: center; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                        जून</th>
                    <th colspan="3"
                        style="text-align: center; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                        जुलै</th>
                    <th colspan="3"
                        style="text-align: center; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                        ऑगस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                        सप्टेंबर</th>
                    <th colspan="3"
                        style="text-align: center; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                        ऑक्टोबर</th>
                    <th colspan="3"
                        style="text-align: center; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                        नोव्हेंबर</th>
                    <th colspan="3"
                        style="text-align: center; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                        डिसेंबर</th>
                    <th colspan="3"
                        style="text-align: center; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                        जानेवारी</th>
                    <th colspan="3"
                        style="text-align: center; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                        फेब्रुवारी</th>
                    <th colspan="3"
                        style="text-align: center; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                        मार्च</th>
                    <th colspan="3"
                        style="text-align: center; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                        एकूण</th>
                </tr>
                <tr>
                    <th colspan="4" style="text-align: center; border-left: 2px solid black;"></th>
                </tr>
                <tr>
                    <th colspan="4" style="border-left: 2px solid black; border-right: 2px solid black;">जिल्हा</th>
                    <th style="border-left: 2px solid black; overflow-wrap: break-word;">जमा</th>
                    <th style="overflow-wrap: break-word;">बाकी</th>
                    <th style="border-right: 2px solid black; overflow-wrap: break-word;">एकूण</th>

                    <th style="border-left: 2px solid black; overflow-wrap: break-word;">जमा</th>
                    <th style="overflow-wrap: break-word;">बाकी</th>
                    <th style="border-right: 2px solid black; overflow-wrap: break-word;">एकूण</th>

                    <th style="border-left: 2px solid black; overflow-wrap: break-word;">जमा</th>
                    <th style="overflow-wrap: break-word;">बाकी</th>
                    <th style="border-right: 2px solid black; overflow-wrap: break-word;">एकूण</th>

                    <th style="border-left: 2px solid black; overflow-wrap: break-word;">जमा</th>
                    <th style="overflow-wrap: break-word;">बाकी</th>
                    <th style="border-right: 2px solid black; overflow-wrap: break-word;">एकूण</th>

                    <th style="border-left: 2px solid black;">जमा</th>
                    <th style="overflow-wrap: break-word;">बाकी</th>
                    <th style="border-right: 2px solid black; overflow-wrap: break-word;">एकूण</th>

                    <th style="border-left: 2px solid black; overflow-wrap: break-word;">जमा</th>
                    <th style="overflow-wrap: break-word;">बाकी</th>
                    <th style="border-right: 2px solid black; overflow-wrap: break-word;">एकूण</th>

                    <th style="border-left: 2px solid black; overflow-wrap: break-word;">जमा</th>
                    <th style="overflow-wrap: break-word;">बाकी</th>
                    <th style="border-right: 2px solid black; overflow-wrap: break-word;">एकूण</th>

                    <th style="border-left: 2px solid black; overflow-wrap: break-word;">जमा</th>
                    <th style="overflow-wrap: break-word;">बाकी</th>
                    <th style="border-right: 2px solid black; overflow-wrap: break-word;">एकूण</th>

                    <th style="border-left: 2px solid black; overflow-wrap: break-word;">जमा</th>
                    <th style="overflow-wrap: break-word;">बाकी</th>
                    <th style="border-right: 2px solid black; overflow-wrap: break-word;">एकूण</th>

                    <th style="border-left: 2px solid black; overflow-wrap: break-word;">जमा</th>
                    <th style="overflow-wrap: break-word;">बाकी</th>
                    <th style="border-right: 2px solid black; overflow-wrap: break-word;">एकूण</th>

                    <th style="border-left: 2px solid black; overflow-wrap: break-word;">जमा</th>
                    <th style="overflow-wrap: break-word;">बाकी</th>
                    <th style="border-right: 2px solid black; overflow-wrap: break-word;">एकूण</th>

                    <th style="border-left: 2px solid black; overflow-wrap: break-word;">जमा</th>
                    <th style="overflow-wrap: break-word;">बाकी</th>
                    <th style="border-right: 2px solid black; overflow-wrap: break-word;">एकूण</th>

                    <th style="border-left: 2px solid black; overflow-wrap: break-word;">जमा</th>
                    <th style="overflow-wrap: break-word;">बाकी</th>
                    <th style="border-right: 2px solid black; overflow-wrap: break-word;">एकूण</th>

                </tr>
            </thead>

            <tbody>

                <ng-container *ngFor="let data of SubRemDistrictBriefly; let i = index">
                    <tr>
                        <td colspan="4"
                            style="border-left: 2px solid black; overflow-wrap: break-word; border-right: 2px solid black;">
                            {{data.district || '--'}}</td>
                        <td style="text-align:right;">{{data.New_4}}</td>
                        <td style="text-align:right;">{{data.Renew_4}}</td>
                        <td style="text-align:right; border-right: 2px solid black;">{{data.Total_4}}</td>



                        <td style="text-align:right;">{{data.New_5}}</td>
                        <td style="text-align:right;">{{data.Renew_5}}</td>
                        <td style="text-align:right; border-right: 2px solid black;">{{data.Total_5}}</td>



                        <td style="text-align:right;">{{data.New_6}}</td>
                        <td style="text-align:right;">{{data.Renew_6}}</td>
                        <td style="text-align:right; border-right: 2px solid black;">{{data.Total_6}}</td>



                        <td style="text-align:right;">{{data.New_7}}</td>
                        <td style="text-align:right;">{{data.Renew_7}}</td>
                        <td style="text-align:right; border-right: 2px solid black;">{{data.Total_7}}</td>



                        <td style="text-align:right;">{{data.New_8}}</td>
                        <td style="text-align:right;">{{data.Renew_8}}</td>
                        <td style="text-align:right; border-right: 2px solid black;">{{data.Total_8}}</td>



                        <td style="text-align:right;">{{data.New_9}}</td>
                        <td style="text-align:right;">{{data.Renew_9}}</td>
                        <td style="text-align:right; border-right: 2px solid black;">{{data.Total_9}}</td>



                        <td style="text-align:right;">{{data.New_10}}</td>
                        <td style="text-align:right;">{{data.Renew_10}}</td>
                        <td style="text-align:right; border-right: 2px solid black;">{{data.Total_10}}</td>



                        <td style="text-align:right;">{{data.New_11}}</td>
                        <td style="text-align:right;">{{data.Renew_11}}</td>
                        <td style="text-align:right; border-right: 2px solid black;">{{data.Total_11}}</td>



                        <td style="text-align:right;">{{data.New_12}}</td>
                        <td style="text-align:right;">{{data.Renew_12}}</td>
                        <td style="text-align:right; border-right: 2px solid black;">{{data.Total_12}}</td>



                        <td style="text-align:right;">{{data.New_1}}</td>
                        <td style="text-align:right;">{{data.Renew_1}}</td>
                        <td style="text-align:right; border-right: 2px solid black;">{{data.Total_1}}</td>



                        <td style="text-align:right;">{{data.New_2}}</td>
                        <td style="text-align:right;">{{data.Renew_2}}</td>
                        <td style="text-align:right; border-right: 2px solid black;">{{data.Total_2}}</td>



                        <td style="text-align:right;">{{data.New_3}}</td>
                        <td style="text-align:right;">{{data.Renew_3}}</td>
                        <td style="text-align:right; border-right: 2px solid black;">{{data.Total_3}}</td>



                        <td style="text-align:right;">{{data.New_total}}</td>
                        <td style="text-align:right;">{{data.Renew_total}}</td>
                        <td style="text-align:right; border-right: 2px solid black;">{{data.Total_total}}</td>




                    </tr>
                </ng-container>




            </tbody>


            <tfoot>
                <tr>
                    <td colspan="4"
                        style="text-align: right; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; font-weight: bold;">
                        <b>एकूण :- </b>
                    </td>
                    <td
                        style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{this.tapal_New_4}}</td>
                    <td
                        style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{this.tapal_Renew_4}}</td>
                    <td
                        style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                        {{this.tapal_Total_4}}</td>

                    <td
                        style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{this.tapal_New_5}}</td>
                    <td
                        style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{this.tapal_Renew_5}}</td>
                    <td
                        style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                        {{this.tapal_Total_5}}</td>


                    <td
                        style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{this.tapal_New_6}}</td>
                    <td
                        style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{this.tapal_Renew_6}}</td>
                    <td
                        style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                        {{this.tapal_Total_6}}</td>

                    <td
                        style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{this.tapal_New_7}}</td>
                    <td
                        style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{this.tapal_Renew_7}}</td>
                    <td
                        style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                        {{this.tapal_Total_7}}</td>

                    <td
                        style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{this.tapal_New_8}}</td>
                    <td
                        style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{this.tapal_Renew_8}}</td>
                    <td
                        style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                        {{this.tapal_Total_8}}</td>

                    <td
                        style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{this.tapal_New_9}}</td>
                    <td
                        style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{this.tapal_Renew_9}}</td>
                    <td
                        style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                        {{this.tapal_Total_9}}</td>

                    <td
                        style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{this.tapal_New_10}}</td>
                    <td
                        style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{this.tapal_Renew_10}}</td>
                    <td
                        style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                        {{this.tapal_Total_10}}</td>

                    <td
                        style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{this.tapal_New_11}}</td>
                    <td
                        style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{this.tapal_Renew_11}}</td>
                    <td
                        style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                        {{this.tapal_Total_11}}</td>

                    <td
                        style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{this.tapal_New_12}}</td>
                    <td
                        style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{this.tapal_Renew_12}}</td>
                    <td
                        style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                        {{this.tapal_Total_12}}</td>

                    <td
                        style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{this.tapal_New_1}}</td>
                    <td
                        style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{this.tapal_Renew_1}}</td>
                    <td
                        style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                        {{this.tapal_Total_1}}</td>

                    <td
                        style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{this.tapal_New_2}}</td>
                    <td
                        style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{this.tapal_Renew_2}}</td>
                    <td
                        style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                        {{this.tapal_Total_2}}</td>

                    <td
                        style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{this.tapal_New_3}}</td>
                    <td
                        style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{this.tapal_Renew_3}}</td>
                    <td
                        style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                        {{this.tapal_Total_3}}</td>

                    <td
                        style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{this.tapal_New_total}}</td>
                    <td
                        style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{this.tapal_Renew_total}}</td>
                    <td
                        style="text-align:right; font-weight:600; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                        {{this.tapal_Total_total}}</td>


                </tr>



            </tfoot>
        </table>


    </div>
    <div style="margin-left: 80%; margin-bottom: 2%;">
        <!-- <button class="noPrint" style="margin-top: 2%;" mat-raised-button color="primary"
            [printStyle]="{table : {'border-collapse':'collapse'}, td : {'border': 'solid 1px'}, th : {'border': 'solid 1px'}}"
            printSectionId="print-section2" ngxPrint>
            print
        </button> -->
        <button class="noPrint" style="margin-top: 2%; margin-left: 2%"
            (click)="exportExcel1('Remaining_Subscription_District_Briefly')" mat-raised-button color="primary">
            Export
        </button>

        <!-- <button class="noPrint" style="margin-top: 2%;" mat-raised-button color="primary"
           [useExistingCss]="true"
            printSectionId="print-section" ngxPrint>
            print
        </button> -->

        <button class="noPrint" style="margin-top: 2%; margin-left: 2%" mat-raised-button color="primary"
            (click)="printPage1()">
            Print
        </button>

        <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>
            Close
        </button>
    </div>
</div>

<div *ngIf="reportType == 'RemainingSubscriptionTaluka'">
    <div id="print-section1" class="container">

        <table class="table table-bordered">
            <thead>
                <tr>
                    <th colspan="158" style="text-align: center !important; font-size: 20px;">तालुका निहाय</th>
                </tr>
                <tr>
                    <th colspan="146" style="text-align: center !important;font-size: 20 !important;font-weight: 600;">
                        हिंदुस्तान प्रकाशन संस्था - विवेक साप्ताहिक - वर्गणी विभाग</th>
                    <th colspan="12" style="text-align: center !important;font-size: 20 !important;font-weight: 600;">
                        दिनांक : {{ currentDate | date: 'dd-MM-yyyy' }}</th>
                </tr>
                <tr>
                    <th colspan="74" style="text-align: center !important;"> वर्गणीदार नूतनीकरण व्यवसाय तपशिल </th>
                    <th colspan="72" style="text-align: center !important;">जमा बाकी तपशील</th>
                    <th colspan="6" style="text-align: center !important;">दिनांक पासून:{{startDate | date:
                        'dd-MM-yyyy'}}</th>
                    <th colspan="6" style="text-align: center !important;">पर्यंत: {{endDate | date: 'dd-MM-yyyy'}}</th>

                </tr>
                <tr>
                    <th colspan="2"
                        style="font-size: 14; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        नूतनीकरण येणे बाकी</th>
                    <th colspan="12"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">एप्रिल</th>
                    <th colspan="12"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">मे</th>
                    <th colspan="12"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">जून</th>
                    <th colspan="12"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">जुलै</th>
                    <th colspan="12"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">ऑगस्ट</th>
                    <th colspan="12"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">सप्टेंबर</th>
                    <th colspan="12"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">ऑक्टोबर</th>
                    <th colspan="12"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">नोव्हेंबर</th>
                    <th colspan="12"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">डिसेंबर</th>
                    <th colspan="12"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">जानेवारी</th>
                    <th colspan="12"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">फेब्रुवारी</th>
                    <th colspan="12"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">मार्च</th>
                    <th colspan="12"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">एकूण</th>
                </tr>
                <tr>
                    <th colspan="2"
                        style="border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        तालुका</th>


                    <!-- april-->
                    <th colspan="3"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">हस्ते</th>
                    <th colspan="3"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">मॅगझीन पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">डिजिटल</th>
                    <!-- may-->
                    <th colspan="3"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">हस्ते</th>
                    <th colspan="3"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">मॅगझीन पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">डिजिटल</th>
                    <!-- june-->
                    <th colspan="3"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">हस्ते</th>
                    <th colspan="3"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">मॅगझीन पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">डिजिटल</th>
                    <!-- jul-->
                    <th colspan="3"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">हस्ते</th>
                    <th colspan="3"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">मॅगझीन पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">डिजिटल</th>
                    <!-- aug-->
                    <th colspan="3"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">हस्ते</th>
                    <th colspan="3"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">मॅगझीन पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">डिजिटल</th>
                    <!-- sep-->
                    <th colspan="3"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">हस्ते</th>
                    <th colspan="3"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">मॅगझीन पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">डिजिटल</th>
                    <!-- oct-->
                    <th colspan="3"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">हस्ते</th>
                    <th colspan="3"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">मॅगझीन पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">डिजिटल</th>
                    <!-- nov-->
                    <th colspan="3"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">हस्ते</th>
                    <th colspan="3"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">मॅगझीन पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">डिजिटल</th>
                    <!-- dec-->
                    <th colspan="3"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">हस्ते</th>
                    <th colspan="3"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">मॅगझीन पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">डिजिटल</th>
                    <!-- jan-->
                    <th colspan="3"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">हस्ते</th>
                    <th colspan="3"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">मॅगझीन पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">डिजिटल</th>
                    <!-- feb-->
                    <th colspan="3"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">हस्ते</th>
                    <th colspan="3"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">मॅगझीन पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">डिजिटल</th>
                    <!-- mar-->
                    <th colspan="3"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">हस्ते</th>
                    <th colspan="3"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">मॅगझीन पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">डिजिटल</th>

                    <!-- total-->
                    <th colspan="3"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">हस्ते</th>
                    <th colspan="3"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">मॅगझीन पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-rigth">डिजिटल</th>
                </tr>
                <tr>
                    <th colspan="2" style="border-left: 2px solid black; border-bottom: 2px solid black;"></th>
                    <th class="br-left" style="border-bottom: 2px solid black; border-left: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black; border-left: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black; border-left: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black; border-left: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th class="br-left" style="border-bottom: 2px solid black; border-left: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black; border-left: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black; border-left: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black; border-left: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th class="br-left" style="border-bottom: 2px solid black; border-left: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black; border-left: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black; border-left: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black; border-left: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th class="br-left" style="border-bottom: 2px solid black; border-left: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black; border-left: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black; border-left: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black; border-left: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th class="br-left" style="border-bottom: 2px solid black; border-left: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black; border-left: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black; border-left: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black; border-left: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th class="br-left" style="border-bottom: 2px solid black; border-left: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black; border-left: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black; border-left: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black; border-left: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th class="br-left" style="border-bottom: 2px solid black; border-left: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black; border-left: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black; border-left: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black; border-left: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th class="br-left" style="border-bottom: 2px solid black; border-left: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black; border-left: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black; border-left: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th class="br-left" style="border-bottom: 2px solid black; border-left: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black; border-left: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black; border-left: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black; border-left: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th class="br-left" style="border-bottom: 2px solid black; border-left: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black; border-left: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black; border-left: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black; border-left: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th class="br-left" style="border-bottom: 2px solid black; border-left: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black; border-left: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black; border-left: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black; border-left: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th class="br-left" style="border-bottom: 2px solid black; border-left: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black; border-left: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black; border-left: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black; border-left: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <!-- <th colspan="6"></th> -->
                    <th class="br-left" style="border-bottom: 2px solid black; border-left: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black; border-left: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black; border-left: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black; border-left: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th class="br-right" style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण
                    </th>
                </tr>
            </thead>
            <tbody *ngFor="let data of SubRemTaluka; let i = index">

                <tr>

                    <td colspan="2"
                        style="font-size:14px; text-align: center; border-left: 2px solid black; border-right: 2px solid black;">
                        <b> {{data.country || '--'}} <br> {{data.state || '--'}}</b>
                    </td>
                    <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                    <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                    <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                    <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                    <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                    <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                    <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                    <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                    <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                    <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                    <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                    <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                    <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                    <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                    <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                    <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                    <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                    <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                    <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                    <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                    <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>

                    <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                    <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                    <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                    <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                    <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                    <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                    <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                    <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                    <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                    <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                    <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                    <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                    <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                    <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                    <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                    <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                    <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                    <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                    <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                    <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>

                    <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                    <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                    <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                    <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                    <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                    <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                    <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                    <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                    <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                    <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                    <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                    <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                    <td colspan="3" class="br-right" style="border-right: 2px solid black;"></td>
                </tr>

                <ng-container *ngFor="let data11 of data.districts">
                    <tr>

                        <td colspan="2" style="font-size:14px"
                            style="border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                            <b>{{data11.district || '--'}}</b>
                        </td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>

                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>

                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-right" style="border-right: 2px solid black;"></td>
                    </tr>

                    <ng-container *ngFor="let data1 of data11.talukas">
                        <tr>

                            <td colspan="2" style="border-left: 2px solid black; border-right: 2px solid black;">
                                {{data1.taluka || '--'}}</td>
                            <td style="text-align: right;" class="br-left">{{data1.tapal_New_4}}</td>
                            <td style="text-align: right;">{{data1.tapal_Renew_4}}</td>
                            <td style="text-align: right; border-right: 2px solid black;">{{data1.tapal_Total_4}}</td>

                            <td style="text-align: right;" class="br-left">{{data1.haste_New_4}}</td>
                            <td style="text-align: right;">{{data1.haste_Renew_4}}</td>
                            <td style="text-align: right; border-right: 2px solid black;">{{data1.haste_Total_4}}</td>

                            <td style="text-align: right;" class="br-left">{{data1.magzine_Renew_4}}</td>
                            <td style="text-align: right;">{{data1.magzine_New_4}}</td>
                            <td style="text-align: right; border-right: 2px solid black;">{{data1.magzine_Total_4}}</td>

                            <td style="text-align: right;" class="br-left">{{data1.digital_Renew_4}}</td>
                            <td style="text-align: right;">{{data1.digital_New_4}}</td>
                            <td style="text-align: right; border-right: 2px solid black;">{{data1.digital_Total_4}}</td>

                            <td style="text-align: right;" class="br-left"> {{data1.tapal_New_5}}</td>
                            <td style="text-align: right;">{{data1.tapal_Renew_5}}</td>
                            <td style="text-align: right; border-right: 2px solid black;">{{data1.tapal_Total_5}}</td>

                            <td style="text-align: right;" class="br-left">{{data1.haste_New_5}}</td>
                            <td style="text-align: right;">{{data1.haste_Renew_5}}</td>
                            <td style="text-align: right; border-right: 2px solid black;">{{data1.haste_Total_5}}</td>

                            <td style="text-align: right;" class="br-left">{{data1.magzine_Renew_5}}</td>
                            <td style="text-align: right;">{{data1.magzine_New_5}}</td>
                            <td style="text-align: right; border-right: 2px solid black;">{{data1.magzine_Total_5}}</td>

                            <td style="text-align: right;" class="br-left">{{data1.digital_Renew_5}}</td>
                            <td style="text-align: right;">{{data1.digital_New_5}}</td>
                            <td style="text-align: right; border-right: 2px solid black;">{{data1.digital_Total_5}}</td>

                            <td style="text-align: right;" class="br-left">{{data1.tapal_New_6}}</td>
                            <td style="text-align: right;">{{data1.tapal_Renew_6}}</td>
                            <td style="text-align: right; border-right: 2px solid black;">{{data1.tapal_Total_6}}</td>

                            <td style="text-align: right;" class="br-left">{{data1.haste_New_6}}</td>
                            <td style="text-align: right;">{{data1.haste_Renew_6}}</td>
                            <td style="text-align: right; border-right: 2px solid black;">{{data1.haste_Total_6}}</td>

                            <td style="text-align: right;" class="br-left">{{data1.magzine_Renew_6}}</td>
                            <td style="text-align: right;">{{data1.magzine_New_6}}</td>
                            <td style="text-align: right; border-right: 2px solid black;">{{data1.magzine_Total_6}}</td>

                            <td style="text-align: right;" class="br-left">{{data1.digital_Renew_6}}</td>
                            <td style="text-align: right;">{{data1.digital_New_6}}</td>
                            <td style="text-align: right; border-right: 2px solid black;">{{data1.digital_Total_6}}</td>

                            <td style="text-align: right;" class="br-left">{{data1.tapal_New_7}}</td>
                            <td style="text-align: right;">{{data1.tapal_Renew_7}}</td>
                            <td style="text-align: right; border-right: 2px solid black;">{{data1.tapal_Total_7}}</td>

                            <td style="text-align: right;" class="br-left">{{data1.haste_New_7}}</td>
                            <td style="text-align: right;">{{data1.haste_Renew_7}}</td>
                            <td style="text-align: right; border-right: 2px solid black;">{{data1.haste_Total_7}}</td>

                            <td style="text-align: right;" class="br-left">{{data1.magzine_Renew_7}}</td>
                            <td style="text-align: right;">{{data1.magzine_New_7}}</td>
                            <td style="text-align: right; border-right: 2px solid black;">{{data1.magzine_Total_7}}</td>

                            <td style="text-align: right;" class="br-left">{{data1.digital_Renew_7}}</td>
                            <td style="text-align: right;">{{data1.digital_New_7}}</td>
                            <td style="text-align: right; border-right: 2px solid black;">{{data1.digital_Total_7}}</td>

                            <td style="text-align: right;" class="br-left">{{data1.tapal_New_8}}</td>
                            <td style="text-align: right;">{{data1.tapal_Renew_8}}</td>
                            <td style="text-align: right; border-right: 2px solid black;">{{data1.tapal_Total_8}}</td>

                            <td style="text-align: right;" class="br-left">{{data1.haste_New_8}}</td>
                            <td style="text-align: right;">{{data1.haste_Renew_8}}</td>
                            <td style="text-align: right; border-right: 2px solid black;">{{data1.haste_Total_8}}</td>

                            <td style="text-align: right;" class="br-left">{{data1.magzine_Renew_8}}</td>
                            <td style="text-align: right;">{{data1.magzine_New_8}}</td>
                            <td style="text-align: right; border-right: 2px solid black;">{{data1.magzine_Total_8}}</td>

                            <td style="text-align: right;" class="br-left">{{data1.digital_Renew_8}}</td>
                            <td style="text-align: right;">{{data1.digital_New_8}}</td>
                            <td style="text-align: right; border-right: 2px solid black;">{{data1.digital_Total_8}}</td>

                            <td style="text-align: right;" class="br-left">{{data1.tapal_New_9}}</td>
                            <td style="text-align: right;">{{data1.tapal_Renew_9}}</td>
                            <td style="text-align: right; border-right: 2px solid black;">{{data1.tapal_Total_9}}</td>

                            <td style="text-align: right;" class="br-left">{{data1.haste_New_9}}</td>
                            <td style="text-align: right;">{{data1.haste_Renew_9}}</td>
                            <td style="text-align: right; border-right: 2px solid black;">{{data1.haste_Total_9}}</td>

                            <td style="text-align: right;" class="br-left">{{data1.magzine_Renew_9}}</td>
                            <td style="text-align: right;">{{data1.magzine_New_9}}</td>
                            <td style="text-align: right; border-right: 2px solid black;">{{data1.magzine_Total_9}}</td>

                            <td style="text-align: right;" class="br-left">{{data1.digital_Renew_9}}</td>
                            <td style="text-align: right;">{{data1.digital_New_9}}</td>
                            <td style="text-align: right; border-right: 2px solid black;">{{data1.digital_Total_9}}</td>

                            <td style="text-align: right;" class="br-left">{{data1.tapal_New_10}}</td>
                            <td style="text-align: right;">{{data1.tapal_Renew_10}}</td>
                            <td style="text-align: right; border-right: 2px solid black;">{{data1.tapal_Total_10}}</td>

                            <td style="text-align: right;" class="br-left">{{data1.haste_New_10}}</td>
                            <td style="text-align: right;">{{data1.haste_Renew_10}}</td>
                            <td style="text-align: right; border-right: 2px solid black;">{{data1.haste_Total_10}}</td>

                            <td style="text-align: right;" class="br-left">{{data1.magzine_Renew_10}}</td>
                            <td style="text-align: right;">{{data1.magzine_New_10}}</td>
                            <td style="text-align: right; border-right: 2px solid black;">{{data1.magzine_Total_10}}
                            </td>

                            <td style="text-align: right;" class="br-left">{{data1.digital_Renew_10}}</td>
                            <td style="text-align: right;">{{data1.digital_New_10}}</td>
                            <td style="text-align: right; border-right: 2px solid black;">{{data1.digital_Total_10}}
                            </td>
                            <!-- <td>{{data.rem_april_haste_total}}</td> -->


                            <td style="text-align: right;" class="br-left">{{data1.tapal_New_11}}</td>
                            <td style="text-align: right;">{{data1.tapal_Renew_11}}</td>
                            <td style="text-align: right; border-right: 2px solid black;">{{data1.tapal_Total_11}}</td>

                            <td style="text-align: right;" class="br-left">{{data1.haste_New_11}}</td>
                            <td style="text-align: right;">{{data1.haste_Renew_11}}</td>
                            <td style="text-align: right; border-right: 2px solid black;">{{data1.haste_Total_11}}</td>

                            <td style="text-align: right;" class="br-left">{{data1.magzine_Renew_11}}</td>
                            <td style="text-align: right;">{{data1.magzine_New_11}}</td>
                            <td style="text-align: right; border-right: 2px solid black;">{{data1.magzine_Total_11}}
                            </td>

                            <td style="text-align: right;" class="br-left">{{data1.digital_Renew_11}}</td>
                            <td style="text-align: right;">{{data1.digital_New_11}}</td>
                            <td style="text-align: right; border-right: 2px solid black;">{{data1.digital_Total_11}}
                            </td>

                            <td style="text-align: right;" class="br-left">{{data1.tapal_New_12}}</td>
                            <td style="text-align: right;">{{data1.tapal_Renew_12}}</td>
                            <td style="text-align: right; border-right: 2px solid black;">{{data1.tapal_Total_12}}</td>

                            <td style="text-align: right;" class="br-left">{{data1.haste_New_12}}</td>
                            <td style="text-align: right;">{{data1.haste_Renew_12}}</td>
                            <td style="text-align: right; border-right: 2px solid black;">{{data1.haste_Total_12}}</td>

                            <td style="text-align: right;" class="br-left">{{data1.magzine_Renew_12}}</td>
                            <td style="text-align: right;">{{data1.magzine_New_12}}</td>
                            <td style="text-align: right; border-right: 2px solid black;">{{data1.magzine_Total_12}}
                            </td>

                            <td style="text-align: right;" class="br-left">{{data1.digital_Renew_12}}</td>
                            <td style="text-align: right;">{{data1.digital_New_12}}</td>
                            <td style="text-align: right; border-right: 2px solid black;">{{data1.digital_Total_12}}
                            </td>


                            <td style="text-align: right;" class="br-left">{{data1.tapal_New_1}}</td>
                            <td style="text-align: right;">{{data1.tapal_Renew_1}}</td>
                            <td style="text-align: right; border-right: 2px solid black;">{{data1.tapal_Total_1}}</td>

                            <td style="text-align: right;" class="br-left">{{data1.haste_New_1}}</td>
                            <td style="text-align: right;">{{data1.haste_Renew_1}}</td>
                            <td style="text-align: right; border-right: 2px solid black;">{{data1.haste_Total_1}}</td>

                            <td style="text-align: right;" class="br-left">{{data1.magzine_Renew_1}}</td>
                            <td style="text-align: right;">{{data1.magzine_New_1}}</td>
                            <td style="text-align: right; border-right: 2px solid black;">{{data1.magzine_Total_1}}</td>

                            <td style="text-align: right;" class="br-left">{{data1.digital_Renew_1}}</td>
                            <td style="text-align: right;">{{data1.digital_New_1}}</td>
                            <td style="text-align: right; border-right: 2px solid black;">{{data1.digital_Total_1}}</td>

                            <td style="text-align: right;" class="br-left">{{data1.tapal_New_2}}</td>
                            <td style="text-align: right;">{{data1.tapal_Renew_2}}</td>
                            <td style="text-align: right; border-right: 2px solid black;">{{data1.tapal_Total_2}}</td>

                            <td style="text-align: right;" class="br-left">{{data1.haste_New_2}}</td>
                            <td style="text-align: right;">{{data1.haste_Renew_2}}</td>
                            <td style="text-align: right; border-right: 2px solid black;">{{data1.haste_Total_2}}</td>

                            <td style="text-align: right;" class="br-left">{{data1.magzine_Renew_2}}</td>
                            <td style="text-align: right;">{{data1.magzine_New_2}}</td>
                            <td style="text-align: right; border-right: 2px solid black;">{{data1.magzine_Total_2}}</td>

                            <td style="text-align: right;" class="br-left">{{data1.digital_Renew_2}}</td>
                            <td style="text-align: right;">{{data1.digital_New_2}}</td>
                            <td style="text-align: right; border-right: 2px solid black;">{{data1.digital_Total_2}}</td>


                            <td style="text-align: right;" class="br-left">{{data1.tapal_New_3}}</td>
                            <td style="text-align: right;">{{data1.tapal_Renew_3}}</td>
                            <td style="text-align: right; border-right: 2px solid black;">{{data1.tapal_Total_3}}</td>

                            <td style="text-align: right;" class="br-left">{{data1.haste_New_3}}</td>
                            <td style="text-align: right;">{{data1.haste_Renew_3}}</td>
                            <td style="text-align: right; border-right: 2px solid black;">{{data1.haste_Total_3}}</td>

                            <td style="text-align: right;" class="br-left">{{data1.magzine_Renew_3}}</td>
                            <td style="text-align: right;">{{data1.magzine_New_3}}</td>
                            <td style="text-align: right; border-right: 2px solid black;">{{data1.magzine_Total_3}}</td>

                            <td style="text-align: right;" class="br-left">{{data1.digital_Renew_3}}</td>
                            <td style="text-align: right;">{{data1.digital_New_3}}</td>
                            <td style="text-align: right; border-right: 2px solid black;">{{data1.digital_Total_3}}</td>


                            <td style="text-align: right;" class="br-left">{{data1.tapal_New_Total}}</td>
                            <td style="text-align: right;">{{data1.tapal_Renew_Total}}</td>
                            <td style="text-align: right; border-right: 2px solid black;">{{data1.tapal_Total_Total}}
                            </td>

                            <td style="text-align: right;" class="br-left">{{data1.haste_New_Total}}</td>
                            <td style="text-align: right;">{{data1.haste_Renew_Total}}</td>
                            <td style="text-align: right; border-right: 2px solid black;">{{data1.haste_Total_Total}}
                            </td>

                            <td style="text-align: right;" class="br-left">{{data1.magzine_New_Total}}</td>
                            <td style="text-align: right;">{{data1.magzine_Renew_Total}}</td>
                            <td style="text-align: right; border-right: 2px solid black;">{{data1.magzine_Total_Total}}
                            </td>

                            <td style="text-align: right;" class="br-left">{{data1.digital_New_Total}}</td>
                            <td style="text-align: right;">{{data1.digital_Renew_Total}}</td>
                            <td style="text-align: right; border-right: 2px solid black;" class="br-right">
                                {{data1.digital_Total_Total}}</td>


                        </tr>
                    </ng-container>
                    <tr>
                        <td colspan="2"
                            style="text-align: right; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                            <b>एकूण:</b>
                        </td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                            {{data11.tapal_New_4}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data11.tapal_Renew_4}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data11.tapal_Total_4}}</td>

                        <td class="final-data br-left"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                            {{data11.haste_New_4}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data11.haste_Renew_4}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data11.haste_Total_4}}</td>

                        <td class="final-data br-left"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                            {{data11.magzine_New_4}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data11.magzine_Renew_4}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data11.magzine_Total_4}}</td>

                        <td class="final-data br-left"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                            {{data11.digital_New_4}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data11.digital_Renew_4}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data11.digital_Total_4}}</td>

                        <td class="final-data br-left"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                            {{data11.tapal_New_5}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data11.tapal_Renew_5}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data11.tapal_Total_5}}</td>

                        <td class="final-data br-left"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                            {{data11.haste_New_5}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data11.haste_Renew_5}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data11.haste_Total_5}}</td>

                        <td class="final-data br-left"
                            style="text-align: right; font-weight: bold;border-top: 2px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                            {{data11.magzine_New_5}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data11.magzine_Renew_5}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data11.magzine_Total_5}}</td>

                        <td class="final-data br-left"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                            {{data11.digital_New_5}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data11.digital_Renew_5}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data11.digital_Total_5}}</td>

                        <td class="final-data br-left"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                            {{data11.tapal_New_6}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data11.tapal_Renew_6}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data11.tapal_Total_6}}</td>

                        <td class="final-data br-left"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                            {{data11.haste_New_6}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data11.haste_Renew_6}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data11.haste_Total_6}}</td>

                        <td class="final-data br-left"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                            {{data11.magzine_New_6}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data11.magzine_Renew_6}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data11.magzine_Total_6}}</td>

                        <td class="final-data br-left"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                            {{data11.digital_New_6}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data11.digital_Renew_6}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data11.digital_Total_6}}</td>

                        <td class="final-data br-left"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                            {{data11.tapal_New_7}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data11.tapal_Renew_7}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data11.tapal_Total_7}}</td>

                        <td class="final-data br-left"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                            {{data11.haste_New_7}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data11.haste_Renew_7}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data11.haste_Total_7}}</td>

                        <td class="final-data br-left"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                            {{data11.magzine_New_7}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data11.magzine_Renew_7}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data11.magzine_Total_7}}</td>

                        <td class="final-data br-left"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                            {{data11.digital_New_7}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data11.digital_Renew_7}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data11.digital_Total_7}}</td>

                        <td class="final-data br-left"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                            {{data11.tapal_New_8}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data11.tapal_Renew_8}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data11.tapal_Total_8}}</td>

                        <td class="final-data br-left"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                            {{data11.haste_New_8}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data11.haste_Renew_8}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data11.haste_Total_8}}</td>

                        <td class="final-data br-left"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                            {{data11.magzine_New_8}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data11.magzine_Renew_8}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data11.magzine_Total_8}}</td>

                        <td class="final-data br-left"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                            {{data11.digital_New_8}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data11.digital_Renew_8}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data11.digital_Total_8}}</td>

                        <td class="final-data br-left"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                            {{data11.tapal_New_9}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data11.tapal_Renew_9}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data11.tapal_Total_9}}</td>

                        <td class="final-data br-left"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                            {{data11.haste_New_9}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data11.haste_Renew_9}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data11.haste_Total_9}}</td>

                        <td class="final-data br-left"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                            {{data11.magzine_New_9}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data11.magzine_Renew_9}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data11.magzine_Total_9}}</td>

                        <td class="final-data br-left"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                            {{data11.digital_New_9}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data11.digital_Renew_9}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data11.digital_Total_9}}</td>

                        <td class="final-data br-left"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                            {{data11.tapal_New_10}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data11.tapal_Renew_10}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data11.tapal_Total_10}}</td>

                        <td class="final-data br-left"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                            {{data11.haste_New_10}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data11.haste_Renew_10}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data11.haste_Total_10}}</td>

                        <td class="final-data br-left"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                            {{data11.magzine_New_10}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data11.magzine_Renew_10}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data11.magzine_Total_10}}</td>

                        <td class="final-data br-left"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                            {{data11.digital_New_10}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data11.digital_Renew_10}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data11.digital_Total_10}}</td>

                        <td class="final-data br-left"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                            {{data11.tapal_New_11}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data11.tapal_Renew_11}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data11.tapal_Total_11}}</td>

                        <td class="final-data br-left"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                            {{data11.haste_New_11}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data11.haste_Renew_11}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data11.haste_Total_11}}</td>

                        <td class="final-data br-left"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                            {{data11.magzine_Renew_11}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data11.magzine_Renew_11}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data11.magzine_Total_11}}</td>

                        <td class="final-data br-left"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                            {{data11.digital_New_11}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data11.digital_Renew_11}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data11.digital_Total_11}}</td>

                        <td class="final-data br-left"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                            {{data11.tapal_New_12}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data11.tapal_Renew_12}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data11.tapal_Total_12}}</td>

                        <td class="final-data br-left"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                            {{data11.haste_New_12}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data11.haste_Renew_12}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data11.haste_Total_12}}</td>

                        <td class="final-data br-left"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                            {{data11.magzine_New_12}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data11.magzine_Renew_12}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data11.magzine_Total_12}}</td>

                        <td class="final-data br-left"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                            {{data11.digital_New_12}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data11.digital_Renew_12}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data11.digital_Total_12}}</td>

                        <td class="final-data br-left"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                            {{data11.tapal_New_1}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data11.tapal_Renew_1}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data11.tapal_Total_1}}</td>

                        <td class="final-data br-left"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                            {{data11.haste_New_1}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data11.haste_Renew_1}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data11.haste_Total_1}}</td>

                        <td class="final-data br-left"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                            {{data11.magzine_New_1}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data11.magzine_Renew_1}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data11.magzine_Total_1}}</td>

                        <td class="final-data br-left"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                            {{data11.digital_New_1}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data11.digital_Renew_1}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data11.digital_Total_1}}</td>

                        <td class="final-data br-left"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                            {{data11.tapal_New_2}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data11.tapal_Renew_2}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data11.tapal_Total_2}}</td>

                        <td class="final-data br-left"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                            {{data11.haste_New_2}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data11.haste_Renew_2}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data11.haste_Total_2}}</td>

                        <td class="final-data br-left"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                            {{data11.magzine_New_2}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data11.magzine_Renew_2}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data11.magzine_Total_2}}</td>

                        <td class="final-data br-left"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                            {{data11.digital_New_2}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data11.digital_Renew_2}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data11.digital_Total_2}}</td>

                        <td class="final-data br-left"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                            {{data11.tapal_New_3}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data11.tapal_Renew_3}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data11.tapal_Total_3}}</td>

                        <td class="final-data br-left"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                            {{data11.haste_New_3}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data11.haste_Renew_3}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data11.haste_Total_3}}</td>

                        <td class="final-data br-left"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                            {{data11.magzine_New_3}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data11.magzine_Renew_3}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data11.magzine_Total_3}}</td>

                        <td class="final-data br-left"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                            {{data11.digital_New_3}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data11.digital_Renew_3}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data11.digital_Total_3}}</td>

                        <td class="final-data br-left"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                            {{data11.tapal_New_total}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data11.tapal_Renew_total}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data11.tapal_Total_total}}</td>

                        <td class="final-data br-left"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                            {{data11.haste_New_total}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data11.haste_Renew_total}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data11.haste_Total_total}}</td>

                        <td class="final-data br-left"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                            {{data11.magzine_New_total}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data11.magzine_Renew_total}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data11.magzine_Total_total}}</td>

                        <td class="final-data br-left"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-left: 2px solid black;">
                            {{data11.digital_New_total}}</td>
                        <td class="final-data"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data11.digital_Renew_total}}</td>
                        <td class="final-data br-right"
                            style="text-align: right; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data11.digital_Total_total}}</td>


                    </tr>
                </ng-container>

            </tbody>

            <tfoot>
            </tfoot>

            <tr>
                <td colspan="2"
                    style="text-align: center; color: black; font-size: 14px; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    <b>एकूण:</b>
                </td>

                <td class="final-data br-left"
                    style="font-weight: bold; border-right: 1px solid black; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{tapal_New_4}}</td>
                <td class="final-data"
                    style="font-weight: bold; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{tapal_Renew_4}}</td>
                <td class="final-data"
                    style="font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{tapal_Total_4}}</td>

                <td class="final-data br-left"
                    style="font-weight: bold; border-right: 1px solid black; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{haste_New_4}}</td>
                <td class="final-data"
                    style="font-weight: bold; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{haste_Renew_4}}</td>
                <td class="final-data"
                    style="font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{haste_Total_4}}</td>

                <td class="final-data br-left"
                    style="border-right: 1px solid black; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{magzine_New_4}}</td>
                <td class="final-data"
                    style="border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{magzine_Renew_4}}</td>
                <td class="final-data" style="border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{magzine_Total_4}}</td>

                <td class="final-data br-left"
                    style="border-right: 1px solid black; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{digital_New_4}}</td>
                <td class="final-data"
                    style="border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{digital_Renew_4}}</td>
                <td class="final-data" style="border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{digital_Total_4}}</td>

                <td class="final-data br-left"
                    style="border-right: 1px solid black; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{tapal_New_5}}</td>
                <td class="final-data"
                    style="border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{tapal_Renew_5}}</td>
                <td class="final-data" style="border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{tapal_Total_5}}</td>

                <td class="final-data br-left"
                    style="border-right: 1px solid black; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{haste_New_5}}</td>
                <td class="final-data"
                    style="border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{haste_Renew_5}}</td>
                <td class="final-data" style="border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{haste_Total_5}}</td>

                <td class="final-data br-left"
                    style="border-right: 1px solid black; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{magzine_New_5}}</td>
                <td class="final-data"
                    style="border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{magzine_Renew_5}}</td>
                <td class="final-data" style="border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{magzine_Total_5}}</td>

                <td class="final-data br-left"
                    style="border-right: 1px solid black; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{digital_New_5}}</td>
                <td class="final-data"
                    style="border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{digital_Renew_5}}</td>
                <td class="final-data" style="border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{digital_Total_5}}</td>

                <td class="final-data br-left"
                    style="border-right: 1px solid black; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{data.tapal_New_6}}</td>
                <td class="final-data"
                    style="border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{tapal_Renew_6}}</td>
                <td class="final-data" style="border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{tapal_Total_6}}</td>

                <td class="final-data br-left"
                    style="border-right: 1px solid black; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{haste_New_6}}</td>
                <td class="final-data"
                    style="border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{haste_Renew_6}}</td>
                <td class="final-data" style="border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{haste_Total_6}}</td>

                <td class="final-data br-left"
                    style="border-right: 1px solid black; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{magzine_New_6}}</td>
                <td class="final-data"
                    style="border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{magzine_Renew_6}}</td>
                <td class="final-data" style="border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{magzine_Total_6}}</td>

                <td class="final-data br-left"
                    style="border-right: 1px solid black; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{digital_New_6}}</td>
                <td class="final-data"
                    style="border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{digital_Renew_6}}</td>
                <td class="final-data" style="border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{digital_Total_6}}</td>

                <td class="final-data br-left"
                    style="border-right: 1px solid black; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{tapal_New_7}}</td>
                <td class="final-data"
                    style="border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{tapal_Renew_7}}</td>
                <td class="final-data" style="border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{tapal_Total_7}}</td>

                <td class="final-data br-left"
                    style="border-right: 1px solid black; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{haste_New_7}}</td>
                <td class="final-data"
                    style="border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{haste_Renew_7}}</td>
                <td class="final-data" style="border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{haste_Total_7}}</td>

                <td class="final-data br-left"
                    style="border-right: 1px solid black; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{magzine_New_7}}</td>
                <td class="final-data"
                    style="border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{magzine_Renew_7}}</td>
                <td class="final-data" style="border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{magzine_Total_7}}</td>

                <td class="final-data br-left"
                    style="border-right: 1px solid black; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{digital_New_7}}</td>
                <td class="final-data"
                    style="border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{digital_Renew_7}}</td>
                <td class="final-data" style="border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{digital_Total_7}}</td>

                <td class="final-data br-left"
                    style="border-right: 1px solid black; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{tapal_New_8}}</td>
                <td class="final-data"
                    style="border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{tapal_Renew_8}}</td>
                <td class="final-data" style="border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{tapal_Total_8}}</td>

                <td class="final-data br-left"
                    style="border-right: 1px solid black; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{haste_New_8}}</td>
                <td class="final-data"
                    style="border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{haste_Renew_8}}</td>
                <td class="final-data" style="border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{haste_Total_8}}</td>

                <td class="final-data br-left"
                    style="border-right: 1px solid black; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{magzine_New_8}}</td>
                <td class="final-data"
                    style="border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{magzine_Renew_8}}</td>
                <td class="final-data" style="border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{magzine_Total_8}}</td>

                <td class="final-data br-left"
                    style="border-right: 1px solid black; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{digital_New_8}}</td>
                <td class="final-data"
                    style="border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{digital_Renew_8}}</td>
                <td class="final-data" style="border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{digital_Total_8}}</td>

                <td class="final-data br-left"
                    style="border-right: 1px solid black; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{tapal_New_9}}</td>
                <td class="final-data"
                    style="border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{tapal_Renew_9}}</td>
                <td class="final-data" style="border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{tapal_Total_9}}</td>

                <td class="final-data br-left"
                    style="border-right: 1px solid black; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{haste_New_9}}</td>
                <td class="final-data"
                    style="border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{haste_Renew_9}}</td>
                <td class="final-data" style="border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{haste_Total_9}}</td>

                <td class="final-data br-left"
                    style="border-right: 1px solid black; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{magzine_New_9}}</td>
                <td class="final-data"
                    style="border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{magzine_Renew_9}}</td>
                <td class="final-data" style="border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{magzine_Total_9}}</td>

                <td class="final-data br-left"
                    style="border-right: 1px solid black; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{digital_New_9}}</td>
                <td class="final-data"
                    style="border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{digital_Renew_9}}</td>
                <td class="final-data" style="border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{digital_Total_9}}</td>

                <td class="final-data br-left"
                    style="border-right: 1px solid black; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{tapal_New_10}}</td>
                <td class="final-data"
                    style="border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{tapal_Renew_10}}</td>
                <td class="final-data" style="border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{tapal_Total_10}}</td>

                <td class="final-data br-left"
                    style="border-right: 1px solid black; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{haste_New_10}}</td>
                <td class="final-data"
                    style="border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{haste_Renew_10}}</td>
                <td class="final-data" style="border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{haste_Total_10}}</td>

                <td class="final-data br-left"
                    style="border-right: 1px solid black; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{magzine_New_10}}</td>
                <td class="final-data"
                    style="border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{magzine_Renew_10}}</td>
                <td class="final-data" style="border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{magzine_Total_10}}</td>

                <td class="final-data br-left"
                    style="border-right: 1px solid black; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{digital_New_10}}</td>
                <td class="final-data"
                    style="border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{digital_Renew_10}}</td>
                <td class="final-data" style="border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{digital_Total_10}}</td>



                <td class="final-data br-left"
                    style="border-right: 1px solid black; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{tapal_New_11}}</td>
                <td class="final-data"
                    style="border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{tapal_Renew_11}}</td>
                <td class="final-data" style="border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{tapal_Total_11}}</td>

                <td class="final-data br-left"
                    style="border-right: 1px solid black; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{haste_New_11}}</td>
                <td class="final-data"
                    style="border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{haste_Renew_11}}</td>
                <td class="final-data" style="border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{haste_Total_11}}</td>

                <td class="final-data br-left"
                    style="border-right: 1px solid black; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{magzine_New_11}}</td>
                <td class="final-data"
                    style="border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{magzine_Renew_11}}</td>
                <td class="final-data" style="border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{magzine_Total_11}}</td>

                <td class="final-data br-left"
                    style="border-right: 1px solid black; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{digital_New_11}}</td>
                <td class="final-data"
                    style="border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{digital_Renew_11}}</td>
                <td class="final-data" style="border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{digital_Total_11}}</td>

                <td class="final-data br-left"
                    style="border-right: 1px solid black; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{tapal_New_12}}</td>
                <td class="final-data"
                    style="border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{tapal_Renew_12}}</td>
                <td class="final-data" style="border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{tapal_Total_12}}</td>

                <td class="final-data br-left"
                    style="border-right: 1px solid black; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{haste_New_12}}</td>
                <td class="final-data"
                    style="border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{haste_Renew_12}}</td>
                <td class="final-data" style="border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{haste_Total_12}}</td>

                <td class="final-data br-left"
                    style="border-right: 1px solid black; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{magzine_New_12}}</td>
                <td class="final-data"
                    style="border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{magzine_Renew_12}}</td>
                <td class="final-data" style="border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{magzine_Total_12}}</td>

                <td class="final-data br-left"
                    style="border-right: 1px solid black; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{digital_New_12}}</td>
                <td class="final-data"
                    style="border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{digital_Renew_12}}</td>
                <td class="final-data" style="border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{digital_Total_12}}</td>

                <td class="final-data br-left"
                    style="border-right: 1px solid black; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{tapal_New_1}}</td>
                <td class="final-data"
                    style="border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{tapal_Renew_1}}</td>
                <td class="final-data" style="border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{tapal_Total_1}}</td>

                <td class="final-data br-left"
                    style="border-right: 1px solid black; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{haste_New_1}}</td>
                <td class="final-data"
                    style="border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{haste_Renew_1}}</td>
                <td class="final-data" style="border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{haste_Total_1}}</td>

                <td class="final-data br-left"
                    style="border-right: 1px solid black; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{magzine_New_1}}</td>
                <td class="final-data"
                    style="border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{magzine_Renew_1}}</td>
                <td class="final-data" style="border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{magzine_Total_1}}</td>

                <td class="final-data br-left"
                    style="border-right: 1px solid black; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{digital_New_1}}</td>
                <td class="final-data"
                    style="border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{digital_Renew_1}}</td>
                <td class="final-data" style="border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{digital_Total_1}}</td>

                <td class="final-data br-left"
                    style="border-right: 1px solid black; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{tapal_New_2}}</td>
                <td class="final-data"
                    style="border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{tapal_Renew_2}}</td>
                <td class="final-data" style="border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{tapal_Total_2}}</td>

                <td class="final-data br-left"
                    style="border-right: 1px solid black; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{haste_New_2}}</td>
                <td class="final-data"
                    style="border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{haste_Renew_2}}</td>
                <td class="final-data"
                    style="border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{haste_Total_2}}</td>

                <td class="final-data br-left"
                    style="border-right: 1px solid black; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{magzine_New_2}}</td>
                <td class="final-data"
                    style="border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{magzine_Renew_2}}</td>
                <td class="final-data" style="border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{magzine_Total_2}}</td>

                <td class="final-data br-left"
                    style="border-right: 1px solid black; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{digital_New_2}}</td>
                <td class="final-data"
                    style="border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{digital_Renew_2}}</td>
                <td class="final-data" style="border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{digital_Total_2}}</td>

                <td class="final-data br-left"
                    style="border-right: 1px solid black; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{tapal_New_3}}</td>
                <td class="final-data"
                    style="border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{tapal_Renew_3}}</td>
                <td class="final-data" style="border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{tapal_Total_3}}</td>

                <td class="final-data br-left"
                    style="border-right: 1px solid black; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{haste_New_3}}</td>
                <td class="final-data"
                    style="border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{haste_Renew_3}}</td>
                <td class="final-data" style="border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{haste_Total_3}}</td>

                <td class="final-data br-left"
                    style="border-right: 1px solid black; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{magzine_New_3}}</td>
                <td class="final-data"
                    style="border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{magzine_Renew_3}}</td>
                <td class="final-data" style="border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{magzine_Total_3}}</td>

                <td class="final-data br-left"
                    style="border-right: 1px solid black; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{digital_New_3}}</td>
                <td class="final-data"
                    style="border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{digital_Renew_3}}</td>
                <td class="final-data" style="border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{digital_Total_3}}</td>

                <td class="final-data br-left"
                    style="border-right: 1px solid black; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{tapal_New_total}}</td>
                <td class="final-data"
                    style="border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{tapal_Renew_total}}</td>
                <td class="final-data" style="border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{tapal_Total_total}}</td>

                <td class="final-data br-left"
                    style="border-right: 1px solid black; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{haste_New_total}}</td>
                <td class="final-data"
                    style="border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{haste_Renew_total}}</td>
                <td class="final-data" style="border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{haste_Total_total}}</td>

                <td class="final-data br-left"
                    style="border-right: 1px solid black; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{magzine_New_total}}</td>
                <td class="final-data"
                    style="border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{magzine_Renew_total}}</td>
                <td class="final-data" style="border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{magzine_Total_total}}</td>

                <td class="final-data br-left"
                    style="border-right: 1px solid black; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{digital_New_total}}</td>
                <td class="final-data"
                    style="border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    {{digital_Renew_total}}</td>
                <td class="final-data br-right"
                    style="border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                    {{digital_Total_total}}</td>

            </tr>



        </table>




    </div>
    <div style="margin-left: 80%; margin-bottom: 2%;">
        <!-- <button class="noPrint" style="margin-top: 2%;" mat-raised-button color="primary"
            [printStyle]="{table : {'border-collapse':'collapse'}, td : {'border': 'solid 1px'}, th : {'border': 'solid 1px'}}"
            printSectionId="print-section2" ngxPrint>
            print
        </button> -->
        <button class="noPrint" style="margin-top: 2%; margin-left: 2%;"
            (click)="exportExcel('Remaining_Subscription_Taluka')" mat-raised-button color="primary">
            Export
        </button>

        <!-- <button class="noPrint" style="margin-top: 2%; margin-left: 2%;" mat-raised-button color="primary"
           [useExistingCss]="true"
            printSectionId="print-section" ngxPrint>
            print
        </button> -->

        <button class="noPrint" style="margin-right: 2%; margin-left: 2%" mat-raised-button color="primary"
            (click)="printPage()">
            Print
        </button>

        <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>
            Close
        </button>
    </div>
</div>

<!-- Remaining Subscription Taluka Briefly  -->
<div class="table-container" *ngIf="reportType == 'RemainingSubscriptionTalukaBriefly'">
    <div id="print-section1" class="container">

        <table class="fixed-header">
            <thead>
                <tr>
                    <th colspan="41"
                        style="text-align: center !important; font-size: 13px; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black;">
                        हिंदुस्तान प्रकाशन संस्था - विवेक साप्ताहिक - वर्गणी विभाग रिपोर्ट वर्गणीदार नूतनीकरण व्यवसाय
                        जमा </th>
                    <th colspan="6"
                        style="text-align: center !important; border-top: 2px solid black; border-right: 2px solid black;">
                        दिनांक : {{ currentDate | date: 'dd-MM-yyyy' }}</th>
                </tr>
                <tr>
                    <th colspan="35"
                        style="text-align: center !important; font-size: 11px; padding-left: 14%; border-left: 2px solid black;">
                        संक्षिप्त बाकी तपशील</th>
                    <!-- <th colspan="12" style="text-align: center !important;font-size: 20 !important;font-weight: 600;"> दिनांक : {{ currentDate | date: 'dd-MM-yyyy' }}</th> -->
                    <th colspan="6"
                        style="text-align: center !important; border-left: 2px solid black; border-right: 2px solid black;">
                        दिनांक पासून:{{startDate | date: 'dd-MM-yyyy'}} </th>
                    <th colspan="6" style="text-align: center !important; border-right: 2px solid black;">पर्यंत:
                        {{endDate | date: 'dd-MM-yyyy'}}</th>
                </tr>
                <!-- <tr>
                    <th colspan="20" style="text-align: center !important;"> वर्गणीदार नूतनीकरण व्यवसाय तपशिल </th>
                    <th colspan="15" style="text-align: center !important;">जमा बाकी तपशील</th>
                    <th colspan="6" style="text-align: center !important;">दिनांक पासून:{{startDate | date: 'dd-MM-yyyy'}} </th>
                    <th colspan="6" style="text-align: center !important;">पर्यंत: {{endDate | date: 'dd-MM-yyyy'}}</th>
              
                </tr> -->
                <tr>
                    <th colspan="8" style="border-left: 2px solid black;"> </th>

                    <th colspan="3" style="text-align: center; font-weight: 600; border-left: 2px solid black;">एप्रिल
                    </th>
                    <th colspan="3" style="text-align: center; border-left: 2px solid black;">मे</th>
                    <th colspan="3" style="text-align: center;border-left: 2px solid black;">जून</th>
                    <th colspan="3" style="text-align: center;border-left: 2px solid black;">जुलै</th>
                    <th colspan="3" style="text-align: center;border-left: 2px solid black;">ऑगस्ट</th>
                    <th colspan="3" style="text-align: center;border-left: 2px solid black;">सप्टेंबर</th>
                    <th colspan="3" style="text-align: center;border-left: 2px solid black;">ऑक्टोबर</th>
                    <th colspan="3" style="text-align: center;border-left: 2px solid black;">नोव्हेंबर</th>
                    <th colspan="3" style="text-align: center;border-left: 2px solid black;">डिसेंबर</th>
                    <th colspan="3" style="text-align: center;border-left: 2px solid black;">जानेवारी</th>
                    <th colspan="3" style="text-align: center;border-left: 2px solid black;">फेब्रुवारी</th>
                    <th colspan="3" style="text-align: center;border-left: 2px solid black;">मार्च</th>
                    <th colspan="3"
                        style="text-align: center;border-left: 2px solid black;border-right: 2px solid black;">एकूण</th>
                </tr>
                <tr>
                    <th colspan="4" style=" border-left: 2px solid black; border-top: 2px solid black;"><b>जिल्हा</b>
                    </th>
                    <th colspan="4" style=" border-left: 2px solid black; border-top: 2px solid black;"><b>तालुका</b>
                    </th>

                    <th style="border-left: 2px solid black;">जमा</th>
                    <th>बाकी</th>
                    <th>एकूण</th>

                    <th style="border-left: 2px solid black;">जमा</th>
                    <th>बाकी</th>
                    <th>एकूण</th>

                    <th style="border-left: 2px solid black;">जमा</th>
                    <th>बाकी</th>
                    <th>एकूण</th>

                    <th style="border-left: 2px solid black;">जमा</th>
                    <th>बाकी</th>
                    <th>एकूण</th>

                    <th style="border-left: 2px solid black;">जमा</th>
                    <th>बाकी</th>
                    <th>एकूण</th>

                    <th style="border-left: 2px solid black;">जमा</th>
                    <th>बाकी</th>
                    <th>एकूण</th>

                    <th style="border-left: 2px solid black;">जमा</th>
                    <th>बाकी</th>
                    <th>एकूण</th>

                    <th style="border-left: 2px solid black;">जमा</th>
                    <th>बाकी</th>
                    <th>एकूण</th>

                    <th style="border-left: 2px solid black;">जमा</th>
                    <th>बाकी</th>
                    <th>एकूण</th>

                    <th style="border-left: 2px solid black;">जमा</th>
                    <th>बाकी</th>
                    <th>एकूण</th>

                    <th style="border-left: 2px solid black;">जमा</th>
                    <th>बाकी</th>
                    <th>एकूण</th>

                    <th style="border-left: 2px solid black;">जमा</th>
                    <th>बाकी</th>
                    <th>एकूण</th>


                    <th style="border-left: 2px solid black;">जमा</th>
                    <th>बाकी</th>
                    <th style="border-right: 2px solid black;">एकूण</th>
                </tr>
            </thead>
            <!-- *ngFor="let data of OutstandingInDetailFormBeans; let i = index" -->
            <tbody *ngFor="let data of SubRemRenewTalBriefly">
                <!-- Rep name header row -->
                <tr>
                    <td colspan="8"
                        style="text-align: center; font-weight: bold; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{data.rep_name}}
                    </td>
                    <td colspan="3" style="border-left: 2px solid black;"></td>
                    <td colspan="3" style="border-left: 2px solid black;"></td>
                    <td colspan="3" style="border-left: 2px solid black;"></td>
                    <td colspan="3" style="border-left: 2px solid black;"></td>
                    <td colspan="3" style="border-left: 2px solid black;"></td>
                    <td colspan="3" style="border-left: 2px solid black;"></td>
                    <td colspan="3" style="border-left: 2px solid black;"></td>
                    <td colspan="3" style="border-left: 2px solid black;"></td>
                    <td colspan="3" style="border-left: 2px solid black;"></td>
                    <td colspan="3" style="border-left: 2px solid black;"></td>
                    <td colspan="3" style="border-left: 2px solid black;"></td>
                    <td colspan="3" style="border-left: 2px solid black;"></td>
                    <td colspan="3" style="border-left: 2px solid black; border-right: 2px solid black;"></td>
                </tr>

                <!-- Iterate districts inside each rep -->
                <ng-container *ngFor="let distData of data.districts">
                    <!-- Taluka rows -->
                    <ng-container *ngFor="let data1 of distData.talukas">
                        <tr>
                            <td colspan="4" style="word-wrap: break-word; border-left: 2px solid black;">
                                {{distData.district}}</td>
                            <td colspan="4" style="word-wrap: break-word; border-left: 2px solid black;">
                                {{data1.taluka}}</td>

                            <td style="text-align: right; border-left: 2px solid black;">{{data1.New_4}}</td>
                            <td style="text-align: right;">{{data1.Renew_4}}</td>
                            <td style="text-align: right;">{{data1.Total_4}}</td>

                            <td style="text-align: right; border-left: 2px solid black;">{{data1.New_5}}</td>
                            <td style="text-align: right;">{{data1.Renew_5}}</td>
                            <td style="text-align: right;">{{data1.Total_5}}</td>

                            <td style="text-align: right; border-left: 2px solid black;">{{data1.New_6}}</td>
                            <td style="text-align: right;">{{data1.Renew_6}}</td>
                            <td style="text-align: right;">{{data1.Total_6}}</td>

                            <td style="text-align: right; border-left: 2px solid black;">{{data1.New_7}}</td>
                            <td style="text-align: right;">{{data1.Renew_7}}</td>
                            <td style="text-align: right;">{{data1.Total_7}}</td>

                            <td style="text-align: right; border-left: 2px solid black;">{{data1.New_8}}</td>
                            <td style="text-align: right;">{{data1.Renew_8}}</td>
                            <td style="text-align: right;">{{data1.Total_8}}</td>

                            <td style="text-align: right; border-left: 2px solid black;">{{data1.New_9}}</td>
                            <td style="text-align: right;">{{data1.Renew_9}}</td>
                            <td style="text-align: right;">{{data1.Total_9}}</td>

                            <td style="text-align: right; border-left: 2px solid black;">{{data1.New_10}}</td>
                            <td style="text-align: right;">{{data1.Renew_10}}</td>
                            <td style="text-align: right;">{{data1.Total_10}}</td>

                            <td style="text-align: right; border-left: 2px solid black;">{{data1.New_11}}</td>
                            <td style="text-align: right;">{{data1.Renew_11}}</td>
                            <td style="text-align: right;">{{data1.Total_11}}</td>

                            <td style="text-align: right; border-left: 2px solid black;">{{data1.New_12}}</td>
                            <td style="text-align: right;">{{data1.Renew_12}}</td>
                            <td style="text-align: right;">{{data1.Total_12}}</td>

                            <td style="text-align: right; border-left: 2px solid black;">{{data1.New_1}}</td>
                            <td style="text-align: right;">{{data1.Renew_1}}</td>
                            <td style="text-align: right;">{{data1.Total_1}}</td>

                            <td style="text-align: right; border-left: 2px solid black;">{{data1.New_2}}</td>
                            <td style="text-align: right;">{{data1.Renew_2}}</td>
                            <td style="text-align: right;">{{data1.Total_2}}</td>

                            <td style="text-align: right; border-left: 2px solid black;">{{data1.New_3}}</td>
                            <td style="text-align: right;">{{data1.Renew_3}}</td>
                            <td style="text-align: right;">{{data1.Total_3}}</td>

                            <td style="text-align: right; border-left: 2px solid black;">{{data1.New_Total}}</td>
                            <td style="text-align: right;">{{data1.Renew_Total}}</td>
                            <td style="text-align: right; border-right: 2px solid black;">{{data1.Total_Total}}</td>
                        </tr>
                    </ng-container>
                </ng-container>

                <!-- Rep-level subtotal row -->
                <tr>
                    <td colspan="8"
                        style="text-align: right; font-weight: 600; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        एकूण :-</td>

                    <td
                        style="text-align: right; font-weight: 600; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.New_4}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.Renew_4}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.Total_4}}</td>

                    <td
                        style="text-align: right; font-weight: 600; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.New_5}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.Renew_5}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.Total_5}}</td>

                    <td
                        style="text-align: right; font-weight: 600; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.New_6}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.Renew_6}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.Total_6}}</td>

                    <td
                        style="text-align: right; font-weight: 600; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.New_7}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.Renew_7}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.Total_7}}</td>

                    <td
                        style="text-align: right; font-weight: 600; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.New_8}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.Renew_8}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.Total_8}}</td>

                    <td
                        style="text-align: right; font-weight: 600; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.New_9}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.Renew_9}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.Total_9}}</td>

                    <td
                        style="text-align: right; font-weight: 600; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.New_10}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.Renew_10}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.Total_10}}</td>

                    <td
                        style="text-align: right; font-weight: 600; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.New_11}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.Renew_11}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.Total_11}}</td>

                    <td
                        style="text-align: right; font-weight: 600; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.New_12}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.Renew_12}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.Total_12}}</td>

                    <td
                        style="text-align: right; font-weight: 600; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.New_1}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.Renew_1}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.Total_1}}</td>

                    <td
                        style="text-align: right; font-weight: 600; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.New_2}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.Renew_2}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.Total_2}}</td>

                    <td
                        style="text-align: right; font-weight: 600; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.New_3}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.Renew_3}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.Total_3}}</td>

                    <td
                        style="text-align: right; font-weight: 600; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.New_Total}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.Renew_Total}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.Total_Total}}</td>
                </tr>
            </tbody>

            <tfoot>
                <tr>
                    <td colspan="8"
                        style="text-align: left; font-size: 10px; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                        <b>एकूण :-</b>
                    </td>


                    <td
                        style="text-align: right; font-weight: 600; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_New_4}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_Renew_4}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_Total_4}}</td>

                    <td
                        style="text-align: right; font-weight: 600; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_New_5}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_Renew_5}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_Total_5}}</td>

                    <td
                        style="text-align: right; font-weight: 600; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_New_6}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_Renew_6}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_Total_6}}</td>

                    <td
                        style="text-align: right; font-weight: 600; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_New_7}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_Renew_7}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_Total_7}}</td>

                    <td
                        style="text-align: right; font-weight: 600; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_New_8}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_Renew_8}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_Total_8}}</td>

                    <td
                        style="text-align: right; font-weight: 600; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_New_9}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_Renew_9}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_Total_9}}</td>

                    <td
                        style="text-align: right; font-weight: 600; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_New_10}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_Renew_10}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_Total_10}}</td>

                    <td
                        style="text-align: right; font-weight: 600; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_New_11}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_Renew_11}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_Total_11}}</td>

                    <td
                        style="text-align: right; font-weight: 600; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_New_12}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_Renew_12}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_Total_12}}</td>

                    <td
                        style="text-align: right; font-weight: 600; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_New_1}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_Renew_1}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_Total_1}}</td>

                    <td
                        style="text-align: right; font-weight: 600; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_New_2}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_Renew_2}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_Total_2}}</td>

                    <td
                        style="text-align: right; font-weight: 600; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_New_3}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_Renew_3}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_Total_3}}</td>

                    <td
                        style="text-align: right; font-weight: 600; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_New_total}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_Renew_total}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-right: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_Total_total}}</td>
                </tr>
            </tfoot>
        </table>


    </div>
    <div style="margin-left: 80%; margin-bottom: 2%;">
        <!-- <button class="noPrint" style="margin-top: 2%;" mat-raised-button color="primary"
            [printStyle]="{table : {'border-collapse':'collapse'}, td : {'border': 'solid 1px'}, th : {'border': 'solid 1px'}}"
            printSectionId="print-section2" ngxPrint>
            print
        </button> -->
        <button class="noPrint" style="margin-top: 2%; margin-left: 2%"
            (click)="exportExcel('Remaining_Subscription_Taluka_Briefly')" mat-raised-button color="primary">
            Export
        </button>

        <!-- <button class="noPrint" style="margin-top: 2%;" mat-raised-button color="primary"
           [useExistingCss]="true"
            printSectionId="print-section1" ngxPrint>
            print
        </button> -->

        <button class="noPrint" style="margin-top: 2%; margin-left: 2%" mat-raised-button color="primary"
            (click)="printPage()">
            Print
        </button>

        <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>
            Close
        </button>
    </div>
</div>

<div *ngIf="reportType == 'RemainingSubscriptionOffReprensantive'">
    <div id="print-section8" class="container">

        <table class="table table-bordered">
            <thead>
                <tr>
                    <th colspan="158" style="text-align: center !important; font-size: 14px;">कार्यलय प्रतिनिधी</th>

                </tr>
                <tr>
                    <th colspan="134" style="text-align: center !important;">हिंदुस्तान प्रकाशन संस्था - विवेक साप्ताहिक
                        - वर्गणी विभाग</th>

                    <th colspan="24" style="text-align: center !important;">दिनांक: {{ currentDate | date: 'dd-MM-yyyy'
                        }}</th>

                </tr>
                <tr>
                    <th colspan="74" style="text-align: center !important;">वर्गणीदार नूतनीकरण व्यवसाय तपशिल</th>
                    <th colspan="60" style="text-align: center !important;">जमा बाकी तपशील</th>
                    <th colspan="12" style="text-align: center !important;">दिनांक पासून:{{startDate | date:
                        'dd-MM-yyyy'}}</th>
                    <th colspan="12" style="text-align: center !important;">पर्यंत: {{endDate | date: 'dd-MM-yyyy'}}
                    </th>

                </tr>

                <tr>
                    <th colspan="2"
                        style="font-size: 14px; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                        नूतनीकरण येणे बाकी</th>
                    <th colspan="12"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">एप्रिल</th>
                    <th colspan="12"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">मे</th>
                    <th colspan="12"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">जून</th>
                    <th colspan="12"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">जुलै</th>
                    <th colspan="12"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">ऑगस्ट</th>
                    <th colspan="12"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">सप्टेंबर</th>
                    <th colspan="12"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">ऑक्टोबर</th>
                    <th colspan="12"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">नोव्हेंबर</th>
                    <th colspan="12"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">डिसेंबर</th>
                    <th colspan="12"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">जानेवारी</th>
                    <th colspan="12"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">फेब्रुवारी</th>
                    <th colspan="12"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">मार्च</th>
                    <th colspan="12"
                        style="text-align: center; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">एकूण</th>
                </tr>
                <tr>
                    <th colspan="2"
                        style="border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        प्रतिनिधी</th>


                    <!-- april-->
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">हस्ते</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">मॅगझीन पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">डिजिटल</th>
                    <!-- may-->
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">हस्ते</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">मॅगझीन पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">डिजिटल</th>
                    <!-- june-->
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">हस्ते</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">मॅगझीन पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">डिजिटल</th>
                    <!-- jul-->
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">हस्ते</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">मॅगझीन पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">डिजिटल</th>
                    <!-- aug-->
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">हस्ते</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">मॅगझीन पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">डिजिटल</th>
                    <!-- sep-->
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">हस्ते</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">मॅगझीन पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">डिजिटल</th>
                    <!-- oct-->
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">हस्ते</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">मॅगझीन पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">डिजिटल</th>
                    <!-- nov-->
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">हस्ते</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">मॅगझीन पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">डिजिटल</th>
                    <!-- dec-->
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">हस्ते</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">मॅगझीन पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">डिजिटल</th>
                    <!-- jan-->
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">हस्ते</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">मॅगझीन पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">डिजिटल</th>
                    <!-- feb-->
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">हस्ते</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">मॅगझीन पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">डिजिटल</th>
                    <!-- mar-->
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">हस्ते</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">मॅगझीन पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">डिजिटल</th>

                    <!-- total-->
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">हस्ते</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">मॅगझीन पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-rigth">डिजिटल</th>
                </tr>
                <tr>
                    <th colspan="2"
                        style="border-left: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                    </th>
                    <th class="br-left" style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th class="br-left" style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th class="br-left" style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th class="br-left" style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th class="br-left" style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th class="br-left" style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th class="br-left" style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th class="br-left" style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th class="br-left" style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th class="br-left" style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th class="br-left" style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th class="br-left" style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th class="br-left" style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th class="br-left" style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <!-- <th colspan="6"></th> -->
                    <th class="br-left" style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>
                    <th class="br-left" style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th class="br-right" style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण
                    </th>
                </tr>
            </thead>

            <!-- *ngFor="let data of OutstandingInDetailFormBeans; let i = index" -->
            <tbody>
                <ng-container *ngFor="let data2 of SubRemOffRep; let i = index">

                    <tr>
                        <td colspan="2"
                            style="font-weight: bold; font-size: 14px; text-align: center; border-left: 2px solid black; border-right: 2px solid black; border-bottom: 2px solid black;">
                            {{data2.office_rep_name || '--'}}</td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>

                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>

                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>

                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>

                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>

                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>

                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>

                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>

                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>

                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>

                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>

                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>

                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-right" style="border-right: 2px solid black;"></td>
                    </tr>


                    <ng-container *ngFor="let data11 of data2.districts; let i = index">

                        <tr>
                            <td colspan="2"
                                style="text-align: left;font-size: 15px;text-align: center;font-weight: bold; border-left: 2px solid black; border-right: 2px solid black; border-bottom: 2px solid black;">
                                {{data11.district || '--'}}</td>
                            <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                            <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                            <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                            <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>

                            <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                            <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                            <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                            <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>

                            <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                            <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                            <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                            <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>

                            <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                            <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                            <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                            <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>

                            <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                            <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                            <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                            <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>

                            <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                            <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                            <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                            <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>

                            <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                            <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                            <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                            <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>

                            <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                            <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                            <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                            <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>

                            <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                            <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                            <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                            <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>

                            <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                            <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                            <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                            <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>

                            <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                            <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                            <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                            <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>

                            <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                            <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                            <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                            <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>

                            <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                            <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                            <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                            <td colspan="3" class="br-right" style="border-right: 2px solid black;"></td>
                        </tr>



                        <ng-container *ngFor="let data1 of data11.talukas let i = index">
                            <tr>
                                <td colspan="2"
                                    style="border-left: 2px solid black; border-right: 2px solid black; border-bottom: 2px solid black;">
                                    <b>{{data1.taluka || '--'}}</b>
                                </td>
                                <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                                <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                                <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                                <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>

                                <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                                <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                                <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                                <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>

                                <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                                <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                                <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                                <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>

                                <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                                <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                                <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                                <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>

                                <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                                <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                                <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                                <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>

                                <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                                <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                                <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                                <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>

                                <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                                <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                                <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                                <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>

                                <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                                <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                                <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                                <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>

                                <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                                <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                                <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                                <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>

                                <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                                <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                                <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                                <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>

                                <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                                <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                                <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                                <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>

                                <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                                <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                                <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                                <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>

                                <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                                <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                                <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                                <td colspan="3" class="br-right" style="border-right: 2px solid black;"></td>

                            </tr>

                            <tr *ngFor="let data of data1.rep_info; let i = index">
                                <td colspan="2" style="border-left: 2px solid black; border-right: 2px solid black;">
                                    {{data.rep_name}}</td>

                                <!-- April (4) -->
                                <td class="br-left" style="text-align: right;">{{formatValue(data.tapal_New_4)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.tapal_Renew_4)}}</td>
                                <td class="br-left" style="text-align: right; border-right: 2px solid black;">
                                    {{formatValue(data.tapal_Total_4)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.haste_New_4)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.haste_Renew_4)}}</td>
                                <td class="br-left" style="text-align: right; border-right: 2px solid black;">
                                    {{formatValue(data.haste_Total_4)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.magzine_New_4)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.magzine_Renew_4)}}
                                </td>
                                <td class="br-left" style="text-align: right; border-right: 2px solid black;">
                                    {{formatValue(data.magzine_Total_4)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.digital_New_4)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.digital_Renew_4)}}
                                </td>
                                <td class="br-left" style="text-align: right; border-right: 2px solid black;">
                                    {{formatValue(data.digital_Total_4)}}</td>

                                <!-- May (5) -->
                                <td class="br-left" style="text-align: right;">{{formatValue(data.tapal_New_5)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.tapal_Renew_5)}}</td>
                                <td class="br-left" style="text-align: right; border-right: 2px solid black;">
                                    {{formatValue(data.tapal_Total_5)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.haste_New_5)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.haste_Renew_5)}}</td>
                                <td class="br-left" style="text-align: right; border-right: 2px solid black;">
                                    {{formatValue(data.haste_Total_5)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.magzine_New_5)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.magzine_Renew_5)}}
                                </td>
                                <td class="br-left" style="text-align: right; border-right: 2px solid black;">
                                    {{formatValue(data.magzine_Total_5)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.digital_New_5)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.digital_Renew_5)}}
                                </td>
                                <td class="br-left" style="text-align: right; border-right: 2px solid black;">
                                    {{formatValue(data.digital_Total_5)}}</td>

                                <!-- June (6) -->
                                <td class="br-left" style="text-align: right;">{{formatValue(data.tapal_New_6)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.tapal_Renew_6)}}</td>
                                <td class="br-left" style="text-align: right; border-right: 2px solid black;">
                                    {{formatValue(data.tapal_Total_6)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.haste_New_6)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.haste_Renew_6)}}</td>
                                <td class="br-left" style="text-align: right; border-right: 2px solid black;">
                                    {{formatValue(data.haste_Total_6)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.magzine_New_6)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.magzine_Renew_6)}}
                                </td>
                                <td class="br-left" style="text-align: right; border-right: 2px solid black;">
                                    {{formatValue(data.magzine_Total_6)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.digital_New_6)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.digital_Renew_6)}}
                                </td>
                                <td class="br-left" style="text-align: right; border-right: 2px solid black;">
                                    {{formatValue(data.digital_Total_6)}}</td>

                                <!-- July (7) -->
                                <td class="br-left" style="text-align: right;">{{formatValue(data.tapal_New_7)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.tapal_Renew_7)}}</td>
                                <td class="br-left" style="text-align: right; border-right: 2px solid black;">
                                    {{formatValue(data.tapal_Total_7)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.haste_New_7)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.haste_Renew_7)}}</td>
                                <td class="br-left" style="text-align: right; border-right: 2px solid black;">
                                    {{formatValue(data.haste_Total_7)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.magzine_New_7)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.magzine_Renew_7)}}
                                </td>
                                <td class="br-left" style="text-align: right; border-right: 2px solid black;">
                                    {{formatValue(data.magzine_Total_7)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.digital_New_7)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.digital_Renew_7)}}
                                </td>
                                <td class="br-left" style="text-align: right; border-right: 2px solid black;">
                                    {{formatValue(data.digital_Total_7)}}</td>

                                <!-- August (8) -->
                                <td class="br-left" style="text-align: right;">{{formatValue(data.tapal_New_8)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.tapal_Renew_8)}}</td>
                                <td class="br-left" style="text-align: right; border-right: 2px solid black;">
                                    {{formatValue(data.tapal_Total_8)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.haste_New_8)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.haste_Renew_8)}}</td>
                                <td class="br-left" style="text-align: right; border-right: 2px solid black;">
                                    {{formatValue(data.haste_Total_8)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.magzine_New_8)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.magzine_Renew_8)}}
                                </td>
                                <td class="br-left" style="text-align: right; border-right: 2px solid black;">
                                    {{formatValue(data.magzine_Total_8)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.digital_New_8)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.digital_Renew_8)}}
                                </td>
                                <td class="br-left" style="text-align: right; border-right: 2px solid black;">
                                    {{formatValue(data.digital_Total_8)}}</td>

                                <!-- September (9) -->
                                <td class="br-left" style="text-align: right;">{{formatValue(data.tapal_New_9)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.tapal_Renew_9)}}</td>
                                <td class="br-left" style="text-align: right; border-right: 2px solid black;">
                                    {{formatValue(data.tapal_Total_9)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.haste_New_9)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.haste_Renew_9)}}</td>
                                <td class="br-left" style="text-align: right; border-right: 2px solid black;">
                                    {{formatValue(data.haste_Total_9)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.magzine_New_9)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.magzine_Renew_9)}}
                                </td>
                                <td class="br-left" style="text-align: right; border-right: 2px solid black;">
                                    {{formatValue(data.magzine_Total_9)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.digital_New_9)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.digital_Renew_9)}}
                                </td>
                                <td class="br-left" style="text-align: right; border-right: 2px solid black;">
                                    {{formatValue(data.digital_Total_9)}}</td>

                                <!-- October (10) -->
                                <td class="br-left" style="text-align: right;">{{formatValue(data.tapal_New_10)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.tapal_Renew_10)}}</td>
                                <td class="br-left" style="text-align: right; border-right: 2px solid black;">
                                    {{formatValue(data.tapal_Total_10)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.haste_New_10)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.haste_Renew_10)}}</td>
                                <td class="br-left" style="text-align: right; border-right: 2px solid black;">
                                    {{formatValue(data.haste_Total_10)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.magzine_New_10)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.magzine_Renew_10)}}
                                </td>
                                <td class="br-left" style="text-align: right; border-right: 2px solid black;">
                                    {{formatValue(data.magzine_Total_10)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.digital_New_10)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.digital_Renew_10)}}
                                </td>
                                <td class="br-left" style="text-align: right; border-right: 2px solid black;">
                                    {{formatValue(data.digital_Total_10)}}</td>

                                <!-- November (11) -->
                                <td class="br-left" style="text-align: right;">{{formatValue(data.tapal_New_11)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.tapal_Renew_11)}}</td>
                                <td class="br-left" style="text-align: right; border-right: 2px solid black;">
                                    {{formatValue(data.tapal_Total_11)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.haste_New_11)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.haste_Renew_11)}}</td>
                                <td class="br-left" style="text-align: right; border-right: 2px solid black;">
                                    {{formatValue(data.haste_Total_11)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.magzine_New_11)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.magzine_Renew_11)}}
                                </td>
                                <td class="br-left" style="text-align: right; border-right: 2px solid black;">
                                    {{formatValue(data.magzine_Total_11)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.digital_New_11)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.digital_Renew_11)}}
                                </td>
                                <td class="br-left" style="text-align: right; border-right: 2px solid black;">
                                    {{formatValue(data.digital_Total_11)}}</td>

                                <!-- December (12) -->
                                <td class="br-left" style="text-align: right;">{{formatValue(data.tapal_New_12)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.tapal_Renew_12)}}</td>
                                <td class="br-left" style="text-align: right; border-right: 2px solid black;">
                                    {{formatValue(data.tapal_Total_12)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.haste_New_12)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.haste_Renew_12)}}</td>
                                <td class="br-left" style="text-align: right; border-right: 2px solid black;">
                                    {{formatValue(data.haste_Total_12)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.magzine_New_12)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.magzine_Renew_12)}}
                                </td>
                                <td class="br-left" style="text-align: right; border-right: 2px solid black;">
                                    {{formatValue(data.magzine_Total_12)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.digital_New_12)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.digital_Renew_12)}}
                                </td>
                                <td class="br-left" style="text-align: right; border-right: 2px solid black;">
                                    {{formatValue(data.digital_Total_12)}}</td>

                                <!-- January (1) -->
                                <td class="br-left" style="text-align: right;">{{formatValue(data.tapal_New_1)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.tapal_Renew_1)}}</td>
                                <td class="br-left" style="text-align: right; border-right: 2px solid black;">
                                    {{formatValue(data.tapal_Total_1)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.haste_New_1)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.haste_Renew_1)}}</td>
                                <td class="br-left" style="text-align: right; border-right: 2px solid black;">
                                    {{formatValue(data.haste_Total_1)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.magzine_New_1)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.magzine_Renew_1)}}
                                </td>
                                <td class="br-left" style="text-align: right; border-right: 2px solid black;">
                                    {{formatValue(data.magzine_Total_1)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.digital_New_1)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.digital_Renew_1)}}
                                </td>
                                <td class="br-left" style="text-align: right; border-right: 2px solid black;">
                                    {{formatValue(data.digital_Total_1)}}</td>

                                <!-- February (2) -->
                                <td class="br-left" style="text-align: right;">{{formatValue(data.tapal_New_2)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.tapal_Renew_2)}}</td>
                                <td class="br-left" style="text-align: right; border-right: 2px solid black;">
                                    {{formatValue(data.tapal_Total_2)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.haste_New_2)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.haste_Renew_2)}}</td>
                                <td class="br-left" style="text-align: right; border-right: 2px solid black;">
                                    {{formatValue(data.haste_Total_2)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.magzine_New_2)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.magzine_Renew_2)}}
                                </td>
                                <td class="br-left" style="text-align: right; border-right: 2px solid black;">
                                    {{formatValue(data.magzine_Total_2)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.digital_New_2)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.digital_Renew_2)}}
                                </td>
                                <td class="br-left" style="text-align: right; border-right: 2px solid black;">
                                    {{formatValue(data.digital_Total_2)}}</td>

                                <!-- March (3) -->
                                <td class="br-left" style="text-align: right;">{{formatValue(data.tapal_New_3)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.tapal_Renew_3)}}</td>
                                <td class="br-left" style="text-align: right; border-right: 2px solid black;">
                                    {{formatValue(data.tapal_Total_3)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.haste_New_3)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.haste_Renew_3)}}</td>
                                <td class="br-left" style="text-align: right; border-right: 2px solid black;">
                                    {{formatValue(data.haste_Total_3)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.magzine_New_3)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.magzine_Renew_3)}}
                                </td>
                                <td class="br-left" style="text-align: right; border-right: 2px solid black;">
                                    {{formatValue(data.magzine_Total_3)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.digital_New_3)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.digital_Renew_3)}}
                                </td>
                                <td class="br-left" style="text-align: right; border-right: 2px solid black;">
                                    {{formatValue(data.digital_Total_3)}}</td>

                                <!-- Total -->
                                <td class="br-left" style="text-align: right;">{{formatValue(data.tapal_New_Total)}}
                                </td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.tapal_Renew_Total)}}
                                </td>
                                <td class="br-left" style="text-align: right; border-right: 2px solid black;">
                                    {{formatValue(data.tapal_Total_Total)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.haste_New_Total)}}
                                </td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.haste_Renew_Total)}}
                                </td>
                                <td class="br-left" style="text-align: right; border-right: 2px solid black;">
                                    {{formatValue(data.haste_Total_Total)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.magzine_New_Total)}}
                                </td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.magzine_Renew_Total)}}
                                </td>
                                <td class="br-left" style="text-align: right; border-right: 2px solid black;">
                                    {{formatValue(data.magzine_Total_Total)}}</td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.digital_New_Total)}}
                                </td>
                                <td class="br-left" style="text-align: right;">{{formatValue(data.digital_Renew_Total)}}
                                </td>
                                <td class="br-left" style="text-align: right; border-right: 2px solid black;">
                                    {{formatValue(data.digital_Total_Total)}}</td>
                            </tr>

                            <tr>
                                <td colspan="2"
                                    style="text-align: right; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    <b>एकूण</b>
                                </td>

                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.tapal_New_4)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.tapal_Renew_4)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                    {{formatValue(data1.tapal_Total_4)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.haste_New_4)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.haste_Renew_4)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.haste_Total_4)}}</td>

                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.magzine_New_4)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.magzine_Renew_4)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                    {{formatValue(data1.magzine_Total_4)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.digital_New_4)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.digital_Renew_4)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                    {{formatValue(data1.digital_Total_4)}}</td>

                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.tapal_New_5)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.tapal_Renew_5)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                    {{formatValue(data1.tapal_Total_5)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.haste_New_5)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.haste_Renew_5)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                    {{formatValue(data1.haste_Total_5)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.magzine_New_5)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.magzine_Renew_5)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                    {{formatValue(data1.magzine_Total_5)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.digital_New_5)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.digital_Renew_5)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right:  2px solid black;">
                                    {{formatValue(data1.digital_Total_5)}}</td>

                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.tapal_New_6)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.tapal_Renew_6)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                    {{formatValue(data1.tapal_Total_6)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.haste_New_6)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.haste_Renew_6)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                    {{formatValue(data1.haste_Total_6)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.magzine_New_6)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.magzine_Renew_6)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                    {{formatValue(data1.magzine_Total_6)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.digital_New_6)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.digital_Renew_6)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right:  2px solid black;">
                                    {{formatValue(data1.digital_Total_6)}}</td>

                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.tapal_New_7)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.tapal_Renew_7)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                    {{formatValue(data1.tapal_Total_7)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.haste_New_7)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.haste_Renew_7)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                    {{formatValue(data1.haste_Total_7)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.magzine_New_7)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.magzine_Renew_7)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                    {{formatValue(data1.magzine_Total_7)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.digital_New_7)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.digital_Renew_7)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right:  2px solid black;">
                                    {{formatValue(data1.digital_Total_7)}}</td>

                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.tapal_New_8)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.tapal_Renew_8)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                    {{formatValue(data1.tapal_Total_8)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.haste_New_8)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.haste_Renew_8)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                    {{formatValue(data1.haste_Total_8)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.magzine_New_8)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.magzine_Renew_8)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                    {{formatValue(data1.magzine_Total_8)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.digital_New_8)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.digital_Renew_8)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                    {{formatValue(data1.digital_Total_8)}}</td>

                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.tapal_New_9)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.tapal_Renew_9)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                    {{formatValue(data1.tapal_Total_9)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.haste_New_9)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.haste_Renew_9)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                    {{formatValue(data1.haste_Total_9)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.magzine_New_9)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.magzine_Renew_9)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                    {{formatValue(data1.magzine_Total_9)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.digital_New_9)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.digital_Renew_9)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                    {{formatValue(data1.digital_Total_9)}}</td>

                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.tapal_New_10)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.tapal_Renew_10)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                    {{formatValue(data1.tapal_Total_10)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.haste_New_10)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.haste_Renew_10)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                    {{formatValue(data1.haste_Total_10)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.magzine_New_10)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.magzine_Renew_10)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                    {{formatValue(data1.magzine_Total_10)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.digital_New_10)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.digital_Renew_10)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                    {{formatValue(data1.digital_Total_10)}}</td>

                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.tapal_New_11)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.tapal_Renew_11)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                    {{formatValue(data1.tapal_Total_11)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.haste_New_11)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.haste_Renew_11)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                    {{formatValue(data1.haste_Total_11)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.magzine_New_11)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.magzine_Renew_11)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                    {{formatValue(data1.magzine_Total_11)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.digital_New_11)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.digital_Renew_11)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                    {{formatValue(data1.digital_Total_11)}}</td>

                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.tapal_New_12)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.tapal_Renew_12)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                    {{formatValue(data1.tapal_Total_12)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.haste_New_12)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.haste_Renew_12)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                    {{formatValue(data1.haste_Total_12)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.magzine_New_12)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.magzine_Renew_12)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                    {{formatValue(data1.magzine_Total_12)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.digital_New_12)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.digital_Renew_12)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                    {{formatValue(data1.digital_Total_12)}}</td>


                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.tapal_New_1)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.tapal_Renew_1)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                    {{formatValue(data1.tapal_Total_1)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.haste_New_1)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.haste_Renew_1)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                    {{formatValue(data1.haste_Total_1)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.magzine_New_1)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.magzine_Renew_1)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                    {{formatValue(data1.magzine_Total_1)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.digital_New_1)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.digital_Renew_1)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid right;">
                                    {{formatValue(data1.digital_Total_1)}}</td>

                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.tapal_New_2)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.tapal_Renew_2)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                    {{formatValue(data1.tapal_Total_2)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.haste_New_2)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.haste_Renew_2)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                    {{formatValue(data1.haste_Total_2)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.magzine_New_2)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.magzine_Renew_2)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                    {{formatValue(data1.magzine_Total_2)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.digital_New_2)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.digital_Renew_2)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                    {{formatValue(data1.digital_Total_2)}}</td>

                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.tapal_New_3)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.tapal_Renew_3)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                    {{formatValue(data1.tapal_Total_3)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.haste_New_3)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.haste_Renew_3)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                    {{formatValue(data1.haste_Total_3)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.magzine_New_3)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.magzine_Renew_3)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                    {{formatValue(data1.magzine_Total_3)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.digital_New_3)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.digital_Renew_3)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                    {{formatValue(data1.digital_Total_3)}}</td>

                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.tapal_New_total)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.tapal_Renew_total)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                    {{formatValue(data1.tapal_Total_total)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.haste_New_total)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.haste_Renew_total)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                    {{formatValue(data1.haste_Total_total)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.magzine_New_total)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.magzine_Renew_total)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                    {{formatValue(data1.magzine_Total_total)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.digital_New_total)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    {{formatValue(data1.digital_Renew_total)}}</td>
                                <td
                                    style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                    {{formatValue(data1.digital_Total_total)}}</td>

                            </tr>
                        </ng-container>
                        <tr>
                            <td colspan="2"
                                style="text-align: right; border-left: 2px solid black; border-right: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                                <b>{{data11.district || '--'}} : एकूण</b>
                            </td>

                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.tapal_New_4)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.tapal_Renew_4)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                {{formatValue(data11.tapal_Total_4)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.haste_New_4)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.haste_Renew_4)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                {{formatValue(data11.haste_Total_4)}}</td>

                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.magzine_New_4)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.magzine_Renew_4)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                {{formatValue(data11.magzine_Total_4)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.digital_New_4)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.digital_Renew_4)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                {{formatValue(data11.digital_Total_4)}}</td>

                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.tapal_New_5)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.tapal_Renew_5)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                {{formatValue(data11.tapal_Total_5)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.haste_New_5)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.haste_Renew_5)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                {{formatValue(data11.haste_Total_5)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.magzine_New_5)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.magzine_Renew_5)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                {{formatValue(data11.magzine_Total_5)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.digital_New_5)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.digital_Renew_5)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                {{formatValue(data11.digital_Total_5)}}</td>

                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.tapal_New_6)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.tapal_Renew_6)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                {{formatValue(data11.tapal_Total_6)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.haste_New_6)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.haste_Renew_6)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                {{formatValue(data11.haste_Total_6)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.magzine_New_6)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.magzine_Renew_6)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                {{formatValue(data11.magzine_Total_6)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.digital_New_6)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.digital_Renew_6)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                {{formatValue(data11.digital_Total_6)}}</td>

                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.tapal_New_7)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.tapal_Renew_7)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                {{formatValue(data11.tapal_Total_7)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.haste_New_7)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.haste_Renew_7)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                {{formatValue(data11.haste_Total_7)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.magzine_New_7)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.magzine_Renew_7)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                {{formatValue(data11.magzine_Total_7)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.digital_New_7)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.digital_Renew_7)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                {{formatValue(data11.digital_Total_7)}}</td>

                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.tapal_New_8)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.tapal_Renew_8)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                {{formatValue(data11.tapal_Total_8)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.haste_New_8)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.haste_Renew_8)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                {{formatValue(data11.haste_Total_8)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.magzine_New_8)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.magzine_Renew_8)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                {{formatValue(data11.magzine_Total_8)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.digital_New_8)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.digital_Renew_8)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                {{formatValue(data11.digital_Total_8)}}</td>

                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.tapal_New_9)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.tapal_Renew_9)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                {{formatValue(data11.tapal_Total_9)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.haste_New_9)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.haste_Renew_9)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                {{formatValue(data11.haste_Total_9)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.magzine_New_9)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.magzine_Renew_9)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                {{formatValue(data11.magzine_Total_9)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.digital_New_9)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.digital_Renew_9)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                {{formatValue(data11.digital_Total_9)}}</td>

                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.tapal_New_10)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.tapal_Renew_10)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                {{formatValue(data11.tapal_Total_10)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.haste_New_10)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.haste_Renew_10)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                {{formatValue(data11.haste_Total_10)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.magzine_New_10)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.magzine_Renew_10)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                {{formatValue(data11.magzine_Total_10)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.digital_New_10)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.digital_Renew_10)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                {{formatValue(data11.digital_Total_10)}}</td>

                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.tapal_New_11)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.tapal_Renew_11)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                {{formatValue(data11.tapal_Total_11)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.haste_New_11)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.haste_Renew_11)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                {{formatValue(data11.haste_Total_11)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.magzine_New_11)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.magzine_Renew_11)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                {{formatValue(data11.magzine_Total_11)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.digital_New_11)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.digital_Renew_11)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                {{formatValue(data11.digital_Total_11)}}</td>

                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.tapal_New_12)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.tapal_Renew_12)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                {{formatValue(data11.tapal_Total_12)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.haste_New_12)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.haste_Renew_12)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                {{formatValue(data11.haste_Total_12)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.magzine_New_12)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.magzine_Renew_12)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                {{formatValue(data11.magzine_Total_12)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.digital_New_12)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.digital_Renew_12)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                {{formatValue(data11.digital_Total_12)}}</td>

                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.tapal_New_1)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.tapal_Renew_1)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                {{formatValue(data11.tapal_Total_1)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.haste_New_1)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.haste_Renew_1)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                {{formatValue(data11.haste_Total_1)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.magzine_New_1)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.magzine_Renew_1)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                {{formatValue(data11.magzine_Total_1)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.digital_New_1)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.digital_Renew_1)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                {{formatValue(data11.digital_Total_1)}}</td>

                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.tapal_New_2)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.tapal_Renew_2)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                {{formatValue(data11.tapal_Total_2)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.haste_New_2)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.haste_Renew_2)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                {{formatValue(data11.haste_Total_2)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.magzine_New_2)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.magzine_Renew_2)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                {{formatValue(data11.magzine_Total_2)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.digital_New_2)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.digital_Renew_2)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                {{formatValue(data11.digital_Total_2)}}</td>

                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.tapal_New_3)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.tapal_Renew_3)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                {{formatValue(data11.tapal_Total_3)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.haste_New_3)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.haste_Renew_3)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                {{formatValue(data11.haste_Total_3)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.magzine_New_3)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.magzine_Renew_3)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                {{formatValue(data11.magzine_Total_3)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.digital_New_3)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.digital_Renew_3)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                {{formatValue(data11.digital_Total_3)}}</td>

                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.tapal_New_total)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.tapal_Renew_total)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                {{formatValue(data11.tapal_Total_total)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.haste_New_total)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.haste_Renew_total)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                {{formatValue(data11.haste_Total_total)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.magzine_New_total)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.magzine_Renew_total)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                {{formatValue(data11.magzine_Total_total)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.digital_New_total)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{formatValue(data11.digital_Renew_total)}}</td>
                            <td
                                style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                                {{formatValue(data11.digital_Total_total)}}</td>



                        </tr>
                    </ng-container>
                    <tr>
                        <td colspan="2"
                            style="text-align: right; border-bottom: 2px solid black; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black;">
                            <b>{{(data2.office_rep_name || '--')}} : एकूण</b>
                        </td>


                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.tapal_New_4)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.tapal_Renew_4)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{formatValue(data2.tapal_Total_4)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.haste_New_4)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.haste_Renew_4)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{formatValue(data2.haste_Total_4)}}</td>

                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.magzine_New_4)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.magzine_Renew_4)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{formatValue(data2.magzine_Total_4)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.digital_New_4)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.digital_Renew_4)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{formatValue(data2.digital_Total_4)}}</td>

                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.tapal_New_5)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.tapal_Renew_5)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{formatValue(data2.tapal_Total_5)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.haste_New_5)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.haste_Renew_5)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{formatValue(data2.haste_Total_5)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.magzine_New_5)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.magzine_Renew_5)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{formatValue(data2.magzine_Total_5)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.digital_New_5)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.digital_Renew_5)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{formatValue(data2.digital_Total_5)}}</td>

                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.tapal_New_6)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.tapal_Renew_6)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{formatValue(data2.tapal_Total_6)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.haste_New_6)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.haste_Renew_6)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{formatValue(data2.haste_Total_6)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.magzine_New_6)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.magzine_Renew_6)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{formatValue(data2.magzine_Total_6)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.digital_New_6)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.digital_Renew_6)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{formatValue(data2.digital_Total_6)}}</td>

                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.tapal_New_7)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.tapal_Renew_7)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{formatValue(data2.tapal_Total_7)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.haste_New_7)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.haste_Renew_7)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{formatValue(data2.haste_Total_7)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.magzine_New_7)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.magzine_Renew_7)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{formatValue(data2.magzine_Total_7)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.digital_New_7)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.digital_Renew_7)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{formatValue(data2.digital_Total_7)}}</td>

                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.tapal_New_8)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.tapal_Renew_8)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{formatValue(data2.tapal_Total_8)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.haste_New_8)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.haste_Renew_8)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{formatValue(data2.haste_Total_8)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.magzine_New_8)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.magzine_Renew_8)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{formatValue(data2.magzine_Total_8)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.digital_New_8)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.digital_Renew_8)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{formatValue(data2.digital_Total_8)}}</td>

                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.tapal_New_9)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.tapal_Renew_9)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{formatValue(data2.tapal_Total_9)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.haste_New_9)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.haste_Renew_9)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{formatValue(data2.haste_Total_9)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.magzine_New_9)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.magzine_Renew_9)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{formatValue(data2.magzine_Total_9)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.digital_New_9)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.digital_Renew_9)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{formatValue(data2.digital_Total_9)}}</td>

                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.tapal_New_10)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.tapal_Renew_10)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{formatValue(data2.tapal_Total_10)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.haste_New_10)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.haste_Renew_10)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{formatValue(data2.haste_Total_10)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.magzine_New_10)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.magzine_Renew_10)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{formatValue(data2.magzine_Total_10)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.digital_New_10)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.digital_Renew_10)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{formatValue(data2.digital_Total_10)}}</td>

                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.tapal_New_11)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.tapal_Renew_11)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{formatValue(data2.tapal_Total_11)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.haste_New_11)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.haste_Renew_11)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{formatValue(data2.haste_Total_11)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.magzine_New_11)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.magzine_Renew_11)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{formatValue(data2.magzine_Total_11)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.digital_New_11)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.digital_Renew_11)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{formatValue(data2.digital_Total_11)}}</td>

                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.tapal_New_12)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.tapal_Renew_12)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{formatValue(data2.tapal_Total_12)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.haste_New_12)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.haste_Renew_12)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{formatValue(data2.haste_Total_12)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.magzine_New_12)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.magzine_Renew_12)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{formatValue(data2.magzine_Total_12)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.digital_New_12)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.digital_Renew_12)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{formatValue(data2.digital_Total_12)}}</td>

                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.tapal_New_1)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.tapal_Renew_1)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{formatValue(data2.tapal_Total_1)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.haste_New_1)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.haste_Renew_1)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{formatValue(data2.haste_Total_1)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.magzine_New_1)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.magzine_Renew_1)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{formatValue(data2.magzine_Total_1)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.digital_New_1)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.digital_Renew_1)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{formatValue(data2.digital_Total_1)}}</td>



                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.tapal_New_2)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.tapal_Renew_2)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{formatValue(data2.tapal_Total_2)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.haste_New_2)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.haste_Renew_2)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{formatValue(data2.haste_Total_2)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.magzine_New_2)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.magzine_Renew_2)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{formatValue(data2.magzine_Total_2)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.digital_New_2)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.digital_Renew_2)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{formatValue(data2.digital_Total_2)}}</td>



                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.tapal_New_3)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.tapal_Renew_3)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{formatValue(data2.tapal_Total_3)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.haste_New_3)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.haste_Renew_3)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{formatValue(data2.haste_Total_3)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.magzine_New_3)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.magzine_Renew_3)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{formatValue(data2.magzine_Total_3)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.digital_New_3)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.digital_Renew_3)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{formatValue(data2.digital_Total_3)}}</td>

                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.tapal_New_total)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.tapal_Renew_total)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{formatValue(data2.tapal_Total_total)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.haste_New_total)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.haste_Renew_total)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{formatValue(data2.haste_Total_total)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.magzine_New_total)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.magzine_Renew_total)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{formatValue(data2.magzine_Total_total)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.digital_New_total)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{formatValue(data2.digital_Renew_total)}}</td>
                        <td
                            style="text-align:right; font-weight:600; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{formatValue(data2.digital_Total_total)}}</td>

                    </tr>
                </ng-container>



            </tbody>

            <tfoot>
                <tr>
                    <td colspan="2"
                        style="color: black; text-align: center; font-size: 14px; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        <b>एकूण</b>
                    </td>
                    <!-- April -->
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(tapal_New_4)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(tapal_Renew_4)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;border-right:2px solid black;">
                        {{formatValue(tapal_Total_4)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(haste_New_4)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(haste_Renew_4)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;border-right:2px solid black;">
                        {{formatValue(haste_Total_4)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(magzine_New_4)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(magzine_Renew_4)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;border-right:2px solid black;">
                        {{formatValue(magzine_Total_4)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(digital_New_4)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(digital_Renew_4)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;border-right:2px solid black;">
                        {{formatValue(digital_Total_4)}}</td>
                    <!-- May -->
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(tapal_New_5)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(tapal_Renew_5)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;border-right:2px solid black;">
                        {{formatValue(tapal_Total_5)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(haste_New_5)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(haste_Renew_5)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;border-right:2px solid black;">
                        {{formatValue(haste_Total_5)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(magzine_New_5)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(magzine_Renew_5)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;border-right:2px solid black;">
                        {{formatValue(magzine_Total_5)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(digital_New_5)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(digital_Renew_5)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;border-right:2px solid black;">
                        {{formatValue(digital_Total_5)}}</td>
                    <!-- June -->
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(tapal_New_6)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(tapal_Renew_6)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;border-right:2px solid black;">
                        {{formatValue(tapal_Total_6)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(haste_New_6)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(haste_Renew_6)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;border-right:2px solid black;">
                        {{formatValue(haste_Total_6)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(magzine_New_6)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(magzine_Renew_6)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;border-right:2px solid black;">
                        {{formatValue(magzine_Total_6)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(digital_New_6)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(digital_Renew_6)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;border-right:2px solid black;">
                        {{formatValue(digital_Total_6)}}</td>
                    <!-- July -->
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(tapal_New_7)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(tapal_Renew_7)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;border-right:2px solid black;">
                        {{formatValue(tapal_Total_7)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(haste_New_7)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(haste_Renew_7)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;border-right:2px solid black;">
                        {{formatValue(haste_Total_7)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(magzine_New_7)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(magzine_Renew_7)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;border-right:2px solid black;">
                        {{formatValue(magzine_Total_7)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(digital_New_7)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(digital_Renew_7)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;border-right:2px solid black;">
                        {{formatValue(digital_Total_7)}}</td>
                    <!-- August -->
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(tapal_New_8)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(tapal_Renew_8)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;border-right:2px solid black;">
                        {{formatValue(tapal_Total_8)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(haste_New_8)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(haste_Renew_8)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;border-right:2px solid black;">
                        {{formatValue(haste_Total_8)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(magzine_New_8)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(magzine_Renew_8)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;border-right:2px solid black;">
                        {{formatValue(magzine_Total_8)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(digital_New_8)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(digital_Renew_8)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;border-right:2px solid black;">
                        {{formatValue(digital_Total_8)}}</td>
                    <!-- September -->
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(tapal_New_9)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(tapal_Renew_9)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;border-right:2px solid black;">
                        {{formatValue(tapal_Total_9)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(haste_New_9)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(haste_Renew_9)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;border-right:2px solid black;">
                        {{formatValue(haste_Total_9)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(magzine_New_9)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(magzine_Renew_9)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;border-right:2px solid black;">
                        {{formatValue(magzine_Total_9)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(digital_New_9)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(digital_Renew_9)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;border-right:2px solid black;">
                        {{formatValue(digital_Total_9)}}</td>
                    <!-- October -->
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(tapal_New_10)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(tapal_Renew_10)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;border-right:2px solid black;">
                        {{formatValue(tapal_Total_10)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(haste_New_10)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(haste_Renew_10)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;border-right:2px solid black;">
                        {{formatValue(haste_Total_10)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(magzine_New_10)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(magzine_Renew_10)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;border-right:2px solid black;">
                        {{formatValue(magzine_Total_10)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(digital_New_10)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(digital_Renew_10)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;border-right:2px solid black;">
                        {{formatValue(digital_Total_10)}}</td>
                    <!-- November -->
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(tapal_New_11)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(tapal_Renew_11)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;border-right:2px solid black;">
                        {{formatValue(tapal_Total_11)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(haste_New_11)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(haste_Renew_11)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;border-right:2px solid black;">
                        {{formatValue(haste_Total_11)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(magzine_New_11)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(magzine_Renew_11)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;border-right:2px solid black;">
                        {{formatValue(magzine_Total_11)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(digital_New_11)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(digital_Renew_11)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;border-right:2px solid black;">
                        {{formatValue(digital_Total_11)}}</td>
                    <!-- December -->
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(tapal_New_12)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(tapal_Renew_12)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;border-right:2px solid black;">
                        {{formatValue(tapal_Total_12)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(haste_New_12)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(haste_Renew_12)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;border-right:2px solid black;">
                        {{formatValue(haste_Total_12)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(magzine_New_12)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(magzine_Renew_12)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;border-right:2px solid black;">
                        {{formatValue(magzine_Total_12)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(digital_New_12)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(digital_Renew_12)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;border-right:2px solid black;">
                        {{formatValue(digital_Total_12)}}</td>
                    <!-- January -->
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(tapal_New_1)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(tapal_Renew_1)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;border-right:2px solid black;">
                        {{formatValue(tapal_Total_1)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(haste_New_1)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(haste_Renew_1)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;border-right:2px solid black;">
                        {{formatValue(haste_Total_1)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(magzine_New_1)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(magzine_Renew_1)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;border-right:2px solid black;">
                        {{formatValue(magzine_Total_1)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(digital_New_1)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(digital_Renew_1)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;border-right:2px solid black;">
                        {{formatValue(digital_Total_1)}}</td>
                    <!-- February -->
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(tapal_New_2)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(tapal_Renew_2)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;border-right:2px solid black;">
                        {{formatValue(tapal_Total_2)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(haste_New_2)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(haste_Renew_2)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;border-right:2px solid black;">
                        {{formatValue(haste_Total_2)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(magzine_New_2)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(magzine_Renew_2)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;border-right:2px solid black;">
                        {{formatValue(magzine_Total_2)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(digital_New_2)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(digital_Renew_2)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;border-right:2px solid black;">
                        {{formatValue(digital_Total_2)}}</td>
                    <!-- March -->
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(tapal_New_3)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(tapal_Renew_3)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;border-right:2px solid black;">
                        {{formatValue(tapal_Total_3)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(haste_New_3)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(haste_Renew_3)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;border-right:2px solid black;">
                        {{formatValue(haste_Total_3)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(magzine_New_3)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(magzine_Renew_3)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;border-right:2px solid black;">
                        {{formatValue(magzine_Total_3)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(digital_New_3)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(digital_Renew_3)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;border-right:2px solid black;">
                        {{formatValue(digital_Total_3)}}</td>
                    <!-- Grand Total -->
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(tapal_New_total)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(tapal_Renew_total)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;border-right:2px solid black;">
                        {{formatValue(tapal_Total_total)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(haste_New_total)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(haste_Renew_total)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;border-right:2px solid black;">
                        {{formatValue(haste_Total_total)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(magzine_New_total)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(magzine_Renew_total)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;border-right:2px solid black;">
                        {{formatValue(magzine_Total_total)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(digital_New_total)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;">
                        {{formatValue(digital_Renew_total)}}</td>
                    <td
                        style="color:black;text-align:right;font-weight:600;font-size:14px;border-top:2px solid black;border-bottom:2px solid black;border-right:2px solid black;">
                        {{formatValue(digital_Total_total)}}</td>
                </tr>
            </tfoot>

        </table>



        <!-- <tr>
            <td colspan="2"
                style="color: black; text-align: center; font-size: 14px; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                <b>एकूण</b>
            </td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(tapal_New_4)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(tapal_Renew_4)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                {{formatValue(tapal_Total_4)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(haste_New_4)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(haste_Renew_4)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                {{formatValue(haste_Total_4)}}</td>

            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(magzine_New_4)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(magzine_Renew_4)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                {{formatValue(magzine_Total_4)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(digital_New_4)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(digital_Renew_4)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                {{formatValue(digital_Total_4)}}</td>

            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(tapal_New_5)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(tapal_Renew_5)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                {{formatValue(tapal_Total_5)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(haste_New_5)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(haste_Renew_5)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                {{formatValue(haste_Total_5)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(magzine_New_5)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(magzine_Renew_5)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                {{formatValue(magzine_Total_5)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(digital_New_5)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(digital_Renew_5)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px soild black;">
                {{formatValue(digital_Total_5)}}</td>

            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(tapal_New_6)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(tapal_Renew_6)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                {{formatValue(tapal_Total_6)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(haste_New_6)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(haste_Renew_6)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                {{formatValue(haste_Total_6)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(magzine_New_6)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(magzine_Renew_6)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                {{formatValue(magzine_Total_6)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(digital_New_6)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(digital_Renew_6)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                {{formatValue(digital_Total_6)}}</td>

            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(tapal_New_7)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(tapal_Renew_7)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                {{formatValue(tapal_Total_7)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(haste_New_7)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(haste_Renew_7)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                {{formatValue(haste_Total_7)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(magzine_New_7)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(magzine_Renew_7)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                {{formatValue(magzine_Total_7)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(digital_New_7)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(digital_Renew_7)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                {{formatValue(digital_Total_7)}}</td>

            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(tapal_New_8)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(tapal_Renew_8)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                {{formatValue(tapal_Total_8)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(haste_New_8)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(haste_Renew_8)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                {{formatValue(haste_Total_8)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(magzine_New_8)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(magzine_Renew_8)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                {{formatValue(magzine_Total_8)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(digital_New_8)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(digital_Renew_8)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black ;">
                {{formatValue(digital_Total_8)}}</td>

            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(tapal_New_9)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(tapal_Renew_9)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                {{formatValue(tapal_Total_9)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(haste_New_9)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(haste_Renew_9)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                {{formatValue(haste_Total_9)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(magzine_New_9)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(magzine_Renew_9)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                {{formatValue(magzine_Total_9)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(digital_New_9)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(digital_Renew_9)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                {{formatValue(digital_Total_9)}}</td>

            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(tapal_New_10)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(tapal_Renew_10)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                {{formatValue(tapal_Total_10)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(haste_New_10)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(haste_Renew_10)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                {{formatValue(haste_Total_10)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(magzine_New_10)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(magzine_Renew_10)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                {{formatValue(magzine_Total_10)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(digital_New_10)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(digital_Renew_10)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                {{formatValue(digital_Total_10)}}</td>

            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(tapal_New_11)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(tapal_Renew_11)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                {{formatValue(tapal_Total_11)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(haste_New_11)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(haste_Renew_11)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                {{formatValue(haste_Total_11)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(magzine_New_11)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(magzine_Renew_11)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                {{formatValue(magzine_Total_11)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(digital_New_11)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(digital_Renew_11)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                {{formatValue(digital_Total_11)}}</td>

            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(tapal_New_12)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(tapal_Renew_12)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                {{formatValue(tapal_Total_12)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(haste_New_12)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(haste_Renew_12)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                {{formatValue(haste_Total_12)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(magzine_New_12)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(magzine_Renew_12)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                {{formatValue(magzine_Total_12)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(digital_New_12)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(digital_Renew_12)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                {{formatValue(digital_Total_12)}}</td>

            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(tapal_New_1)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(tapal_Renew_1)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                {{formatValue(tapal_Total_1)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(haste_New_1)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(haste_Renew_1)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                {{formatValue(haste_Total_1)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(magzine_New_1)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(magzine_Renew_1)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                {{formatValue(magzine_Total_1)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(digital_New_1)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(digital_Renew_1)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                {{formatValue(digital_Total_1)}}</td>

            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(tapal_New_2)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(tapal_Renew_2)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                {{formatValue(tapal_Total_2)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(haste_New_2)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(haste_Renew_2)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                {{formatValue(haste_Total_2)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(magzine_New_2)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(magzine_Renew_2)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                {{formatValue(magzine_Total_2)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(digital_New_2)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(digital_Renew_2)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                {{formatValue(digital_Total_2)}}</td>

            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(tapal_New_3)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(tapal_Renew_3)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                {{formatValue(tapal_Total_3)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(haste_New_3)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(haste_Renew_3)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                {{formatValue(haste_Total_3)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(magzine_New_3)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(magzine_Renew_3)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                {{formatValue(magzine_Total_3)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(digital_New_3)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(digital_Renew_3)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                {{formatValue(digital_Total_3)}}</td>

            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(tapal_New_total)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(tapal_Renew_total)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                {{formatValue(tapal_Total_total)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(haste_New_total)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(haste_Renew_total)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                {{formatValue(haste_Total_total)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(magzine_New_total)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(magzine_Renew_total)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                {{formatValue(magzine_Total_total)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(digital_New_total)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                {{formatValue(digital_Renew_total)}}</td>
            <td
                style="color: black; text-align:right; font-weight:600; font-size: 14px; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                {{formatValue(digital_Total_total)}}</td>
        </tr> -->


    </div>
    <div style="margin-left: 80%; margin-bottom: 2%;">
        <!-- <button class="noPrint" style="margin-top: 2%;" mat-raised-button color="primary"
            [printStyle]="{table : {'border-collapse':'collapse'}, td : {'border': 'solid 1px'}, th : {'border': 'solid 1px'}}"
            printSectionId="print-section2" ngxPrint>
            print
        </button> -->
        <button class="noPrint" style="margin-top: 2%; margin-left: 2%"
            (click)="exportExcel18('Remaining_Subscription_Off_Reprensantive')" mat-raised-button color="primary">
            Export
        </button>

        <button class="noPrint" style="margin-top: 2%; margin-left: 2%;" mat-raised-button color="primary"
            [useExistingCss]="true" printSectionId="print-section8" ngxPrint>
            print
        </button>

        <button class="noPrint" style="margin-top: 2%; margin-left: 2%;" mat-button mat-dialog-close>
            Close
        </button>
    </div>
</div>

<div *ngIf="reportType == 'RemainingSubscriptionReprensantive'">
    <div id="print-section" class="container">

        <table class="table table-bordered">
            <thead>
                <tr>
                    <th colspan="80" style="text-align: center !important; font-size: 14px;">जिल्हा निहाय </th>
                    <!-- <th colspan="2">Advt. Outstanding Report</th> -->
                    <!-- <th colspan="2">दिनांक</th>
                    <th colspan="2">पृष्ठ क्र</th> -->
                </tr>
                <tr>
                    <th colspan="60" style="text-align: center !important;">हिंदुस्तान प्रकाशन संस्था - विवेक साप्ताहिक
                        - वर्गणी विभाग</th>
                    <th colspan="10" style="text-align: center !important;">Date</th>
                    <th colspan="10" style="text-align: center !important;">From {{startDate}}</th>
                    <!-- <th colspan="2">To {{endDate}}</th>
                     <th colspan="1">In Details</th>  -->
                </tr>
                <tr>
                    <th colspan="30" style="text-align: center !important;">वर्गणीदार नोंदणी - नवीन व्यवसाय तपशिल </th>
                    <th colspan="10" style="text-align: center !important;">कोकण</th>
                    <th colspan="10" style="text-align: center !important;">Districtwise</th>
                    <th colspan="10" style="text-align: center !important;">Very Briefly</th>
                    <th colspan="10" style="text-align: center !important;">From</th>
                    <th colspan="10" style="text-align: center !important;">To</th>
                </tr>
                <tr>
                    <th colspan="4"
                        style="border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        नूतनीकरण येणे बाकी</th>
                    <th colspan="12"
                        style="border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        एप्रिल</th>
                    <th colspan="12"
                        style="border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        मे</th>
                    <th colspan="12"
                        style="border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        जून</th>
                    <th colspan="12"
                        style="border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        जुलै</th>
                    <th colspan="12"
                        style="border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        ऑगस्ट</th>
                    <th colspan="12"
                        style="border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        सप्टेंबर</th>
                    <th colspan="12"
                        style="border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        ऑक्टोबर</th>
                    <th colspan="12"
                        style="border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        नोव्हेंबर</th>
                    <th colspan="12"
                        style="border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        डिसेंबर</th>
                    <th colspan="12"
                        style="border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        जानेवारी</th>
                    <th colspan="12"
                        style="border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        फेब्रुवारी</th>
                    <th colspan="12"
                        style="border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        मार्च</th>
                    <th colspan="12"
                        style="border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        एकूण</th>
                </tr>
                <tr>
                    <th colspan="2"
                        style="border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        जिल्हा</th>
                    <th colspan="2" style="border-bottom: 2px solid black; border-right: 2px solid black;">तालुका</th>
                    <!-- <th colspan="2">Reprensantive</th> -->


                    <!-- april-->
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">हस्ते</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">मॅगझीन पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">डिजिटल</th>
                    <!-- april-->
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">हस्ते</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">मॅगझीन पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">डिजिटल</th>
                    <!-- april-->
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">हस्ते</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">मॅगझीन पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">डिजिटल</th>
                    <!-- april-->
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">हस्ते</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">मॅगझीन पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">डिजिटल</th>
                    <!-- april-->
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">हस्ते</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">मॅगझीन पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">डिजिटल</th>
                    <!-- april-->
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">हस्ते</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">मॅगझीन पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">डिजिटल</th>
                    <!-- april-->
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">हस्ते</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">मॅगझीन पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">डिजिटल</th>
                    <!-- april-->
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">हस्ते</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">मॅगझीन पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">डिजिटल</th>
                    <!-- april-->
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">हस्ते</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">मॅगझीन पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">डिजिटल</th>
                    <!-- april-->
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">हस्ते</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">मॅगझीन पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">डिजिटल</th>
                    <!-- april-->
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">हस्ते</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">मॅगझीन पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">डिजिटल</th>
                    <!-- april-->
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">हस्ते</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">मॅगझीन पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">डिजिटल</th>
                    <!-- <th colspan="4"></th> -->

                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">हस्ते</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">मॅगझीन पोस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-bottom: 2px solid black; border-right: 2px solid black;"
                        class="br-left">डिजिटल</th>
                    <!-- <th colspan="4"></th> -->
                </tr>
                <tr>
                    <th colspan="4"
                        style="border-left: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                    </th>
                    <th style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>

                    <th style="border-bottom: 2px solid black;">जमा</th>
                    <th style="border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">एकूण</th>



                </tr>
            </thead>
            <!-- *ngFor="let data of OutstandingInDetailFormBeans; let i = index" -->
            <tbody>
                <ng-container *ngFor="let data3 of SubRemRep; let i = index">

                    <tr>
                        <td colspan="4"
                            style="border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 2px solid black;">
                            {{data3.rep_name}}</td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>

                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>

                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>

                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>

                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>

                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>

                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>

                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>

                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>

                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>

                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>

                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>

                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-left" style="border-right: 2px solid black;"></td>
                        <td colspan="3" class="br-right" style="border-right: 2px solid black;"></td>

                    </tr>


                    <tr *ngFor="let data of data3.rep_info; let i = index">
                        <td colspan="2"
                            style="border-left: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data.district}}</td>
                        <td colspan="2" style="border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data.taluka}}</td>
                        <!-- <td colspan="1">{{data.off_rep}}</td> -->
                        <td style="text-align: right;">{{data.tapal_New_4}}</td>
                        <td style="text-align: right;">{{data.tapal_Renew_4}}</td>
                        <td style="text-align: right; border-right: 2px solid black;">{{data.tapal_Total_4}}</td>
                        <td style="text-align: right;">{{data.haste_New_4}}</td>
                        <td style="text-align: right;">{{data.haste_Renew_4}}</td>
                        <td style="text-align: right; border-right: 2px solid black;">{{data.haste_Total_4}}</td>
                        <td style="text-align: right;">{{data.magzine_New_4}}</td>
                        <td style="text-align: right;">{{data.magzine_Renew_4}}</td>
                        <td style="text-align: right; border-right: 2px solid black;">{{data.magzine_Total_4}}</td>
                        <td style="text-align: right;">{{data.digital_New_4}}</td>
                        <td style="text-align: right;">{{data.digital_Renew_4}}</td>
                        <td style="text-align: right; border-right: 2px solid black;">{{data.digital_Total_4}}</td>

                        <td style="text-align: right;">{{data.tapal_New_5}}</td>
                        <td style="text-align: right;">{{data.tapal_Renew_5}}</td>
                        <td style="text-align: right; border-right: 2px solid black;">{{data.tapal_Total_5}}</td>
                        <td style="text-align: right;">{{data.haste_New_5}}</td>
                        <td style="text-align: right;">{{data.haste_Renew_5}}</td>
                        <td style="text-align: right; border-right: 2px solid black;">{{data.haste_Total_5}}</td>
                        <td style="text-align: right;">{{data.magzine_New_5}}</td>
                        <td style="text-align: right;">{{data.magzine_Renew_5}}</td>
                        <td style="text-align: right; border-right: 2px solid black;">{{data.magzine_Total_5}}</td>
                        <td style="text-align: right;">{{data.digital_New_5}}</td>
                        <td style="text-align: right;">{{data.digital_Renew_5}}</td>
                        <td style="text-align: right; border-right: 2px solid black;">{{data.digital_Total_5}}</td>

                        <td style="text-align: right;">{{data.tapal_New_6}}</td>
                        <td style="text-align: right;">{{data.tapal_Renew_6}}</td>
                        <td style="text-align: right; border-right: 2px solid black;">{{data.tapal_Total_6}}</td>
                        <td style="text-align: right;">{{data.haste_New_6}}</td>
                        <td style="text-align: right;">{{data.haste_Renew_6}}</td>
                        <td style="text-align: right; border-right: 2px solid black;">{{data.haste_Total_6}}</td>
                        <td style="text-align: right;">{{data.magzine_New_6}}</td>
                        <td style="text-align: right;">{{data.magzine_Renew_6}}</td>
                        <td style="text-align: right; border-right: 2px solid black;">{{data.magzine_Total_6}}</td>
                        <td style="text-align: right;">{{data.digital_New_6}}</td>
                        <td style="text-align: right;">{{data.digital_Renew_6}}</td>
                        <td style="text-align: right; border-right: 2px solid black;">{{data.digital_Total_6}}</td>

                        <td style="text-align: right;">{{data.tapal_New_7}}</td>
                        <td style="text-align: right;">{{data.tapal_Renew_7}}</td>
                        <td style="text-align: right; border-right: 2px solid black;">{{data.tapal_Total_7}}</td>
                        <td style="text-align: right;">{{data.haste_New_7}}</td>
                        <td style="text-align: right;">{{data.haste_Renew_7}}</td>
                        <td style="text-align: right; border-right: 2px solid black;">{{data.haste_Total_7}}</td>
                        <td style="text-align: right;">{{data.magzine_New_7}}</td>
                        <td style="text-align: right;">{{data.magzine_Renew_7}}</td>
                        <td style="text-align: right; border-right: 2px solid black;">{{data.magzine_Total_7}}</td>
                        <td style="text-align: right;">{{data.digital_New_7}}</td>
                        <td style="text-align: right;">{{data.digital_Renew_7}}</td>
                        <td style="text-align: right; border-right: 2px solid black;">{{data.digital_Total_7}}</td>

                        <td style="text-align: right;">{{data.tapal_New_8}}</td>
                        <td style="text-align: right;">{{data.tapal_Renew_8}}</td>
                        <td style="text-align: right; border-right: 2px solid black;">{{data.tapal_Total_8}}</td>
                        <td style="text-align: right;">{{data.haste_New_8}}</td>
                        <td style="text-align: right;">{{data.haste_Renew_8}}</td>
                        <td style="text-align: right; border-right: 2px solid black;">{{data.haste_Total_8}}</td>
                        <td style="text-align: right;">{{data.magzine_New_8}}</td>
                        <td style="text-align: right;">{{data.magzine_Renew_8}}</td>
                        <td style="text-align: right; border-right: 2px solid black;">{{data.magzine_Total_8}}</td>
                        <td style="text-align: right;">{{data.digital_New_8}}</td>
                        <td style="text-align: right;">{{data.digital_Renew_8}}</td>
                        <td style="text-align: right; border-right: 2px solid black;">{{data.digital_Total_7}}</td>

                        <td style="text-align: right;">{{data.tapal_New_9}}</td>
                        <td style="text-align: right;">{{data.tapal_Renew_9}}</td>
                        <td style="text-align: right; border-right: 2px solid black;">{{data.tapal_Total_9}}</td>
                        <td style="text-align: right;">{{data.haste_New_9}}</td>
                        <td style="text-align: right;">{{data.haste_Renew_9}}</td>
                        <td style="text-align: right; border-right: 2px solid black;">{{data.haste_Total_9}}</td>
                        <td style="text-align: right;">{{data.magzine_New_9}}</td>
                        <td style="text-align: right;">{{data.magzine_Renew_9}}</td>
                        <td style="text-align: right; border-right: 2px solid black;">{{data.magzine_Total_9}}</td>
                        <td style="text-align: right;">{{data.digital_New_9}}</td>
                        <td style="text-align: right;">{{data.digital_Renew_9}}</td>
                        <td style="text-align: right; border-right: 2px solid black;">{{data.digital_Total_9}}</td>

                        <td style="text-align: right;">{{data.tapal_New_10}}</td>
                        <td style="text-align: right;">{{data.tapal_Renew_10}}</td>
                        <td style="text-align: right; border-right: 2px solid black;">{{data.tapal_Total_10}}</td>
                        <td style="text-align: right;">{{data.haste_New_10}}</td>
                        <td style="text-align: right;">{{data.haste_Renew_10}}</td>
                        <td style="text-align: right; border-right: 2px solid black;">{{data.haste_Total_10}}</td>
                        <td style="text-align: right;">{{data.magzine_New_10}}</td>
                        <td style="text-align: right;">{{data.magzine_Renew_10}}</td>
                        <td style="text-align: right; border-right: 2px solid black;">{{data.magzine_Total_10}}</td>
                        <td style="text-align: right;">{{data.digital_New_10}}</td>
                        <td style="text-align: right;">{{data.digital_Renew_10}}</td>
                        <td style="text-align: right; border-right: 2px solid black;">{{data.digital_Total_10}}</td>

                        <td style="text-align: right;">{{data.tapal_New_11}}</td>
                        <td style="text-align: right;">{{data.tapal_Renew_11}}</td>
                        <td style="text-align: right; border-right: 2px solid black;">{{data.tapal_Total_11}}</td>
                        <td style="text-align: right;">{{data.haste_New_11}}</td>
                        <td style="text-align: right;">{{data.haste_Renew_11}}</td>
                        <td style="text-align: right; border-right: 2px solid black;">{{data.haste_Total_11}}</td>
                        <td style="text-align: right;">{{data.magzine_New_11}}</td>
                        <td style="text-align: right;">{{data.magzine_Renew_11}}</td>
                        <td style="text-align: right; border-right: 2px solid black;">{{data.magzine_Total_11}}</td>
                        <td style="text-align: right;">{{data.digital_New_11}}</td>
                        <td style="text-align: right;">{{data.digital_Renew_11}}</td>
                        <td style="text-align: right; border-right: 2px solid black;">{{data.digital_Total_11}}</td>


                        <td style="text-align: right;">{{data.tapal_New_12}}</td>
                        <td style="text-align: right;">{{data.tapal_Renew_12}}</td>
                        <td style="text-align: right; border-right: 2px solid black;">{{data.tapal_Total_12}}</td>
                        <td style="text-align: right;">{{data.haste_New_12}}</td>
                        <td style="text-align: right;">{{data.haste_Renew_12}}</td>
                        <td style="text-align: right; border-right: 2px solid black;">{{data.haste_Total_12}}</td>
                        <td style="text-align: right;">{{data.magzine_New_12}}</td>
                        <td style="text-align: right;">{{data.magzine_Renew_12}}</td>
                        <td style="text-align: right; border-right: 2px solid black;">{{data.magzine_Total_12}}</td>
                        <td style="text-align: right;">{{data.digital_New_12}}</td>
                        <td style="text-align: right;">{{data.digital_Renew_12}}</td>
                        <td style="text-align: right; border-right: 2px solid black;">{{data.digital_Total_12}}</td>


                        <td style="text-align: right;">{{data.tapal_New_1}}</td>
                        <td style="text-align: right;">{{data.tapal_Renew_1}}</td>
                        <td style="text-align: right; border-right: 2px solid black;">{{data.tapal_Total_1}}</td>
                        <td style="text-align: right;">{{data.haste_New_1}}</td>
                        <td style="text-align: right;">{{data.haste_Renew_1}}</td>
                        <td style="text-align: right; border-right: 2px solid black;">{{data.haste_Total_1}}</td>
                        <td style="text-align: right;">{{data.magzine_New_1}}</td>
                        <td style="text-align: right;">{{data.magzine_Renew_1}}</td>
                        <td style="text-align: right; border-right: 2px solid black;">{{data.magzine_Total_1}}</td>
                        <td style="text-align: right;">{{data.digital_New_1}}</td>
                        <td style="text-align: right;">{{data.digital_Renew_1}}</td>
                        <td style="text-align: right; border-right: 2px solid black;">{{data.digital_Total_1}}</td>


                        <td style="text-align: right;">{{data.tapal_New_2}}</td>
                        <td style="text-align: right;">{{data.tapal_Renew_2}}</td>
                        <td style="text-align: right; border-right: 2px solid black;">{{data.tapal_Total_2}}</td>
                        <td style="text-align: right;">{{data.haste_New_2}}</td>
                        <td style="text-align: right;">{{data.haste_Renew_2}}</td>
                        <td style="text-align: right; border-right: 2px solid black;">{{data.haste_Total_2}}</td>
                        <td style="text-align: right;">{{data.magzine_New_2}}</td>
                        <td style="text-align: right;">{{data.magzine_Renew_2}}</td>
                        <td style="text-align: right; border-right: 2px solid black;">{{data.magzine_Total_2}}</td>
                        <td style="text-align: right;">{{data.digital_New_2}}</td>
                        <td style="text-align: right;">{{data.digital_Renew_2}}</td>
                        <td style="text-align: right; border-right: 2px solid black;">{{data.digital_Total_2}}</td>


                        <td style="text-align: right;">{{data.tapal_New_3}}</td>
                        <td style="text-align: right;">{{data.tapal_Renew_3}}</td>
                        <td style="text-align: right; border-right: 2px solid black;">{{data.tapal_Total_3}}</td>
                        <td style="text-align: right;">{{data.haste_New_3}}</td>
                        <td style="text-align: right;">{{data.haste_Renew_3}}</td>
                        <td style="text-align: right; border-right: 2px solid black;">{{data.haste_Total_3}}</td>
                        <td style="text-align: right;">{{data.magzine_New_3}}</td>
                        <td style="text-align: right;">{{data.magzine_Renew_3}}</td>
                        <td style="text-align: right; border-right: 2px solid black;">{{data.magzine_Total_3}}</td>
                        <td style="text-align: right;">{{data.digital_New_3}}</td>
                        <td style="text-align: right;">{{data.digital_Renew_3}}</td>
                        <td style="text-align: right; border-right: 2px solid black;">{{data.digital_Total_3}}</td>


                        <td style="text-align: right;">{{data.tapal_New_3}}</td>
                        <td style="text-align: right;">{{data.tapal_Renew_3}}</td>
                        <td style="text-align: right; border-right: 2px solid black;">{{data.tapal_Total_3}}</td>
                        <td style="text-align: right;">{{data.haste_New_3}}</td>
                        <td style="text-align: right;">{{data.haste_Renew_3}}</td>
                        <td style="text-align: right; border-right: 2px solid black;">{{data.haste_Total_3}}</td>
                        <td style="text-align: right;">{{data.magzine_New_3}}</td>
                        <td style="text-align: right;">{{data.magzine_Renew_3}}</td>
                        <td style="text-align: right; border-right: 2px solid black;">{{data.magzine_Total_3}}</td>
                        <td style="text-align: right;">{{data.digital_New_3}}</td>
                        <td style="text-align: right;">{{data.digital_Renew_3}}</td>
                        <td style="text-align: right; border-right: 2px solid black;">{{data.digital_Total_3}}</td>


                    </tr>
                    <tr>
                        <td colspan="4"
                            style="font-weight: bold; text-align: right; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                            एकूण</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.tapal_New_4}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.tapal_Renew_4}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.tapal_Total_4}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.haste_New_4}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.haste_Renew_4}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.haste_Total_4}}</td>

                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.magzine_New_4}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.magzine_Renew_4}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.magzine_Total_4}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.digital_New_4}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.digital_Renew_4}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.digital_Total_4}}</td>

                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.tapal_New_5}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.tapal_Renew_5}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.tapal_Total_5}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.haste_New_5}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.haste_Renew_5}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.haste_Total_5}}</td>

                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.magzine_New_5}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.magzine_Renew_5}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.magzine_Total_5}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.digital_New_5}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.digital_Renew_5}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.digital_Total_5}}</td>

                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.tapal_New_6}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.tapal_Renew_6}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.tapal_Total_6}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.haste_New_6}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.haste_Renew_6}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.haste_Total_6}}</td>

                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.magzine_New_6}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.magzine_Renew_6}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.magzine_Total_6}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.digital_New_6}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.digital_Renew_6}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.digital_Total_6}}</td>

                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.tapal_New_7}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.tapal_Renew_7}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.tapal_Total_7}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.haste_New_7}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.haste_Renew_7}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.haste_Total_7}}</td>

                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.magzine_New_7}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.magzine_Renew_7}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.magzine_Total_7}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.digital_New_7}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.digital_Renew_7}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.digital_Total_7}}</td>

                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.tapal_New_8}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.tapal_Renew_8}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.tapal_Total_8}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.haste_New_8}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.haste_Renew_8}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.haste_Total_8}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.magzine_New_8}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.magzine_Renew_8}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.magzine_Total_8}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.digital_New_8}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.digital_Renew_8}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.digital_Total_8}}</td>

                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.tapal_New_9}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.tapal_Renew_9}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.tapal_Total_9}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.haste_New_9}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.haste_Renew_9}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.haste_Total_9}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.magzine_New_9}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.magzine_Renew_9}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.magzine_Total_9}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.digital_New_9}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.digital_Renew_9}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.digital_Total_9}}</td>

                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.tapal_New_10}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.tapal_Renew_10}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.tapal_Total_10}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.haste_New_10}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.haste_Renew_10}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.haste_Total_10}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.magzine_New_10}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.magzine_Renew_10}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.magzine_Total_10}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.digital_New_10}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.digital_Renew_10}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.digital_Total_10}}</td>

                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.tapal_New_11}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.tapal_Renew_11}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.tapal_Total_11}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.haste_New_11}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.haste_Renew_11}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.haste_Total_11}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.magzine_New_11}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.magzine_Renew_11}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.magzine_Total_11}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.digital_New_11}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.digital_Renew_11}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.digital_Total_11}}</td>

                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.tapal_New_12}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.tapal_Renew_12}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.tapal_Total_12}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.haste_New_12}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.haste_Renew_12}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.haste_Total_12}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.magzine_New_12}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.magzine_Renew_12}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.magzine_Total_12}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.digital_New_12}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.digital_Renew_12}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.digital_Total_12}}</td>

                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.tapal_New_1}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.tapal_Renew_1}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.tapal_Total_1}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.haste_New_1}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.haste_Renew_1}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.haste_Total_1}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.magzine_New_1}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.magzine_Renew_1}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.magzine_Total_1}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.digital_New_1}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.digital_Renew_1}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.digital_Total_1}}</td>

                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.tapal_New_2}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.tapal_Renew_2}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.tapal_Total_2}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.haste_New_2}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.haste_Renew_2}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.haste_Total_2}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.magzine_New_2}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.magzine_Renew_2}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.magzine_Total_2}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.digital_New_2}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.digital_Renew_2}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.digital_Total_2}}</td>

                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.tapal_New_3}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.tapal_Renew_3}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.tapal_Total_3}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.haste_New_3}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.haste_Renew_3}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.haste_Total_3}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.magzine_New_3}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.magzine_Renew_3}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.magzine_Total_3}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.digital_New_3}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.digital_Renew_3}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.digital_Total_3}}</td>

                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.tapal_New_total}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.tapal_Renew_total}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.tapal_Total_Total}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.haste_New_total}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.haste_Renew_total}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.haste_Total_Total}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.magzine_New_total}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.magzine_Renew_total}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.magzine_Total_Total}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.digital_New_total}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.digital_Renew_total}}</td>
                        <td
                            style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                            {{data3.digital_Total_Total}}</td>
                    </tr>

                </ng-container>



            </tbody>

            <tfoot>
                <tr>
                    <td colspan="4"
                        style="font-weight: bold; color: black; text-align: center; font-size: 14px; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        महिना एकूण</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{tapal_New_4}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{tapal_Renew_4}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{tapal_Total_4}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{haste_New_4}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{haste_Renew_4}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{haste_Total_4}}</td>

                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{magzine_New_4}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{magzine_Renew_4}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{magzine_Total_4}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{digital_New_4}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{digital_Renew_4}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{digital_Total_4}}</td>

                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{tapal_New_5}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{tapal_Renew_5}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{tapal_Total_5}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{haste_New_5}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{haste_Renew_5}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{haste_Total_5}}</td>

                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{magzine_New_5}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{magzine_Renew_5}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{magzine_Total_5}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{digital_New_5}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{digital_Renew_5}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{digital_Total_5}}</td>

                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{data.tapal_New_6}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{tapal_Renew_6}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{tapal_Total_6}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{haste_New_6}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{haste_Renew_6}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{haste_Total_6}}</td>

                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{magzine_New_6}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{magzine_Renew_6}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{magzine_Total_6}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{digital_New_6}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{digital_Renew_6}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{digital_Total_6}}</td>

                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{tapal_New_7}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{tapal_Renew_7}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{tapal_Total_7}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{haste_New_7}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{haste_Renew_7}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{haste_Total_7}}</td>

                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{magzine_New_7}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{magzine_Renew_7}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{magzine_Total_7}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{digital_New_7}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{digital_Renew_7}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{digital_Total_7}}</td>

                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{tapal_New_8}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{tapal_Renew_8}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{tapal_Total_8}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{haste_New_8}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{haste_Renew_8}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{haste_Total_8}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{magzine_New_8}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{magzine_Renew_8}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{magzine_Total_8}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{digital_New_8}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{digital_Renew_8}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{digital_Total_8}}</td>

                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{tapal_New_9}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{tapal_Renew_9}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{tapal_Total_9}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{haste_New_9}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{haste_Renew_9}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{haste_Total_9}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{magzine_New_9}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{magzine_Renew_9}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{magzine_Total_9}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{digital_New_9}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{digital_Renew_9}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{digital_Total_9}}</td>

                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{tapal_New_10}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{tapal_Renew_10}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{tapal_Total_10}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{haste_New_10}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{haste_Renew_10}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{haste_Total_10}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{magzine_New_10}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{magzine_Renew_10}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{magzine_Total_10}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{digital_New_10}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{digital_Renew_10}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{digital_Total_10}}</td>

                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{tapal_New_11}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{tapal_Renew_11}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{tapal_Total_11}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{haste_New_11}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{haste_Renew_11}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{haste_Total_11}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{magzine_New_11}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{magzine_Renew_11}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{magzine_Total_11}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{digital_New_11}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{digital_Renew_11}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{digital_Total_11}}</td>

                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{tapal_New_12}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{tapal_Renew_12}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{tapal_Total_12}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{haste_New_12}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{haste_Renew_12}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{haste_Total_12}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{magzine_New_12}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{magzine_Renew_12}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{magzine_Total_12}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{digital_New_12}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{digital_Renew_12}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{digital_Total_12}}</td>

                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{tapal_New_1}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{tapal_Renew_1}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{tapal_Total_1}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{haste_New_1}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{haste_Renew_1}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{haste_Total_1}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{magzine_New_1}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{magzine_Renew_1}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{magzine_Total_1}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{digital_New_1}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{digital_Renew_1}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{digital_Total_1}}</td>

                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{tapal_New_2}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{tapal_Renew_2}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{tapal_Total_2}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{haste_New_2}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{haste_Renew_2}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{haste_Total_2}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{magzine_New_2}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{magzine_Renew_2}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{magzine_Total_2}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{digital_New_2}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{digital_Renew_2}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{digital_Total_2}}</td>

                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{tapal_New_3}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{tapal_Renew_3}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{tapal_Total_3}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{haste_New_3}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{haste_Renew_3}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{haste_Total_3}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{magzine_New_3}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{magzine_Renew_3}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{magzine_Total_3}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{digital_New_3}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{digital_Renew_3}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{digital_Total_3}}</td>

                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{tapal_New_total}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{tapal_Renew_total}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{tapal_Total_total}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{haste_New_total}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{haste_Renew_total}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{haste_Total_total}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{magzine_New_total}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{magzine_Renew_total}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{magzine_Total_total}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{digital_New_total}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{digital_Renew_total}}</td>
                    <td
                        style="color: black; font-weight: bold; text-align: right; font-size: 14px; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        {{digital_Total_total }}</td>
                </tr>
            </tfoot>
        </table>


    </div>
    <div style="margin-left: 80%; margin-bottom: 2%;">
        <!-- <button class="noPrint" style="margin-top: 2%;" mat-raised-button color="primary"
            [printStyle]="{table : {'border-collapse':'collapse'}, td : {'border': 'solid 1px'}, th : {'border': 'solid 1px'}}"
            printSectionId="print-section2" ngxPrint>
            print
        </button> -->
        <button class="noPrint" style="margin-top: 2%; margin-left: 2%;"
            (click)="exportExcel19('Remaining_Subscription_Reprensantive')" mat-raised-button color="primary">
            Export
        </button>

        <button class="noPrint" style="margin-top: 2%; margin-left: 2%;" mat-raised-button color="primary"
            [useExistingCss]="true" printSectionId="print-section" ngxPrint>
            Print
        </button>

        <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>
            Close
        </button>
    </div>
</div>










<div class="table-container" *ngIf="reportType == 'RemainingSubscriptionReprensantiveOffvb'">
    <div id="print-section1" class="container">

        <table class="fixed-header">
            <thead>
                <tr>
                    <th colspan="37"
                        style="text-align: center !important; font-size: 13px; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black;">
                        हिंदुस्तान प्रकाशन संस्था - विवेक साप्ताहिक - वर्गणी विभाग रिपोर्ट वर्गणीदार नूतनीकरण व्यवसाय
                        जमा </th>
                    <th colspan="6"
                        style="text-align: center !important; border-right: 2px solid black; border-top: 2px solid black;">
                        दिनांक {{ currentDate | date: 'dd-MM-yyyy' }}
                </tr>
                <tr>
                    <th colspan="31"
                        style="text-align: center !important; font-size: 11px; padding-left: 15%; border-left: 2px solid black;">
                        संक्षिप्त बाकी तपशील</th>
                    <!-- <th colspan="12" style="text-align: center !important;font-size: 20 !important;font-weight: 600;">दिनांक   {{ currentDate | date: 'dd-MM-yyyy' }} </th> -->
                    <th colspan="6"
                        style="text-align: center !important; border-right: 2px solid black; border-left: 2px solid black;">
                        दिनांक पासून:{{startDate | date: 'dd-MM-yyyy'}}</th>
                    <th colspan="6" style="text-align: center !important; border-right: 2px solid black;"> पर्यंत:
                        {{endDate | date: 'dd-MM-yyyy'}}</th>
                </tr>
                <!-- <tr>
                    <th colspan="19" style="text-align: center !important;"> वर्गणीदार नूतनीकरण व्यवसाय तपशिल </th>
                    <th colspan="12" style="text-align: center !important;">जमा बाकी तपशील</th>
                    <th colspan="6" style="text-align: center !important;">दिनांक पासून:{{startDate | date: 'dd-MM-yyyy'}}</th>
                    <th colspan="6" style="text-align: center !important;"> पर्यंत: {{endDate  | date: 'dd-MM-yyyy'}}</th>
                    
                </tr> -->
                <tr>
                    <th colspan="4" style="border-right: 2px solid black; border-left: 2px solid black;"> </th>

                    <th colspan="3"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black;  border-bottom: 2px solid black;">
                        एप्रिल</th>
                    <th colspan="3"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black;  border-bottom: 2px solid black;">
                        मे</th>
                    <th colspan="3"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black;  border-bottom: 2px solid black;">
                        जून</th>
                    <th colspan="3"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black;  border-bottom: 2px solid black;">
                        जुलै</th>
                    <th colspan="3"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black;  border-bottom: 2px solid black;">
                        ऑगस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black;  border-bottom: 2px solid black;">
                        सप्टेंबर</th>
                    <th colspan="3"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black;  border-bottom: 2px solid black;">
                        ऑक्टोबर</th>
                    <th colspan="3"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black;  border-bottom: 2px solid black;">
                        नोव्हेंबर</th>
                    <th colspan="3"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black;  border-bottom: 2px solid black;">
                        डिसेंबर</th>
                    <th colspan="3"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black;  border-bottom: 2px solid black;">
                        जानेवारी</th>
                    <th colspan="3"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black;  border-bottom: 2px solid black;">
                        फेब्रुवारी</th>
                    <th colspan="3"
                        style="text-align: center; border-left: 2px solid black; border-top: 2px solid black;  border-bottom: 2px solid black;">
                        मार्च</th>
                    <th colspan="3"
                        style="text-align: center; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black;  border-bottom: 2px solid black;">
                        एकूण</th>
                </tr>
                <tr>
                    <th colspan="4"
                        style="border-left: 2px solid black; overflow-wrap: break-word; border-bottom: 2px solid black;">
                        <b>कार्यालयीन प्रतिनिधीचे नाव</b>
                    </th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">जमा</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">एकूण</th>

                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">जमा</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">एकूण</th>

                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">जमा</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">एकूण</th>

                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">जमा</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">एकूण</th>

                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">जमा</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">एकूण</th>

                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">जमा</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">एकूण</th>

                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">जमा</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">एकूण</th>

                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">जमा</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">एकूण</th>

                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">जमा</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">एकूण</th>

                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">जमा</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">एकूण</th>

                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">जमा</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">एकूण</th>

                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">जमा</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">बाकी</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">एकूण</th>


                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">जमा</th>
                    <th style="border-left: 2px solid black; border-bottom: 2px solid black;">बाकी</th>
                    <th
                        style="border-right: 2px solid black; border-left: 2px solid black; border-bottom: 2px solid black;">
                        एकूण</th>
                </tr>
            </thead>
            <!-- *ngFor="let data of OutstandingInDetailFormBeans; let i = index" -->
            <tbody *ngFor="let data1 of SubRemOffVBriefly; let i = index">
                <tr>
                    <td colspan="4"
                        style="border-left: 2px solid black; font-weight: bolder; overflow-wrap: break-word;">
                        {{data1.office_rep_name}}</td>

                    <td style="text-align: right;border-left: 2px solid black;">{{data1.New_4}}</td>
                    <td style="text-align: right;">{{data1.Renew_4}}</td>
                    <td style="text-align: right;">{{data1.Total_4}}</td>

                    <td style="text-align: right;border-left: 2px solid black;">{{data1.New_5}}</td>
                    <td style="text-align: right;">{{data1.Renew_5}}</td>
                    <td style="text-align: right;">{{data1.Total_5}}</td>

                    <td style="text-align: right;border-left: 2px solid black;">{{data1.New_6}}</td>
                    <td style="text-align: right;">{{data1.Renew_6}}</td>
                    <td style="text-align: right;">{{data1.Total_6}}</td>

                    <td style="text-align: right;border-left: 2px solid black;">{{data1.New_7}}</td>
                    <td style="text-align: right;">{{data1.Renew_7}}</td>
                    <td style="text-align: right;">{{data1.Total_7}}</td>


                    <td style="text-align: right;border-left: 2px solid black;">{{data1.New_8}}</td>
                    <td style="text-align: right;">{{data1.Renew_8}}</td>
                    <td style="text-align: right;">{{data1.Total_8}}</td>

                    <td style="text-align: right;border-left: 2px solid black;">{{data1.New_9}}</td>
                    <td style="text-align: right;">{{data1.Renew_9}}</td>
                    <td style="text-align: right;">{{data1.Total_9}}</td>

                    <td style="text-align: right;border-left: 2px solid black;">{{data1.New_10}}</td>
                    <td style="text-align: right;">{{data1.Renew_10}}</td>
                    <td style="text-align: right;">{{data1.Total_10}}</td>

                    <td style="text-align: right;border-left: 2px solid black;">{{data1.New_11}}</td>
                    <td style="text-align: right;">{{data1.Renew_11}}</td>
                    <td style="text-align: right;">{{data1.Total_11}}</td>

                    <td style="text-align: right;border-left: 2px solid black;">{{data1.New_12}}</td>
                    <td style="text-align: right;">{{data1.Renew_12}}</td>
                    <td style="text-align: right;">{{data1.Total_12}}</td>

                    <td style="text-align: right;border-left: 2px solid black;">{{data1.New_1}}</td>
                    <td style="text-align: right;">{{data1.Renew_1}}</td>
                    <td style="text-align: right;">{{data1.Total_1}}</td>

                    <td style="text-align: right;border-left: 2px solid black;">{{data1.New_2}}</td>
                    <td style="text-align: right;">{{data1.Renew_2}}</td>
                    <td style="text-align: right;">{{data1.Total_2}}</td>

                    <td style="text-align: right;border-left: 2px solid black;">{{data1.New_3}}</td>
                    <td style="text-align: right;">{{data1.Renew_3}}</td>
                    <td style="text-align: right;">{{data1.Total_3}}</td>

                    <td style="text-align: right;border-left: 2px solid black;">{{data1.new_total}}</td>
                    <td style="text-align: right;">{{data1.renew_total}}</td>
                    <td style="text-align: right;border-right: 2px solid black;">{{data1.total_total}}</td>


                </tr>

            </tbody>

            <tfoot>
                <tr>
                    <td colspan="4"
                        style="color: black; text-align: left;font-size: 14px; border-left: 2px solid black; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        <b>एकूण :- </b>
                    </td>


                    <td
                        style="color: black; font-size: 14px; font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black;">
                        {{total_New_4}}</td>
                    <td
                        style="color: black; font-size: 14px; font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black;">
                        {{total_Renew_4}}</td>
                    <td
                        style="color: black; font-size: 14px; font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{total_Total_4}}</td>

                    <td
                        style="color: black; font-size: 14px; font-weight: bold; text-align: right; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black;">
                        {{total_New_5}}</td>
                    <td
                        style="color: black; font-size: 14px; font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black;">
                        {{total_Renew_5}}</td>
                    <td
                        style="color: black; font-size: 14px; font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{total_Total_5}}</td>

                    <td
                        style="color: black; font-size: 14px; font-weight: bold; text-align: right; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black;">
                        {{total_New_6}}</td>
                    <td
                        style="color: black; font-size: 14px; font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black;">
                        {{total_Renew_6}}</td>
                    <td
                        style="color: black; font-size: 14px; font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{total_Total_6}}</td>

                    <td
                        style="color: black; font-size: 14px; font-weight: bold; text-align: right; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black;">
                        {{total_New_7}}</td>
                    <td
                        style="color: black; font-size: 14px; font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black;">
                        {{total_Renew_7}}</td>
                    <td
                        style="color: black; font-size: 14px; font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{total_Total_7}}</td>

                    <td
                        style="color: black; font-size: 14px; font-weight: bold; text-align: right; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black;">
                        {{total_New_8}}</td>
                    <td
                        style="color: black; font-size: 14px; font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black;">
                        {{total_Renew_8}}</td>
                    <td
                        style="color: black; font-size: 14px; font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{total_Total_8}}</td>

                    <td
                        style="color: black; font-size: 14px; font-weight: bold; text-align: right; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black;">
                        {{total_New_9}}</td>
                    <td
                        style="color: black; font-size: 14px; font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black;">
                        {{total_Renew_9}}</td>
                    <td
                        style="color: black; font-size: 14px; font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{total_Total_9}}</td>

                    <td
                        style="color: black; font-size: 14px; font-weight: bold; text-align: right; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black;">
                        {{total_New_10}}</td>
                    <td
                        style="color: black; font-size: 14px; font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black;">
                        {{total_Renew_10}}</td>
                    <td
                        style="color: black; font-size: 14px; font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{total_Total_10}}</td>

                    <td
                        style="color: black; font-size: 14px; font-weight: bold; text-align: right; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black;">
                        {{total_New_11}}</td>
                    <td
                        style="color: black; font-size: 14px; font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black;">
                        {{total_Renew_11}}</td>
                    <td
                        style="color: black; font-size: 14px; font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{total_Total_11}}</td>

                    <td
                        style="color: black; font-size: 14px; font-weight: bold; text-align: right; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black;">
                        {{total_New_12}}</td>
                    <td
                        style="color: black; font-size: 14px; font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black;">
                        {{total_Renew_12}}</td>
                    <td
                        style="color: black; font-size: 14px; font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{total_Total_12}}</td>

                    <td
                        style="color: black; font-size: 14px; font-weight: bold; text-align: right; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black;">
                        {{total_New_1}}</td>
                    <td
                        style="color: black; font-size: 14px; font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black;">
                        {{total_Renew_1}}</td>
                    <td
                        style="color: black; font-size: 14px; font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{total_Total_1}}</td>

                    <td
                        style="color: black; font-size: 14px; font-weight: bold; text-align: right; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black;">
                        {{total_New_2}}</td>
                    <td
                        style="color: black; font-size: 14px; font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black;">
                        {{total_Renew_2}}</td>
                    <td
                        style="color: black; font-size: 14px; font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{total_Total_2}}</td>

                    <td
                        style="color: black; font-size: 14px; font-weight: bold; text-align: right; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black;">
                        {{total_New_3}}</td>
                    <td
                        style="color: black; font-size: 14px; font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black;">
                        {{total_Renew_3}}</td>
                    <td
                        style="color: black; font-size: 14px; font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{total_Total_3}}</td>

                    <td
                        style="color: black; font-size: 14px; font-weight: bold; text-align: right; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black; border-right: 1px solid black;">
                        {{total_New_total}}</td>
                    <td
                        style="color: black; font-size: 14px; font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black;">
                        {{total_Renew_total}}</td>
                    <td
                        style="color: black; font-size: 14px; font-weight: bold; text-align: right; border-right: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_Total_total}}</td>

                </tr>
            </tfoot>
        </table>


    </div>
    <div style="margin-left: 80%; margin-bottom: 2%;">
        <!-- <button class="noPrint" style="margin-top: 2%;" mat-raised-button color="primary"
            [printStyle]="{table : {'border-collapse':'collapse'}, td : {'border': 'solid 1px'}, th : {'border': 'solid 1px'}}"
            printSectionId="print-section2" ngxPrint>
            print
        </button> -->
        <button class="noPrint" style="margin-top: 2%; margin-left: 2%"
            (click)="exportExcel('Remaining_Subscription_off_Reprensantive_very_Briefly')" mat-raised-button color="primary">
            Export
        </button>

        <!-- <button class="noPrint" style="margin-top: 2%; margin-left: 2%" mat-raised-button color="primary"
           [useExistingCss]="true"
            printSectionId="print-section" ngxPrint>
            Print
        </button> -->

        <button class="noPrint" style="margin-top: 2%; margin-left: 2%" mat-raised-button color="primary"
            (click)="printPage2()">
            Print
        </button>

        <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>
            Close
        </button>
    </div>
</div>


<div class="table-container" *ngIf="reportType == 'RemainingSubscriptionReprensantiveRepb'">
    <div id="print-section1" class="container">

        <table class="fixed-header">
            <thead>
                <tr>
                    <th colspan="41"
                        style="text-align: center !important; font-size: 13px; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black;">
                        हिंदुस्तान प्रकाशन संस्था - विवेक साप्ताहिक - वर्गणी विभाग रिपोर्ट वर्गणीदार नूतनीकरण व्यवसाय
                        जमा </th>
                    <th colspan="6"
                        style="text-align: center !important; border-top: 2px solid black; border-right: 2px solid black;">
                        दिनांक : {{ currentDate | date: 'dd-MM-yyyy' }}</th>
                </tr>
                <tr>
                    <th colspan="35"
                        style="text-align: center !important; font-size: 11px; padding-left: 14%; border-left: 2px solid black;">
                        संक्षिप्त बाकी तपशील</th>
                    <!-- <th colspan="12" style="text-align: center !important;font-size: 20 !important;font-weight: 600;"> दिनांक : {{ currentDate | date: 'dd-MM-yyyy' }}</th> -->
                    <th colspan="6"
                        style="text-align: center !important; border-left: 2px solid black; border-right: 2px solid black;">
                        दिनांक पासून:{{startDate | date: 'dd-MM-yyyy'}} </th>
                    <th colspan="6" style="text-align: center !important; border-right: 2px solid black;">पर्यंत:
                        {{endDate | date: 'dd-MM-yyyy'}}</th>
                </tr>
                <!-- <tr>
                    <th colspan="20" style="text-align: center !important;"> वर्गणीदार नूतनीकरण व्यवसाय तपशिल </th>
                    <th colspan="15" style="text-align: center !important;">जमा बाकी तपशील</th>
                    <th colspan="6" style="text-align: center !important;">दिनांक पासून:{{startDate | date: 'dd-MM-yyyy'}} </th>
                    <th colspan="6" style="text-align: center !important;">पर्यंत: {{endDate | date: 'dd-MM-yyyy'}}</th>
              
                </tr> -->
                <tr>
                    <th colspan="8" style="border-left: 2px solid black;"> </th>

                    <th colspan="3" style="text-align: center; font-weight: 600; border-left: 2px solid black;">एप्रिल
                    </th>
                    <th colspan="3" style="text-align: center; border-left: 2px solid black;">मे</th>
                    <th colspan="3" style="text-align: center;border-left: 2px solid black;">जून</th>
                    <th colspan="3" style="text-align: center;border-left: 2px solid black;">जुलै</th>
                    <th colspan="3" style="text-align: center;border-left: 2px solid black;">ऑगस्ट</th>
                    <th colspan="3" style="text-align: center;border-left: 2px solid black;">सप्टेंबर</th>
                    <th colspan="3" style="text-align: center;border-left: 2px solid black;">ऑक्टोबर</th>
                    <th colspan="3" style="text-align: center;border-left: 2px solid black;">नोव्हेंबर</th>
                    <th colspan="3" style="text-align: center;border-left: 2px solid black;">डिसेंबर</th>
                    <th colspan="3" style="text-align: center;border-left: 2px solid black;">जानेवारी</th>
                    <th colspan="3" style="text-align: center;border-left: 2px solid black;">फेब्रुवारी</th>
                    <th colspan="3" style="text-align: center;border-left: 2px solid black;">मार्च</th>
                    <th colspan="3"
                        style="text-align: center;border-left: 2px solid black;border-right: 2px solid black;">एकूण</th>
                </tr>
                <tr>
                    <th colspan="4" style=" border-left: 2px solid black; border-top: 2px solid black;"><b>जिल्हा</b>
                    </th>
                    <th colspan="4" style=" border-left: 2px solid black; border-top: 2px solid black;"><b>तालुका</b>
                    </th>

                    <th style="border-left: 2px solid black;">जमा</th>
                    <th>बाकी</th>
                    <th>एकूण</th>

                    <th style="border-left: 2px solid black;">जमा</th>
                    <th>बाकी</th>
                    <th>एकूण</th>

                    <th style="border-left: 2px solid black;">जमा</th>
                    <th>बाकी</th>
                    <th>एकूण</th>

                    <th style="border-left: 2px solid black;">जमा</th>
                    <th>बाकी</th>
                    <th>एकूण</th>

                    <th style="border-left: 2px solid black;">जमा</th>
                    <th>बाकी</th>
                    <th>एकूण</th>

                    <th style="border-left: 2px solid black;">जमा</th>
                    <th>बाकी</th>
                    <th>एकूण</th>

                    <th style="border-left: 2px solid black;">जमा</th>
                    <th>बाकी</th>
                    <th>एकूण</th>

                    <th style="border-left: 2px solid black;">जमा</th>
                    <th>बाकी</th>
                    <th>एकूण</th>

                    <th style="border-left: 2px solid black;">जमा</th>
                    <th>बाकी</th>
                    <th>एकूण</th>

                    <th style="border-left: 2px solid black;">जमा</th>
                    <th>बाकी</th>
                    <th>एकूण</th>

                    <th style="border-left: 2px solid black;">जमा</th>
                    <th>बाकी</th>
                    <th>एकूण</th>

                    <th style="border-left: 2px solid black;">जमा</th>
                    <th>बाकी</th>
                    <th>एकूण</th>


                    <th style="border-left: 2px solid black;">जमा</th>
                    <th>बाकी</th>
                    <th style="border-right: 2px solid black;">एकूण</th>
                </tr>
            </thead>
            <!-- *ngFor="let data of OutstandingInDetailFormBeans; let i = index" -->
            <tbody *ngFor="let data of SubRemRepBriefly; let i = index">

                <tr>
                    <td colspan="8"
                        style="text-align: center; word-wrap: break-word; border-left: 2px solid black; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                        <b>{{data.rep_name}}</b>
                    </td>
                    <td colspan="3" style="border-left: 2px solid black;"></td>
                    <td colspan="3" style="border-left: 2px solid black;"></td>
                    <td colspan="3" style="border-left: 2px solid black;"></td>
                    <td colspan="3" style="border-left: 2px solid black;"></td>
                    <td colspan="3" style="border-left: 2px solid black;"></td>
                    <td colspan="3" style="border-left: 2px solid black;"></td>
                    <td colspan="3" style="border-left: 2px solid black;"></td>
                    <td colspan="3" style="border-left: 2px solid black;"></td>
                    <td colspan="3" style="border-left: 2px solid black;"></td>
                    <td colspan="3" style="border-left: 2px solid black;"></td>
                    <td colspan="3" style="border-left: 2px solid black;"></td>
                    <td colspan="3" style="border-left: 2px solid black;"></td>
                    <td colspan="3" style="border-left: 2px solid black;border-right: 2px solid black;"></td>

                </tr>
                <ng-container *ngFor="let data1 of data.rep_info">
                    <tr>

                        <td colspan="4" style="border-left: 2px solid black; word-wrap: break-word;">{{data1.district}}
                        </td>

                        <td colspan="4" style="word-wrap: break-word; border-left: 2px solid black;">{{data1.taluka}}
                        </td>

                        <td style="text-align: right; border-left: 2px solid black;">{{data1.New_4}}</td>
                        <td style="text-align: right;">{{data1.Renew_4}}</td>
                        <td style="text-align: right;">{{data1.Total_4}}</td>

                        <td style="text-align: right; border-left: 2px solid black;">{{data1.New_5}}</td>
                        <td style="text-align: right;">{{data1.Renew_5}}</td>
                        <td style="text-align: right;">{{data1.Total_5}}</td>

                        <td style="text-align: right; border-left: 2px solid black;">{{data1.New_6}}</td>
                        <td style="text-align: right;">{{data1.Renew_6}}</td>
                        <td style="text-align: right;">{{data1.Total_6}}</td>

                        <td style="text-align: right; border-left: 2px solid black;">{{data1.New_7}}</td>
                        <td style="text-align: right;">{{data1.Renew_7}}</td>
                        <td style="text-align: right;">{{data1.Total_7}}</td>


                        <td style="text-align: right;border-left: 2px solid black;">{{data1.New_8}}</td>
                        <td style="text-align: right;">{{data1.Renew_8}}</td>
                        <td style="text-align: right;">{{data1.Total_8}}</td>

                        <td style="text-align: right;border-left: 2px solid black;">{{data1.New_9}}</td>
                        <td style="text-align: right;">{{data1.Renew_9}}</td>
                        <td style="text-align: right;">{{data1.Total_9}}</td>

                        <td style="text-align: right;border-left: 2px solid black;">{{data1.New_10}}</td>
                        <td style="text-align: right;">{{data1.Renew_10}}</td>
                        <td style="text-align: right;">{{data1.Total_10}}</td>

                        <td style="text-align: right;border-left: 2px solid black;">{{data1.New_11}}</td>
                        <td style="text-align: right;">{{data1.Renew_11}}</td>
                        <td style="text-align: right;">{{data1.Total_11}}</td>

                        <td style="text-align: right;border-left: 2px solid black;">{{data1.New_12}}</td>
                        <td style="text-align: right;">{{data1.Renew_12}}</td>
                        <td style="text-align: right;">{{data1.Total_12}}</td>

                        <td style="text-align: right;border-left: 2px solid black;">{{data1.New_1}}</td>
                        <td style="text-align: right;">{{data1.Renew_1}}</td>
                        <td style="text-align: right;">{{data1.Total_1}}</td>

                        <td style="text-align: right;border-left: 2px solid black;">{{data1.New_2}}</td>
                        <td style="text-align: right;">{{data1.Renew_2}}</td>
                        <td style="text-align: right;">{{data1.Total_2}}</td>

                        <td style="text-align: right;border-left: 2px solid black;">{{data1.New_3}}</td>
                        <td style="text-align: right;">{{data1.Renew_3}}</td>
                        <td style="text-align: right;">{{data1.Total_3}}</td>

                        <td style="text-align: right;border-left: 2px solid black;">{{data1.New_Total}}</td>
                        <td style="text-align: right;">{{data1.Renew_Total}}</td>
                        <td style="text-align: right;border-right: 2px solid black;">{{data1.Total_Total}}</td>


                    </tr>
                </ng-container>

                <tr>

                    <td colspan="8"
                        style="text-align: right; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        <b>एकूण :-</b>
                    </td>


                    <td
                        style="text-align: right;font-weight: 600; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.New_4}}</td>
                    <td
                        style="text-align: right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.Renew_4}}</td>
                    <td
                        style="text-align: right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.Total_4}}</td>

                    <td
                        style="text-align: right;font-weight: 600; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.New_5}}</td>
                    <td
                        style="text-align: right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.Renew_5}}</td>
                    <td
                        style="text-align: right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.Total_5}}</td>

                    <td
                        style="text-align: right;font-weight: 600; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.New_6}}</td>
                    <td
                        style="text-align: right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.Renew_6}}</td>
                    <td
                        style="text-align: right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.Total_6}}</td>

                    <td
                        style="text-align: right;font-weight: 600; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.New_7}}</td>
                    <td
                        style="text-align: right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.Renew_7}}</td>
                    <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.Total_7}}</td>


                    <td
                        style="text-align: right;font-weight: 600; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.New_8}}</td>
                    <td
                        style="text-align: right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.Renew_8}}</td>
                    <td
                        style="text-align: right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.Total_8}}</td>

                    <td
                        style="text-align: right;font-weight: 600; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.New_9}}</td>
                    <td
                        style="text-align: right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.Renew_9}}</td>
                    <td
                        style="text-align: right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.Total_9}}</td>

                    <td
                        style="text-align: right;font-weight: 600; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.New_10}}</td>
                    <td
                        style="text-align: right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.Renew_10}}</td>
                    <td
                        style="text-align: right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.Total_10}}</td>

                    <td
                        style="text-align: right;font-weight: 600; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.New_11}}</td>
                    <td
                        style="text-align: right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.Renew_11}}</td>
                    <td
                        style="text-align: right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.Total_11}}</td>

                    <td
                        style="text-align: right;font-weight: 600; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.New_12}}</td>
                    <td
                        style="text-align: right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.Renew_12}}</td>
                    <td
                        style="text-align: right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.Total_12}}</td>

                    <td
                        style="text-align: right;font-weight: 600; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.New_1}}</td>
                    <td
                        style="text-align: right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.Renew_1}}</td>
                    <td
                        style="text-align: right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.Total_1}}</td>

                    <td
                        style="text-align: right;font-weight: 600; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.New_2}}</td>
                    <td
                        style="text-align: right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.Renew_2}}</td>
                    <td
                        style="text-align: right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.Total_2}}</td>

                    <td
                        style="text-align: right;font-weight: 600; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.New_3}}</td>
                    <td
                        style="text-align: right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.Renew_3}}</td>
                    <td
                        style="text-align: right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.Total_3}}</td>

                    <td
                        style="text-align: right;font-weight: 600; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.New_Total}}</td>
                    <td
                        style="text-align: right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.Renew_Total}}</td>
                    <td
                        style="text-align: right;font-weight: 600; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{data.Total_Total}}</td>


                </tr>

            </tbody>

            <tfoot>
                <tr>
                    <td colspan="8"
                        style="text-align: left; font-size: 10px; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                        <b>एकूण :-</b>
                    </td>


                    <td
                        style="text-align: right; font-weight: 600; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_New_4}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_Renew_4}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_Total_4}}</td>

                    <td
                        style="text-align: right; font-weight: 600; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_New_5}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_Renew_5}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_Total_5}}</td>

                    <td
                        style="text-align: right; font-weight: 600; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_New_6}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_Renew_6}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_Total_6}}</td>

                    <td
                        style="text-align: right; font-weight: 600; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_New_7}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_Renew_7}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_Total_7}}</td>

                    <td
                        style="text-align: right; font-weight: 600; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_New_8}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_Renew_8}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_Total_8}}</td>

                    <td
                        style="text-align: right; font-weight: 600; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_New_9}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_Renew_9}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_Total_9}}</td>

                    <td
                        style="text-align: right; font-weight: 600; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_New_10}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_Renew_10}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_Total_10}}</td>

                    <td
                        style="text-align: right; font-weight: 600; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_New_11}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_Renew_11}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_Total_11}}</td>

                    <td
                        style="text-align: right; font-weight: 600; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_New_12}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_Renew_12}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_Total_12}}</td>

                    <td
                        style="text-align: right; font-weight: 600; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_New_1}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_Renew_1}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_Total_1}}</td>

                    <td
                        style="text-align: right; font-weight: 600; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_New_2}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_Renew_2}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_Total_2}}</td>

                    <td
                        style="text-align: right; font-weight: 600; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_New_3}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_Renew_3}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_Total_3}}</td>

                    <td
                        style="text-align: right; font-weight: 600; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_New_total}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_Renew_total}}</td>
                    <td
                        style="text-align: right; font-weight: 600; border-right: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                        {{total_Total_total}}</td>
                </tr>
            </tfoot>
        </table>


    </div>
    <div style="margin-left: 80%; margin-bottom: 2%;">
        <!-- <button class="noPrint" style="margin-top: 2%;" mat-raised-button color="primary"
            [printStyle]="{table : {'border-collapse':'collapse'}, td : {'border': 'solid 1px'}, th : {'border': 'solid 1px'}}"
            printSectionId="print-section2" ngxPrint>
            print
        </button> -->
        <button class="noPrint" style="margin-top: 2%; margin-left: 2%"
            (click)="exportExcel('Remaining_Subscription_Reprensantive_Briefly')" mat-raised-button color="primary">
            Export
        </button>

        <!-- <button class="noPrint" style="margin-top: 2%;" mat-raised-button color="primary"
           [useExistingCss]="true"
            printSectionId="print-section1" ngxPrint>
            print
        </button> -->

        <button class="noPrint" style="margin-top: 2%; margin-left: 2%" mat-raised-button color="primary"
            (click)="printPage()">
            Print
        </button>

        <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>
            Close
        </button>
    </div>
</div>

<div class="table-container" *ngIf="reportType == 'RemainingSubscriptionReprensantiveRepvb'">
    <div id="print-section1" class="container">

        <table class="fixed-header">
            <thead>
                <tr>
                    <th colspan="45"
                        style="text-align: center !important; font-size: 14px; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black;">
                        प्रतिनिधीची अत्यंत संक्षेपात रिपोर्ट वर्गणीदार नूतनीकरण व्यवसाय जमा बाकी तपशील</th>
                    <th colspan="6"
                        style="text-align: center !important; border-right: 2px solid black; border-top: 2px solid black;">
                        दिनांक : {{ currentDate | date: 'dd-MM-yyyy' }}</th>
                </tr>
                <tr>
                    <th colspan="39"
                        style="text-align: center !important; font-size: 12px; padding-left: 12%; border-left: 2px solid black; ">
                        हिंदुस्तान प्रकाशन संस्था - विवेक साप्ताहिक - वर्गणी विभाग</th>
                    <th colspan="6" style="text-align: center !important; border-left: 2px solid black;">दिनांक
                        पासून:{{startDate | date: 'dd-MM-yyyy'}} </th>
                    <th colspan="6"
                        style="text-align: center !important; border-left: 2px solid black; border-right: 2px solid black;">
                        पर्यंत: {{endDate | date: 'dd-MM-yyyy'}}</th>
                </tr>
                <!-- <tr>
                    <th colspan="21" style="text-align: center !important;"> वर्गणीदार नूतनीकरण व्यवसाय तपशिल </th>
                    <th colspan="18" style="text-align: center !important;">जमा बाकी तपशील</th>
                    <th colspan="6" style="text-align: center !important;">दिनांक पासून:{{startDate | date: 'dd-MM-yyyy'}} </th>
                    <th colspan="6" style="text-align: center !important;">पर्यंत: {{endDate | date: 'dd-MM-yyyy'}}</th>
              
                </tr> -->
                <tr>
                    <th colspan="12"
                        style="border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                        नूतनीकरण येणे बाकी</th>

                    <th colspan="3"
                        style="text-align: center; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                        एप्रिल</th>
                    <th colspan="3"
                        style="text-align: center; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                        मे</th>
                    <th colspan="3"
                        style="text-align: center; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                        जून</th>
                    <th colspan="3"
                        style="text-align: center; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                        जुलै</th>
                    <th colspan="3"
                        style="text-align: center; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                        ऑगस्ट</th>
                    <th colspan="3"
                        style="text-align: center; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                        सप्टेंबर</th>
                    <th colspan="3"
                        style="text-align: center; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                        ऑक्टोबर</th>
                    <th colspan="3"
                        style="text-align: center; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                        नोव्हेंबर</th>
                    <th colspan="3"
                        style="text-align: center; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                        डिसेंबर</th>
                    <th colspan="3"
                        style="text-align: center; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                        जानेवारी</th>
                    <th colspan="3"
                        style="text-align: center; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                        फेब्रुवारी</th>
                    <th colspan="3"
                        style="text-align: center; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                        मार्च</th>
                    <th colspan="3"
                        style="text-align: center; border-left: 2px solid black;border-right: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                        एकूण</th>
                </tr>
                <tr>
                    <th colspan="4" style="border-left: 2px solid black; border-bottom: 2px solid black;">
                        <b>प्रतिनिधी</b>
                    </th>
                    <th colspan="4" style="border-left: 2px solid black; border-bottom: 2px solid black;"><b>जिल्हा</b>
                    </th>
                    <th colspan="4" style="border-left: 2px solid black; border-bottom: 2px solid black;"><b>तालुका</b>
                    </th>

                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">बाकी</th>
                    <th>एकूण</th>

                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black;">एकूण</th>

                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black;">एकूण</th>

                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black;">एकूण</th>

                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black;">एकूण</th>

                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black;">एकूण</th>

                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black;">एकूण</th>

                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black;">एकूण</th>

                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black;">एकूण</th>

                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black;">एकूण</th>

                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black;">एकूण</th>

                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">बाकी</th>
                    <th style="border-bottom: 2px solid black;">एकूण</th>


                    <th
                        style="border-left: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                        जमा</th>
                    <th style="border-bottom: 2px solid black; border-right: 2px solid black;">बाकी</th>
                    <th style="border-right: 2px solid black; border-bottom: 2px solid black;">एकूण</th>
                </tr>
            </thead>
            <!-- *ngFor="let data of OutstandingInDetailFormBeans; let i = index" -->
            <tbody *ngFor="let data1 of SubRemRepVBriefly; let i = index">
                <tr>
                    <td colspan="4" style="font-weight: bold; border-left: 2px solid black; overflow-wrap: break-word;">
                        {{data1.rep_name}}</td>

                    <td colspan="4" style="border-left: 2px solid black; overflow-wrap: break-word;">{{data1.district}}
                    </td>

                    <td colspan="4" style="border-left: 2px solid black; overflow-wrap: break-word;">{{data1.taluka}}
                    </td>

                    <td style="text-align: right; border-left: 2px solid black;">{{data1.New_4}}</td>
                    <td style="text-align: right;">{{data1.Renew_4}}</td>
                    <td style="text-align: right;">{{data1.Total_4}}</td>

                    <td style="text-align: right;border-left: 2px solid black;">{{data1.New_5}}</td>
                    <td style="text-align: right;">{{data1.Renew_5}}</td>
                    <td style="text-align: right;">{{data1.Total_5}}</td>

                    <td style="text-align: right;border-left: 2px solid black;">{{data1.New_6}}</td>
                    <td style="text-align: right;">{{data1.Renew_6}}</td>
                    <td style="text-align: right;">{{data1.Total_6}}</td>

                    <td style="text-align: right;border-left: 2px solid black;">{{data1.New_7}}</td>
                    <td style="text-align: right;">{{data1.Renew_7}}</td>
                    <td style="text-align: right;">{{data1.Total_7}}</td>


                    <td style="text-align: right;border-left: 2px solid black;">{{data1.New_8}}</td>
                    <td style="text-align: right;">{{data1.Renew_8}}</td>
                    <td style="text-align: right;">{{data1.Total_8}}</td>

                    <td style="text-align: right;border-left: 2px solid black;">{{data1.New_9}}</td>
                    <td style="text-align: right;">{{data1.Renew_9}}</td>
                    <td style="text-align: right;">{{data1.Total_9}}</td>

                    <td style="text-align: right;border-left: 2px solid black;">{{data1.New_10}}</td>
                    <td style="text-align: right;">{{data1.Renew_10}}</td>
                    <td style="text-align: right;">{{data1.Total_10}}</td>

                    <td style="text-align: right;border-left: 2px solid black;">{{data1.New_11}}</td>
                    <td style="text-align: right;">{{data1.Renew_11}}</td>
                    <td style="text-align: right;">{{data1.Total_11}}</td>

                    <td style="text-align: right;border-left: 2px solid black;">{{data1.New_12}}</td>
                    <td style="text-align: right;">{{data1.Renew_12}}</td>
                    <td style="text-align: right;">{{data1.Total_12}}</td>

                    <td style="text-align: right;border-left: 2px solid black;">{{data1.New_1}}</td>
                    <td style="text-align: right;">{{data1.Renew_1}}</td>
                    <td style="text-align: right;">{{data1.Total_1}}</td>

                    <td style="text-align: right;border-left: 2px solid black;">{{data1.New_2}}</td>
                    <td style="text-align: right;">{{data1.Renew_2}}</td>
                    <td style="text-align: right;">{{data1.Total_2}}</td>

                    <td style="text-align: right;border-left: 2px solid black;">{{data1.New_3}}</td>
                    <td style="text-align: right;">{{data1.Renew_3}}</td>
                    <td style="text-align: right;">{{data1.Total_3}}</td>

                    <td style="text-align: right;border-left: 2px solid black;">{{data1.new_total}}</td>
                    <td style="text-align: right;">{{data1.renew_total}}</td>
                    <td style="text-align: right;border-right: 2px solid black;">{{data1.total_total}}</td>


                </tr>

            </tbody>

            <tfoot>

            </tfoot>
            <tr>
                <td colspan="12"
                    style="text-align: center; color: black; font-size: 14px; font-weight: bold; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                    <b>एकूण :-</b>
                </td>


                <td
                    style="text-align: right; font-weight: 600; color: black; font-size: 14px; font-weight: bold; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black;">
                    {{total_New_4}}</td>
                <td
                    style="text-align: right; font-weight: 600; color: black; font-size: 14px; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black;">
                    {{total_Renew_4}}</td>
                <td
                    style="text-align: right; font-weight: 600; color: black; font-size: 14px; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black;">
                    {{total_Total_4}}</td>

                <td
                    style="text-align: right; font-weight: 600; color: black; font-size: 14px; font-weight: bold; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black;">
                    {{total_New_5}}</td>
                <td
                    style="text-align: right; font-weight: 600; color: black; font-size: 14px; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black;">
                    {{total_Renew_5}}</td>
                <td
                    style="text-align: right; font-weight: 600; color: black; font-size: 14px; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black;">
                    {{total_Total_5}}</td>

                <td
                    style="text-align: right; font-weight: 600; color: black; font-size: 14px; font-weight: bold; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black;">
                    {{total_New_6}}</td>
                <td
                    style="text-align: right; font-weight: 600; color: black; font-size: 14px; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black;">
                    {{total_Renew_6}}</td>
                <td
                    style="text-align: right; font-weight: 600; color: black; font-size: 14px; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black;">
                    {{total_Total_6}}</td>

                <td
                    style="text-align: right; font-weight: 600; color: black; font-size: 14px; font-weight: bold; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black;">
                    {{total_New_7}}</td>
                <td
                    style="text-align: right; font-weight: 600; color: black; font-size: 14px; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black;">
                    {{total_Renew_7}}</td>
                <td
                    style="text-align: right; font-weight: 600; color: black; font-size: 14px; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black;">
                    {{total_Total_7}}</td>

                <td
                    style="text-align: right; font-weight: 600; color: black; font-size: 14px; font-weight: bold; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black;">
                    {{total_New_8}}</td>
                <td
                    style="text-align: right; font-weight: 600; color: black; font-size: 14px; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black;">
                    {{total_Renew_8}}</td>
                <td
                    style="text-align: right; font-weight: 600; color: black; font-size: 14px; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black;">
                    {{total_Total_8}}</td>

                <td
                    style="text-align: right; font-weight: 600; color: black; font-size: 14px; font-weight: bold; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black;">
                    {{total_New_9}}</td>
                <td
                    style="text-align: right; font-weight: 600; color: black; font-size: 14px; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black;">
                    {{total_Renew_9}}</td>
                <td
                    style="text-align: right; font-weight: 600; color: black; font-size: 14px; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black;">
                    {{total_Total_9}}</td>

                <td
                    style="text-align: right; font-weight: 600; color: black; font-size: 14px; font-weight: bold; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black;">
                    {{total_New_10}}</td>
                <td
                    style="text-align: right; font-weight: 600; color: black; font-size: 14px; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black;">
                    {{total_Renew_10}}</td>
                <td
                    style="text-align: right; font-weight: 600; color: black; font-size: 14px; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black;">
                    {{total_Total_10}}</td>

                <td
                    style="text-align: right; font-weight: 600; color: black; font-size: 14px; font-weight: bold; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black;">
                    {{total_New_11}}</td>
                <td
                    style="text-align: right; font-weight: 600; color: black; font-size: 14px; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black;">
                    {{total_Renew_11}}</td>
                <td
                    style="text-align: right; font-weight: 600; color: black; font-size: 14px; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black;">
                    {{total_Total_11}}</td>

                <td
                    style="text-align: right; font-weight: 600; color: black; font-size: 14px; font-weight: bold; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black;">
                    {{total_New_12}}</td>
                <td
                    style="text-align: right; font-weight: 600; color: black; font-size: 14px; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black;">
                    {{total_Renew_12}}</td>
                <td
                    style="text-align: right; font-weight: 600; color: black; font-size: 14px; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black;">
                    {{total_Total_12}}</td>

                <td
                    style="text-align: right; font-weight: 600; color: black; font-size: 14px; font-weight: bold; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black;">
                    {{total_New_1}}</td>
                <td
                    style="text-align: right; font-weight: 600; color: black; font-size: 14px; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black;">
                    {{total_Renew_1}}</td>
                <td
                    style="text-align: right; font-weight: 600; color: black; font-size: 14px; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black;">
                    {{total_Total_1}}</td>

                <td
                    style="text-align: right; font-weight: 600; color: black; font-size: 14px; font-weight: bold; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black;">
                    {{total_New_2}}</td>
                <td
                    style="text-align: right; font-weight: 600; color: black; font-size: 14px; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black;">
                    {{total_Renew_2}}</td>
                <td
                    style="text-align: right; font-weight: 600; color: black; font-size: 14px; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black;">
                    {{total_Total_2}}</td>

                <td
                    style="text-align: right; font-weight: 600; color: black; font-size: 14px; font-weight: bold; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black;">
                    {{total_New_3}}</td>
                <td
                    style="text-align: right; font-weight: 600; color: black; font-size: 14px; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black;">
                    {{total_Renew_3}}</td>
                <td
                    style="text-align: right; font-weight: 600; color: black; font-size: 14px; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black;">
                    {{total_Total_3}}</td>

                <td
                    style="text-align: right; font-weight: 600; color: black; font-size: 14px; font-weight: bold; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black;">
                    {{total_New_total}}</td>
                <td
                    style="text-align: right; font-weight: 600; color: black; font-size: 14px; font-weight: bold; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black;">
                    {{total_Renew_total}}</td>
                <td
                    style="text-align: right; font-weight: 600; color: black; font-size: 14px; font-weight: bold; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black;">
                    {{total_Total_total}}</td>
            </tr>
        </table>


    </div>
    <div style="margin-left: 80%; margin-bottom: 2%;">
        <!-- <button class="noPrint" style="margin-top: 2%;" mat-raised-button color="primary"
            [printStyle]="{table : {'border-collapse':'collapse'}, td : {'border': 'solid 1px'}, th : {'border': 'solid 1px'}}"
            printSectionId="print-section2" ngxPrint>
            print
        </button> -->
        <button class="noPrint" style="margin-top: 2%; margin-left: 2%"
            (click)="exportExcel('Remaining_Subscription_Reprensantive_very_Briefly_Report')" mat-raised-button
            color="primary">
            Export
        </button>

        <!-- <button class="noPrint" style="margin-top: 2%; margin-left: 2%" mat-raised-button color="primary"
           [useExistingCss]="true"
            printSectionId="print-section" ngxPrint>
            print
        </button> -->

        <button class="noPrint" style="margin-top: 2%; margin-left: 2%" mat-raised-button color="primary"
            (click)="printPage()">
            Print
        </button>

        <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>
            Close
        </button>
    </div>
</div>

<div class="table-container" *ngIf="reportType == 'RemainingSubscriptionoffReprensantiveBriefly'">
    <div id="print-section1" class="container">

        <table class="fixed-header">
            <thead>
                <tr>
                    <th colspan="37"
                        style="text-align: center !important; font-size: 13px; border-left: 2px solid black;">कार्यालय
                        प्रतिनिधी संक्षिप्त अहवाल वर्गणीदार नूतनीकरण व्यवसाय जमा बाकी तपशील</th>
                    <th colspan="6"
                        style="text-align: center !important; border-left: 2px solid black; border-right: 2px solid black;">
                        दिनांक {{ currentDate | date: 'dd-MM-yyyy' }}

                </tr>
                <tr>
                    <th colspan="31"
                        style="text-align: center !important; font-size: 11px; padding-left: 14%; border-left: 2px solid black;">
                        हिंदुस्तान प्रकाशन संस्था - विवेक साप्ताहिक - वर्गणी विभाग</th>
                    <!-- <th colspan="12" style="text-align: center !important;font-size: 20 !important;font-weight: 600;"> दिनांक   {{ currentDate | date: 'dd-MM-yyyy' }} </th> -->
                    <th colspan="6"
                        style="text-align: center !important; border-left: 2px solid black; border-right: 2px solid black;">
                        दिनांक पासून:{{startDate | date: 'dd-MM-yyyy' }} </th>
                    <th colspan="6" style="text-align: center !important; border-right: 2px solid black;"> पर्यंत:
                        {{endDate | date: 'dd-MM-yyyy' }}</th>
                </tr>
                <!-- <tr>
                    <th colspan="22" style="text-align: center !important;"> वर्गणीदार नूतनीकरण व्यवसाय तपशिल </th>
                    <th colspan="9" style="text-align: center !important;"> जमा बाकी तपशील</th>
                    <th colspan="6" style="text-align: center !important;">दिनांक पासून:{{startDate  | date: 'dd-MM-yyyy' }} </th>
                    <th colspan="6" style="text-align: center !important;"> पर्यंत: {{endDate  | date: 'dd-MM-yyyy' }}</th>
                </tr> -->
                <tr>
                    <th colspan="4" style="border-left: 2px solid black;">नूतनीकरण येणे बाकी</th>

                    <th colspan="3" style="text-align: center; font-weight: 600; border-left: 2px solid black;">एप्रिल
                    </th>
                    <th colspan="3" style="text-align: center;  border-left: 2px solid black;">मे</th>
                    <th colspan="3" style="text-align: center;  border-left: 2px solid black;">जून</th>
                    <th colspan="3" style="text-align: center;  border-left: 2px solid black;">जुलै</th>
                    <th colspan="3" style="text-align: center;  border-left: 2px solid black;">ऑगस्ट</th>
                    <th colspan="3" style="text-align: center;  border-left: 2px solid black;">सप्टेंबर</th>
                    <th colspan="3" style="text-align: center;  border-left: 2px solid black;">ऑक्टोबर</th>
                    <th colspan="3" style="text-align: center;  border-left: 2px solid black;">नोव्हेंबर</th>
                    <th colspan="3" style="text-align: center;  border-left: 2px solid black;">डिसेंबर</th>
                    <th colspan="3" style="text-align: center;  border-left: 2px solid black;">जानेवारी</th>
                    <th colspan="3" style="text-align: center;  border-left: 2px solid black;">फेब्रुवारी</th>
                    <th colspan="3" style="text-align: center;  border-left: 2px solid black;">मार्च</th>
                    <th colspan="3" style="text-align: center;  border-left: 2px solid black;">एकूण</th>
                </tr>
                <tr>

                    <!-- <th colspan="4"><b>तालुका</b></th> -->
                    <th colspan="4" style="border-left: 2px solid black;"><b>प्रतिनिधी</b></th>
                    <th style=" border-left: 2px solid black;">जमा</th>
                    <th>बाकी</th>
                    <th>एकूण</th>

                    <th style=" border-left: 2px solid black;">जमा</th>
                    <th>बाकी</th>
                    <th>एकूण</th>

                    <th style=" border-left: 2px solid black;">जमा</th>
                    <th>बाकी</th>
                    <th>एकूण</th>

                    <th style=" border-left: 2px solid black;">जमा</th>
                    <th>बाकी</th>
                    <th>एकूण</th>

                    <th style=" border-left: 2px solid black;">जमा</th>
                    <th>बाकी</th>
                    <th>एकूण</th>

                    <th style=" border-left: 2px solid black;">जमा</th>
                    <th>बाकी</th>
                    <th>एकूण</th>

                    <th style=" border-left: 2px solid black;">जमा</th>
                    <th>बाकी</th>
                    <th>एकूण</th>

                    <th style=" border-left: 2px solid black;">जमा</th>
                    <th>बाकी</th>
                    <th>एकूण</th>

                    <th style=" border-left: 2px solid black;">जमा</th>
                    <th>बाकी</th>
                    <th>एकूण</th>

                    <th style=" border-left: 2px solid black;">जमा</th>
                    <th>बाकी</th>
                    <th>एकूण</th>

                    <th style=" border-left: 2px solid black;">जमा</th>
                    <th>बाकी</th>
                    <th>एकूण</th>

                    <th style=" border-left: 2px solid black;">जमा</th>
                    <th>बाकी</th>
                    <th>एकूण</th>


                    <th style=" border-left: 2px solid black;">जमा</th>
                    <th>बाकी</th>
                    <th style=" border-right: 2px solid black;">एकूण</th>
                </tr>
            </thead>

            <tbody>
                <ng-container *ngFor="let data2 of SubRemOffRepbrief; let i = index">
                    <tr>

                        <td colspan="4"
                            style="font-size: 16px; text-align: center; overflow-wrap: break-word; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                            <b> {{ data2.office_rep_name || '--'}}</b>
                        </td>
                        <td colspan="3" style="border-left: 2px solid black;"></td>
                        <td colspan="3" style="border-left: 2px solid black;"></td>
                        <td colspan="3" style="border-left: 2px solid black;"></td>
                        <td colspan="3" style="border-left: 2px solid black;"></td>
                        <td colspan="3" style="border-left: 2px solid black;"></td>
                        <td colspan="3" style="border-left: 2px solid black;"></td>
                        <td colspan="3" style="border-left: 2px solid black;"></td>
                        <td colspan="3" style="border-left: 2px solid black;"></td>
                        <td colspan="3" style="border-left: 2px solid black;"></td>
                        <td colspan="3" style="border-left: 2px solid black;"></td>
                        <td colspan="3" style="border-left: 2px solid black;"></td>
                        <td colspan="3" style="border-left: 2px solid black;"></td>
                        <td colspan="3" style="border-left: 2px solid black;border-right: 2px solid black;"></td>
                    </tr>

                    <ng-container *ngFor="let data11 of data2.districts; let i = index">


                        <tr>
                            <!-- <td colspan="4"></td> -->
                            <td colspan="4"
                                style="text-align: left; font-size: 16px; text-align: center; overflow-wrap: break-word; border-left: 2px solid black; border-bottom: 2px solid black;">
                                <b>{{ data11.district || '--' }}</b>
                            </td>
                            <td colspan="3" style="border-left: 2px solid black;"></td>
                            <td colspan="3" style="border-left: 2px solid black;"></td>
                            <td colspan="3" style="border-left: 2px solid black;"></td>
                            <td colspan="3" style="border-left: 2px solid black;"></td>
                            <td colspan="3" style="border-left: 2px solid black;"></td>
                            <td colspan="3" style="border-left: 2px solid black;"></td>
                            <td colspan="3" style="border-left: 2px solid black;"></td>
                            <td colspan="3" style="border-left: 2px solid black;"></td>
                            <td colspan="3" style="border-left: 2px solid black;"></td>
                            <td colspan="3" style="border-left: 2px solid black;"></td>
                            <td colspan="3" style="border-left: 2px solid black;"></td>
                            <td colspan="3" style="border-left: 2px solid black;"></td>
                            <td colspan="3" style="border-left: 2px solid black;border-right: 2px solid black;"></td>
                        </tr>


                        <ng-container *ngFor="let data1 of data11.talukas; let i = index">


                            <tr>

                                <td colspan="4"
                                    style="text-align: left; overflow-wrap: break-word; border-left: 2px solid black; border-top: 2px solid black;">
                                    <b>{{ data1.rep_taluka || '--' }}</b>
                                </td>
                                <td colspan="3" style="border-left: 2px solid black;"></td>
                                <td colspan="3" style="border-left: 2px solid black;"></td>
                                <td colspan="3" style="border-left: 2px solid black;"></td>
                                <td colspan="3" style="border-left: 2px solid black;"></td>
                                <td colspan="3" style="border-left: 2px solid black;"></td>
                                <td colspan="3" style="border-left: 2px solid black;"></td>
                                <td colspan="3" style="border-left: 2px solid black;"></td>
                                <td colspan="3" style="border-left: 2px solid black;"></td>
                                <td colspan="3" style="border-left: 2px solid black;"></td>
                                <td colspan="3" style="border-left: 2px solid black;"></td>
                                <td colspan="3" style="border-left: 2px solid black;"></td>
                                <td colspan="3" style="border-left: 2px solid black;"></td>
                                <td colspan="3" style="border-left: 2px solid black;border-right: 2px solid black;">
                                </td>
                            </tr>

                            <tr *ngFor="let data of data1.representatives; let i = index">

                                <!-- <td colspan="4">{{data.rep_taluka}}</td> -->
                                <td colspan="4"
                                    style="color: black; border-left: 2px solid black; overflow-wrap: break-word; border-top: 2px solid black;">
                                    {{data.rep_name}}</td>

                                <td style="text-align: right; border-left: 2px solid black;">{{data.new_4}}</td>
                                <td style="text-align: right;">{{data.renew_4}}</td>
                                <td style="text-align: right;">{{data.total_4}}</td>


                                <td style="text-align: right; border-left: 2px solid black;">{{data.new_5}}</td>
                                <td style="text-align: right;">{{data.renew_5}}</td>
                                <td style="text-align: right;">{{data.total_5}}</td>

                                <td style="text-align: right; border-left: 2px solid black;">{{data.new_6}}</td>
                                <td style="text-align: right;">{{data.renew_6}}</td>
                                <td style="text-align: right;">{{data.total_6}}</td>

                                <td style="text-align: right; border-left: 2px solid black;">{{data.new_7}}</td>
                                <td style="text-align: right;">{{data.renew_7}}</td>
                                <td style="text-align: right;">{{data.total_7}}</td>

                                <td style="text-align: right; border-left: 2px solid black;">{{data.new_8}}</td>
                                <td style="text-align: right;">{{data.renew_8}}</td>
                                <td style="text-align: right;">{{data.total_8}}</td>

                                <td style="text-align: right; border-left: 2px solid black;">{{data.new_9}}</td>
                                <td style="text-align: right;">{{data.renew_9}}</td>
                                <td style="text-align: right;">{{data.total_9}}</td>

                                <td style="text-align: right; border-left: 2px solid black;">{{data.new_10}}</td>
                                <td style="text-align: right;">{{data.renew_10}}</td>
                                <td style="text-align: right;">{{data.total_10}}</td>

                                <td style="text-align: right; border-left: 2px solid black;">{{data.new_11}}</td>
                                <td style="text-align: right;">{{data.renew_11}}</td>
                                <td style="text-align: right;">{{data.total_11}}</td>

                                <td style="text-align: right; border-left: 2px solid black;">{{data.new_12}}</td>
                                <td style="text-align: right;">{{data.renew_12}}</td>
                                <td style="text-align: right;">{{data.total_12}}</td>

                                <td style="text-align: right; border-left: 2px solid black;">{{data.new_1}}</td>
                                <td style="text-align: right;">{{data.renew_1}}</td>
                                <td style="text-align: right;">{{data.total_1}}</td>

                                <td style="text-align: right; border-left: 2px solid black;">{{data.new_2}}</td>
                                <td style="text-align: right;">{{data.renew_2}}</td>
                                <td style="text-align: right;">{{data.total_2}}</td>

                                <td style="text-align: right; border-left: 2px solid black;">{{data.new_3}}</td>
                                <td style="text-align: right;">{{data.renew_3}}</td>
                                <td style="text-align: right;">{{data.total_3}}</td>
                                <td style="text-align: right; border-left: 2px solid black;">{{data.new_Total}}</td>
                                <td style="text-align: right;">{{data.renew_Total}}</td>
                                <td style="text-align: right; border-right: 2px solid black;">{{data.total_Total}}</td>




                            </tr>


                            <tr>

                                <th colspan="4"
                                    style="text-align: left; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                                    <b> एकूण :-</b>
                                </th>
                                <td
                                    style="text-align:right; font-weight: 600; border-left: 2px solid black; border-top: 2px solid black;">
                                    {{data1.new_4}}</td>
                                <td style="text-align:right;font-weight: 600; border-top: 2px solid black;">
                                    {{data1.renew_4}}</td>
                                <td style="text-align:right;font-weight: 600; border-top: 2px solid black;">
                                    {{data1.total_4}}</td>
                                <td
                                    style="text-align:right; font-weight: 600; border-left: 2px solid black; border-top: 2px solid black;">
                                    {{data1.new_5}}</td>
                                <td style="text-align:right;font-weight: 600; border-top: 2px solid black;">
                                    {{data1.renew_5}}</td>
                                <td style="text-align:right;font-weight: 600; border-top: 2px solid black;">
                                    {{data1.total_5}}</td>
                                <td
                                    style="text-align:right;font-weight: 600; border-left: 2px solid black; border-top: 2px solid black;">
                                    {{data1.new_6}}</td>
                                <td style="text-align:right;font-weight: 600; border-top: 2px solid black;">
                                    {{data1.renew_6}}</td>
                                <td style="text-align:right;font-weight: 600; border-top: 2px solid black;">
                                    {{data1.total_6}}</td>
                                <td
                                    style="text-align:right; font-weight: 600;border-left: 2px solid black; border-top: 2px solid black;">
                                    {{data1.new_7}}</td>
                                <td style="text-align:right;font-weight: 600; border-top: 2px solid black;">
                                    {{data1.renew_7}}</td>
                                <td style="text-align:right;font-weight: 600; border-top: 2px solid black;">
                                    {{data1.total_7}}</td>
                                <td
                                    style="text-align:right;font-weight: 600; border-left: 2px solid black; border-top: 2px solid black;">
                                    {{data1.new_8}}</td>
                                <td style="text-align:right;font-weight: 600; border-top: 2px solid black;">
                                    {{data1.renew_8}}</td>
                                <td style="text-align:right;font-weight: 600; border-top: 2px solid black;">
                                    {{data1.total_8}}</td>
                                <td
                                    style="text-align:right;font-weight: 600; border-left: 2px solid black; border-top: 2px solid black;">
                                    {{data1.new_9}}</td>
                                <td style="text-align:right;font-weight: 600; border-top: 2px solid black;">
                                    {{data1.renew_9}}</td>
                                <td style="text-align:right;font-weight: 600; border-top: 2px solid black;">
                                    {{data1.total_9}}</td>
                                <td
                                    style="text-align:right; font-weight: 600;border-left: 2px solid black; border-top: 2px solid black;">
                                    {{data1.new_10}}</td>
                                <td style="text-align:right;font-weight: 600; border-top: 2px solid black;">
                                    {{data1.renew_10}}</td>
                                <td style="text-align:right;font-weight: 600; border-top: 2px solid black;">
                                    {{data1.total_10}}</td>
                                <td
                                    style="text-align:right;font-weight: 600; border-left: 2px solid black; border-top: 2px solid black;">
                                    {{data1.new_11}}</td>
                                <td style="text-align:right;font-weight: 600; border-top: 2px solid black;">
                                    {{data1.renew_11}}</td>
                                <td style="text-align:right;font-weight: 600; border-top: 2px solid black;">
                                    {{data1.total_11}}</td>
                                <td
                                    style="text-align:right;font-weight: 600; border-left: 2px solid black; border-top: 2px solid black;">
                                    {{data1.new_12}}</td>
                                <td style="text-align:right;font-weight: 600; border-top: 2px solid black;">
                                    {{data1.renew_12}}</td>
                                <td style="text-align:right;font-weight: 600; border-top: 2px solid black;">
                                    {{data1.total_12}}</td>
                                <td
                                    style="text-align:right;font-weight: 600; border-left: 2px solid black; border-top: 2px solid black;">
                                    {{data1.new_1}}</td>
                                <td style="text-align:right;font-weight: 600; border-top: 2px solid black;">
                                    {{data1.renew_1}}</td>
                                <td style="text-align:right;font-weight: 600; border-top: 2px solid black;">
                                    {{data1.total_1}}</td>
                                <td
                                    style="text-align:right;font-weight: 600; border-left: 2px solid black; border-top: 2px solid black;">
                                    {{data1.new_2}}</td>
                                <td style="text-align:right;font-weight: 600; border-top: 2px solid black;">
                                    {{data1.renew_2}}</td>
                                <td style="text-align:right;font-weight: 600; border-top: 2px solid black;">
                                    {{data1.total_2}}</td>
                                <td
                                    style="text-align:right;font-weight: 600; border-left: 2px solid black; border-top: 2px solid black;">
                                    {{data1.new_3}}</td>
                                <td style="text-align:right;font-weight: 600; border-top: 2px solid black;">
                                    {{data1.renew_3}}</td>
                                <td style="text-align:right;font-weight: 600; border-top: 2px solid black;">
                                    {{data1.total_3}}</td>
                                <td
                                    style="text-align:right; font-weight: 600;border-left: 2px solid black; border-top: 2px solid black;">
                                    {{data1.new_Total}}</td>
                                <td style="text-align:right;font-weight: 600; border-top: 2px solid black;">
                                    {{data1.renew_Total}}</td>
                                <td
                                    style="text-align:right; font-weight: 600; border-right: 2px solid black; border-top: 2px solid black;">
                                    {{data1.total_Total}}</td>


                            </tr>
                        </ng-container>

                        <tr>
                            <!-- <td colspan="4"></td> -->
                            <td colspan="4"
                                style="text-align: right; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                                <b>{{ data11.district || '--' }} : एकूण</b>
                            </td>
                            <td
                                style="text-align:right; font-weight: 600; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{data11.new_4}}</td>
                            <td
                                style="text-align:right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{data11.renew_4}}</td>
                            <td
                                style="text-align:right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{data11.total_4}}</td>

                            <td
                                style="text-align:right; font-weight: 600;border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{data11.new_5}}</td>
                            <td
                                style="text-align:right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{data11.renew_5}}</td>
                            <td
                                style="text-align:right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{data11.total_5}}</td>
                            <td
                                style="text-align:right;font-weight: 600;border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{data11.new_6}}</td>
                            <td
                                style="text-align:right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{data11.renew_6}}</td>
                            <td
                                style="text-align:right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{data11.total_6}}</td>
                            <td
                                style="text-align:right; font-weight: 600;border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{data11.new_7}}</td>
                            <td
                                style="text-align:right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{data11.renew_7}}</td>
                            <td
                                style="text-align:right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{data11.total_7}}</td>
                            <td
                                style="text-align:right;font-weight: 600;border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{data11.new_8}}</td>
                            <td
                                style="text-align:right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{data11.renew_8}}</td>
                            <td
                                style="text-align:right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{data11.total_8}}</td>
                            <!-- <td style="text-align:right;font-weight: 600;border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">{{data11.new_9}}</td> -->
                            <td
                                style="text-align:right;font-weight: 600;border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{data11.new_9}}</td>
                            <td
                                style="text-align:right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{data11.renew_9}}</td>
                            <td
                                style="text-align:right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{data11.total_9}}</td>
                            <td
                                style="text-align:right;font-weight: 600;border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{data11.new_10}}</td>
                            <td
                                style="text-align:right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{data11.renew_10}}</td>
                            <td
                                style="text-align:right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{data11.total_10}}</td>
                            <td
                                style="text-align:right;font-weight: 600;border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{data11.new_11}}</td>
                            <td
                                style="text-align:right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{data11.renew_11}}</td>
                            <td
                                style="text-align:right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{data11.total_11}}</td>
                            <td
                                style="text-align:right;font-weight: 600;border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{data11.new_12}}</td>
                            <td
                                style="text-align:right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{data11.renew_12}}</td>
                            <td
                                style="text-align:right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{data11.total_12}}</td>
                            <td
                                style="text-align:right;font-weight: 600;border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{data11.new_1}}</td>
                            <td
                                style="text-align:right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{data11.renew_1}}</td>
                            <td
                                style="text-align:right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{data11.total_1}}</td>
                            <td
                                style="text-align:right;font-weight: 600;border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{data11.new_2}}</td>
                            <td
                                style="text-align:right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{data11.renew_2}}</td>
                            <td
                                style="text-align:right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{data11.total_2}}</td>
                            <td
                                style="text-align:right;font-weight: 600;border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{data11.new_3}}</td>
                            <td
                                style="text-align:right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{data11.renew_3}}</td>
                            <td
                                style="text-align:right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{data11.total_3}}</td>
                            <td
                                style="text-align:right;font-weight: 600;border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{data11.new_Total}}</td>
                            <td
                                style="text-align:right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{data11.renew_Total}}</td>
                            <td
                                style="text-align:right;font-weight: 600;border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                                {{data11.total_Total}}</td>
                        </tr>

                    </ng-container>
                    <tr>
                        <!-- <td colspan="4"></td> -->
                        <td colspan="4"
                            style="text-align: center; border-left: 2px solid black; border-top: 2px solid black;">
                            <b>{{data2.office_rep_name || '--' }} : एकूण</b>
                        </td>
                        <td
                            style="text-align:right; font-weight: 600; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data2.new_4}}</td>
                        <td
                            style="text-align:right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data2.renew_4}}</td>
                        <td
                            style="text-align:right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data2.total_4}}</td>

                        <td
                            style="text-align:right; font-weight: 600;border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data2.new_5}}</td>
                        <td
                            style="text-align:right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data2.renew_5}}</td>
                        <td
                            style="text-align:right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data2.total_5}}</td>
                        <td
                            style="text-align:right;font-weight: 600;border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data2.new_6}}</td>
                        <td
                            style="text-align:right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data2.renew_6}}</td>
                        <td
                            style="text-align:right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data2.total_6}}</td>
                        <td
                            style="text-align:right; font-weight: 600;border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data2.new_7}}</td>
                        <td
                            style="text-align:right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data2.renew_7}}</td>
                        <td
                            style="text-align:right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data2.total_7}}</td>
                        <td
                            style="text-align:right;font-weight: 600;border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data2.new_8}}</td>
                        <td
                            style="text-align:right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data2.renew_8}}</td>
                        <td
                            style="text-align:right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data2.total_8}}</td>
                        <td
                            style="text-align:right;font-weight: 600;border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data2.new_9}}</td>
                        <td
                            style="text-align:right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data2.renew_9}}</td>
                        <td
                            style="text-align:right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data2.total_9}}</td>
                        <td
                            style="text-align:right;font-weight: 600; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data2.new_10}}</td>
                        <td
                            style="text-align:right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data2.renew_10}}</td>
                        <td
                            style="text-align:right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data2.total_10}}</td>
                        <td
                            style="text-align:right;font-weight: 600; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data2.new_11}}</td>
                        <td
                            style="text-align:right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data2.renew_11}}</td>
                        <td
                            style="text-align:right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data2.total_11}}</td>
                        <td
                            style="text-align:right;font-weight: 600; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data2.new_12}}</td>
                        <td
                            style="text-align:right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data2.renew_12}}</td>
                        <td
                            style="text-align:right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data2.total_12}}</td>
                        <td
                            style="text-align:right;font-weight: 600; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data2.new_1}}</td>
                        <td
                            style="text-align:right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data2.renew_1}}</td>
                        <td
                            style="text-align:right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data2.total_1}}</td>
                        <td
                            style="text-align:right;font-weight: 600; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data2.new_2}}</td>
                        <td
                            style="text-align:right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data2.renew_2}}</td>
                        <td
                            style="text-align:right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data2.total_2}}</td>
                        <td
                            style="text-align:right;font-weight: 600; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data2.new_3}}</td>
                        <td
                            style="text-align:right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data2.renew_3}}</td>
                        <td
                            style="text-align:right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data2.total_3}}</td>
                        <td
                            style="text-align:right;font-weight: 600; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data2.new_Total}}</td>
                        <td
                            style="text-align:right;font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data2.renew_Total}}</td>
                        <td
                            style="text-align:right;font-weight: 600; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                            {{data2.total_Total}}</td>

                    </tr>

                </ng-container>


            </tbody>

            <tfoot>
                <tr>
                    <!-- <tr> -->
                    <th colspan="4"
                        style="text-align: left; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        <b>एकूण</b>
                    </th>

                    <td
                        style="text-align:right; font-weight: 600;border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{new_4}}</td>
                    <td
                        style="text-align:right; font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{renew_4}}</td>
                    <td
                        style="text-align:right; font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{total_4}}</td>
                    <!-- <td>{{data.rem_april_post_total}}</td> -->

                    <td
                        style="text-align:right; font-weight: 600;border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{new_5}}</td>
                    <td
                        style="text-align:right; font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{renew_5}}</td>
                    <td
                        style="text-align:right; font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{total_5}}</td>
                    <!-- <td>{{data.rem_april_haste_total}}</td> -->

                    <td
                        style="text-align:right; font-weight: 600;border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{new_6}}</td>
                    <td
                        style="text-align:right; font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{renew_6}}</td>
                    <td
                        style="text-align:right; font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{total_6}}</td>
                    <!-- <td>{{data.rem_may_post_total}}</td> -->

                    <td
                        style="text-align:right; font-weight: 600;border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{new_7}}</td>
                    <td
                        style="text-align:right; font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{renew_7}}</td>
                    <td
                        style="text-align:right; font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{total_7}}</td>
                    <!-- <td>{{data.rem_may_haste_total}}</td> -->

                    <td
                        style="text-align:right; font-weight: 600;border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{new_8}}</td>
                    <td
                        style="text-align:right; font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{renew_8}}</td>
                    <td
                        style="text-align:right; font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{total_8}}</td>
                    <!-- <td>{{data.rem_jun_post_total}}</td> -->

                    <td
                        style="text-align:right; font-weight: 600;border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{new_9}}</td>
                    <td
                        style="text-align:right; font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{renew_9}}</td>
                    <td
                        style="text-align:right; font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{total_9}}</td>
                    <!-- <td>{{data.rem_jun_haste_total}}</td> -->

                    <td
                        style="text-align:right; font-weight: 600;border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{new_10}}</td>
                    <td
                        style="text-align:right; font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{renew_10}}</td>
                    <td
                        style="text-align:right; font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{total_10}}</td>
                    <!-- <td>{{data.rem_jul_post_total}}</td> -->

                    <td
                        style="text-align:right; font-weight: 600;border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{new_11}}</td>
                    <td
                        style="text-align:right; font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{renew_11}}</td>
                    <td
                        style="text-align:right; font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{total_11}}</td>
                    <!-- <td>{{data.rem_jul_haste_total}}</td> -->

                    <td
                        style="text-align:right; font-weight: 600;border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{new_12}}</td>
                    <td
                        style="text-align:right; font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{renew_12}}</td>
                    <td
                        style="text-align:right; font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{total_12}}</td>
                    <!-- <td>{{data.rem_aug_post_total}}</td> -->

                    <td
                        style="text-align:right; font-weight: 600;border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{new_1}}</td>
                    <td
                        style="text-align:right; font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{renew_1}}</td>
                    <td
                        style="text-align:right; font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{total_1}}</td>
                    <!-- <td>{{data.rem_aug_haste_total}}</td> -->

                    <td
                        style="text-align:right; font-weight: 600;border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{new_2}}</td>
                    <td
                        style="text-align:right; font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{renew_2}}</td>
                    <td
                        style="text-align:right; font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{total_2}}</td>
                    <!-- <td>{{data.rem_sep_post_total}}</td> -->

                    <td
                        style="text-align:right; font-weight: 600; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{new_3}}</td>
                    <td
                        style="text-align:right; font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{renew_3}}</td>
                    <td
                        style="text-align:right; font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{total_3}}</td>

                    <td
                        style="text-align:right; font-weight: 600; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{new_Total}}</td>
                    <td
                        style="text-align:right; font-weight: 600; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{renew_Total}}</td>
                    <td
                        style="text-align:right; font-weight: 600;border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                        {{total_Total}}</td>

                </tr>
            </tfoot>
        </table>


    </div>
    <div style="margin-left: 80%; margin-bottom: 2%;">
        <!-- <button class="noPrint" style="margin-top: 2%;" mat-raised-button color="primary"
            [printStyle]="{table : {'border-collapse':'collapse'}, td : {'border': 'solid 1px'}, th : {'border': 'solid 1px'}}"
            printSectionId="print-section2" ngxPrint>
            print
        </button> -->
        <button class="noPrint" style="margin-top: 2%; margin-left: 2%"
            (click)="exportExcel('Remaining_Subscription_Off-Reprensantive_Briefly_Report')" mat-raised-button
            color="primary">
            Export
        </button>

        <!-- <button class="noPrint" style="margin-top: 2%;" mat-raised-button color="primary"
           [useExistingCss]="true"
            printSectionId="print-section" ngxPrint>
            print
        </button> -->

        <button class="noPrint" style="margin-top: 2%; margin-left: 2%" mat-raised-button color="primary"
            (click)="printPage5()">
            Print
        </button>

        <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>
            Close
        </button>
    </div>

</div>